var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _g, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _g2, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 60,
    viewBox: "0 0 70 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_336_14486)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M26.7297 49.3523C26.7297 49.5891 25.4033 49.7865 23.7602 49.7865C22.117 49.7865 20.7906 49.5891 20.7906 49.3523C20.7906 49.1154 22.1368 48.918 23.7602 48.918C25.3835 48.918 26.7297 49.1154 26.7297 49.3523Z",
    fill: "url(#paint0_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M48.704 49.3523C48.704 49.5891 47.3777 49.7865 45.7345 49.7865C44.0914 49.7865 42.765 49.5891 42.765 49.3523C42.765 49.1154 44.0914 48.918 45.7345 48.918C47.3777 48.918 48.704 49.1154 48.704 49.3523Z",
    fill: "url(#paint1_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M42.3493 48.3652C43.9893 48.3652 45.3188 48.1707 45.3188 47.9309C45.3188 47.691 43.9893 47.4966 42.3493 47.4966C40.7093 47.4966 39.3798 47.691 39.3798 47.9309C39.3798 48.1707 40.7093 48.3652 42.3493 48.3652Z",
    fill: "url(#paint2_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.7,
    d: "M26.6505 48.4047C28.2905 48.4047 29.62 48.2103 29.62 47.9704C29.62 47.7306 28.2905 47.5361 26.6505 47.5361C25.0105 47.5361 23.681 47.7306 23.681 47.9704C23.681 48.2103 25.0105 48.4047 26.6505 48.4047Z",
    fill: "url(#paint3_radial_336_14486)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.4306 50.1024C34.0149 49.9247 33.9753 48.918 33.9753 48.918L32.8666 50.5564C32.9342 51.1401 32.9342 51.7296 32.8666 52.3133C32.2727 52.866 32.5301 53.0634 32.5301 53.0634C32.5099 53.1102 32.4996 53.1606 32.4996 53.2115C32.4996 53.2624 32.5099 53.3128 32.5301 53.3595C32.4993 53.4026 32.4798 53.4527 32.4735 53.5053C32.4672 53.5578 32.4742 53.6111 32.4939 53.6602C32.5136 53.7093 32.5454 53.7527 32.5863 53.7864C32.6272 53.8201 32.676 53.843 32.7281 53.853C32.6291 54.3071 32.9854 54.1689 32.9854 54.1689C32.6885 54.7019 33.5397 55.1164 33.5793 54.6229C33.6407 54.2048 33.835 53.8173 34.1336 53.5174C34.3316 53.32 34.1336 51.958 34.6681 51.4052C34.7641 51.315 34.836 51.2022 34.8772 51.0772C34.9184 50.9522 34.9276 50.819 34.904 50.6895C34.8804 50.5601 34.8247 50.4386 34.742 50.336C34.6594 50.2335 34.5523 50.1532 34.4306 50.1024Z",
    fill: "url(#paint4_radial_336_14486)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3256 27.4348C38.1598 27.02 40.1201 24.3928 39.7041 21.5666C39.2881 18.7405 36.6533 16.7858 33.8191 17.2006C30.9849 17.6154 29.0246 20.2427 29.4406 23.0688C29.8566 25.8949 32.4914 27.8496 35.3256 27.4348Z",
    fill: "url(#paint5_radial_336_14486)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6312 46.6085C24.6312 47.6547 24.2155 48.4838 23.7206 48.4838C23.2257 48.4838 23.1663 48.1877 23.0079 47.714C22.988 47.6497 22.988 47.5809 23.0079 47.5166C22.9256 47.2277 22.8856 46.9285 22.8891 46.6283C22.8676 46.3655 22.8676 46.1014 22.8891 45.8386C22.8891 45.7005 22.8891 45.6018 22.8891 45.4833C23.0673 45.049 23.3246 44.7529 23.6018 44.7529C23.8789 44.7529 24.6312 45.6215 24.6312 46.6085Z",
    fill: "url(#paint6_linear_336_14486)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.453 49.4128C24.2947 48.8987 24.0175 48.5625 23.7008 48.5625C23.384 48.5625 23.1069 48.8987 22.9485 49.4128H24.453Z",
    fill: "url(#paint7_linear_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7404 45.9372C23.7084 46.3018 23.5386 46.6405 23.2653 46.8848C23.1384 46.9811 23.0465 47.1162 23.0036 47.2694C22.9608 47.4226 22.9692 47.5856 23.0277 47.7336C23.0079 47.6693 23.0079 47.6005 23.0277 47.5362C23.0191 47.4058 23.0415 47.2753 23.0932 47.1552C23.1448 47.0352 23.2241 46.929 23.3247 46.8453C23.591 46.6063 23.7542 46.2738 23.78 45.9175C23.8018 45.8182 23.788 45.7144 23.7409 45.6243C23.6939 45.5341 23.6167 45.4632 23.5226 45.424C23.4428 45.398 23.3565 45.3995 23.2776 45.4281C23.1986 45.4567 23.1316 45.5109 23.0871 45.5819C23.0331 45.6719 23.0153 45.779 23.0374 45.8816C23.0594 45.9842 23.1196 46.0746 23.2059 46.1346C23.2245 46.1556 23.2473 46.1725 23.2729 46.184C23.2985 46.1955 23.3263 46.2015 23.3544 46.2015C23.3824 46.2015 23.4102 46.1955 23.4358 46.184C23.4614 46.1725 23.4843 46.1556 23.5028 46.1346C23.5318 46.0944 23.5474 46.046 23.5474 45.9964C23.5474 45.9469 23.5318 45.8985 23.5028 45.8583C23.5028 45.8583 23.3841 45.7596 23.3445 45.8583C23.3445 45.8583 23.3445 45.8583 23.3445 45.7596C23.3875 45.7611 23.4296 45.7726 23.4674 45.7931C23.5052 45.8137 23.5376 45.8427 23.5622 45.878C23.5946 45.9243 23.6119 45.9795 23.6119 46.0359C23.6119 46.0924 23.5946 46.1475 23.5622 46.1938C23.5381 46.2195 23.509 46.24 23.4767 46.2541C23.4443 46.2681 23.4094 46.2753 23.3742 46.2753C23.3389 46.2753 23.304 46.2681 23.2716 46.2541C23.2393 46.24 23.2102 46.2195 23.1861 46.1938C23.0928 46.1115 23.03 46.0003 23.0079 45.878C23.0079 45.7398 23.0079 45.6411 23.0079 45.5227C23.0614 45.4632 23.1309 45.4204 23.2082 45.3994C23.2854 45.3784 23.3671 45.38 23.4434 45.4042C23.5479 45.444 23.635 45.5193 23.6893 45.6168C23.7436 45.7143 23.7617 45.8277 23.7404 45.9372Z",
    fill: "#0F0F0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7206 47.6941C23.6626 47.7123 23.6004 47.7123 23.5424 47.6941C23.4813 47.6523 23.4313 47.5964 23.3968 47.531C23.3623 47.4656 23.3444 47.3929 23.3444 47.319C23.3403 47.2651 23.3534 47.2112 23.3819 47.1651C23.4103 47.119 23.4527 47.083 23.5028 47.0624C23.5768 47.0171 23.6655 47.0021 23.7504 47.0205C23.8352 47.0389 23.9097 47.0892 23.9581 47.1611C23.9678 47.2133 23.9678 47.2668 23.9581 47.319C23.9292 47.3679 23.8884 47.4086 23.8394 47.4375C23.8176 47.4569 23.7894 47.4676 23.7602 47.4676C23.731 47.4676 23.7028 47.4569 23.681 47.4375C23.681 47.4375 23.681 47.2006 23.681 47.1808C23.681 47.1808 23.681 47.3782 23.681 47.4177C23.704 47.4099 23.7249 47.397 23.742 47.3799C23.7592 47.3627 23.7722 47.3419 23.78 47.319C23.7892 47.2801 23.7892 47.2395 23.78 47.2006C23.7362 47.1402 23.6725 47.0972 23.6001 47.0792C23.5276 47.0611 23.4511 47.0691 23.384 47.1019C23.3408 47.1242 23.3049 47.1584 23.2804 47.2003C23.2558 47.2422 23.2437 47.2902 23.2455 47.3388C23.2462 47.4048 23.2628 47.4697 23.2938 47.5281C23.3247 47.5865 23.3693 47.6366 23.4236 47.6743C23.4792 47.7117 23.5447 47.7316 23.6117 47.7316C23.6787 47.7316 23.7442 47.7117 23.7998 47.6743C23.9042 47.6159 23.9838 47.5216 24.0238 47.4091C24.0638 47.2966 24.0616 47.1734 24.0175 47.0624C23.9543 46.9407 23.8506 46.8447 23.7242 46.7907C23.5979 46.7367 23.4567 46.7281 23.3247 46.7663C23.4673 46.7221 23.621 46.7295 23.7586 46.7873C23.8962 46.8451 24.009 46.9495 24.0769 47.0821C24.1247 47.2018 24.1291 47.3343 24.0894 47.4569C24.0496 47.5794 23.9682 47.6843 23.8592 47.7533C23.8101 47.741 23.7633 47.721 23.7206 47.6941Z",
    fill: "#0F0F0E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1363 46.6094H24.0373C24.001 46.5909 23.9705 46.5626 23.9495 46.5276C23.9285 46.4926 23.9178 46.4525 23.9185 46.4117C23.9076 46.3867 23.902 46.3598 23.902 46.3326C23.902 46.3054 23.9076 46.2784 23.9185 46.2535C23.9499 46.2404 23.9835 46.2337 24.0175 46.2337C24.0515 46.2337 24.0851 46.2404 24.1165 46.2535C24.1292 46.2988 24.1292 46.3466 24.1165 46.3919C24.1165 46.3919 24.1165 46.3919 24.1165 46.293C24.0919 46.2808 24.0648 46.2745 24.0373 46.2745C24.0098 46.2745 23.9827 46.2808 23.9581 46.293C23.9477 46.3111 23.9422 46.3315 23.9422 46.3524C23.9422 46.3732 23.9477 46.3937 23.9581 46.4117C23.9603 46.4442 23.9705 46.4756 23.9878 46.5032C24.005 46.5308 24.0289 46.5537 24.0571 46.5699C24.0902 46.589 24.1278 46.599 24.166 46.599C24.2042 46.599 24.2418 46.589 24.2749 46.5699C24.3363 46.522 24.3823 46.457 24.4069 46.3832C24.4316 46.3093 24.4338 46.2298 24.4135 46.1546C24.3921 46.094 24.3516 46.0419 24.298 46.0062C24.2445 45.9705 24.1808 45.9532 24.1165 45.9569C23.7404 45.9569 23.6216 46.4117 23.6216 46.4117C23.6216 46.4117 23.7602 45.9173 24.1561 45.9173C24.2306 45.914 24.304 45.9356 24.365 45.9785C24.4259 46.0215 24.4708 46.0834 24.4926 46.1546C24.5115 46.2376 24.5067 46.3243 24.4787 46.4047C24.4507 46.4851 24.4006 46.556 24.3343 46.6094H24.1363Z",
    fill: "#0F0F0E"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7602 48.2873C23.7602 48.2873 23.6018 48.1094 23.6414 47.8721C23.6394 47.8284 23.6519 47.7854 23.677 47.7496C23.7021 47.7138 23.7383 47.6874 23.78 47.6743C23.7483 47.6823 23.7199 47.6999 23.6986 47.7247C23.6774 47.7495 23.6643 47.7802 23.6612 47.8127C23.6612 48.0303 23.6612 48.1489 23.7602 48.1885C23.7834 48.2046 23.8111 48.2133 23.8394 48.2133C23.8677 48.2133 23.8953 48.2046 23.9186 48.1885H23.7404C23.7404 48.1885 23.9186 48.1885 23.9582 48.1885V48.3071C23.9264 48.3216 23.8913 48.3273 23.8565 48.3239C23.8218 48.3204 23.7885 48.3078 23.7602 48.2873Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2256 49.4118C23.0871 48.9775 23.7205 48.5234 23.7205 48.5234C23.8683 48.6212 23.9903 48.753 24.0764 48.9075C24.1626 49.0621 24.2102 49.235 24.2155 49.4118C24.2056 49.236 24.156 49.0648 24.0703 48.9109C23.9846 48.7571 23.865 48.6246 23.7205 48.5234C23.7205 48.5234 23.1069 48.9972 23.2256 49.4118Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3642 49.4125C23.3642 49.1159 23.7205 48.7797 23.7205 48.7797C23.824 48.8514 23.9099 48.9456 23.9716 49.0552C24.0333 49.1648 24.0693 49.287 24.0769 49.4125C24.0769 49.0764 23.7799 48.8193 23.7403 48.7797C23.7007 48.7402 23.3048 49.1159 23.384 49.4125H23.3642Z",
    fill: "#0F0F0E"
  }))), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6205 45.2461C27.6205 46.2726 27.2048 47.2202 26.7099 47.2202C26.2149 47.2202 26.1556 46.9241 25.9972 46.4503C25.9861 46.385 25.9861 46.3182 25.9972 46.2529C25.9646 45.9577 25.9646 45.6598 25.9972 45.3646C25.9757 45.0952 25.9757 44.8246 25.9972 44.5552L26.0962 44.2196C26.2743 43.7854 26.5317 43.4893 26.8088 43.4893C27.086 43.4893 27.6205 44.2196 27.6205 45.2461Z",
    fill: "url(#paint8_linear_336_14486)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4424 48.0102C27.284 47.4969 27.0068 47.1416 26.6901 47.1416C26.3733 47.1416 26.0962 47.4969 25.9378 48.0102H27.4424Z",
    fill: "url(#paint9_linear_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7297 44.5159C26.695 44.8853 26.526 45.2294 26.2545 45.4831C26.1276 45.5795 26.0358 45.7146 25.9929 45.8678C25.95 46.021 25.9585 46.184 26.017 46.332C26.0059 46.2666 26.0059 46.1999 26.017 46.1346C26.0138 46.003 26.0407 45.8724 26.0956 45.7528C26.1504 45.6331 26.2319 45.5274 26.3337 45.4437C26.6001 45.2047 26.7633 44.8722 26.789 44.5159C26.789 44.2593 26.789 44.0618 26.5317 44.0224C26.4518 43.9964 26.3656 43.9979 26.2866 44.0265C26.2077 44.0551 26.1406 44.1093 26.0962 44.1803C26.0421 44.2703 26.0244 44.3774 26.0464 44.48C26.0685 44.5825 26.1287 44.673 26.2149 44.733C26.2335 44.754 26.2564 44.7708 26.282 44.7824C26.3076 44.7939 26.3353 44.7998 26.3634 44.7998C26.3915 44.7998 26.4193 44.7939 26.4449 44.7824C26.4705 44.7708 26.4933 44.754 26.5119 44.733C26.5515 44.72 26.586 44.6949 26.6104 44.6612C26.6349 44.6276 26.648 44.5871 26.648 44.5455C26.648 44.5039 26.6349 44.4634 26.6104 44.4297C26.586 44.396 26.5515 44.3709 26.5119 44.358C26.5549 44.3595 26.597 44.371 26.6348 44.3915C26.6726 44.4121 26.7051 44.4411 26.7297 44.4764C26.7297 44.4764 26.7297 44.6343 26.7297 44.7922C26.7056 44.8179 26.6765 44.8384 26.6441 44.8524C26.6118 44.8665 26.5769 44.8737 26.5416 44.8737C26.5063 44.8737 26.4714 44.8665 26.4391 44.8524C26.4067 44.8384 26.3776 44.8179 26.3535 44.7922C26.2599 44.702 26.1975 44.5845 26.1753 44.4567L26.2743 44.1211C26.3283 44.0618 26.397 44.0178 26.4734 43.9935C26.5499 43.9693 26.6315 43.9656 26.7099 43.9829C26.764 44.0605 26.7947 44.152 26.7982 44.2465C26.8017 44.341 26.7779 44.4345 26.7297 44.5159Z",
    fill: "#0F0F0E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7098 46.2926H26.5317C26.4717 46.2497 26.4226 46.1934 26.3883 46.1283C26.3539 46.0632 26.3352 45.9911 26.3337 45.9175C26.3332 45.8616 26.3476 45.8065 26.3754 45.758C26.4032 45.7094 26.4435 45.6691 26.4921 45.6411C26.5291 45.6168 26.5709 45.6005 26.6147 45.5933C26.6584 45.5861 26.7032 45.5882 26.7462 45.5994C26.7891 45.6105 26.8292 45.6306 26.8638 45.6582C26.8985 45.6858 26.927 45.7203 26.9474 45.7596C26.9555 45.8053 26.9555 45.8521 26.9474 45.8978C26.9261 45.9568 26.8838 46.0059 26.8286 46.0359C26.8286 46.0359 26.7098 46.0359 26.6702 46.0359C26.6306 46.0359 26.6702 45.7793 26.6702 45.7596C26.6702 45.7596 26.6702 45.957 26.6702 45.9767H26.9276L27.0266 45.878C27.0358 45.8391 27.0358 45.7985 27.0266 45.7596C26.9721 45.711 26.9017 45.6842 26.8286 45.6842C26.7556 45.6842 26.6851 45.711 26.6306 45.7596C26.5874 45.782 26.5515 45.8161 26.527 45.858C26.5024 45.9 26.4903 45.948 26.4921 45.9965C26.4928 46.0625 26.5094 46.1274 26.5404 46.1858C26.5713 46.2442 26.6159 46.2943 26.6702 46.3321C26.7258 46.3694 26.7913 46.3893 26.8583 46.3893C26.9253 46.3893 26.9908 46.3694 27.0464 46.3321C27.1508 46.2736 27.2304 46.1793 27.2704 46.0668C27.3104 45.9543 27.3082 45.8311 27.2641 45.7201C27.2009 45.5984 27.0972 45.5024 26.9708 45.4484C26.8445 45.3944 26.7033 45.3858 26.5713 45.424C26.7139 45.3798 26.8676 45.3872 27.0052 45.445C27.1428 45.5028 27.2556 45.6072 27.3235 45.7398C27.3713 45.8595 27.3757 45.992 27.336 46.1146C27.2962 46.2371 27.2148 46.342 27.1058 46.411C27.0351 46.4223 26.9628 46.4175 26.8942 46.397C26.8256 46.3765 26.7626 46.3408 26.7098 46.2926Z",
    fill: "#0F0F0E"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1256 45.2278H27.0266C26.9902 45.2092 26.9598 45.1809 26.9388 45.1459C26.9178 45.1109 26.907 45.0708 26.9078 45.03C26.91 44.9975 26.9202 44.9661 26.9374 44.9385C26.9547 44.9109 26.9785 44.888 27.0068 44.8718C27.0369 44.8545 27.071 44.8453 27.1058 44.8453C27.1405 44.8453 27.1746 44.8545 27.2047 44.8718C27.2214 44.9164 27.2214 44.9656 27.2047 45.0102C27.2047 45.0102 27.2047 45.0102 27.2047 44.9114C27.1535 44.8933 27.0976 44.8933 27.0464 44.9114C27.0359 44.9329 27.0304 44.9566 27.0304 44.9806C27.0304 45.0046 27.0359 45.0282 27.0464 45.0498C27.0355 45.0747 27.0298 45.1017 27.0298 45.1289C27.0298 45.1561 27.0355 45.183 27.0464 45.208C27.0808 45.2227 27.1178 45.2302 27.1552 45.2302C27.1927 45.2302 27.2297 45.2227 27.2641 45.208C27.3237 45.1585 27.3682 45.0934 27.3926 45.0201C27.4171 44.9467 27.4206 44.868 27.4027 44.7927C27.3845 44.7301 27.3447 44.6759 27.2903 44.6397C27.236 44.6036 27.1706 44.5877 27.1058 44.595C26.7296 44.595 26.6108 45.0498 26.6108 45.0498C26.6108 45.0498 26.7494 44.5752 27.1454 44.5752C27.218 44.5671 27.2911 44.5844 27.3525 44.624C27.4138 44.6636 27.4595 44.7232 27.4819 44.7927C27.5061 44.8756 27.5038 44.9639 27.4754 45.0454C27.4471 45.1269 27.394 45.1976 27.3235 45.2475L27.1256 45.2278Z",
    fill: "#0F0F0E"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M26.7495 46.866C26.7495 46.866 26.5911 46.688 26.6307 46.4309C26.6329 46.3907 26.6473 46.3521 26.6721 46.3203C26.6969 46.2884 26.7308 46.265 26.7693 46.2529C26.7376 46.2609 26.7092 46.2785 26.6879 46.3033C26.6666 46.3281 26.6536 46.3589 26.6505 46.3914C26.6505 46.5891 26.6505 46.7275 26.7495 46.7671C26.7727 46.7832 26.8003 46.7919 26.8287 46.7919C26.857 46.7919 26.8846 46.7832 26.9078 46.7671H26.7297L26.9276 46.6089V46.7275C26.9185 46.7676 26.8958 46.8033 26.8633 46.8285C26.8308 46.8538 26.7906 46.867 26.7495 46.866Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M26.2149 48.0099C26.0764 47.5756 26.7099 47.1216 26.7099 47.1216C26.8576 47.2194 26.9796 47.3511 27.0658 47.5057C27.1519 47.6602 27.1996 47.8331 27.2048 48.0099C27.1909 47.8351 27.1395 47.6654 27.0542 47.5121C26.9688 47.3588 26.8514 47.2257 26.7099 47.1216C26.7099 47.1216 26.0962 47.5953 26.2149 48.0099Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3536 48.0112C26.2546 47.6948 26.7099 47.3784 26.7099 47.3784C26.8134 47.4501 26.8992 47.5442 26.961 47.6539C27.0227 47.7635 27.0587 47.8857 27.0662 48.0112C27.0673 47.8861 27.0371 47.7627 26.9783 47.6522C26.9196 47.5417 26.8341 47.4476 26.7297 47.3784C26.7297 47.3784 26.2942 47.7146 26.3734 48.0112H26.3536Z",
    fill: "#0F0F0E"
  }))), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M43.2401 45.2461C43.2401 46.2726 42.8442 47.2202 42.3493 47.2202C41.8544 47.2202 41.795 46.9241 41.6168 46.4503V46.2529C41.5345 45.964 41.4945 45.6648 41.498 45.3646C41.4992 45.0919 41.5324 44.8202 41.597 44.5552C41.6208 44.4409 41.6539 44.3286 41.696 44.2196C41.8544 43.7854 42.1117 43.4893 42.4087 43.4893C42.7056 43.4893 43.2401 44.2196 43.2401 45.2461Z",
    fill: "url(#paint10_linear_336_14486)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0818 48.0102C42.9234 47.4969 42.6462 47.1416 42.3295 47.1416C42.0127 47.1416 41.7356 47.4969 41.5772 48.0102H43.0818Z",
    fill: "url(#paint11_linear_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3691 44.5161C42.3345 44.8855 42.1655 45.2296 41.894 45.4834C41.7662 45.5792 41.6723 45.7132 41.6261 45.8658C41.5798 46.0184 41.5835 46.1818 41.6366 46.3322V46.1348C41.6281 46.0045 41.6505 45.8739 41.7021 45.7539C41.7537 45.6338 41.833 45.5276 41.9336 45.4439C42.0734 45.331 42.188 45.1901 42.2698 45.0302C42.3517 44.8704 42.399 44.6953 42.4087 44.5161C42.4087 44.2595 42.4087 44.0621 42.1316 44.0226C42.0517 43.9967 41.9654 43.9981 41.8865 44.0267C41.8076 44.0553 41.7405 44.1095 41.696 44.1805C41.6536 44.2731 41.6423 44.3769 41.6637 44.4765C41.6851 44.576 41.7381 44.6661 41.8148 44.7332C41.8352 44.7547 41.8597 44.7719 41.8869 44.7836C41.9142 44.7953 41.9435 44.8013 41.9732 44.8013C42.0028 44.8013 42.0322 44.7953 42.0594 44.7836C42.0867 44.7719 42.1112 44.7547 42.1316 44.7332C42.158 44.692 42.172 44.644 42.172 44.5951C42.172 44.5461 42.158 44.4981 42.1316 44.4569C42.1169 44.4274 42.0943 44.4026 42.0664 44.3852C42.0384 44.3678 42.0062 44.3584 41.9732 44.3582C42.0051 44.346 42.0403 44.346 42.0722 44.3582C42.1125 44.3595 42.1519 44.3711 42.1865 44.3918C42.2212 44.4125 42.25 44.4417 42.2701 44.4766C42.2701 44.4766 42.2701 44.6345 42.2701 44.7925C42.2189 44.8396 42.1518 44.8658 42.0821 44.8658C42.0124 44.8658 41.9452 44.8396 41.894 44.7925C41.7938 44.7074 41.73 44.5873 41.7158 44.4569C41.7396 44.3425 41.7727 44.2303 41.8148 44.1213C41.8674 44.0603 41.936 44.0151 42.0129 43.9907C42.0898 43.9663 42.172 43.9636 42.2503 43.9831C42.3184 44.0518 42.3657 44.1383 42.3867 44.2325C42.4077 44.3268 42.4016 44.4251 42.3691 44.5161Z",
    fill: "#0F0F0E"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3296 46.2926H42.1712C42.1087 46.2507 42.0565 46.1952 42.0188 46.1302C41.9811 46.0652 41.9587 45.9924 41.9534 45.9175C41.9692 45.8087 42.0258 45.71 42.1118 45.6411C42.1488 45.6168 42.1906 45.6005 42.2344 45.5933C42.2782 45.5861 42.323 45.5882 42.3659 45.5994C42.4088 45.6105 42.4489 45.6306 42.4836 45.6582C42.5182 45.6858 42.5467 45.7203 42.5671 45.7596C42.5816 45.7797 42.5894 45.8039 42.5894 45.8287C42.5894 45.8535 42.5816 45.8776 42.5671 45.8978C42.5524 45.9544 42.5171 46.0037 42.4681 46.0359C42.4681 46.0359 42.3296 46.0359 42.3098 46.0359C42.29 46.0359 42.3098 45.7793 42.3098 45.7596C42.3098 45.7596 42.3098 45.957 42.3098 45.9767H42.4285C42.4285 45.9767 42.4285 45.9767 42.4285 45.878C42.4373 45.8595 42.4419 45.8393 42.4419 45.8188C42.4419 45.7983 42.4373 45.7781 42.4285 45.7596C42.4285 45.6411 42.2306 45.5819 42.0326 45.7596C41.9945 45.786 41.9637 45.8215 41.9429 45.8629C41.9222 45.9043 41.9122 45.9502 41.9138 45.9965C41.9061 46.0638 41.9189 46.1319 41.9507 46.1918C41.9825 46.2517 42.0318 46.3006 42.092 46.3321C42.1476 46.3694 42.213 46.3893 42.2801 46.3893C42.3471 46.3893 42.4126 46.3694 42.4681 46.3321C42.569 46.2705 42.6445 46.1749 42.6808 46.0626C42.7171 45.9504 42.7119 45.8289 42.6661 45.7201C42.6059 45.5957 42.5026 45.4972 42.3752 45.4428C42.2479 45.3884 42.1051 45.3817 41.9732 45.424C42.113 45.3809 42.2637 45.3891 42.398 45.447C42.5323 45.5049 42.6414 45.6088 42.7057 45.7398C42.7576 45.859 42.7642 45.9929 42.7241 46.1165C42.684 46.2401 42.6 46.3448 42.4879 46.411C42.4267 46.3842 42.3725 46.3437 42.3296 46.2926Z",
    fill: "#0F0F0E"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M42.765 45.2278C42.7263 45.2103 42.6931 45.1827 42.6687 45.1479C42.6443 45.1131 42.6297 45.0724 42.6265 45.0301C42.6287 44.9976 42.6388 44.9662 42.6561 44.9386C42.6734 44.911 42.6972 44.8881 42.7254 44.8719C42.7555 44.8545 42.7897 44.8454 42.8244 44.8454C42.8592 44.8454 42.8933 44.8545 42.9234 44.8719C42.9327 44.8938 42.9374 44.9173 42.9374 44.9411C42.9374 44.9649 42.9327 44.9884 42.9234 45.0103C42.9234 45.0103 42.9234 45.0103 42.9234 44.9114C42.9234 44.8126 42.9234 44.9114 42.765 44.9114C42.6067 44.9114 42.765 44.9114 42.765 45.0499C42.7672 45.0823 42.7774 45.1138 42.7947 45.1414C42.8119 45.169 42.8358 45.1919 42.864 45.2081C42.8951 45.2223 42.9288 45.2296 42.963 45.2296C42.9972 45.2296 43.0309 45.2223 43.062 45.2081C43.1215 45.1586 43.166 45.0935 43.1905 45.0201C43.215 44.9468 43.2185 44.868 43.2006 44.7928C43.19 44.7481 43.1685 44.7067 43.1379 44.6724C43.1074 44.6381 43.0688 44.6119 43.0256 44.5963C42.9824 44.5806 42.9359 44.5759 42.8904 44.5825C42.845 44.5892 42.8019 44.6071 42.765 44.6346C42.4087 44.6346 42.2899 45.0894 42.2899 45.0894C42.2899 45.0894 42.4087 44.6148 42.8046 44.6148C42.8772 44.6067 42.9504 44.624 43.0117 44.6636C43.0731 44.7033 43.1188 44.7629 43.1412 44.8323C43.1686 44.915 43.1679 45.0044 43.1393 45.0866C43.1106 45.1688 43.0556 45.2393 42.9828 45.2872C42.9445 45.2981 42.904 45.2983 42.8656 45.2879C42.8272 45.2774 42.7924 45.2567 42.765 45.2278Z",
    fill: "#0F0F0E"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M42.3889 46.8664C42.2899 46.8664 42.2108 46.6885 42.2702 46.4314C42.2708 46.3935 42.2823 46.3565 42.3034 46.325C42.3244 46.2934 42.3541 46.2686 42.3889 46.2534C42.3609 46.2647 42.3368 46.2837 42.3192 46.3082C42.3017 46.3327 42.2915 46.3617 42.2899 46.3918C42.2899 46.5896 42.2899 46.728 42.3889 46.7676C42.4879 46.8071 42.4879 46.7676 42.5473 46.7676H42.3691C42.3691 46.7676 42.5473 46.7676 42.5869 46.7676C42.6265 46.7676 42.5869 46.7676 42.5869 46.8862C42.5566 46.906 42.5204 46.9149 42.4844 46.9113C42.4484 46.9077 42.4147 46.8918 42.3889 46.8664Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8346 48.0099C41.696 47.5756 42.3295 47.1216 42.3493 47.1216C42.4908 47.2257 42.6082 47.3588 42.6936 47.5121C42.7789 47.6654 42.8303 47.8351 42.8442 48.0099C42.8367 47.8358 42.7901 47.6656 42.7079 47.5119C42.6256 47.3582 42.5099 47.2248 42.3691 47.1216C42.3691 47.1216 41.7356 47.5953 41.8742 48.0099H41.8346Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9732 48.0112C41.8742 47.6948 42.3295 47.3784 42.3295 47.3784C42.4327 47.4488 42.5172 47.5432 42.5758 47.6534C42.6345 47.7636 42.6654 47.8864 42.6661 48.0112C42.6595 47.8876 42.6259 47.767 42.5678 47.6577C42.5097 47.5484 42.4283 47.4531 42.3295 47.3784C42.3295 47.3784 41.8742 47.7146 41.9732 48.0112Z",
    fill: "#0F0F0E"
  }))), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M46.566 46.6082C46.566 47.6545 46.1503 48.4836 45.6553 48.4836C45.1604 48.4836 45.101 48.1875 44.9427 47.7137C44.9228 47.6494 44.9228 47.5806 44.9427 47.5163C44.8316 47.2252 44.7648 46.9191 44.7447 46.6082C44.7232 46.3455 44.7232 46.0814 44.7447 45.8186C44.7843 45.7021 44.8174 45.5835 44.8437 45.4633C45.0219 45.029 45.2792 44.7329 45.5564 44.7329C45.8335 44.7329 46.566 45.6212 46.566 46.6082Z",
    fill: "url(#paint12_linear_336_14486)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M46.3879 49.4128C46.2295 48.8987 45.9523 48.5625 45.6356 48.5625C45.3188 48.5625 45.0417 48.8987 44.8833 49.4128H46.3879Z",
    fill: "url(#paint13_linear_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6751 45.9372C45.6634 46.1188 45.6154 46.2962 45.5338 46.4589C45.4521 46.6217 45.3387 46.7665 45.2 46.8848C45.0731 46.9811 44.9813 47.1162 44.9384 47.2694C44.8955 47.4226 44.904 47.5856 44.9625 47.7336C44.9426 47.6693 44.9426 47.6005 44.9625 47.5362C44.9539 47.4058 44.9763 47.2753 45.0279 47.1552C45.0795 47.0352 45.1588 46.929 45.2594 46.8453C45.5258 46.6063 45.689 46.2738 45.7147 45.9175C45.7365 45.8182 45.7227 45.7144 45.6757 45.6243C45.6287 45.5341 45.5514 45.4632 45.4574 45.424C45.3775 45.398 45.2913 45.3995 45.2123 45.4281C45.1334 45.4567 45.0663 45.5109 45.0219 45.5819C44.9678 45.6719 44.9501 45.779 44.9721 45.8816C44.9942 45.9842 45.0544 46.0746 45.1406 46.1346C45.161 46.1561 45.1855 46.1733 45.2128 46.185C45.24 46.1967 45.2694 46.2027 45.299 46.2027C45.3287 46.2027 45.358 46.1967 45.3852 46.185C45.4125 46.1733 45.437 46.1561 45.4574 46.1346C45.4838 46.0934 45.4979 46.0454 45.4979 45.9964C45.4979 45.9475 45.4838 45.8995 45.4574 45.8583C45.4574 45.8583 45.3386 45.7596 45.299 45.8583C45.299 45.8583 45.299 45.8583 45.398 45.7596C45.4384 45.7609 45.4777 45.7725 45.5124 45.7932C45.547 45.8139 45.5758 45.8431 45.596 45.878C45.6283 45.9243 45.6457 45.9795 45.6457 46.0359C45.6457 46.0924 45.6283 46.1475 45.596 46.1938C45.5737 46.2191 45.5462 46.2392 45.5155 46.2531C45.4848 46.2669 45.4515 46.274 45.4178 46.274C45.3841 46.274 45.3508 46.2669 45.32 46.2531C45.2893 46.2392 45.2619 46.2191 45.2396 46.1938C45.1348 46.1184 45.0637 46.005 45.0417 45.878C45.0813 45.7615 45.1143 45.6429 45.1406 45.5227C45.1941 45.4632 45.2636 45.4204 45.3409 45.3994C45.4181 45.3784 45.4998 45.38 45.5762 45.4042C45.6454 45.4723 45.692 45.5599 45.7097 45.6552C45.7274 45.7505 45.7153 45.849 45.6751 45.9372Z",
    fill: "#0F0F0E"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6553 47.6941C45.5973 47.7123 45.5351 47.7123 45.4771 47.6941C45.416 47.6523 45.3661 47.5964 45.3316 47.531C45.2971 47.4656 45.2791 47.3929 45.2792 47.319C45.2751 47.2651 45.2882 47.2112 45.3166 47.1651C45.3451 47.119 45.3874 47.083 45.4376 47.0624C45.5116 47.0171 45.6003 47.0021 45.6851 47.0205C45.77 47.0389 45.8444 47.0892 45.8929 47.1611C45.9128 47.2119 45.9128 47.2682 45.8929 47.319L45.7741 47.4375C45.7523 47.4569 45.7241 47.4676 45.6949 47.4676C45.6657 47.4676 45.6375 47.4569 45.6157 47.4375C45.6157 47.4375 45.6157 47.2006 45.6157 47.1808C45.6157 47.1808 45.6157 47.3782 45.6157 47.4177C45.6157 47.4572 45.6157 47.4177 45.7147 47.4177C45.7377 47.4099 45.7586 47.397 45.7757 47.3799C45.7929 47.3627 45.8059 47.3419 45.8137 47.319C45.823 47.2801 45.823 47.2395 45.8137 47.2006C45.77 47.1402 45.7062 47.0972 45.6338 47.0792C45.5613 47.0611 45.4848 47.0691 45.4178 47.1019C45.3746 47.1242 45.3386 47.1584 45.3141 47.2003C45.2895 47.2422 45.2774 47.2902 45.2792 47.3388C45.2782 47.4074 45.2962 47.475 45.3311 47.5342C45.366 47.5933 45.4165 47.6418 45.4771 47.6743C45.5327 47.7117 45.5982 47.7316 45.6652 47.7316C45.7322 47.7316 45.7977 47.7117 45.8533 47.6743C45.9542 47.6128 46.0296 47.5172 46.0659 47.4049C46.1023 47.2927 46.097 47.1711 46.0513 47.0624C45.988 46.9407 45.8843 46.8447 45.758 46.7907C45.6316 46.7367 45.4904 46.7281 45.3584 46.7663C45.501 46.7221 45.6547 46.7295 45.7923 46.7873C45.93 46.8451 46.0427 46.9495 46.1106 47.0821C46.1585 47.2018 46.1629 47.3343 46.1231 47.4569C46.0833 47.5794 46.0019 47.6843 45.8929 47.7533C45.8099 47.7546 45.728 47.7342 45.6553 47.6941Z",
    fill: "#0F0F0E"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M46.0711 46.6094H45.9721C45.9382 46.588 45.9099 46.559 45.8892 46.5246C45.8686 46.4903 45.8563 46.4516 45.8533 46.4117C45.8555 46.3792 45.8657 46.3478 45.8829 46.3202C45.9002 46.2926 45.924 46.2697 45.9523 46.2535C45.9836 46.2404 46.0173 46.2337 46.0513 46.2337C46.0852 46.2337 46.1189 46.2404 46.1502 46.2535C46.1502 46.2535 46.1502 46.3919 46.2492 46.3919C46.2492 46.3919 46.2492 46.3919 46.2492 46.293C46.2246 46.2808 46.1975 46.2745 46.17 46.2745C46.1426 46.2745 46.1155 46.2808 46.0909 46.293C46.0804 46.3111 46.0749 46.3315 46.0749 46.3524C46.0749 46.3732 46.0804 46.3937 46.0909 46.4117C46.093 46.4442 46.1032 46.4756 46.1205 46.5032C46.1378 46.5308 46.1616 46.5537 46.1898 46.5699C46.2229 46.589 46.2605 46.599 46.2987 46.599C46.3369 46.599 46.3745 46.589 46.4076 46.5699C46.4691 46.522 46.515 46.457 46.5397 46.3832C46.5643 46.3093 46.5666 46.2298 46.5462 46.1546C46.5248 46.094 46.4843 46.0419 46.4308 46.0062C46.3772 45.9705 46.3135 45.9532 46.2492 45.9569C45.8731 45.9569 45.7741 46.4117 45.7741 46.4117C45.7741 46.4117 45.9127 45.9173 46.3086 45.9173C46.3831 45.914 46.4566 45.9356 46.5175 45.9785C46.5784 46.0215 46.6233 46.0834 46.6452 46.1546C46.664 46.2376 46.6592 46.3243 46.6312 46.4047C46.6032 46.4851 46.5532 46.556 46.4868 46.6094H46.0711Z",
    fill: "#0F0F0E"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M45.695 48.2873C45.695 48.2873 45.5366 48.1094 45.5762 47.8721C45.5742 47.8284 45.5867 47.7854 45.6118 47.7496C45.6368 47.7138 45.673 47.6874 45.7148 47.6743C45.7003 47.6945 45.6925 47.7187 45.6925 47.7435C45.6925 47.7684 45.7003 47.7926 45.7148 47.8127C45.7148 48.0303 45.7148 48.1489 45.7148 48.1885C45.738 48.2046 45.7656 48.2133 45.7939 48.2133C45.8223 48.2133 45.8499 48.2046 45.8731 48.1885C45.8731 48.1885 45.7741 48.1885 45.7148 48.1885C45.7148 48.1885 45.8929 48.1885 45.9325 48.1885V48.3071C45.8961 48.33 45.8533 48.3405 45.8104 48.3369C45.7676 48.3334 45.727 48.316 45.695 48.2873Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M45.1604 49.4118C45.0218 48.9775 45.6553 48.5234 45.6553 48.5234C45.7961 48.6266 45.9119 48.76 45.9941 48.9138C46.0764 49.0675 46.1229 49.2377 46.1305 49.4118C46.1206 49.236 46.071 49.0648 45.9853 48.9109C45.8996 48.7571 45.78 48.6246 45.6355 48.5234C45.6355 48.5234 45.0218 48.9972 45.1406 49.4118H45.1604Z",
    fill: "#0F0F0E"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M45.299 49.4125C45.2 49.1159 45.6553 48.7797 45.6553 48.7797C45.7622 48.8479 45.8506 48.9413 45.9127 49.0516C45.9749 49.162 46.0088 49.2859 46.0117 49.4125C46.0117 49.0764 45.7147 48.8193 45.6751 48.7797C45.6355 48.7402 45.2396 49.1159 45.3188 49.4125H45.299Z",
    fill: "#0F0F0E"
  }))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8255 23.9072H30.59C27.7801 23.9072 25.5023 26.1786 25.5023 28.9805V38.4361C25.5023 41.2379 27.7801 43.5093 30.59 43.5093H38.8255C41.6354 43.5093 43.9132 41.2379 43.9132 38.4361V28.9805C43.9132 26.1786 41.6354 23.9072 38.8255 23.9072Z",
    fill: "url(#paint14_radial_336_14486)"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2315 24.6377H31.2037C28.4375 24.6377 26.1951 26.8737 26.1951 29.632V37.8044C26.1951 40.5627 28.4375 42.7987 31.2037 42.7987H38.2315C40.9977 42.7987 43.2401 40.5627 43.2401 37.8044V29.632C43.2401 26.8737 40.9977 24.6377 38.2315 24.6377Z",
    fill: "url(#paint15_radial_336_14486)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M38.192 25.1509H31.3225C28.6876 25.1509 26.5515 27.2808 26.5515 29.9083V37.6465C26.5515 40.2739 28.6876 42.4039 31.3225 42.4039H38.192C40.827 42.4039 42.963 40.2739 42.963 37.6465V29.9083C42.963 27.2808 40.827 25.1509 38.192 25.1509Z",
    fill: "url(#paint16_linear_336_14486)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M25.4627 23.6899C26.235 25.3945 27.3541 26.9204 28.7489 28.171C28.4176 29.2438 28.2769 30.3662 28.3332 31.4873C28.3332 31.4873 28.3332 31.8427 27.6403 30.9149C26.2859 29.333 25.2688 27.4927 24.651 25.506C24.651 25.506 24.3936 25.7824 24.1561 24.677C24.1561 24.677 25.1855 24.3216 25.4627 23.6899Z",
    fill: "url(#paint17_radial_336_14486)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6408 24.0651C25.6408 24.0651 25.3835 24.7757 24.1561 24.677C24.1561 24.677 23.483 24.2822 23.6018 23.8874C23.6503 23.8498 23.6907 23.8028 23.7205 23.7492C23.7205 23.2755 24.3144 23.2162 24.3738 23.0386C24.3738 23.0386 24.2155 22.6043 24.3738 22.3477C24.1676 22.0415 23.9887 21.7178 23.8393 21.3804C23.8107 21.2972 23.8107 21.2069 23.8393 21.1238C23.9581 20.7487 24.2155 21.1238 24.4332 21.4001C24.651 21.6765 24.849 21.7555 25.1063 22.17C25.3597 22.7782 25.5391 23.4144 25.6408 24.0651Z",
    fill: "url(#paint18_radial_336_14486)"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5125 22.624L24.6312 22.7822L24.7302 22.9602C24.7882 23.0808 24.8346 23.2066 24.8688 23.3359V23.1579V22.98C24.8284 22.925 24.7952 22.8652 24.7698 22.802L24.6708 22.624H24.5125Z",
    fill: "#070707"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9479 23.3149C24.9479 23.5127 24.9479 23.5127 24.9479 23.7104L24.8292 24.0862V23.9082C24.8181 23.8427 24.8181 23.7759 24.8292 23.7104C24.8185 23.645 24.8185 23.5782 24.8292 23.5127V23.3149H24.9479Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M24.948 23.2954C24.9562 23.3677 24.9562 23.4407 24.948 23.5129C24.9273 23.4416 24.8937 23.3746 24.849 23.3152C24.849 23.3152 24.849 23.3152 24.849 23.2163L24.948 23.2954Z",
    fill: "#070707"
  }))), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4729 21.4009V21.5195C24.4729 21.5195 24.2353 21.1438 24.2947 21.0647C24.3541 20.9856 24.4729 21.4009 24.4729 21.4009Z",
    fill: "url(#paint19_radial_336_14486)"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2749 25.0519C24.2186 25.0474 24.1658 25.0231 24.1259 24.9833C24.086 24.9435 24.0616 24.8908 24.0571 24.8348C24.0571 24.7772 24.0801 24.7219 24.1209 24.6812C24.1617 24.6405 24.2171 24.6176 24.2749 24.6176C24.7501 24.5912 25.1999 24.395 25.5419 24.0649C25.5605 24.0439 25.5833 24.0271 25.6089 24.0155C25.6345 24.004 25.6623 23.998 25.6904 23.998C25.7184 23.998 25.7462 24.004 25.7718 24.0155C25.7974 24.0271 25.8203 24.0439 25.8388 24.0649C25.8726 24.1069 25.8909 24.1591 25.8909 24.2129C25.8909 24.2668 25.8726 24.319 25.8388 24.361C25.4241 24.7976 24.8573 25.059 24.2551 25.0914L24.2749 25.0519Z",
    fill: "url(#paint20_radial_336_14486)"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6906 25.6837H24.354C24.3252 25.679 24.2977 25.6685 24.273 25.6529C24.2483 25.6374 24.227 25.617 24.2104 25.5931C24.1938 25.5691 24.1822 25.5421 24.1762 25.5136C24.1703 25.4851 24.1702 25.4556 24.1759 25.4271C24.1937 25.3751 24.2292 25.3309 24.2761 25.3021C24.3231 25.2732 24.3786 25.2616 24.4332 25.2692C24.6852 25.3151 24.945 25.2895 25.183 25.1952C25.421 25.101 25.6277 24.9419 25.7794 24.7362C25.8109 24.6864 25.8609 24.6512 25.9185 24.6383C25.976 24.6253 26.0364 24.6357 26.0863 24.6671C26.1361 24.6985 26.1715 24.7484 26.1845 24.8058C26.1975 24.8631 26.1871 24.9233 26.1556 24.9731C25.9944 25.2083 25.7745 25.3975 25.5176 25.5222C25.2607 25.6468 24.9757 25.7025 24.6906 25.6837Z",
    fill: "url(#paint21_radial_336_14486)"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6198 25.9894L24.2037 26.0977L25.5459 18.8974L24.962 18.7891L23.6198 25.9894Z",
    fill: "url(#paint22_linear_336_14486)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0249 19.0573L25.0176 19.0962L25.4653 19.1792L25.4726 19.1403L25.0249 19.0573Z",
    fill: "#B3B3B3"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9949 19.2272L24.9876 19.2661L25.4353 19.3491L25.4425 19.3102L24.9949 19.2272Z",
    fill: "#B3B3B3"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9684 19.3976L24.9612 19.4365L25.4089 19.5195L25.4161 19.4806L24.9684 19.3976Z",
    fill: "#B3B3B3"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9189 19.5641L24.9117 19.603L25.3594 19.686L25.3666 19.6471L24.9189 19.5641Z",
    fill: "#B3B3B3"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8925 19.7346L24.8853 19.7734L25.3329 19.8564L25.3402 19.8175L24.8925 19.7346Z",
    fill: "#B3B3B3"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8625 19.924L24.8552 19.9629L25.3029 20.0459L25.3102 20.007L24.8625 19.924Z",
    fill: "#B3B3B3"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M24.8324 20.0939L24.8252 20.1328L25.2729 20.2158L25.2801 20.1769L24.8324 20.0939Z",
    fill: "#B3B3B3"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7865 20.2409L24.7793 20.2798L25.227 20.3628L25.2342 20.3239L24.7865 20.2409Z",
    fill: "#B3B3B3"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7764 20.4308L24.7691 20.4697L25.2168 20.5527L25.224 20.5138L24.7764 20.4308Z",
    fill: "#B3B3B3"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7463 20.6203L24.7391 20.6592L25.1868 20.7422L25.194 20.7033L24.7463 20.6203Z",
    fill: "#B3B3B3"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M24.7004 20.7673L24.6932 20.8062L25.1409 20.8891L25.1481 20.8502L24.7004 20.7673Z",
    fill: "#B3B3B3"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6704 20.9572L24.6631 20.9961L25.1108 21.0791L25.1181 21.0402L24.6704 20.9572Z",
    fill: "#B3B3B3"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6393 21.1027L24.6321 21.1416L25.0798 21.2245L25.087 21.1856L24.6393 21.1027Z",
    fill: "#B3B3B3"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5945 21.2941L24.5872 21.333L25.0349 21.416L25.0422 21.3771L24.5945 21.2941Z",
    fill: "#B3B3B3"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5644 21.464L24.5572 21.5029L25.0049 21.5859L25.0121 21.547L24.5644 21.464Z",
    fill: "#B3B3B3"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M24.538 21.6345L24.5308 21.6733L24.9784 21.7563L24.9857 21.7174L24.538 21.6345Z",
    fill: "#B3B3B3"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5278 21.8044L24.5206 21.8433L24.9683 21.9262L24.9755 21.8874L24.5278 21.8044Z",
    fill: "#B3B3B3"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4819 21.9709L24.4747 22.0098L24.9224 22.0927L24.9296 22.0539L24.4819 21.9709Z",
    fill: "#B3B3B3"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4519 22.1408L24.4446 22.1797L24.8923 22.2627L24.8996 22.2238L24.4519 22.1408Z",
    fill: "#B3B3B3"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4219 22.3307L24.4146 22.3696L24.8623 22.4526L24.8695 22.4137L24.4219 22.3307Z",
    fill: "#B3B3B3"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M24.376 22.4777L24.3687 22.5166L24.8164 22.5996L24.8236 22.5607L24.376 22.4777Z",
    fill: "#B3B3B3"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3459 22.6672L24.3387 22.7061L24.7864 22.789L24.7936 22.7502L24.3459 22.6672Z",
    fill: "#B3B3B3"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M24.3159 22.8371L24.3087 22.876L24.7563 22.959L24.7636 22.9201L24.3159 22.8371Z",
    fill: "#B3B3B3"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2898 23.0041L24.2826 23.043L24.7303 23.1259L24.7375 23.0871L24.2898 23.0041Z",
    fill: "#B3B3B3"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2598 23.174L24.2526 23.2129L24.7002 23.2959L24.7075 23.257L24.2598 23.174Z",
    fill: "#B3B3B3"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2334 23.3444L24.2261 23.3833L24.6738 23.4663L24.6811 23.4274L24.2334 23.3444Z",
    fill: "#B3B3B3"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1839 23.5109L24.1766 23.5498L24.6243 23.6328L24.6316 23.5939L24.1839 23.5109Z",
    fill: "#B3B3B3"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9851 23.7262L23.9779 23.7651L24.4258 23.8472L24.4329 23.8083L23.9851 23.7262Z",
    fill: "#B3B3B3"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1274 23.8508L24.1202 23.8896L24.5679 23.9726L24.5751 23.9337L24.1274 23.8508Z",
    fill: "#B3B3B3"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0974 24.0407L24.0901 24.0796L24.5378 24.1626L24.5451 24.1237L24.0974 24.0407Z",
    fill: "#B3B3B3"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0515 24.1877L24.0443 24.2266L24.4919 24.3095L24.4992 24.2707L24.0515 24.1877Z",
    fill: "#B3B3B3"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0413 24.3776L24.0341 24.4165L24.4817 24.4995L24.489 24.4606L24.0413 24.3776Z",
    fill: "#B3B3B3"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0112 24.5475L24.004 24.5864L24.4517 24.6694L24.4589 24.6305L24.0112 24.5475Z",
    fill: "#B3B3B3"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7938 24.7365L23.7867 24.7754L24.2345 24.8574L24.2417 24.8185L23.7938 24.7365Z",
    fill: "#B3B3B3"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7634 24.9255L23.7562 24.9644L24.2041 25.0464L24.2113 25.0075L23.7634 24.9255Z",
    fill: "#B3B3B3"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9053 25.0739L23.8981 25.1128L24.3458 25.1958L24.353 25.1569L23.9053 25.0739Z",
    fill: "#B3B3B3"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8594 25.2404L23.8522 25.2793L24.2999 25.3623L24.3071 25.3234L23.8594 25.2404Z",
    fill: "#B3B3B3"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8294 25.4103L23.8221 25.4492L24.2698 25.5322L24.2771 25.4933L23.8294 25.4103Z",
    fill: "#B3B3B3"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6489 25.6003L23.6418 25.6392L24.0896 25.7212L24.0968 25.6823L23.6489 25.6003Z",
    fill: "#B3B3B3"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7927 25.7507L23.7855 25.7896L24.2331 25.8725L24.2404 25.8336L23.7927 25.7507Z",
    fill: "#B3B3B3"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M24.651 23.5716C24.651 23.8875 24.2551 23.848 24.2551 23.848C24.2535 23.8781 24.245 23.9074 24.2303 23.9337C24.2155 23.96 24.1949 23.9826 24.1701 23.9997C24.1453 24.0169 24.1168 24.0281 24.0869 24.0326C24.0571 24.0371 24.0266 24.0347 23.9977 24.0256C23.9977 24.0256 23.9977 24.0256 23.9977 24.1441C23.9587 24.1912 23.9118 24.2313 23.8592 24.2625H23.7602C23.5027 24.0411 23.3225 23.7439 23.2455 23.4137C23.0871 22.8412 23.4434 22.8807 23.4434 22.8807C23.4434 22.4662 23.7008 22.4267 23.7008 22.4267C23.7008 21.9529 24.1363 22.1306 24.1363 22.1306C24.1302 22.0733 24.1398 22.0155 24.1642 21.9633C24.1887 21.9111 24.2269 21.8665 24.2749 21.8345C24.6906 22.5846 25.0272 23.1373 25.0272 23.1373C24.948 23.4334 24.948 23.5716 24.651 23.5716Z",
    fill: "url(#paint23_radial_336_14486)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M24.5125 23.2163C24.5125 23.2163 24.5125 23.4338 24.6312 23.4338C24.75 23.4338 24.849 23.4338 24.8292 23.2954C24.7908 23.2192 24.7368 23.1518 24.6708 23.0977C24.6369 23.1035 24.6049 23.1173 24.5774 23.138C24.5498 23.1586 24.5276 23.1854 24.5125 23.2163Z",
    fill: "url(#paint24_radial_336_14486)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1363 23.4929C24.1363 23.4929 24.1363 23.7104 24.2551 23.7104C24.3739 23.7104 24.4728 23.7104 24.453 23.572C24.4332 23.4336 24.2749 23.394 24.2749 23.394C24.2447 23.3956 24.2157 23.4058 24.1911 23.4233C24.1666 23.4408 24.1476 23.465 24.1363 23.4929Z",
    fill: "url(#paint25_radial_336_14486)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M23.78 23.7888C23.78 23.7888 23.8987 24.0063 23.9383 23.9866C23.9779 23.9668 24.1561 23.9866 24.1165 23.8086C24.0579 23.7473 23.9913 23.6941 23.9185 23.6504C23.9185 23.6504 23.7998 23.6899 23.78 23.7888Z",
    fill: "url(#paint26_radial_336_14486)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5028 23.9863C23.5028 23.9863 23.6216 24.2039 23.6612 24.2039C23.7008 24.2039 23.8789 24.0852 23.8394 24.0259C23.7807 23.9645 23.7142 23.9113 23.6414 23.8677C23.6414 23.8677 23.5226 23.9072 23.5028 23.9863Z",
    fill: "url(#paint27_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9978 22.1108C23.989 22.1764 23.989 22.2427 23.9978 22.3082C23.9978 22.3082 23.9978 22.4267 23.9978 22.5056C24.0283 22.6333 24.068 22.7587 24.1165 22.8807L24.2947 23.236C24.3558 23.3488 24.4288 23.4546 24.5125 23.5519C24.416 23.4557 24.3298 23.3499 24.2551 23.236L24.1363 22.9202C24.0917 22.7985 24.0585 22.673 24.0373 22.5451C24.0373 22.5451 24.0373 22.4069 24.0373 22.3477V22.1503L23.9978 22.1108Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1957 23.8675C24.1061 23.7704 24.0265 23.6646 23.9581 23.5517C23.8832 23.4416 23.8233 23.3221 23.7799 23.1963C23.725 23.068 23.6787 22.9361 23.6414 22.8015C23.6206 22.6708 23.6206 22.5375 23.6414 22.4067C23.6302 22.5381 23.6302 22.6702 23.6414 22.8015C23.6756 22.9307 23.722 23.0562 23.7799 23.1766L23.9779 23.5319L24.1759 23.8675H24.1957Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9185 24.0455C23.8206 23.9879 23.7388 23.9064 23.681 23.8087C23.6037 23.7293 23.5431 23.6353 23.5028 23.5323V23.3744C23.496 23.3219 23.496 23.2689 23.5028 23.2164C23.495 23.1047 23.495 22.9926 23.5028 22.8809C23.4938 22.9859 23.4938 23.0916 23.5028 23.1967C23.4916 23.2487 23.4916 23.3026 23.5028 23.3546C23.5099 23.407 23.5099 23.4601 23.5028 23.5125L23.681 23.7889L23.8987 24.0455H23.9185Z",
    fill: "#070707"
  }))), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M40.6665 28.842C40.1122 28.1116 38.8056 26.6903 38.093 26.5916C37.3803 26.4929 35.1037 25.9797 34.391 25.8218H34.1732C33.4605 25.9797 31.0849 26.5127 30.4712 26.5916C29.8575 26.6706 28.4916 28.1116 27.8977 28.842C27.3037 29.5724 27.5413 32.3755 27.5413 32.3755L28.2144 34.3496H29.3824C29.6506 33.4402 29.8361 32.5087 29.9367 31.5662C29.9769 32.05 30.148 32.5139 30.4316 32.9085C30.6663 33.4515 30.7689 34.0422 30.7311 34.6322C30.6932 35.2223 30.516 35.7951 30.2139 36.3039C30.788 37.4291 33.6981 37.4093 34.292 37.4093C34.8859 37.4093 37.7762 37.4093 38.3503 36.3039C38.0482 35.7951 37.871 35.2223 37.8331 34.6322C37.7953 34.0422 37.8979 33.4515 38.1326 32.9085C38.4162 32.5139 38.5873 32.05 38.6275 31.5662C38.7143 32.2413 38.8804 32.9038 39.1224 33.5402L40.3498 34.3496L41.0229 32.3755C41.0229 32.3755 41.2209 29.4737 40.6665 28.842Z",
    fill: "url(#paint28_radial_336_14486)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M38.3305 36.3041C38.4749 34.7883 39.1807 33.3807 40.3102 32.3561C40.6404 31.9431 40.8841 31.4682 41.0269 30.9596C41.1697 30.451 41.2088 29.9189 41.1417 29.395C41.202 29.9277 41.1561 30.4671 41.0066 30.982C40.8571 31.4969 40.607 31.9773 40.2706 32.3955C39.1741 33.3878 38.4715 34.7399 38.291 36.2054L38.3305 36.3041Z",
    fill: "#FC0606"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M38.5088 36.0474C38.5088 36.0474 38.4098 34.9419 40.9438 33.4614C38.4296 34.9222 38.5286 35.9882 38.5286 35.9882L38.5088 36.0474Z",
    fill: "#FC0606"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4493 36.3042C38.9401 35.5156 39.6674 34.9009 40.528 34.5474C39.6645 34.8962 38.9359 35.512 38.4493 36.3042Z",
    fill: "#FC0606"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1122 35.6345C40.6416 35.5179 41.1119 35.2163 41.4386 34.7842C41.1073 35.2113 40.639 35.5116 40.1122 35.6345Z",
    fill: "#FC0606"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M36.826 26.1577C37.5219 26.2329 38.1953 26.4478 38.8057 26.7894C39.1037 26.9712 39.3823 27.1828 39.6371 27.4211L39.9737 27.8356L40.2508 28.2699C40.4131 28.5749 40.5521 28.8916 40.6666 29.2175C40.7915 29.5351 40.8778 29.8664 40.9239 30.2045C40.9735 30.5515 40.9735 30.9037 40.9239 31.2507C40.8768 31.5889 40.7551 31.9125 40.5676 32.1982C40.7408 31.9074 40.8552 31.5855 40.9041 31.2507C40.9537 30.9103 40.9537 30.5646 40.9041 30.2242C40.8581 29.8797 40.7717 29.5418 40.6468 29.2175C40.5369 28.8962 40.3978 28.5856 40.231 28.2897L40.0924 28.0725V27.9738C39.9911 27.8334 39.8785 27.7014 39.7559 27.579L39.3798 27.2237C39.2422 27.1202 39.0965 27.0278 38.9442 26.9473C38.6479 26.7747 38.3365 26.6294 38.0138 26.513C37.684 26.4125 37.3462 26.3399 37.0042 26.2959L36.826 26.1577Z",
    fill: "#FC0606"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0015 43.3711V44.8714L21.8993 45.2464L21.8597 43.6277H22.117L23.3444 43.608H23.3642H24.5916H24.6114L25.819 43.5882H25.8388L27.0662 43.5685H27.086H28.2936H28.3134L29.5408 43.5488H29.5606L30.7682 43.529H30.788H32.0154H32.0352L33.2626 43.5093L34.49 43.4895H34.5098H35.7372L36.9844 43.4698L38.2118 43.4501H39.459L40.6864 43.4303H41.9336L43.161 43.4106L44.4082 43.3908H45.6356L46.8828 43.3711H47.0015Z",
    fill: "url(#paint29_linear_336_14486)"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3642 43.7263C23.3642 44.2593 22.7505 44.6936 22.7505 44.6936C22.7505 44.6936 22.117 44.2593 22.117 43.7263C22.117 43.1934 22.3942 42.7788 22.7505 42.7788C23.1068 42.7788 23.3642 43.1934 23.3642 43.7263Z",
    fill: "#FFF206"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6114 43.7263C24.6114 44.2593 23.9779 44.6936 23.9779 44.6936C23.9779 44.6936 23.3642 44.2593 23.3642 43.7263C23.3642 43.1934 23.6414 42.7788 23.9779 42.7788C24.3144 42.7788 24.6114 43.1934 24.6114 43.7263Z",
    fill: "#FFF206"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8388 43.7263C25.8388 44.2593 25.2251 44.6936 25.2251 44.6936C25.2251 44.6936 24.6114 44.2593 24.6114 43.7263C24.6114 43.1934 24.8885 42.7788 25.2251 42.7788C25.5616 42.7788 25.8388 43.1934 25.8388 43.7263Z",
    fill: "#FFF206"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M27.086 43.7263C27.086 44.2593 26.4525 44.6936 26.4525 44.6936C26.4525 44.6936 25.8388 44.2593 25.8388 43.7263C25.8388 43.1934 26.116 42.7788 26.4525 42.7788C26.789 42.7788 27.086 43.1934 27.086 43.7263Z",
    fill: "#FFF206"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3134 43.7263C28.3134 44.2593 27.6997 44.6936 27.6997 44.6936C27.6997 44.6936 27.086 44.2593 27.086 43.7263C27.086 43.1934 27.3632 42.7788 27.6997 42.7788C28.0362 42.7788 28.3134 43.1934 28.3134 43.7263Z",
    fill: "#FFF206"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5606 43.7263C29.5606 44.2593 28.9271 44.6936 28.9271 44.6936C28.9271 44.6936 28.3134 44.2593 28.3134 43.7263C28.3134 43.1934 28.5906 42.7788 28.9271 42.7788C29.2637 42.7788 29.5606 43.1934 29.5606 43.7263Z",
    fill: "#FFF206"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M30.887 43.687C30.887 44.22 30.2733 44.6345 30.2733 44.6345C30.2733 44.6345 29.6596 44.22 29.6596 43.687C29.6596 43.154 29.9368 42.7197 30.2733 42.7197C30.6099 42.7197 30.887 43.154 30.887 43.687Z",
    fill: "#FFF206"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0352 43.6474C32.0352 44.1804 31.4215 44.595 31.4215 44.595C31.4215 44.595 30.887 44.1804 30.887 43.6474C30.887 43.1145 31.1641 42.6802 31.5205 42.6802C31.8768 42.6802 32.0352 43.1145 32.0352 43.6474Z",
    fill: "#FFF206"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2626 43.6474C33.2626 44.1804 32.6489 44.595 32.6489 44.595C32.6489 44.595 32.0352 44.1804 32.0352 43.6474C32.0352 43.1145 32.3124 42.6802 32.6489 42.6802C32.9855 42.6802 33.2626 43.1145 33.2626 43.6474Z",
    fill: "#FFF206"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5098 43.6474C34.5098 44.1804 33.8961 44.595 33.8961 44.595C33.8961 44.595 33.2626 44.1804 33.2626 43.6474C33.2626 43.1145 33.5397 42.6802 33.8961 42.6802C34.2524 42.6802 34.5098 43.1145 34.5098 43.6474Z",
    fill: "#FFF206"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M35.757 43.6077C35.757 44.1209 35.1235 44.5552 35.1235 44.5552C35.1235 44.5552 34.5098 44.1209 34.5098 43.6077C34.5098 43.0944 34.8463 42.6602 35.1235 42.6602C35.4006 42.6602 35.757 43.0747 35.757 43.6077Z",
    fill: "#FFF206"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9844 43.5486C36.9844 44.0816 36.3707 44.5159 36.3707 44.5159C36.3707 44.5159 35.757 44.0816 35.757 43.5486C35.757 43.0156 36.0341 42.6011 36.3707 42.6011C36.7072 42.6011 36.9844 43.0354 36.9844 43.5486Z",
    fill: "#FFF206"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2316 43.5486C38.2316 44.0816 37.5981 44.5159 37.5981 44.5159C37.5981 44.5159 36.9844 44.0816 36.9844 43.5486C36.9844 43.0156 37.2615 42.6011 37.5981 42.6011C37.9346 42.6011 38.2316 43.0354 38.2316 43.5486Z",
    fill: "#FFF206"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M39.459 43.509C39.459 44.042 38.8453 44.4763 38.8453 44.4763C38.8453 44.4763 38.2316 44.042 38.2316 43.509C38.2316 42.976 38.5087 42.6602 38.8057 42.6602C39.1026 42.6602 39.459 42.9957 39.459 43.509Z",
    fill: "#FFF206"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7853 43.4695C40.7853 44.0025 40.1518 44.4368 40.1518 44.4368C40.1518 44.4368 39.5381 44.0025 39.5381 43.4695C39.5381 42.9365 39.8153 42.522 40.1518 42.522C40.4884 42.522 40.7853 42.9365 40.7853 43.4695Z",
    fill: "#FFF206"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9336 43.4302C41.9336 43.9632 41.3199 44.3974 41.3199 44.3974C41.3199 44.3974 40.7062 43.9632 40.7062 43.4302C40.7062 42.8972 40.9833 42.4629 41.3199 42.4629C41.6564 42.4629 41.9336 42.8972 41.9336 43.4302Z",
    fill: "#FFF206"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1808 43.4695C43.1808 44.0025 42.5671 44.4368 42.5671 44.4368C42.5671 44.4368 41.9336 44.0025 41.9336 43.4695C41.9336 42.9365 42.2107 42.522 42.5671 42.522C42.9234 42.522 43.1808 42.9365 43.1808 43.4695Z",
    fill: "#FFF206"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4082 43.4302C44.4082 43.9632 43.7945 44.3974 43.7945 44.3974C43.7945 44.3974 43.1808 43.9632 43.1808 43.4302C43.1808 42.8972 43.4579 42.4629 43.7945 42.4629C44.131 42.4629 44.4082 42.8972 44.4082 43.4302Z",
    fill: "#FFF206"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6553 43.3906C45.6553 43.9236 45.0416 44.3381 45.0416 44.3381C45.0416 44.3381 44.4081 43.9236 44.4081 43.3906C44.4081 42.8576 44.6853 42.4233 45.0416 42.4233C45.398 42.4233 45.6553 42.8576 45.6553 43.3906Z",
    fill: "#FFF206"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8827 43.3511C46.8827 43.884 46.269 44.2986 46.269 44.2986C46.269 44.2986 45.6553 43.884 45.6553 43.3511C45.6553 42.8181 45.9325 42.3838 46.269 42.3838C46.6056 42.3838 46.8827 42.8181 46.8827 43.3511Z",
    fill: "#FFF206"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M47.0015 43.6081L21.8597 43.9239L21.8201 42.6408L47.0015 42.3447V43.6081Z",
    fill: "url(#paint30_radial_336_14486)"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3642 43.7264C23.3642 44.2593 22.7505 44.6936 22.7505 44.6936C22.7505 44.6936 22.117 44.2593 22.117 43.7264C22.117 43.7264 22.117 43.7264 22.117 43.6079H23.3444L23.3642 43.7264Z",
    fill: "url(#paint31_linear_336_14486)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M24.6114 43.7264C24.6114 44.2593 23.9779 44.6936 23.9779 44.6936C23.9779 44.6936 23.3642 44.2593 23.3642 43.7264V43.6079H24.5916C24.5916 43.6079 24.6114 43.6869 24.6114 43.7264Z",
    fill: "url(#paint32_linear_336_14486)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M25.8388 43.7266C25.8388 44.2596 25.2251 44.6938 25.2251 44.6938C25.2251 44.6938 24.6114 44.2596 24.6114 43.7266V43.5884H25.8388V43.7266Z",
    fill: "url(#paint33_linear_336_14486)"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M27.086 43.7263C27.086 44.2593 26.4525 44.6936 26.4525 44.6936C26.4525 44.6936 25.8388 44.2593 25.8388 43.7263C25.8303 43.674 25.8303 43.6207 25.8388 43.5684H27.0464C27.0711 43.6175 27.0846 43.6714 27.086 43.7263Z",
    fill: "url(#paint34_linear_336_14486)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M27.6997 42.7788C27.3632 42.7788 27.086 43.1934 27.086 43.7263C27.086 44.2593 27.6997 44.6936 27.6997 44.6936C27.6997 44.6936 28.3134 44.2593 28.3134 43.7263C28.3134 43.1934 28.0362 42.7788 27.6997 42.7788Z",
    fill: "url(#paint35_linear_336_14486)"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9073 42.7788C28.5708 42.7788 28.2936 43.1934 28.2936 43.7263C28.2936 44.2593 28.9073 44.6344 28.9073 44.6344C28.9073 44.6344 29.5408 44.2001 29.5408 43.6671C29.5408 43.1341 29.2835 42.7788 28.9073 42.7788Z",
    fill: "url(#paint36_linear_336_14486)"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1743 42.6602C29.8378 42.6602 29.5606 43.0944 29.5606 43.6274C29.5606 44.1604 30.1743 44.575 30.1743 44.575C30.1743 44.575 30.788 44.1604 30.788 43.6274C30.788 43.0944 30.5109 42.6602 30.1743 42.6602Z",
    fill: "url(#paint37_linear_336_14486)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4215 42.6602C31.0652 42.6602 30.788 43.0944 30.788 43.6274C30.788 44.1604 31.4215 44.575 31.4215 44.575C31.4215 44.575 32.0352 44.1604 32.0352 43.6274C32.0352 43.0944 31.7581 42.6602 31.4215 42.6602Z",
    fill: "url(#paint38_linear_336_14486)"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6489 42.6602C32.3124 42.6602 32.0352 43.0944 32.0352 43.6274C32.0352 44.1604 32.6489 44.575 32.6489 44.575C32.6489 44.575 33.2626 44.1604 33.2626 43.6274C33.2626 43.0944 32.9855 42.6602 32.6489 42.6602Z",
    fill: "url(#paint39_linear_336_14486)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8961 42.6602C33.5397 42.6602 33.2626 43.0944 33.2626 43.6274C33.2626 44.1604 33.8961 44.575 33.8961 44.575C33.8961 44.575 34.5098 44.1604 34.5098 43.6274C34.5098 43.0944 34.2326 42.6602 33.8961 42.6602Z",
    fill: "url(#paint40_linear_336_14486)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1235 42.6602C34.7869 42.6602 34.5098 43.0944 34.5098 43.6274C34.5098 44.1604 35.1235 44.575 35.1235 44.575C35.1235 44.575 35.757 44.1407 35.757 43.6274C35.757 43.1142 35.4798 42.6602 35.1235 42.6602Z",
    fill: "url(#paint41_linear_336_14486)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3707 42.6602C36.0341 42.6602 35.757 43.0944 35.757 43.6077C35.757 44.1209 36.3707 44.575 36.3707 44.575C36.3707 44.575 36.9844 44.1407 36.9844 43.6077C36.9844 43.0747 36.7072 42.6602 36.3707 42.6602Z",
    fill: "url(#paint42_linear_336_14486)"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5981 42.6602C37.2615 42.6602 36.9844 43.0944 36.9844 43.6077C36.9844 44.1209 37.5981 44.575 37.5981 44.575C37.5981 44.575 38.2316 44.1407 38.2316 43.6077C38.2316 43.0747 37.9544 42.6602 37.5981 42.6602Z",
    fill: "url(#paint43_linear_336_14486)"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8057 42.6602C38.4691 42.6602 38.192 43.0944 38.192 43.6077C38.192 44.1209 38.8057 44.575 38.8057 44.575C38.8057 44.575 39.4194 44.1407 39.4194 43.6077C39.4194 43.0747 39.1818 42.6602 38.8057 42.6602Z",
    fill: "url(#paint44_linear_336_14486)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M40.0727 42.522C39.7361 42.522 39.459 42.9365 39.459 43.4695C39.459 44.0025 40.0727 44.4368 40.0727 44.4368C40.0727 44.4368 40.7062 44.0025 40.7062 43.4695C40.7062 42.9365 40.429 42.522 40.0727 42.522Z",
    fill: "url(#paint45_linear_336_14486)"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9336 43.4302C41.9336 43.9632 41.3199 44.3974 41.3199 44.3974C41.3199 44.3974 40.7062 43.9632 40.7062 43.4302H41.9336Z",
    fill: "url(#paint46_linear_336_14486)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1808 43.4697C43.1808 44.0027 42.5671 44.437 42.5671 44.437C42.5671 44.437 41.9336 44.0027 41.9336 43.4697H43.1808Z",
    fill: "url(#paint47_linear_336_14486)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4082 43.4302C44.4082 43.9632 43.7945 44.3974 43.7945 44.3974C43.7945 44.3974 43.1808 43.9632 43.1808 43.4302H44.4082Z",
    fill: "url(#paint48_linear_336_14486)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6553 43.3711C45.6553 43.9041 45.0416 44.3186 45.0416 44.3186C45.0416 44.3186 44.4081 43.9041 44.4081 43.3711H45.6553Z",
    fill: "url(#paint49_linear_336_14486)"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8827 43.3711C46.8827 43.8843 46.269 44.2989 46.269 44.2989C45.9499 44.0823 45.7293 43.7489 45.6553 43.3711H46.8827Z",
    fill: "url(#paint50_linear_336_14486)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8935 38.6533L25.4825 39.1666L21.8597 42.6409L47.0015 42.3447L43.8935 38.6533Z",
    fill: "url(#paint51_radial_336_14486)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3707 14.8859C35.9269 14.5482 35.3934 14.348 34.8365 14.3099C34.2796 14.2718 33.7237 14.3976 33.2378 14.6717C32.7519 14.9458 32.3574 15.3561 32.1033 15.8518C31.8492 16.3474 31.7466 16.9065 31.8082 17.4597C31.8699 18.013 32.093 18.536 32.4501 18.9639C32.8071 19.3918 33.2823 19.7058 33.8167 19.8668C34.351 20.0279 34.9211 20.029 35.456 19.8699C35.991 19.7109 36.4674 19.3987 36.826 18.9721C37.0763 18.6788 37.2638 18.3376 37.3769 17.9693C37.49 17.6011 37.5264 17.2137 37.4837 16.8309C37.4411 16.4482 37.3203 16.0781 37.1289 15.7436C36.9375 15.4092 36.6795 15.1172 36.3707 14.8859Z",
    fill: "url(#paint52_radial_336_14486)"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M36.826 19.1105C36.8155 19.0889 36.8101 19.0653 36.8101 19.0413C36.8101 19.0173 36.8155 18.9936 36.826 18.9721C36.8587 18.9429 36.901 18.9268 36.9448 18.9268C36.9886 18.9268 37.0309 18.9429 37.0636 18.9721V19.1896C37.0636 19.1896 36.9844 19.1698 36.826 19.1105Z",
    fill: "url(#paint53_radial_336_14486)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6874 19.3278C36.667 19.3153 36.6497 19.2983 36.6368 19.2782C36.6239 19.2581 36.6157 19.2353 36.6129 19.2115C36.61 19.1877 36.6126 19.1637 36.6205 19.1411C36.6283 19.1184 36.6412 19.0979 36.6581 19.081C36.6751 19.0641 36.6956 19.0512 36.7183 19.0434C36.7409 19.0356 36.765 19.033 36.7888 19.0358C36.8126 19.0386 36.8354 19.0468 36.8556 19.0597C36.8757 19.0726 36.8927 19.0899 36.9052 19.1103C36.9341 19.1867 36.9341 19.2711 36.9052 19.3476C36.8324 19.3654 36.7558 19.3584 36.6874 19.3278Z",
    fill: "url(#paint54_radial_336_14486)"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4498 19.5254C36.4206 19.4928 36.4045 19.4506 36.4045 19.4068C36.4045 19.363 36.4206 19.3208 36.4498 19.2881C36.4852 19.2652 36.5265 19.2529 36.5686 19.2529C36.6108 19.2529 36.6521 19.2652 36.6874 19.2881V19.5254C36.6874 19.5254 36.5092 19.6045 36.4498 19.5254Z",
    fill: "url(#paint55_radial_336_14486)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1925 19.703C36.1633 19.6704 36.1472 19.6282 36.1472 19.5844C36.1472 19.5406 36.1633 19.4984 36.1925 19.4657C36.2252 19.4365 36.2675 19.4204 36.3113 19.4204C36.3551 19.4204 36.3974 19.4365 36.4301 19.4657V19.6833C36.4301 19.6833 36.2519 19.7821 36.1925 19.703Z",
    fill: "url(#paint56_radial_336_14486)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9153 19.8607C35.8896 19.8265 35.8757 19.7848 35.8757 19.742C35.8757 19.6993 35.8896 19.6576 35.9153 19.6234C35.9447 19.5956 35.9837 19.5801 36.0242 19.5801C36.0647 19.5801 36.1037 19.5956 36.1331 19.6234C36.1331 19.7223 36.1331 19.8607 36.1331 19.8607C36.1331 19.8607 35.9549 19.9398 35.9153 19.8607Z",
    fill: "url(#paint57_radial_336_14486)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6184 19.9791C35.5892 19.9465 35.5731 19.9043 35.5731 19.8605C35.5731 19.8167 35.5892 19.7745 35.6184 19.7418C35.6392 19.7359 35.661 19.7344 35.6825 19.7372C35.7039 19.7401 35.7246 19.7473 35.7431 19.7584C35.7617 19.7695 35.7777 19.7843 35.7903 19.8019C35.8029 19.8194 35.8118 19.8394 35.8164 19.8605C35.8164 19.9594 35.8164 20.078 35.8164 20.078C35.8164 20.078 35.658 20.0582 35.6184 19.9791Z",
    fill: "url(#paint58_radial_336_14486)"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3214 20.0583C35.308 20.0163 35.3107 19.9707 35.329 19.9305C35.3473 19.8903 35.3799 19.8584 35.4204 19.8408C35.4204 19.8408 35.5788 19.8408 35.6184 19.9792C35.658 20.1177 35.5194 20.1968 35.5194 20.1968C35.5194 20.1968 35.361 20.1572 35.3214 20.0583Z",
    fill: "url(#paint59_radial_336_14486)"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0245 20.1171C35.0245 20.0183 35.0245 19.9194 35.1235 19.9194C35.1447 19.9131 35.167 19.9119 35.1888 19.9159C35.2105 19.92 35.2309 19.9292 35.2483 19.9427C35.2657 19.9563 35.2797 19.9738 35.289 19.9938C35.2983 20.0138 35.3026 20.0358 35.3017 20.0578L35.2027 20.2753C35.2027 20.2753 35.0245 20.216 35.0245 20.1171Z",
    fill: "url(#paint60_radial_336_14486)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7078 20.1371C34.7014 20.1159 34.7003 20.0936 34.7043 20.0719C34.7084 20.0502 34.7176 20.0298 34.7312 20.0124C34.7447 19.995 34.7622 19.9811 34.7823 19.9718C34.8023 19.9625 34.8243 19.9582 34.8464 19.9591C34.8464 19.9591 35.0047 19.9591 35.0047 20.1173C35.0047 20.2755 34.8662 20.3151 34.8662 20.3151C34.8662 20.3151 34.7078 20.236 34.7078 20.1371Z",
    fill: "url(#paint61_radial_336_14486)"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M34.391 20.137C34.3907 20.093 34.4068 20.0505 34.436 20.0176C34.4652 19.9848 34.5056 19.9639 34.5494 19.959C34.5702 19.9614 34.5904 19.968 34.6087 19.9783C34.627 19.9886 34.6431 20.0024 34.656 20.019C34.6689 20.0355 34.6783 20.0545 34.6838 20.0748C34.6893 20.095 34.6907 20.1162 34.6879 20.137C34.6879 20.2358 34.5296 20.3149 34.5296 20.3149C34.5296 20.3149 34.391 20.2358 34.391 20.137Z",
    fill: "url(#paint62_radial_336_14486)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0743 20.0978C34.0743 19.9989 34.1732 19.9198 34.2524 19.9396C34.3316 19.9593 34.391 19.9396 34.3712 20.1373C34.3514 20.3351 34.193 20.2955 34.193 20.2955C34.193 20.2955 34.0545 20.1966 34.0743 20.0978Z",
    fill: "url(#paint63_radial_336_14486)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7773 20.0187C33.7798 19.9979 33.7863 19.9777 33.7966 19.9594C33.8069 19.9412 33.8208 19.9251 33.8374 19.9122C33.854 19.8993 33.8729 19.8899 33.8932 19.8844C33.9135 19.8789 33.9347 19.8775 33.9555 19.8803C33.9772 19.8867 33.9973 19.8978 34.0144 19.9126C34.0316 19.9275 34.0453 19.9459 34.0546 19.9665C34.064 19.9871 34.0689 20.0095 34.0688 20.0322C34.0688 20.0548 34.0639 20.0772 34.0545 20.0978L33.8763 20.2362C33.8763 20.2362 33.7575 20.1176 33.7773 20.0187Z",
    fill: "url(#paint64_radial_336_14486)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4804 19.9201C33.485 19.8989 33.4938 19.879 33.5064 19.8614C33.519 19.8439 33.5351 19.8291 33.5537 19.818C33.5722 19.8068 33.5928 19.7996 33.6143 19.7968C33.6357 19.7939 33.6575 19.7955 33.6783 19.8014C33.7062 19.8308 33.7217 19.8697 33.7217 19.9102C33.7217 19.9506 33.7062 19.9896 33.6783 20.0189C33.6783 20.1178 33.4804 20.1376 33.4804 20.1376C33.4804 20.1376 33.4408 20.0189 33.4804 19.9201Z",
    fill: "url(#paint65_radial_336_14486)"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1834 19.7814C33.1894 19.7586 33.2003 19.7374 33.2155 19.7194C33.2307 19.7014 33.2497 19.687 33.2712 19.6772C33.2927 19.6675 33.3161 19.6627 33.3396 19.6631C33.3632 19.6636 33.3864 19.6693 33.4075 19.6798C33.4286 19.6903 33.4471 19.7054 33.4616 19.724C33.4761 19.7426 33.4862 19.7642 33.4913 19.7872C33.4964 19.8102 33.4963 19.834 33.491 19.857C33.4856 19.8799 33.4753 19.9014 33.4606 19.9198H33.2428C33.2428 19.9198 33.1438 19.8803 33.1834 19.7814Z",
    fill: "url(#paint66_radial_336_14486)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8666 19.6234C32.8961 19.5956 32.935 19.5801 32.9755 19.5801C33.016 19.5801 33.055 19.5956 33.0844 19.6234C33.0844 19.6234 33.0844 19.7816 33.0844 19.8607C33.0844 19.9398 32.8666 19.8607 32.8666 19.8607C32.8666 19.8607 32.8666 19.7025 32.8666 19.6234Z",
    fill: "url(#paint67_radial_336_14486)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6687 19.4262C32.7014 19.397 32.7436 19.3809 32.7875 19.3809C32.8313 19.3809 32.8736 19.397 32.9063 19.4262C32.9063 19.4262 32.9063 19.5844 32.9063 19.6635C32.9063 19.7426 32.6885 19.6635 32.6885 19.6635C32.6885 19.6635 32.6093 19.5053 32.6687 19.4262Z",
    fill: "url(#paint68_radial_336_14486)"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4311 19.229C32.4311 19.229 32.6093 19.1301 32.6687 19.229C32.6979 19.2616 32.7141 19.3039 32.7141 19.3477C32.7141 19.3914 32.6979 19.4337 32.6687 19.4663H32.4311C32.4311 19.4663 32.3717 19.2883 32.4311 19.229Z",
    fill: "url(#paint69_radial_336_14486)"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2331 18.9724C32.2454 18.9519 32.2629 18.935 32.2837 18.9232C32.3045 18.9115 32.328 18.9053 32.3519 18.9053C32.3758 18.9053 32.3993 18.9115 32.4201 18.9232C32.441 18.935 32.4584 18.9519 32.4707 18.9724C32.4872 18.9854 32.5005 19.0019 32.5096 19.0207C32.5188 19.0396 32.5235 19.0602 32.5235 19.0812C32.5235 19.1021 32.5188 19.1228 32.5096 19.1416C32.5005 19.1605 32.4872 19.177 32.4707 19.1899H32.2331C32.2331 19.1899 32.1539 18.9724 32.2331 18.9724Z",
    fill: "url(#paint70_radial_336_14486)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M32.055 18.7352C32.0698 18.7184 32.0881 18.7049 32.1086 18.6957C32.1291 18.6864 32.1513 18.6816 32.1737 18.6816C32.1962 18.6816 32.2184 18.6864 32.2389 18.6957C32.2594 18.7049 32.2777 18.7184 32.2925 18.7352C32.3166 18.7664 32.3297 18.8046 32.3297 18.844C32.3297 18.8833 32.3166 18.9216 32.2925 18.9527H32.055C32.055 18.9527 31.9758 18.7945 32.055 18.7352Z",
    fill: "url(#paint71_radial_336_14486)"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8966 18.459C31.9309 18.4333 31.9726 18.4194 32.0154 18.4194C32.0583 18.4194 32.0999 18.4333 32.1342 18.459C32.162 18.4884 32.1776 18.5273 32.1776 18.5677C32.1776 18.6082 32.162 18.6471 32.1342 18.6765C32.0352 18.6765 31.8966 18.6765 31.8966 18.6765C31.8966 18.6765 31.8175 18.4985 31.8966 18.459Z",
    fill: "url(#paint72_radial_336_14486)"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7778 18.1629C31.8072 18.1351 31.8462 18.1196 31.8867 18.1196C31.9272 18.1196 31.9662 18.1351 31.9956 18.1629C31.9956 18.1629 31.9956 18.3211 31.9956 18.3607C31.9956 18.4002 31.758 18.3607 31.758 18.3607C31.758 18.3607 31.6788 18.2025 31.7778 18.1629Z",
    fill: "url(#paint73_radial_336_14486)"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6788 17.8668C31.7209 17.8534 31.7666 17.8561 31.8068 17.8744C31.847 17.8926 31.8791 17.9252 31.8966 17.9657C31.9 18.007 31.8904 18.0482 31.8691 18.0837C31.8477 18.1192 31.8158 18.1471 31.7778 18.1635C31.6788 18.1635 31.5601 18.0646 31.5601 18.0646C31.5601 18.0646 31.5799 17.9064 31.6788 17.8668Z",
    fill: "url(#paint74_radial_336_14486)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6195 17.5705C31.6589 17.5579 31.7016 17.5612 31.7386 17.5797C31.7756 17.5982 31.8039 17.6304 31.8174 17.6694C31.8233 17.6916 31.8242 17.7148 31.8202 17.7375C31.8161 17.7601 31.8072 17.7815 31.794 17.8004C31.7808 17.8192 31.7637 17.8349 31.7438 17.8464C31.7239 17.858 31.7018 17.865 31.6789 17.8672L31.4809 17.7485C31.4809 17.7485 31.5205 17.5903 31.6195 17.5705Z",
    fill: "url(#paint75_radial_336_14486)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5799 17.2545C31.6038 17.2456 31.6296 17.2427 31.6549 17.2459C31.6802 17.2491 31.7044 17.2584 31.7254 17.273C31.7464 17.2875 31.7635 17.3069 31.7753 17.3296C31.7872 17.3522 31.7933 17.3773 31.7933 17.4028C31.7933 17.4283 31.7872 17.4535 31.7753 17.4761C31.7635 17.4987 31.7464 17.5181 31.7254 17.5327C31.7044 17.5473 31.6802 17.5566 31.6549 17.5598C31.6296 17.563 31.6038 17.56 31.5799 17.5511C31.4809 17.5511 31.3819 17.4127 31.3819 17.4127C31.3819 17.4127 31.4809 17.2545 31.5799 17.2545Z",
    fill: "url(#paint76_radial_336_14486)"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5799 16.9981C31.6239 16.9978 31.6665 17.0138 31.6994 17.043C31.7323 17.0722 31.7532 17.1126 31.7581 17.1563C31.7556 17.1771 31.7491 17.1972 31.7388 17.2155C31.7284 17.2338 31.7146 17.2498 31.698 17.2627C31.6814 17.2756 31.6624 17.2851 31.6422 17.2906C31.6219 17.296 31.6007 17.2974 31.5799 17.2947C31.4809 17.2947 31.4017 17.1563 31.4017 17.1563C31.4017 17.1563 31.4809 16.9981 31.5799 16.9981Z",
    fill: "url(#paint77_radial_336_14486)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6195 16.623C31.7185 16.623 31.7976 16.623 31.7779 16.801C31.7581 16.979 31.6789 16.9394 31.5799 16.9197C31.4809 16.8999 31.4215 16.7615 31.4215 16.7615C31.4215 16.7615 31.5205 16.623 31.6195 16.623Z",
    fill: "url(#paint78_radial_336_14486)"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6789 16.3269C31.7778 16.3269 31.857 16.4258 31.8372 16.5049C31.8235 16.5491 31.7931 16.5862 31.7524 16.6083C31.7118 16.6305 31.6641 16.6359 31.6195 16.6236C31.5205 16.6236 31.4809 16.4258 31.4809 16.4258C31.4809 16.4258 31.5997 16.3072 31.6789 16.3269Z",
    fill: "url(#paint79_radial_336_14486)"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7778 16.0308C31.8216 16.0403 31.8601 16.0659 31.8858 16.1026C31.9115 16.1392 31.9224 16.1842 31.9164 16.2285C31.887 16.2563 31.848 16.2718 31.8075 16.2718C31.767 16.2718 31.728 16.2563 31.6986 16.2285C31.5997 16.2285 31.5601 16.0308 31.5601 16.0308C31.5601 16.0308 31.6986 15.9912 31.7778 16.0308Z",
    fill: "url(#paint80_radial_336_14486)"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9164 15.7349C31.957 15.7524 31.9896 15.7844 32.0079 15.8246C32.0262 15.8648 32.0288 15.9103 32.0154 15.9524C31.986 15.9802 31.947 15.9957 31.9065 15.9957C31.866 15.9957 31.827 15.9802 31.7976 15.9524C31.6986 15.9524 31.6788 15.7349 31.6788 15.7349C31.6788 15.7349 31.8174 15.6953 31.9164 15.7349Z",
    fill: "url(#paint81_radial_336_14486)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0748 15.478C32.1026 15.5074 32.1181 15.5463 32.1181 15.5868C32.1181 15.6273 32.1026 15.6662 32.0748 15.6956C32.0405 15.7212 31.9988 15.7351 31.956 15.7351C31.9132 15.7351 31.8715 15.7212 31.8372 15.6956V15.478C31.8372 15.478 31.9758 15.4187 32.0748 15.478Z",
    fill: "url(#paint82_radial_336_14486)"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2529 15.2217C32.277 15.2528 32.2901 15.2911 32.2901 15.3304C32.2901 15.3698 32.277 15.408 32.2529 15.4392C32.2381 15.456 32.2198 15.4695 32.1993 15.4787C32.1788 15.488 32.1566 15.4927 32.1342 15.4927C32.1117 15.4927 32.0895 15.488 32.069 15.4787C32.0485 15.4695 32.0302 15.456 32.0154 15.4392V15.2019C32.0154 15.2019 32.1738 15.1623 32.2529 15.2217Z",
    fill: "url(#paint83_radial_336_14486)"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4707 15.0239C32.4999 15.0566 32.5161 15.0988 32.5161 15.1426C32.5161 15.1864 32.4999 15.2286 32.4707 15.2612C32.438 15.2904 32.3958 15.3065 32.3519 15.3065C32.3081 15.3065 32.2658 15.2904 32.2332 15.2612V15.0239C32.2332 15.0239 32.3915 14.9053 32.4707 15.0239Z",
    fill: "url(#paint84_radial_336_14486)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6885 14.7675C32.7053 14.7823 32.7188 14.8006 32.7281 14.821C32.7373 14.8415 32.7421 14.8637 32.7421 14.8861C32.7421 14.9086 32.7373 14.9308 32.7281 14.9512C32.7188 14.9717 32.7053 14.9899 32.6885 15.0048C32.6736 15.0216 32.6553 15.0351 32.6349 15.0443C32.6144 15.0536 32.5922 15.0584 32.5697 15.0584C32.5472 15.0584 32.525 15.0536 32.5045 15.0443C32.4841 15.0351 32.4658 15.0216 32.4509 15.0048V14.7873C32.4509 14.7873 32.6291 14.6884 32.6885 14.7675Z",
    fill: "url(#paint85_radial_336_14486)"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8667 14.5898C32.8835 14.6047 32.897 14.6229 32.9063 14.6434C32.9155 14.6639 32.9203 14.686 32.9203 14.7085C32.9203 14.7309 32.9155 14.7531 32.9063 14.7736C32.897 14.794 32.8835 14.8123 32.8667 14.8271C32.8355 14.8512 32.7972 14.8642 32.7578 14.8642C32.7184 14.8642 32.6801 14.8512 32.6489 14.8271V14.5898C32.6489 14.5898 32.8667 14.5107 32.8667 14.5898Z",
    fill: "url(#paint86_radial_336_14486)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M33.223 14.4321C33.2471 14.4633 33.2602 14.5015 33.2602 14.5409C33.2602 14.5803 33.2471 14.6185 33.223 14.6497C33.1936 14.6775 33.1546 14.693 33.1141 14.693C33.0736 14.693 33.0347 14.6775 33.0052 14.6497V14.4321C33.0052 14.4321 33.1636 14.3333 33.223 14.4321Z",
    fill: "url(#paint87_radial_336_14486)"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5002 14.2937C33.5002 14.2937 33.5002 14.4915 33.5002 14.5112C33.4796 14.5207 33.4571 14.5256 33.4345 14.5256C33.4118 14.5256 33.3894 14.5208 33.3687 14.5114C33.3481 14.502 33.3297 14.4883 33.3148 14.4712C33.2999 14.4542 33.2889 14.4341 33.2824 14.4123V14.1948C33.2824 14.1948 33.4606 14.2146 33.5002 14.2937Z",
    fill: "url(#paint88_radial_336_14486)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7971 14.1953C33.8249 14.2247 33.8405 14.2636 33.8405 14.3041C33.8405 14.3445 33.8249 14.3835 33.7971 14.4128C33.7763 14.4187 33.7545 14.4203 33.733 14.4175C33.7116 14.4146 33.691 14.4074 33.6724 14.3963C33.6539 14.3852 33.6378 14.3704 33.6252 14.3528C33.6126 14.3353 33.6037 14.3153 33.5991 14.2942C33.5991 14.1953 33.5991 14.0767 33.5991 14.0767C33.5991 14.0767 33.7773 14.0964 33.7971 14.1953Z",
    fill: "url(#paint89_radial_336_14486)"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1138 14.1362C34.1208 14.1779 34.1126 14.2207 34.0909 14.2569C34.0691 14.2931 34.0351 14.3205 33.9951 14.334C33.9742 14.3367 33.9531 14.3353 33.9328 14.3299C33.9125 14.3244 33.8935 14.3149 33.877 14.302C33.8604 14.2892 33.8465 14.2731 33.8362 14.2548C33.8259 14.2365 33.8193 14.2164 33.8169 14.1956C33.8169 14.0967 33.9159 13.978 33.9159 13.978C33.9159 13.978 34.094 14.0374 34.1138 14.1362Z",
    fill: "url(#paint90_radial_336_14486)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4108 14.0967C34.4167 14.1175 34.4183 14.1392 34.4154 14.1607C34.4126 14.1821 34.4053 14.2027 34.3942 14.2212C34.3831 14.2397 34.3683 14.2558 34.3507 14.2684C34.3331 14.281 34.3131 14.2898 34.292 14.2944C34.2475 14.2869 34.2065 14.2657 34.1745 14.2338C34.1426 14.2019 34.1214 14.1609 34.1138 14.1165L34.2524 13.9385C34.2524 13.9385 34.4108 13.9978 34.4108 14.0967Z",
    fill: "url(#paint91_radial_336_14486)"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7276 14.0767C34.7276 14.1755 34.7276 14.2744 34.589 14.2744C34.5452 14.2695 34.5048 14.2486 34.4756 14.2158C34.4464 14.1829 34.4303 14.1404 34.4306 14.0964L34.589 13.9185C34.589 13.9185 34.7276 13.9778 34.7276 14.0767Z",
    fill: "url(#paint92_radial_336_14486)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0443 14.1165C35.0443 14.2154 35.0443 14.2945 34.886 14.2747C34.7276 14.2549 34.7474 14.2747 34.7474 14.077C34.7474 13.8792 34.9057 13.9188 34.9057 13.9188C34.9057 13.9188 35.0641 14.0176 35.0443 14.1165Z",
    fill: "url(#paint93_radial_336_14486)"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M35.361 14.1758C35.3589 14.1987 35.3518 14.2208 35.3403 14.2407C35.3287 14.2605 35.313 14.2776 35.2941 14.2908C35.2753 14.304 35.2538 14.3129 35.2312 14.3169C35.2085 14.321 35.1853 14.32 35.1631 14.3142C35.124 14.3007 35.0917 14.2724 35.0732 14.2355C35.0547 14.1985 35.0515 14.1558 35.0641 14.1165L35.2422 13.978C35.2422 13.978 35.3808 14.0769 35.361 14.1758Z",
    fill: "url(#paint94_radial_336_14486)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M35.658 14.2747C35.6416 14.3126 35.6137 14.3445 35.5781 14.3658C35.5426 14.3871 35.5013 14.3967 35.4601 14.3933C35.436 14.3622 35.4229 14.3239 35.4229 14.2845C35.4229 14.2452 35.436 14.2069 35.4601 14.1758C35.4601 14.0769 35.658 14.0571 35.658 14.0571C35.658 14.0571 35.6778 14.1758 35.658 14.2747Z",
    fill: "url(#paint95_radial_336_14486)"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9352 14.3926C35.9313 14.4137 35.9226 14.4335 35.9097 14.4507C35.8968 14.4678 35.8801 14.4817 35.8609 14.4913C35.8417 14.5009 35.8205 14.5059 35.7991 14.5059C35.7776 14.5059 35.7564 14.501 35.7372 14.4914C35.7131 14.4603 35.7001 14.422 35.7001 14.3827C35.7001 14.3433 35.7131 14.3051 35.7372 14.2739L35.955 14.1553C35.955 14.1553 35.9748 14.2937 35.9352 14.3926Z",
    fill: "url(#paint96_radial_336_14486)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2123 14.531C36.2059 14.5527 36.1948 14.5728 36.1799 14.5899C36.165 14.607 36.1467 14.6207 36.126 14.6301C36.1054 14.6394 36.0829 14.6443 36.0603 14.6442C36.0376 14.6442 36.0152 14.6393 35.9946 14.6299C35.9688 14.5956 35.955 14.554 35.955 14.5112C35.955 14.4684 35.9688 14.4268 35.9946 14.3926H36.2123C36.2123 14.3926 36.2717 14.4519 36.2123 14.531Z",
    fill: "url(#paint97_radial_336_14486)"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4697 14.7087C36.4567 14.7252 36.4402 14.7385 36.4213 14.7476C36.4025 14.7568 36.3818 14.7615 36.3608 14.7615C36.3398 14.7615 36.3191 14.7568 36.3003 14.7476C36.2814 14.7385 36.2649 14.7252 36.2519 14.7087C36.2241 14.6794 36.2086 14.6404 36.2086 14.6C36.2086 14.5595 36.2241 14.5206 36.2519 14.4912H36.4697C36.4697 14.4912 36.5291 14.6296 36.4697 14.7087Z",
    fill: "url(#paint98_radial_336_14486)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M36.7072 15.0244C36.676 15.0485 36.6377 15.0615 36.5983 15.0615C36.5589 15.0615 36.5207 15.0485 36.4895 15.0244C36.4602 14.9918 36.4441 14.9495 36.4441 14.9058C36.4441 14.862 36.4602 14.8197 36.4895 14.7871H36.727C36.727 14.7871 36.826 14.8464 36.7072 15.0244Z",
    fill: "url(#paint99_radial_336_14486)"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M36.925 15.1427C36.912 15.1592 36.8955 15.1725 36.8766 15.1816C36.8577 15.1908 36.8371 15.1955 36.8161 15.1955C36.7951 15.1955 36.7744 15.1908 36.7556 15.1816C36.7367 15.1725 36.7202 15.1592 36.7072 15.1427C36.7139 15.1138 36.7286 15.0874 36.7496 15.0664C36.7706 15.0454 36.797 15.0307 36.826 15.0241C36.9025 14.9952 36.987 14.9952 37.0636 15.0241C37.0636 15.0241 37.0042 15.0241 36.925 15.1427Z",
    fill: "url(#paint100_radial_336_14486)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M37.123 15.3997C37.1081 15.4165 37.0898 15.43 37.0694 15.4392C37.0489 15.4484 37.0267 15.4532 37.0042 15.4532C36.9817 15.4532 36.9595 15.4484 36.939 15.4392C36.9185 15.43 36.9003 15.4165 36.8854 15.3997C36.8613 15.3685 36.8483 15.3303 36.8483 15.2909C36.8483 15.2515 36.8613 15.2133 36.8854 15.1821H37.123C37.123 15.1821 37.2022 15.3403 37.123 15.3997Z",
    fill: "url(#paint101_radial_336_14486)"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2813 15.6564C37.2519 15.6842 37.2129 15.6997 37.1724 15.6997C37.1319 15.6997 37.093 15.6842 37.0636 15.6564C37.0343 15.6238 37.0182 15.5815 37.0182 15.5377C37.0182 15.494 37.0343 15.4517 37.0636 15.4191C37.1401 15.3902 37.2246 15.3902 37.3011 15.4191C37.3011 15.4191 37.3803 15.6168 37.2813 15.6564Z",
    fill: "url(#paint102_radial_336_14486)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4199 15.9524C37.3887 15.9764 37.3504 15.9895 37.311 15.9895C37.2716 15.9895 37.2333 15.9764 37.2021 15.9524C37.1743 15.923 37.1588 15.8841 37.1588 15.8436C37.1588 15.8032 37.1743 15.7642 37.2021 15.7349H37.4199C37.4346 15.7692 37.4422 15.8062 37.4422 15.8436C37.4422 15.881 37.4346 15.918 37.4199 15.9524Z",
    fill: "url(#paint103_radial_336_14486)"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5387 16.2483C37.5034 16.2713 37.4621 16.2835 37.4199 16.2835C37.3778 16.2835 37.3365 16.2713 37.3011 16.2483C37.2977 16.2071 37.3074 16.1658 37.3287 16.1303C37.35 16.0948 37.3819 16.0669 37.4199 16.0505C37.4902 16.0248 37.5674 16.0248 37.6377 16.0505C37.6377 16.0505 37.6179 16.2087 37.5387 16.2483Z",
    fill: "url(#paint104_radial_336_14486)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5981 16.5444C37.57 16.5669 37.5351 16.5791 37.4991 16.5791C37.4631 16.5791 37.4282 16.5669 37.4001 16.5444C37.3941 16.5001 37.405 16.4551 37.4307 16.4185C37.4564 16.3819 37.4949 16.3562 37.5387 16.3467C37.6377 16.3467 37.7366 16.4456 37.7366 16.4456C37.7366 16.4456 37.6971 16.5247 37.5981 16.5444Z",
    fill: "url(#paint105_radial_336_14486)"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6377 16.8606C37.6377 16.8606 37.4595 16.8606 37.4595 16.7222C37.4566 16.7024 37.4581 16.6823 37.4638 16.6631C37.4694 16.644 37.4792 16.6263 37.4924 16.6112C37.5055 16.5962 37.5218 16.5842 37.54 16.576C37.5583 16.5679 37.5781 16.5638 37.5981 16.564C37.6971 16.564 37.796 16.6826 37.796 16.6826C37.796 16.6826 37.7366 16.8408 37.6377 16.8606Z",
    fill: "url(#paint106_radial_336_14486)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6575 17.1763C37.6155 17.1763 37.5752 17.1596 37.5455 17.1299C37.5158 17.1003 37.4991 17.06 37.4991 17.0181C37.4991 16.9761 37.5158 16.9359 37.5455 16.9062C37.5752 16.8765 37.6155 16.8599 37.6575 16.8599L37.8356 17.0181C37.8356 17.0181 37.7564 17.1565 37.6575 17.1763Z",
    fill: "url(#paint107_radial_336_14486)"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6376 17.4721C37.5936 17.4724 37.5511 17.4564 37.5182 17.4272C37.4853 17.398 37.4644 17.3576 37.4595 17.3139C37.4725 17.2723 37.499 17.2361 37.5349 17.211C37.5707 17.186 37.6138 17.1735 37.6574 17.1755L37.8158 17.3337C37.8158 17.3337 37.7366 17.4919 37.6376 17.4721Z",
    fill: "url(#paint108_radial_336_14486)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5783 17.7883C37.5574 17.7859 37.5372 17.7793 37.5189 17.769C37.5006 17.7587 37.4846 17.7449 37.4717 17.7283C37.4588 17.7117 37.4493 17.6928 37.4438 17.6725C37.4383 17.6523 37.4369 17.6311 37.4397 17.6103C37.4397 17.6103 37.5387 17.4719 37.6376 17.4917C37.7366 17.5115 37.7762 17.6697 37.7762 17.6697C37.7762 17.6697 37.6772 17.8081 37.5783 17.7883Z",
    fill: "url(#paint109_radial_336_14486)"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4991 18.0843C37.4553 18.0748 37.4168 18.0492 37.3911 18.0125C37.3654 17.9759 37.3545 17.9309 37.3605 17.8866C37.3899 17.8588 37.4289 17.8433 37.4694 17.8433C37.5099 17.8433 37.5488 17.8588 37.5783 17.8866C37.6772 17.8866 37.7168 18.0646 37.7168 18.0646C37.7168 18.0646 37.5981 18.1239 37.4991 18.0843Z",
    fill: "url(#paint110_radial_336_14486)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3803 18.3803C37.3403 18.3668 37.3063 18.3395 37.2845 18.3032C37.2628 18.267 37.2546 18.2242 37.2616 18.1825C37.2942 18.1533 37.3365 18.1372 37.3803 18.1372C37.4242 18.1372 37.4665 18.1533 37.4991 18.1825L37.5981 18.3803C37.5981 18.3803 37.4793 18.4198 37.3803 18.3803Z",
    fill: "url(#paint111_radial_336_14486)"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2417 18.6568C37.22 18.6504 37.1999 18.6394 37.1828 18.6245C37.1656 18.6096 37.1519 18.5912 37.1426 18.5706C37.1332 18.55 37.1283 18.5276 37.1284 18.5049C37.1284 18.4823 37.1333 18.4599 37.1427 18.4393C37.1576 18.4225 37.1759 18.409 37.1963 18.3998C37.2168 18.3905 37.239 18.3857 37.2615 18.3857C37.284 18.3857 37.3062 18.3905 37.3267 18.3998C37.3471 18.409 37.3654 18.4225 37.3803 18.4393V18.6568C37.3803 18.6568 37.3209 18.6964 37.2417 18.6568Z",
    fill: "url(#paint112_radial_336_14486)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0636 18.9724C37.0636 18.9724 36.9448 18.8142 37.0636 18.7549C37.1824 18.6956 37.2022 18.7549 37.2814 18.7549C37.3605 18.7549 37.2814 18.9724 37.2814 18.9724C37.2814 18.9724 37.1428 18.9724 37.0636 18.9724Z",
    fill: "url(#paint113_radial_336_14486)"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M34.391 17.7481C33.654 17.7481 32.9337 17.9663 32.3212 18.3749C31.7088 18.7836 31.2318 19.3644 30.9506 20.0437C30.6695 20.7229 30.597 21.4701 30.7422 22.1906C30.8874 22.911 31.2439 23.5722 31.7664 24.0905C32.2888 24.6087 32.9539 24.9606 33.6771 25.1015C34.4004 25.2425 35.1493 25.1662 35.829 24.8822C36.5087 24.5983 37.0886 24.1196 37.4952 23.5067C37.9018 22.8938 38.1167 22.1744 38.1128 21.4395C38.1128 20.9531 38.0164 20.4715 37.8291 20.0223C37.6418 19.5731 37.3674 19.1653 37.0215 18.8223C36.6756 18.4792 36.2652 18.2078 35.8138 18.0234C35.3623 17.8391 34.8788 17.7455 34.391 17.7481Z",
    fill: "url(#paint114_radial_336_14486)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4493 36.1656C38.5404 35.5405 38.7952 34.9505 39.188 34.4549C39.5807 33.9593 40.0975 33.5757 40.6864 33.3428C40.0941 33.5704 39.5741 33.9525 39.1806 34.449C38.7871 34.9456 38.5345 35.5385 38.4493 36.1656Z",
    fill: "#FC0606"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1428 33.3642C37.4017 33.3525 37.6521 33.2684 37.8655 33.1216C38.079 32.9747 38.247 32.7711 38.3504 32.5337",
    fill: "#F6C1B2"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9763 36.304C29.7958 34.8385 29.0932 33.4864 27.9967 32.4941C27.6761 32.091 27.4612 31.6147 27.3713 31.1081C27.2814 30.6015 27.3195 30.0806 27.4819 29.5923C27.3247 30.0748 27.2893 30.5885 27.3791 31.0879C27.4689 31.5872 27.6811 32.0567 27.9967 32.4546C29.0987 33.459 29.8015 34.8254 29.9763 36.304Z",
    fill: "#FC0606"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M29.818 36.0473C29.818 36.0473 29.917 34.9813 27.4028 33.5205C29.917 34.9418 29.818 35.988 29.818 36.0473Z",
    fill: "#FC0606"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8575 36.304C29.3998 35.5297 28.7063 34.9212 27.8779 34.5669C28.7012 34.9387 29.3917 35.5514 29.8575 36.3238V36.304Z",
    fill: "#FC0606"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1946 35.6327C27.6867 35.4926 27.2406 35.1868 26.9276 34.7642C27.26 35.1894 27.7279 35.4888 28.254 35.613L28.1946 35.6327Z",
    fill: "#FC0606"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5216 33.1667C27.2481 33.0185 27.0424 32.7706 26.9474 32.4746C27.0419 32.7599 27.2396 32.9996 27.5018 33.147L27.5216 33.1667Z",
    fill: "#FC0606"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5799 26.1772C31.2416 26.2164 30.9093 26.296 30.59 26.4141C30.2642 26.5228 29.952 26.6685 29.6596 26.8484C29.5026 26.9286 29.3563 27.0281 29.224 27.1445L28.8479 27.4801C28.7317 27.6028 28.6257 27.7349 28.5312 27.8749C28.5228 27.9073 28.5228 27.9412 28.5312 27.9736L28.3926 28.1908C28.2238 28.4884 28.0782 28.7986 27.9571 29.1185C27.8413 29.439 27.7551 29.7694 27.6997 30.1056C27.6602 30.44 27.6602 30.7779 27.6997 31.1123C27.7246 31.4586 27.8407 31.7923 28.0362 32.0796C27.8545 31.7928 27.7395 31.469 27.6997 31.132C27.6501 30.7917 27.6501 30.4459 27.6997 30.1056C27.7461 29.7631 27.8257 29.4259 27.9373 29.0988C28.0621 28.7805 28.2076 28.4705 28.3728 28.171L28.6499 27.717C28.7489 27.5788 28.8677 27.4604 28.9865 27.3222C29.1024 27.2001 29.2282 27.0879 29.3626 26.9866C29.5002 26.8831 29.6459 26.7907 29.7982 26.7102C30.0945 26.5377 30.4059 26.3923 30.7286 26.2759C31.0579 26.1691 31.3957 26.0898 31.7382 26.0391L31.5799 26.1772Z",
    fill: "#FC0606"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3397 38.5937C40.3755 38.5937 39.4206 38.7814 38.5286 39.1464C37.8441 39.3916 37.1085 39.4596 36.3905 39.3438C35.7372 39.2056 35.2621 38.9293 35.2225 38.6332C35.1829 38.3371 37.2022 36.6592 38.7661 37.0145C39.6844 37.1512 40.5252 37.6054 41.1417 38.2976C41.2191 38.3882 41.2856 38.4876 41.3397 38.5937Z",
    fill: "url(#paint115_radial_336_14486)"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M41.597 38.9299L41.399 38.7124C41.472 38.7783 41.5383 38.8511 41.597 38.9299Z",
    fill: "#ED185A"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2128 38.7122C34.2128 39.265 32.4509 39.8177 30.9068 39.2057C30.0074 38.8728 29.0549 38.7056 28.0956 38.7122V38.5938C28.7126 37.8106 29.6036 37.2888 30.59 37.133C31.9362 36.8764 33.5595 38.2385 34.0149 38.653C34.084 38.6602 34.1511 38.6803 34.2128 38.7122Z",
    fill: "url(#paint116_radial_336_14486)"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M38.291 36.2053C37.0805 36.8966 35.7044 37.2471 34.3097 37.2192C32.915 37.1914 31.5541 36.7864 30.3723 36.0474C30.2657 36.2235 30.1982 36.4203 30.1743 36.6246C30.1504 36.8289 30.1707 37.0359 30.2337 37.2318C31.5675 37.9105 33.0503 38.2462 34.5473 38.2083C36.0443 38.1703 37.5081 37.76 38.8057 37.0146C38.828 36.841 38.7888 36.6651 38.6948 36.5173C38.6008 36.3695 38.458 36.2591 38.291 36.2053Z",
    fill: "url(#paint117_radial_336_14486)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9849 45.9176C35.0068 46.8493 34.8292 47.7749 34.4639 48.6327C34.0987 49.4905 33.5541 50.2608 32.8666 50.8921C31.4017 51.5831 30.9859 49.4116 30.9859 49.4116C30.2139 49.0168 30.2139 48.089 30.0159 48.0298C29.5247 47.8475 29.126 47.4783 28.9073 47.0033C28.6697 46.3519 29.62 47.0033 27.4225 44.7332C26.7912 44.0519 26.3697 43.204 26.2083 42.2905C26.0468 41.377 26.1522 40.4364 26.5119 39.581L26.7296 39.3836C27.0138 39.1089 27.3504 38.8941 27.7195 38.7519L28.1154 38.7124C28.1229 38.7515 28.1229 38.7917 28.1154 38.8308C29.0602 38.8226 29.9989 38.9831 30.887 39.3046C31.7826 39.6636 32.7827 39.6636 33.6783 39.3046C33.9753 39.1664 34.1732 38.9888 34.193 38.8111L34.094 38.7124H34.292C34.292 38.7124 34.5494 39.6994 34.7671 41.1602C34.9925 42.7354 35.0654 44.3285 34.9849 45.9176Z",
    fill: "url(#paint118_radial_336_14486)"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4595 48.8588C37.3209 48.8588 36.6478 48.1284 36.6478 48.1284C36.17 47.2392 35.957 46.2324 36.0341 45.2266L34.8463 44.812C34.8193 46.2315 34.5927 47.6402 34.1732 48.9969C34.1732 49.9445 35.0839 49.0956 35.0839 49.0956C35.0839 49.0956 35.7966 49.7076 35.9945 49.3128C36.1925 48.918 36.3905 48.8193 36.9448 49.0759C37.4991 49.3325 37.5783 48.8588 37.4595 48.8588Z",
    fill: "url(#paint119_linear_336_14486)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9844 49.0757C36.4301 48.8191 36.2123 48.9376 36.0341 49.3126C35.8559 49.6877 35.1235 49.0955 35.1235 49.0955C35.1235 49.0955 34.1336 49.9443 34.2128 48.9968C34.2036 48.9578 34.2036 48.9173 34.2128 48.8783C34.3316 49.3521 35.1037 48.7204 35.1037 48.7204C35.1037 48.7204 35.8164 49.3126 36.0143 48.9376C36.2123 48.5625 36.4103 48.4243 36.9646 48.6809C37.0679 48.7117 37.178 48.7117 37.2813 48.6809C37.2813 48.6809 37.4001 48.7796 37.4397 48.7796C37.4793 48.7796 37.5387 49.3324 36.9844 49.0757Z",
    fill: "url(#paint120_radial_336_14486)"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M41.597 39.0086L41.1813 39.9759C41.1813 39.9759 36.727 41.2393 36.0539 40.805C35.6253 40.3789 35.3713 39.8088 35.3412 39.206C35.6603 39.4622 36.0438 39.6261 36.4499 39.6798C37.1932 39.8152 37.9595 39.747 38.6671 39.4824C39.5918 39.1349 40.5694 38.948 41.5574 38.9297L41.597 39.0086Z",
    fill: "#D77255"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M36.9844 40.4893H37.1625L37.3011 40.6079C37.3522 40.6489 37.3986 40.6953 37.4397 40.7463V40.8452L37.3209 40.687H37.2813C37.1873 40.602 37.0881 40.5227 36.9844 40.4497V40.4893Z",
    fill: "#020202"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2717 44.812C36.2717 44.812 36.7864 45.4053 37.2417 45.3855L36.2717 44.812Z",
    fill: "#BE442A"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9346 42.6604L36.9844 45.5622C36.6891 45.5179 36.3888 45.5179 36.0935 45.5622C35.7588 45.6782 35.4142 45.7641 35.0641 45.8189H34.8463C34.6181 45.8692 34.3817 45.8692 34.1535 45.8189C32.9063 44.8713 32.4509 45.1674 31.8966 45.3451C31.3423 45.5227 31.4215 45.0885 31.4215 45.0885C31.8906 44.5067 32.2343 43.8347 32.4311 43.1144C32.5242 42.7768 32.6434 42.4468 32.7875 42.1274C33.353 41.0889 33.798 39.9895 34.1139 38.8505V38.7124V38.5544C34.1139 38.5544 34.9651 36.8173 35.2819 39.1072C35.4498 39.8516 35.7728 40.5526 36.2298 41.1648C36.6867 41.7769 37.2676 42.2864 37.9346 42.6604Z",
    fill: "url(#paint121_linear_336_14486)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M29.6794 42.7787C30.0947 42.6256 30.5176 42.4938 30.9464 42.3839C31.085 42.3839 30.7682 42.6602 30.3921 42.9366C31.0951 42.849 31.8087 42.9027 32.4905 43.0945C32.7083 42.5615 32.8469 42.1273 32.8469 42.1273C33.5023 41.1333 33.9531 40.0195 34.1733 38.8504C34.0695 39.0406 33.901 39.1877 33.6981 39.2649C32.8025 39.624 31.8024 39.624 30.9068 39.2649C30.0113 38.9118 29.0586 38.7244 28.0957 38.7122C28.1032 38.6731 28.1032 38.6329 28.0957 38.5938L27.6403 38.7122C27.2765 38.8558 26.9413 39.063 26.6505 39.3241C26.6505 40.0545 26.9673 41.081 29.2241 40.9428C32.0946 40.7652 29.7982 41.3179 30.1545 41.5153C30.5109 41.7127 28.65 42.2457 29.2241 42.3839C29.2439 42.3839 28.9073 43.055 29.6794 42.7787Z",
    fill: "url(#paint122_radial_336_14486)"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2524 38.7124V38.8508L34.0941 38.7124H34.2524Z",
    fill: "#DC6B46"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7773 38.8504C33.7773 38.8504 33.9752 38.9688 33.9555 39.1465L33.6981 39.2649C33.3945 39.4857 33.0409 39.6281 32.6687 39.6795C31.9253 39.8159 31.1588 39.7476 30.4514 39.4821C29.4653 39.1221 28.4314 38.9092 27.3829 38.8504L27.6601 38.7122L28.1154 38.5938C28.9495 38.6601 29.7697 38.8463 30.5504 39.1465C31.228 39.3917 31.9573 39.4597 32.6687 39.3439C33.2626 39.1465 33.6189 39.1465 33.7773 38.8504Z",
    fill: "url(#paint123_radial_336_14486)"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0352 40.5286C32.0352 40.5286 30.3723 42.3447 29.6398 42.3447C28.9073 42.3447 28.5708 42.6408 29.0459 42.9369C29.521 43.233 31.5799 41.9696 31.8768 41.5156C32.1738 41.0616 30.59 43.1146 29.6398 43.1935C28.6896 43.2725 29.3428 43.7068 29.8378 43.4501C30.5508 43.0547 31.2152 42.5778 31.8174 42.0288C31.0158 42.7222 30.2742 43.4816 29.6002 44.299C29.6002 44.4174 29.8972 44.299 30.2139 43.9239C30.5307 43.5488 31.3423 42.8382 31.4611 42.9172C31.5799 42.9961 29.4814 44.6938 29.6002 44.8912C29.719 45.0886 30.7484 44.5753 31.5799 43.3514C32.4113 42.1276 33.2032 41.9696 33.3616 41.1405C33.52 40.3114 32.0352 40.5286 32.0352 40.5286Z",
    fill: "url(#paint124_radial_336_14486)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2128 45.7598C32.9656 44.8123 32.5103 45.1084 31.956 45.2861C31.4017 45.4637 31.4809 45.0294 31.4809 45.0294C31.95 44.4477 32.2937 43.7757 32.4905 43.0554C32.0748 42.6606 31.7778 42.404 31.758 42.5422C31.758 42.9765 31.4413 43.5489 30.4317 44.7333C29.422 45.9178 29.7784 45.7796 29.818 46.0362C29.8576 46.2928 31.1443 44.6149 31.1443 44.8123C31.1443 45.0097 30.0159 46.1152 30.1743 46.3323C30.3327 46.5494 30.788 45.7796 31.1443 45.3256C31.5007 44.8715 31.4413 45.3255 31.4215 45.7598C31.4017 46.1941 31.0454 46.1152 30.788 46.5692C30.5306 47.0232 30.9266 47.1417 31.0454 46.7468C31.1641 46.352 31.7382 45.9375 31.4215 46.5692C31.1048 47.2009 31.4215 47.6549 31.4215 47.2404C31.4215 46.8258 32.2926 45.4835 32.3717 45.7598C32.4509 46.0362 31.857 46.964 31.8768 47.1614C31.8966 47.3588 32.5499 46.7074 32.6489 46.1941C32.7479 45.6809 33.4408 45.0492 33.0646 46.3323C32.6885 47.6154 32.7083 48.3063 32.8865 47.951C33.0646 47.5957 33.5793 46.2928 33.6189 46.5889C33.6585 46.885 32.9261 48.563 33.124 48.563C33.322 48.563 33.124 48.563 33.2626 48.3261C33.4012 48.0892 33.2626 48.5235 33.2626 48.563C33.2626 48.6024 34.193 45.7993 33.9357 47.4772C33.6783 49.1552 32.3124 49.9448 33.1042 49.7868C33.8961 49.6289 34.7671 46.2533 34.8859 45.8388C34.6585 45.8606 34.429 45.8337 34.2128 45.7598ZM33.2626 48.2866C33.4606 47.7141 33.7179 46.5494 33.7971 46.9443C33.8763 47.3391 33.4012 47.9115 33.2626 48.2866Z",
    fill: "url(#paint125_radial_336_14486)"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4926 38.2187C24.4926 38.2187 24.4926 39.2057 24.1957 39.3637C24.6346 39.5364 25.1054 39.6134 25.5767 39.5895C26.0479 39.5657 26.5085 39.4416 26.9276 39.2255C26.9276 39.2255 28.5312 38.6135 28.9073 37.9621C28.9073 37.9621 28.353 36.5605 27.1652 36.5605C27.1652 36.5605 26.2743 37.212 25.4033 37.9621C25.2799 38.0692 25.1342 38.1478 24.9768 38.1922C24.8193 38.2365 24.654 38.2456 24.4926 38.2187Z",
    fill: "url(#paint126_radial_336_14486)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4927 38.2188C24.4927 38.2188 24.4927 39.3045 24.1957 39.3637C24.0723 39.4031 23.9422 39.4175 23.8131 39.4059C23.684 39.3943 23.5585 39.3571 23.4441 39.2964C23.3297 39.2356 23.2286 39.1527 23.1469 39.0523C23.0652 38.952 23.0045 38.8364 22.9683 38.7123C22.6714 37.9621 22.6516 37.0343 22.4734 36.7382C22.2952 36.4421 22.0973 36.0276 22.4734 36.1066C22.4734 36.1066 22.6912 36.2842 22.5922 36.1066C22.4932 35.9289 22.315 35.5933 22.3942 35.5143C22.4734 35.4354 22.6516 35.5143 22.6714 35.5143C22.6912 35.5143 22.216 35.0603 22.3744 34.9221C22.5328 34.784 22.8495 35.2972 22.9683 35.3367C23.0871 35.3762 22.6714 34.9814 22.8297 34.8827C22.9881 34.784 23.3445 35.2972 23.5028 35.3959C23.7744 35.7471 23.9515 36.1615 24.0175 36.6001C24.0175 36.7382 23.7206 36.8962 23.483 36.2842L24.4927 38.2188Z",
    fill: "url(#paint127_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M23.7403 36.9751L23.5028 37.0937L23.3048 37.2322L23.1068 37.3904C23.0437 37.4426 22.9958 37.5109 22.9683 37.5881V37.4695C22.9599 37.437 22.9599 37.403 22.9683 37.3706C23.0251 37.3073 23.092 37.2539 23.1662 37.2124C23.307 37.1139 23.4601 37.0341 23.6216 36.9751H23.7403Z",
    fill: "#070707"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M23.2652 38.7122C23.246 38.5813 23.246 38.4483 23.2652 38.3174C23.2554 38.1925 23.2554 38.0671 23.2652 37.9423C23.254 37.8109 23.254 37.6789 23.2652 37.5475C23.2963 37.4229 23.3575 37.3077 23.4434 37.2119C23.3735 37.3198 23.3264 37.4407 23.3048 37.5672C23.2935 37.692 23.2935 37.8175 23.3048 37.9423V38.3174C23.2951 38.4488 23.2951 38.5808 23.3048 38.7122H23.2652Z",
    fill: "#070707"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M23.5622 38.7139C23.4652 38.5967 23.379 38.4709 23.3048 38.3381C23.3015 38.2723 23.3015 38.2063 23.3048 38.1404C23.295 38.0682 23.295 37.995 23.3048 37.9229V38.1206V38.3381C23.3302 38.4014 23.3635 38.4612 23.4038 38.5161C23.4387 38.5784 23.4785 38.6379 23.5226 38.6941L23.5622 38.7139Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6119 35.4946C22.6676 35.5301 22.7149 35.5773 22.7505 35.6328C22.7602 35.685 22.7602 35.7385 22.7505 35.7907C22.8076 35.9026 22.8476 36.0224 22.8693 36.1461C22.8785 36.2709 22.8785 36.3963 22.8693 36.5211C22.8786 36.58 22.8786 36.6399 22.8693 36.6988V36.7975C22.8587 36.7654 22.8587 36.7308 22.8693 36.6988V36.5211V36.1461C22.8386 36.0248 22.7989 35.9061 22.7505 35.7907C22.7505 35.7907 22.7505 35.692 22.7505 35.6328L22.6119 35.4946Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9683 35.3169C23.0542 35.3664 23.1285 35.4337 23.186 35.5143C23.2567 35.5987 23.3166 35.6915 23.3642 35.7907C23.3642 35.7907 23.3642 35.8894 23.3642 35.9288C23.3642 35.9683 23.3642 36.0275 23.3642 36.0868C23.3642 36.146 23.3642 36.1855 23.3642 36.2447C23.3642 36.2447 23.3642 36.146 23.3642 36.0868C23.3556 36.0411 23.3556 35.9942 23.3642 35.9486C23.3553 35.8963 23.3553 35.8429 23.3642 35.7907C23.3257 35.7012 23.2794 35.6153 23.2256 35.534C23.1633 35.4521 23.0901 35.379 23.0079 35.3169H22.9683Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5526 36.166C22.6388 36.3217 22.7053 36.4875 22.7505 36.6595V36.9161C22.7617 37.0013 22.7617 37.0876 22.7505 37.1728L22.6318 36.9359V36.6595C22.6408 36.5808 22.6408 36.5013 22.6318 36.4226C22.6109 36.3329 22.5776 36.2465 22.5328 36.166H22.5526Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9683 37.1333C22.9484 37.0824 22.9484 37.026 22.9683 36.9751V37.1333Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4932 36.7385C22.4883 36.7057 22.4883 36.6724 22.4932 36.6396V36.7385Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6317 37.1333C22.6232 37.0942 22.6232 37.0537 22.6317 37.0146V37.1135V37.1333Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M22.5724 36.186C22.5557 36.1346 22.5557 36.0793 22.5724 36.0278V36.186Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M22.6911 35.554C22.676 35.509 22.676 35.4604 22.6911 35.4155H22.9683L22.6911 35.554Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M22.9683 36.0278C22.9484 35.977 22.9484 35.9205 22.9683 35.8696V36.0278Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0673 36.7385C23.0522 36.6936 23.0522 36.645 23.0673 36.6001V36.7385Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M23.285 35.8303C23.2758 35.8084 23.271 35.7849 23.271 35.7611C23.271 35.7373 23.2758 35.7138 23.285 35.6919V35.8303Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M24.651 38.7131C24.6728 38.5888 24.6728 38.4617 24.651 38.3374C24.67 38.4619 24.67 38.5886 24.651 38.7131Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0769 39.3838C24.0769 39.3838 24.3739 39.3838 24.453 39.2256C24.4134 39.3442 24.0769 39.3838 24.0769 39.3838Z",
    fill: "#070707"
  }))), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2947 36.8961C24.0563 36.6938 23.8314 36.4762 23.6216 36.2446C23.6216 36.2446 23.483 36.2446 23.4434 36.3828C23.4038 36.521 23.7404 36.975 23.7404 36.975C23.6063 37.3409 23.5589 37.7328 23.6018 38.12C23.6076 38.3238 23.6836 38.5194 23.817 38.674C23.9504 38.8285 24.133 38.9326 24.3343 38.9688C24.4927 38.9688 24.4927 38.2187 24.4927 38.2187C24.6312 37.3698 24.4531 36.975 24.2947 36.8961Z",
    fill: "url(#paint128_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8987 36.5215C23.8987 36.5215 23.8987 36.6401 23.7997 36.6599C23.7007 36.6797 23.483 36.3435 23.5226 36.2446C23.5622 36.1457 23.8987 36.5215 23.8987 36.5215Z",
    fill: "url(#paint129_linear_336_14486)"
  }))), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2947 39.6008C24.2731 39.6113 24.2494 39.6167 24.2254 39.6167C24.2014 39.6167 24.1777 39.6113 24.1561 39.6008C24.135 39.5823 24.1181 39.5595 24.1066 39.5339C24.095 39.5084 24.0891 39.4807 24.0891 39.4527C24.0891 39.4247 24.095 39.397 24.1066 39.3715C24.1181 39.346 24.135 39.3232 24.1561 39.3047C24.3502 38.9998 24.4275 38.6353 24.3738 38.2782C24.3681 38.2508 24.3683 38.2224 24.3745 38.1951C24.3806 38.1678 24.3925 38.142 24.4093 38.1196C24.4262 38.0972 24.4476 38.0787 24.4722 38.0652C24.4968 38.0516 24.524 38.0435 24.552 38.0413C24.604 38.0347 24.6567 38.047 24.7004 38.076C24.744 38.105 24.7757 38.1488 24.7896 38.1992C24.8661 38.6771 24.7525 39.1658 24.4728 39.5613C24.4495 39.5833 24.4206 39.5986 24.3892 39.6055C24.3578 39.6125 24.3252 39.6108 24.2947 39.6008Z",
    fill: "url(#paint130_radial_336_14486)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2449 38.1003C25.2135 38.0661 25.1719 38.0428 25.1262 38.0338C25.0805 38.0249 25.0332 38.0308 24.9911 38.0507C24.949 38.0706 24.9145 38.1034 24.8924 38.1443C24.8704 38.1852 24.8621 38.232 24.8688 38.278C24.9392 38.455 24.9598 38.6478 24.9284 38.8357C24.897 39.0235 24.8148 39.1992 24.6906 39.3439C24.6696 39.3624 24.6527 39.3852 24.6411 39.4108C24.6296 39.4363 24.6236 39.464 24.6236 39.492C24.6236 39.52 24.6296 39.5477 24.6411 39.5732C24.6527 39.5987 24.6696 39.6215 24.6906 39.64C24.7342 39.6789 24.7906 39.7003 24.849 39.7003C24.9074 39.7003 24.9638 39.6789 25.0074 39.64C25.1953 39.4356 25.3182 39.1802 25.3604 38.9061C25.4027 38.632 25.3625 38.3516 25.2449 38.1003Z",
    fill: "url(#paint131_radial_336_14486)"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6901 37.0938C27.2043 35.7502 27.479 34.3272 27.5017 32.8892L29.4814 33.5209C29.4814 33.5209 29.3626 37.7255 28.6697 38.219C27.9769 38.7125 26.6901 37.0938 26.6901 37.0938Z",
    fill: "url(#paint132_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9276 39.2258C26.9069 39.35 26.9069 39.4767 26.9276 39.6009C26.9461 39.7191 26.9863 39.8329 27.0464 39.9364C27.0889 40.0489 27.1566 40.1502 27.2444 40.2325L27.3631 40.3707L27.2048 40.2523C27.1207 40.1594 27.0537 40.0525 27.0068 39.9364C26.9647 39.8207 26.9316 39.7019 26.9078 39.5811C26.8968 39.4563 26.8968 39.3308 26.9078 39.2061L26.9276 39.2258Z",
    fill: "#020202"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6703 39.3444C26.6256 39.4507 26.6026 39.5647 26.6026 39.68C26.6026 39.7952 26.6256 39.9093 26.6703 40.0155C26.771 40.2336 26.9465 40.4087 27.1652 40.5091C27.3769 40.62 27.6036 40.6998 27.8383 40.7459H28.5312C28.294 40.7654 28.0556 40.7654 27.8185 40.7459C27.5847 40.6967 27.3584 40.617 27.1454 40.5091C26.9291 40.3959 26.7554 40.2158 26.6505 39.9958C26.562 39.7671 26.562 39.5138 26.6505 39.2852L26.6703 39.3444Z",
    fill: "#020202"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M26.4525 39.6008C26.4525 39.7587 26.4525 39.9166 26.4525 40.0746C26.4421 40.2389 26.4421 40.4037 26.4525 40.5681C26.4732 40.7301 26.5131 40.8891 26.5712 41.0418C26.6189 41.1946 26.708 41.3312 26.8286 41.4366C26.7082 41.327 26.6136 41.1922 26.5514 41.0418C26.484 40.8853 26.4439 40.7184 26.4327 40.5483C26.4223 40.384 26.4223 40.2192 26.4327 40.0548C26.4229 39.897 26.4229 39.7388 26.4327 39.5811L26.4525 39.6008Z",
    fill: "#020202"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M26.3337 39.9757C26.3139 40.2913 26.3139 40.6077 26.3337 40.9233C26.3625 41.2376 26.4222 41.5484 26.5119 41.851C26.6029 42.1426 26.7436 42.4164 26.9276 42.6604C27.0247 42.7806 27.1379 42.8869 27.2642 42.9762L27.4621 43.1144L27.6799 43.2329C27.529 43.1724 27.3834 43.0998 27.2444 43.0157C27.1285 42.9068 27.0225 42.7879 26.9276 42.6604C26.7212 42.4131 26.5724 42.1232 26.4921 41.8116C26.3941 41.5042 26.3343 41.186 26.3139 40.864C26.2843 40.5489 26.2843 40.2317 26.3139 39.9165L26.3337 39.9757Z",
    fill: "#020202"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0764 41.5156C26.0764 41.6735 26.1753 41.8512 26.2347 42.0091C26.2941 42.1671 26.3733 42.3447 26.4327 42.5026C26.4921 42.6606 26.5911 42.8185 26.6901 42.9764C26.7661 43.1347 26.8739 43.2758 27.0068 43.391C26.9273 43.3487 26.8594 43.2877 26.8088 43.2133C26.7451 43.1495 26.6916 43.0763 26.6505 42.9961C26.5518 42.8487 26.472 42.6895 26.4129 42.5224C26.2742 42.1962 26.1616 41.8596 26.0764 41.5156Z",
    fill: "#020202"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4621 44.7923L27.6403 44.891H27.858C28.0025 44.9115 28.1491 44.9115 28.2936 44.891C28.5795 44.9073 28.8651 44.8531 29.125 44.7331C29.394 44.6308 29.6473 44.4913 29.8773 44.3186C30.1149 44.1409 30.3326 43.9435 30.5504 43.7461C30.3592 43.9637 30.147 44.162 29.9169 44.3383C29.6828 44.5208 29.4225 44.6672 29.1448 44.7726C28.867 44.8774 28.5705 44.9244 28.2738 44.9108C28.1359 44.93 27.9959 44.93 27.858 44.9108H27.6403L27.4621 44.8121V44.7923Z",
    fill: "#020202"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0758 45.4258C28.2733 45.4456 28.4722 45.4456 28.6697 45.4258C28.858 45.4052 29.0438 45.3655 29.224 45.3071L29.5012 45.1885L29.7387 45.0303C29.8978 44.9146 30.0439 44.782 30.1743 44.6348C30.0571 44.7931 29.917 44.9331 29.7585 45.05L29.521 45.1885C29.4366 45.2446 29.3427 45.2848 29.2438 45.3071C29.0568 45.3655 28.8645 45.4052 28.6697 45.4258C28.4729 45.4556 28.2726 45.4556 28.0758 45.4258Z",
    fill: "#020202"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9073 46.3123C28.9319 46.3245 28.959 46.3308 28.9865 46.3308C29.014 46.3308 29.0411 46.3245 29.0657 46.3123H29.2438C29.3645 46.3028 29.4805 46.262 29.5804 46.1939C29.7977 46.0855 29.9978 45.9459 30.1743 45.7794L30.6692 45.2464L31.1443 44.7134L30.7088 45.2858C30.5473 45.4667 30.3754 45.638 30.1941 45.7991C30.0176 45.9656 29.8175 46.1053 29.6002 46.2136C29.488 46.2706 29.3679 46.3105 29.2438 46.3321C29.1849 46.342 29.1246 46.342 29.0657 46.3321C29.014 46.3474 28.959 46.3474 28.9073 46.3321V46.3123Z",
    fill: "#020202"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9073 46.6091C28.9606 46.6314 29.0178 46.6429 29.0756 46.6429C29.1333 46.6429 29.1905 46.6314 29.2438 46.6091C29.3542 46.6376 29.47 46.6376 29.5804 46.6091L29.6992 46.4905L29.8377 46.3521C29.8317 46.4046 29.8317 46.4577 29.8377 46.5103L29.6992 46.6091C29.5908 46.672 29.4681 46.706 29.3428 46.708C29.1908 46.7225 29.0381 46.6878 28.9073 46.6091Z",
    fill: "#020202"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7189 47.8723L30.0357 47.7341L30.3128 47.5367C30.4872 47.3888 30.6524 47.2306 30.8078 47.0629L30.9265 46.9247L31.0255 46.7865L31.1443 46.6484L31.2433 46.5102L31.4215 46.2141L31.5204 46.0561V45.918C31.4757 46.0271 31.4227 46.1326 31.3621 46.2338V46.372V46.5299C31.3076 46.6297 31.2411 46.7225 31.1641 46.8063L31.0651 46.9445L30.9463 47.0826L30.4316 47.5367L30.1347 47.7341L29.8179 47.892L29.7189 47.8723Z",
    fill: "#020202"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9565 47.9914C30.0678 48.0119 30.1818 48.0119 30.293 47.9914C30.4045 47.956 30.5062 47.8951 30.59 47.8135L30.7088 47.6948L30.8078 47.5564V47.418V47.5762L30.7088 47.7146C30.7088 47.7146 30.7088 47.8135 30.59 47.853C30.5033 47.9308 30.4025 47.9912 30.293 48.031C30.175 48.0498 30.0547 48.0498 29.9367 48.031L29.9565 47.9914Z",
    fill: "#020202"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9656 45.2271C32.8837 45.6083 32.7779 45.9841 32.6489 46.3522C32.531 46.7217 32.3922 47.0842 32.2332 47.438L31.9758 47.9709L31.6788 48.4645C31.5697 48.6293 31.4507 48.7876 31.3225 48.9382C31.201 49.0922 31.0687 49.2373 30.9266 49.3725L31.3027 48.9185L31.6393 48.4447C31.8433 48.12 32.0284 47.7839 32.1936 47.438C32.3519 47.0826 32.5103 46.7076 32.6291 46.3522C32.7621 45.9837 32.8744 45.608 32.9656 45.2271Z",
    fill: "#020202"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9859 49.5893C31.0444 49.6043 31.1057 49.6043 31.1641 49.5893L31.3027 49.4511L31.5402 49.1352C31.5656 49.0721 31.5989 49.0124 31.6392 48.9576L31.7382 48.7997C31.8117 48.6855 31.8778 48.5668 31.9362 48.4443L31.758 48.7997C31.7295 48.855 31.6964 48.9078 31.659 48.9576L31.5402 49.1352L31.3027 49.4511L31.1443 49.5695L30.9661 49.6682L30.9859 49.5893Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5692 45.8579C34.5692 46.0751 34.5692 46.2922 34.4504 46.5291C34.3316 46.766 34.3316 46.9634 34.2525 47.1805C34.1733 47.3977 34.0941 47.5951 33.9951 47.8122C33.8813 48.0103 33.7557 48.2015 33.619 48.3847C33.7427 48.2009 33.8551 48.0097 33.9555 47.8122C34.0532 47.6066 34.1391 47.3957 34.2129 47.1805C34.2129 46.9634 34.3712 46.7462 34.4306 46.5291C34.49 46.3119 34.5296 46.0948 34.5692 45.8776V45.8579Z",
    fill: "#020202"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1931 45.8188L34.0743 46.2926C34.0304 46.4534 33.9776 46.6115 33.9159 46.7664C33.8553 46.9168 33.7824 47.062 33.6981 47.2007C33.622 47.3479 33.5216 47.4814 33.4012 47.5955C33.4984 47.4647 33.5845 47.326 33.6585 47.1809C33.7429 47.0423 33.8157 46.8971 33.8763 46.7466C33.9528 46.6025 34.0125 46.4502 34.0545 46.2926C34.1098 46.1375 34.156 45.9793 34.1931 45.8188Z",
    fill: "#020202"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6388 45.4238C33.6388 45.8779 33.4606 46.3319 33.3418 46.7662C33.2871 46.9889 33.2143 47.2067 33.124 47.4176C33.0364 47.626 32.9162 47.8193 32.7677 47.9901C32.9001 47.8081 33.0066 47.6088 33.0844 47.3979C33.0844 47.1807 33.2428 46.9636 33.3022 46.7464C33.3801 46.5348 33.4398 46.3168 33.4804 46.095C33.4804 45.8779 33.5992 45.641 33.6388 45.4238Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8961 39.3042C33.9048 39.3697 33.9048 39.4361 33.8961 39.5016C33.8961 39.5016 33.8961 39.62 33.8961 39.699C33.8586 39.8271 33.8123 39.9524 33.7575 40.0741V40.1728C33.7172 40.2276 33.6839 40.2873 33.6585 40.3504L33.5397 40.5084L33.421 40.6663L33.5397 40.4886C33.5654 40.4318 33.5987 40.3786 33.6387 40.3307V40.232V40.1333C33.7034 40.0136 33.7564 39.888 33.7971 39.7582C33.7878 39.6994 33.7878 39.6394 33.7971 39.5806C33.7971 39.5806 33.7971 39.4424 33.7971 39.3832L33.8961 39.3042Z",
    fill: "#020202"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1448 42.2852L29.5012 42.4234H29.8971H30.6692C30.9237 42.3708 31.1701 42.2845 31.4017 42.1667C31.6372 42.0475 31.8624 41.9089 32.0748 41.7522C32.1764 41.6772 32.2694 41.5911 32.3519 41.4956L32.4905 41.3574L32.6291 41.2192L32.8666 41.081L32.9854 40.9428L33.1042 40.7849L33.223 40.627C33.528 40.2012 33.7994 39.7524 34.0346 39.2847C33.8204 39.7555 33.5619 40.2049 33.2626 40.627L33.1438 40.7849L33.025 40.9428L32.8864 41.1008L32.7676 41.239L32.6291 41.3771C32.588 41.428 32.5415 41.4744 32.4905 41.5153L32.1935 41.7719C31.986 41.9356 31.7601 42.0747 31.5204 42.1865C31.0499 42.4249 30.522 42.5275 29.9961 42.4826H29.6002L29.2438 42.3444L29.1448 42.2852Z",
    fill: "#020202"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1743 41.4958C30.5513 41.4568 30.923 41.3774 31.2829 41.2589C31.6408 41.1515 31.9859 41.0059 32.3124 40.8246L32.7875 40.5088C32.9421 40.4024 33.0878 40.2835 33.223 40.1534L33.421 39.956L33.5991 39.7586L33.6981 39.6402V39.5218V39.4033C33.5991 39.5612 33.5002 39.7192 33.3814 39.8771L33.2824 39.9955L33.0844 40.1929C32.811 40.4491 32.5048 40.6682 32.1738 40.8444C31.8445 41.0342 31.4918 41.1802 31.1246 41.2786C30.7646 41.3972 30.3929 41.4766 30.0159 41.5155L30.1743 41.4958Z",
    fill: "#020202"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9073 41.0813C29.3679 41.1306 29.8325 41.1306 30.2931 41.0813L30.9859 40.9826L31.6788 40.8049C31.903 40.7366 32.1214 40.6508 32.3321 40.5483C32.5464 40.4629 32.7519 40.3571 32.9458 40.2325C33.1496 40.1122 33.3418 39.9735 33.5199 39.8179L33.6387 39.7192C33.6798 39.6683 33.7262 39.622 33.7773 39.5811L33.8961 39.4429C33.7531 39.6215 33.5941 39.7867 33.4209 39.9364C33.2432 40.0982 33.0511 40.2436 32.8468 40.3707C32.4428 40.6129 32.0107 40.8052 31.5601 40.9431L30.887 41.101L30.1941 41.1998C29.7269 41.249 29.2557 41.249 28.7885 41.1998L28.9073 41.0813Z",
    fill: "#020202"
  }))), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5606 33.4813C29.5606 33.4813 27.7987 30.8163 28.9073 29.1384C29.5091 28.3632 30.2388 27.6957 31.0651 27.1644C31.9536 28.2932 32.5882 29.5992 32.926 30.994L33.0646 29.7109L31.8768 27.1644L31.4809 26.2563C31.4809 26.2563 29.2834 26.8091 28.8479 27.421C28.3289 28.0683 27.9817 28.8354 27.8383 29.6517C27.7195 31.2704 28.1946 33.4813 29.5606 33.4813Z",
    fill: "url(#paint133_radial_336_14486)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0828 33.4022C39.0828 33.4022 40.4884 30.2833 39.6767 29.1384C39.1153 28.3544 38.4492 27.6504 37.6971 27.0459C36.7983 28.1569 36.1379 29.4403 35.757 30.8163L35.6184 29.5332L36.826 26.9669L37.2021 26.0786C38.1525 26.2852 39.0534 26.6741 39.8549 27.2235C40.3729 27.8767 40.7137 28.6516 40.8447 29.4739C40.9375 30.2266 40.8225 30.9903 40.512 31.6826C40.2015 32.3748 39.7073 32.9694 39.0828 33.4022Z",
    fill: "url(#paint134_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6682 37.6264C34.5476 37.6169 34.4315 37.5761 34.3316 37.508C34.2358 37.4462 34.1278 37.4058 34.0149 37.3896C33.8981 37.4041 33.7844 37.4374 33.6784 37.4883C33.5699 37.5537 33.4482 37.5942 33.322 37.6067C33.1923 37.5767 33.0748 37.5078 32.9855 37.4093C32.8995 37.3462 32.8065 37.2932 32.7083 37.2514C32.5912 37.2229 32.469 37.2229 32.352 37.2514C32.2347 37.2784 32.1129 37.2784 31.9956 37.2514C31.8636 37.1955 31.7478 37.1072 31.6591 36.9948C31.6591 36.9948 31.5205 36.8171 31.4413 36.7974C31.3111 36.7671 31.1756 36.7671 31.0454 36.7974C30.9341 36.8178 30.8201 36.8178 30.7088 36.7974C30.5784 36.7325 30.4788 36.619 30.4317 36.4815C30.4243 36.4329 30.4063 36.3864 30.3789 36.3455C30.3516 36.3046 30.3155 36.2701 30.2733 36.2446C30.3198 36.2721 30.3597 36.3093 30.3904 36.3536C30.4212 36.3979 30.442 36.4482 30.4515 36.5013C30.4681 36.5673 30.5001 36.6285 30.5448 36.6799C30.5895 36.7313 30.6457 36.7716 30.7088 36.7974C30.8133 36.8186 30.9211 36.8186 31.0256 36.7974C31.1614 36.7584 31.3055 36.7584 31.4413 36.7974C31.5346 36.8527 31.6155 36.9266 31.6789 37.0145C31.7582 37.1153 31.8598 37.1964 31.9758 37.2514C32.0873 37.2698 32.201 37.2698 32.3124 37.2514C32.4363 37.2241 32.5646 37.2241 32.6885 37.2514C32.7994 37.288 32.9008 37.3487 32.9855 37.429C33.0815 37.5147 33.197 37.5757 33.322 37.6067C33.4318 37.5893 33.5385 37.556 33.6388 37.508C33.7472 37.4426 33.869 37.4021 33.9951 37.3896C34.115 37.4023 34.2303 37.4429 34.3316 37.508C34.4315 37.5761 34.5476 37.6169 34.6682 37.6264C34.7844 37.5983 34.8927 37.5443 34.9849 37.4685C35.0739 37.3837 35.1828 37.3226 35.3017 37.2909C35.4187 37.2624 35.541 37.2624 35.658 37.2909C35.774 37.3272 35.8984 37.3272 36.0144 37.2909C36.1203 37.2376 36.2146 37.1638 36.2915 37.0737C36.3769 36.9844 36.4774 36.9109 36.5885 36.8566C36.7065 36.8374 36.8268 36.8374 36.9448 36.8566C37.0584 36.899 37.1837 36.8982 37.2969 36.8546C37.41 36.8109 37.5031 36.7273 37.5585 36.6197C37.5585 36.521 37.7169 36.4025 37.8159 36.3631C37.9337 36.3424 38.0543 36.3424 38.1722 36.3631C38.2878 36.4022 38.413 36.4022 38.5286 36.3631C38.4065 36.4037 38.2745 36.4037 38.1524 36.3631C38.0412 36.3427 37.9271 36.3427 37.8159 36.3631C37.714 36.4156 37.631 36.4984 37.5783 36.6C37.5176 36.7143 37.42 36.8047 37.3012 36.8566C37.1708 36.8862 37.0355 36.8862 36.9052 36.8566C36.8005 36.8377 36.6932 36.8377 36.5885 36.8566C36.4793 36.9047 36.384 36.9793 36.3113 37.0737C36.219 37.1636 36.1118 37.2371 35.9946 37.2909C35.8708 37.3195 35.7422 37.3195 35.6184 37.2909C35.5135 37.2749 35.4067 37.2749 35.3017 37.2909C35.1828 37.3226 35.0739 37.3837 34.9849 37.4685C34.8926 37.5557 34.7746 37.6111 34.6484 37.6264H34.6682Z",
    fill: "#F4F3EA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6681 38.1006C34.542 38.088 34.4202 38.0476 34.3118 37.9821C34.2176 37.9172 34.1088 37.8765 33.995 37.8637C33.8788 37.8809 33.7656 37.9141 33.6585 37.9624C33.55 38.0278 33.4283 38.0683 33.3022 38.0808C33.1648 38.056 33.0395 37.9866 32.9458 37.8834C32.8605 37.8085 32.7588 37.7544 32.6489 37.7255C32.5316 37.6985 32.4098 37.6985 32.2925 37.7255C32.1745 37.744 32.0542 37.744 31.9362 37.7255C31.8041 37.6696 31.6883 37.5813 31.5996 37.4689C31.5996 37.4689 31.4413 37.2912 31.3621 37.2715C31.2319 37.2412 31.0964 37.2412 30.9661 37.2715C30.8562 37.3027 30.7396 37.3027 30.6296 37.2715C30.5567 37.2493 30.491 37.2085 30.4388 37.1531C30.3867 37.0977 30.3501 37.0296 30.3327 36.9556C30.3002 36.8597 30.2377 36.7767 30.1545 36.7188C30.2512 36.7846 30.3213 36.8825 30.3524 36.9951C30.3524 37.0938 30.3525 37.1728 30.6296 37.2715C30.7328 37.3034 30.8432 37.3034 30.9464 37.2715C31.0753 37.2319 31.2133 37.2319 31.3423 37.2715C31.4456 37.3202 31.5344 37.395 31.5996 37.4886C31.6861 37.5903 31.7943 37.6712 31.9164 37.7255C32.0338 37.7512 32.1553 37.7512 32.2727 37.7255C32.3974 37.7062 32.5242 37.7062 32.6489 37.7255C32.7598 37.7622 32.8612 37.8228 32.9458 37.9032C33.0445 37.9849 33.1591 38.0454 33.2824 38.0808C33.4015 38.0649 33.5161 38.0246 33.6189 37.9624C33.7319 37.9114 33.8521 37.8781 33.9753 37.8637C34.0959 37.8732 34.2119 37.914 34.3118 37.9821C34.4202 38.0476 34.542 38.088 34.6681 38.1006C34.7886 38.0853 34.9004 38.0296 34.9849 37.9426C35.0836 37.8609 35.1982 37.8004 35.3214 37.765C35.4395 37.7465 35.5597 37.7465 35.6778 37.765C35.795 37.792 35.9169 37.792 36.0341 37.765C36.1529 37.765 36.2321 37.6465 36.3311 37.5676C36.4148 37.4712 36.5154 37.391 36.628 37.3307C36.746 37.3112 36.8664 37.3112 36.9844 37.3307C37.1079 37.3608 37.2369 37.3608 37.3605 37.3307C37.4642 37.2736 37.5525 37.1924 37.6179 37.0938C37.6951 36.9933 37.7888 36.9066 37.895 36.8372C38.0129 36.8165 38.1335 36.8165 38.2513 36.8372C38.3748 36.8681 38.504 36.8681 38.6275 36.8372C38.4985 36.8768 38.3605 36.8768 38.2315 36.8372C38.1203 36.8168 38.0063 36.8168 37.895 36.8372C37.7913 36.8942 37.703 36.9755 37.6376 37.0741C37.577 37.1884 37.4793 37.2788 37.3605 37.3307C37.2315 37.3703 37.0936 37.3703 36.9646 37.3307C36.8543 37.3014 36.7383 37.3014 36.628 37.3307C36.5197 37.3709 36.4241 37.439 36.3509 37.5281C36.2695 37.6305 36.1591 37.7062 36.0341 37.7452C35.9035 37.7724 35.7688 37.7724 35.6382 37.7452C35.5276 37.7185 35.4122 37.7185 35.3016 37.7452C35.1838 37.7687 35.0744 37.8233 34.9849 37.9032C34.8926 37.9904 34.7746 38.0457 34.6483 38.0611L34.6681 38.1006Z",
    fill: "#F4F3EA"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2332 37.8635C32.2332 37.8635 32.0154 37.6069 31.9956 37.6069L32.2332 37.8635ZM35.8164 37.8635C35.8164 37.8635 35.5986 37.5476 35.5788 37.5476L35.8164 37.8635ZM30.9662 37.8635C30.9662 37.8635 30.7682 37.1528 30.7484 37.1528L30.9662 37.8635Z",
    fill: "#F4F3EA"
  }))), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6484 37.9243C34.878 37.9243 35.0641 37.7384 35.0641 37.509C35.0641 37.2797 34.878 37.0938 34.6484 37.0938C34.4188 37.0938 34.2327 37.2797 34.2327 37.509C34.2327 37.7384 34.4188 37.9243 34.6484 37.9243Z",
    fill: "url(#paint135_radial_336_14486)"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6484 37.6665C34.7358 37.6665 34.8067 37.5957 34.8067 37.5083C34.8067 37.4209 34.7358 37.3501 34.6484 37.3501C34.5609 37.3501 34.49 37.4209 34.49 37.5083C34.49 37.5957 34.5609 37.6665 34.6484 37.6665Z",
    fill: "url(#paint136_radial_336_14486)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8464 37.0742C34.8313 37.0829 34.8142 37.0875 34.7969 37.0875C34.7795 37.0875 34.7624 37.0829 34.7474 37.0742C34.7474 37.0742 34.7474 37.0742 34.7474 36.9556L34.8464 37.0742Z",
    fill: "url(#paint137_radial_336_14486)"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9849 37.1333C34.9849 37.1333 34.9849 37.1333 34.8859 37.1333C34.7869 37.1333 34.8859 37.1333 34.8859 37.0146C34.8859 36.896 34.8859 37.0146 34.9849 37.0146V37.1333Z",
    fill: "url(#paint138_radial_336_14486)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0443 37.2122C35.0443 37.2122 35.0443 37.2122 34.9453 37.2122C34.8463 37.2122 34.9453 37.2122 34.9453 37.1133H35.0641C35.0641 37.1133 35.0839 37.1726 35.0443 37.2122Z",
    fill: "url(#paint139_radial_336_14486)"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1037 37.291C35.1037 37.291 35.0047 37.291 34.9849 37.291C34.9849 37.291 35.1433 37.2712 35.1037 37.291Z",
    fill: "url(#paint140_radial_336_14486)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1235 37.3896H35.0245C35.0245 37.3896 35.1235 37.3896 35.1433 37.3896C35.1367 37.3903 35.1301 37.3903 35.1235 37.3896Z",
    fill: "url(#paint141_radial_336_14486)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0839 37.7649C35.0839 37.7649 35.0839 37.7649 35.0839 37.666H35.2027C35.2027 37.666 35.1235 37.7847 35.0839 37.7649Z",
    fill: "url(#paint142_radial_336_14486)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 37.9033V37.7847C34.9453 37.7847 34.9453 37.7847 35.0443 37.7847V37.9033C35.0443 37.9033 34.9849 37.9429 34.9453 37.9033Z",
    fill: "url(#paint143_radial_336_14486)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8464 37.9819C34.8359 37.9639 34.8304 37.9434 34.8304 37.9226C34.8304 37.9018 34.8359 37.8813 34.8464 37.8633V37.9622C34.8464 37.9622 34.8464 38.0215 34.8464 37.9819Z",
    fill: "url(#paint144_radial_336_14486)"
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6681 37.9822C34.6576 37.9501 34.6576 37.9154 34.6681 37.8833C34.6681 37.8833 34.6681 37.8833 34.6681 37.9822C34.6681 38.0811 34.6681 38.0811 34.6681 38.0811C34.6681 38.0811 34.6879 38.0415 34.6681 37.9822Z",
    fill: "url(#paint145_radial_336_14486)"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 37.9624C34.49 38.0613 34.49 37.9624 34.49 38.0613C34.49 38.0613 34.4702 38.002 34.49 37.9624Z",
    fill: "url(#paint146_radial_336_14486)"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M34.391 37.9229C34.406 37.9142 34.4231 37.9097 34.4405 37.9097C34.4579 37.9097 34.4749 37.9142 34.49 37.9229C34.5004 37.941 34.5059 37.9614 34.5059 37.9822C34.5059 38.0031 34.5004 38.0235 34.49 38.0416C34.49 38.0416 34.49 38.0416 34.391 38.0416V37.9229Z",
    fill: "url(#paint147_radial_336_14486)"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3118 37.8438C34.3118 37.8438 34.3118 37.8438 34.4108 37.8438C34.5098 37.8438 34.4108 37.8438 34.4108 37.9624C34.4108 38.0811 34.4108 37.9624 34.292 37.9624C34.1732 37.9624 34.292 37.9031 34.3118 37.8438Z",
    fill: "url(#paint148_radial_336_14486)"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2524 37.7847C34.2524 37.7847 34.3514 37.7847 34.3712 37.7847C34.391 37.7847 34.3712 37.7847 34.3712 37.8835C34.3712 37.9824 34.3712 37.8835 34.2524 37.8835C34.1337 37.8835 34.2128 37.8044 34.2524 37.7847Z",
    fill: "url(#paint149_radial_336_14486)"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2128 37.686H34.3118C34.3118 37.686 34.3118 37.686 34.3118 37.7849H34.2128C34.2128 37.7849 34.1733 37.7256 34.2128 37.686Z",
    fill: "url(#paint150_radial_336_14486)"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2128 37.311C34.2128 37.311 34.2128 37.311 34.0941 37.311C34.0941 37.311 34.1534 37.2913 34.2128 37.311Z",
    fill: "url(#paint151_radial_336_14486)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2524 37.2322C34.2524 37.2322 34.2524 37.2322 34.1534 37.2322C34.0544 37.2322 34.1534 37.2322 34.1534 37.1333L34.2524 37.2322Z",
    fill: "url(#paint152_radial_336_14486)"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3316 37.1528C34.3316 37.1528 34.3316 37.1528 34.3316 37.2517H34.2128C34.2128 37.2517 34.2128 37.2517 34.2128 37.1528H34.3316Z",
    fill: "url(#paint153_radial_336_14486)"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M34.391 37.0938V37.1926C34.391 37.1926 34.391 37.1926 34.292 37.1926C34.1931 37.1926 34.292 37.1926 34.292 37.0938H34.391Z",
    fill: "url(#paint154_radial_336_14486)"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 37.0542V37.1531C34.49 37.1531 34.49 37.1531 34.391 37.1531V37.0542C34.391 37.0542 34.4702 37.0146 34.49 37.0542Z",
    fill: "url(#paint155_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2728 38.3769C32.3384 38.3769 32.3916 38.3238 32.3916 38.2583C32.3916 38.1928 32.3384 38.1396 32.2728 38.1396C32.2072 38.1396 32.154 38.1928 32.154 38.2583C32.154 38.3238 32.2072 38.3769 32.2728 38.3769Z",
    fill: "url(#paint156_radial_336_14486)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2733 37.7456C30.3389 37.7456 30.392 37.6925 30.392 37.627C30.392 37.5614 30.3389 37.5083 30.2733 37.5083C30.2077 37.5083 30.1545 37.5614 30.1545 37.627C30.1545 37.6925 30.2077 37.7456 30.2733 37.7456Z",
    fill: "url(#paint157_radial_336_14486)"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8971 37.5674C29.8975 37.6009 29.8856 37.6334 29.8638 37.6589C29.8419 37.6844 29.8116 37.701 29.7783 37.7058C29.7416 37.7058 29.7063 37.6912 29.6804 37.6653C29.6544 37.6393 29.6398 37.6041 29.6398 37.5674C29.6446 37.5342 29.6613 37.5039 29.6867 37.4821C29.7122 37.4602 29.7448 37.4484 29.7783 37.4487C29.8098 37.4487 29.8401 37.4612 29.8623 37.4835C29.8846 37.5057 29.8971 37.5359 29.8971 37.5674Z",
    fill: "url(#paint158_radial_336_14486)"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1251 38.2978C29.1907 38.2978 29.2438 38.2447 29.2438 38.1792C29.2438 38.1137 29.1907 38.0605 29.1251 38.0605C29.0595 38.0605 29.0063 38.1137 29.0063 38.1792C29.0063 38.2447 29.0595 38.2978 29.1251 38.2978Z",
    fill: "url(#paint159_radial_336_14486)"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M29.9367 38.1597C30.0023 38.1597 30.0555 38.1065 30.0555 38.041C30.0555 37.9755 30.0023 37.9224 29.9367 37.9224C29.8711 37.9224 29.8179 37.9755 29.8179 38.041C29.8179 38.1065 29.8711 38.1597 29.9367 38.1597Z",
    fill: "url(#paint160_radial_336_14486)"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3327 38.8113C30.3279 38.8445 30.3112 38.8748 30.2857 38.8966C30.2602 38.9184 30.2277 38.9303 30.1941 38.9299C30.1626 38.9299 30.1324 38.9174 30.1101 38.8952C30.0878 38.8729 30.0753 38.8427 30.0753 38.8113C30.075 38.7777 30.0868 38.7452 30.1087 38.7198C30.1305 38.6943 30.1609 38.6776 30.1941 38.6729C30.2309 38.6729 30.2661 38.6874 30.2921 38.7134C30.3181 38.7394 30.3327 38.7746 30.3327 38.8113Z",
    fill: "url(#paint161_radial_336_14486)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5306 38.4561C30.5962 38.4561 30.6494 38.4029 30.6494 38.3374C30.6494 38.2719 30.5962 38.2188 30.5306 38.2188C30.465 38.2188 30.4119 38.2719 30.4119 38.3374C30.4119 38.4029 30.465 38.4561 30.5306 38.4561Z",
    fill: "url(#paint162_radial_336_14486)"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0453 37.8633C31.0457 37.8968 31.0338 37.9293 31.012 37.9548C30.9901 37.9802 30.9598 37.9969 30.9265 38.0017C30.8898 38.0017 30.8545 37.9871 30.8286 37.9612C30.8026 37.9352 30.788 37.9 30.788 37.8633C30.7928 37.8301 30.8094 37.7998 30.8349 37.778C30.8604 37.7561 30.893 37.7443 30.9265 37.7446C30.958 37.7446 30.9883 37.7571 31.0105 37.7794C31.0328 37.8016 31.0453 37.8318 31.0453 37.8633Z",
    fill: "url(#paint163_radial_336_14486)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5205 39.0283C31.5861 39.0283 31.6392 38.9752 31.6392 38.9097C31.6392 38.8441 31.5861 38.791 31.5205 38.791C31.4549 38.791 31.4017 38.8441 31.4017 38.9097C31.4017 38.9752 31.4549 39.0283 31.5205 39.0283Z",
    fill: "url(#paint164_radial_336_14486)"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M30.887 38.9297C30.887 38.9664 30.8724 39.0016 30.8464 39.0276C30.8204 39.0535 30.7852 39.0681 30.7484 39.0681C30.7152 39.0633 30.6848 39.0467 30.663 39.0212C30.6412 38.9957 30.6293 38.9632 30.6296 38.9297C30.6296 38.8982 30.6422 38.868 30.6644 38.8458C30.6867 38.8235 30.7169 38.811 30.7484 38.811C30.782 38.8107 30.8145 38.8225 30.84 38.8444C30.8655 38.8662 30.8822 38.8965 30.887 38.9297Z",
    fill: "url(#paint165_radial_336_14486)"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4413 38.416C31.4413 38.4527 31.4267 38.4879 31.4007 38.5139C31.3747 38.5399 31.3394 38.5544 31.3027 38.5544C31.2695 38.5497 31.2391 38.533 31.2173 38.5075C31.1954 38.4821 31.1836 38.4496 31.1839 38.416C31.1839 38.3846 31.1964 38.3544 31.2187 38.3321C31.241 38.3099 31.2712 38.2974 31.3027 38.2974C31.3363 38.297 31.3688 38.3089 31.3943 38.3307C31.4198 38.3525 31.4365 38.3828 31.4413 38.416Z",
    fill: "url(#paint166_radial_336_14486)"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7383 38.0413C31.7335 38.0744 31.7168 38.1048 31.6913 38.1266C31.6658 38.1484 31.6333 38.1603 31.5997 38.1599C31.5682 38.1599 31.538 38.1474 31.5157 38.1252C31.4934 38.1029 31.4809 38.0727 31.4809 38.0413C31.4806 38.0077 31.4924 37.9752 31.5143 37.9498C31.5361 37.9243 31.5665 37.9076 31.5997 37.9028C31.6364 37.9028 31.6717 37.9174 31.6977 37.9434C31.7237 37.9693 31.7383 38.0045 31.7383 38.0413Z",
    fill: "url(#paint167_radial_336_14486)"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9758 38.7124C32.0414 38.7124 32.0946 38.6593 32.0946 38.5937C32.0946 38.5282 32.0414 38.4751 31.9758 38.4751C31.9102 38.4751 31.857 38.5282 31.857 38.5937C31.857 38.6593 31.9102 38.7124 31.9758 38.7124Z",
    fill: "url(#paint168_radial_336_14486)"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M31.7185 39.3247C31.7841 39.3247 31.8372 39.2716 31.8372 39.2061C31.8372 39.1405 31.7841 39.0874 31.7185 39.0874C31.6529 39.0874 31.5997 39.1405 31.5997 39.2061C31.5997 39.2716 31.6529 39.3247 31.7185 39.3247Z",
    fill: "url(#paint169_radial_336_14486)"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5895 39.0281C32.5847 39.0613 32.568 39.0916 32.5425 39.1134C32.5171 39.1352 32.4845 39.1471 32.4509 39.1467C32.4194 39.1467 32.3892 39.1342 32.367 39.112C32.3447 39.0897 32.3322 39.0595 32.3322 39.0281C32.3318 38.9945 32.3437 38.962 32.3655 38.9366C32.3874 38.9111 32.4177 38.8944 32.4509 38.8896C32.4877 38.8896 32.5229 38.9042 32.5489 38.9302C32.5749 38.9562 32.5895 38.9914 32.5895 39.0281Z",
    fill: "url(#paint170_radial_336_14486)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M32.926 38.4561C32.9916 38.4561 33.0448 38.4029 33.0448 38.3374C33.0448 38.2719 32.9916 38.2188 32.926 38.2188C32.8604 38.2188 32.8073 38.2719 32.8073 38.3374C32.8073 38.4029 32.8604 38.4561 32.926 38.4561Z",
    fill: "url(#paint171_radial_336_14486)"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M33.4012 38.5544C33.3964 38.5876 33.3797 38.618 33.3542 38.6398C33.3287 38.6616 33.2962 38.6734 33.2626 38.6731C33.2311 38.6731 33.2009 38.6606 33.1786 38.6383C33.1563 38.6161 33.1438 38.5859 33.1438 38.5544C33.1435 38.5209 33.1553 38.4884 33.1772 38.4629C33.199 38.4375 33.2294 38.4208 33.2626 38.416C33.2993 38.416 33.3346 38.4306 33.3606 38.4566C33.3866 38.4825 33.4012 38.5177 33.4012 38.5544Z",
    fill: "url(#paint172_radial_336_14486)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0052 38.8503C33.0052 38.8818 32.9927 38.912 32.9704 38.9342C32.9481 38.9565 32.9179 38.969 32.8864 38.969C32.8549 38.969 32.8247 38.9565 32.8024 38.9342C32.7802 38.912 32.7676 38.8818 32.7676 38.8503L32.8666 38.7119C32.8666 38.7119 33.0052 38.7119 33.0052 38.8503Z",
    fill: "url(#paint173_radial_336_14486)"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5793 38.8898C33.5793 38.9265 33.5647 38.9617 33.5387 38.9876C33.5127 39.0136 33.4775 39.0282 33.4407 39.0282C33.4407 39.0282 33.322 39.0282 33.322 38.8898C33.3182 38.8734 33.3186 38.8564 33.3232 38.8402C33.3278 38.8241 33.3365 38.8094 33.3484 38.7975C33.3603 38.7856 33.375 38.777 33.3911 38.7724C33.4073 38.7678 33.4244 38.7673 33.4407 38.7711C33.4407 38.7711 33.5793 38.8107 33.5793 38.8898Z",
    fill: "url(#paint174_radial_336_14486)"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5606 38.5544C29.5558 38.5876 29.5391 38.618 29.5136 38.6398C29.4881 38.6616 29.4556 38.6734 29.422 38.6731C29.3905 38.6731 29.3603 38.6606 29.338 38.6383C29.3157 38.6161 29.3032 38.5859 29.3032 38.5544C29.3029 38.5209 29.3147 38.4884 29.3366 38.4629C29.3584 38.4375 29.3888 38.4208 29.422 38.416C29.4588 38.416 29.494 38.4306 29.52 38.4566C29.546 38.4825 29.5606 38.5177 29.5606 38.5544Z",
    fill: "url(#paint175_radial_336_14486)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.5
  }, _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1032 38.2978C37.1688 38.2978 37.2219 38.2447 37.2219 38.1792C37.2219 38.1137 37.1688 38.0605 37.1032 38.0605C37.0376 38.0605 36.9844 38.1137 36.9844 38.1792C36.9844 38.2447 37.0376 38.2978 37.1032 38.2978Z",
    fill: "url(#paint176_radial_336_14486)"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1027 37.6465C39.1683 37.6465 39.2214 37.5934 39.2214 37.5278C39.2214 37.4623 39.1683 37.4092 39.1027 37.4092C39.0371 37.4092 38.9839 37.4623 38.9839 37.5278C38.9839 37.5934 39.0371 37.6465 39.1027 37.6465Z",
    fill: "url(#paint177_radial_336_14486)"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M39.4986 37.4885C39.5034 37.5217 39.5201 37.552 39.5456 37.5739C39.5711 37.5957 39.6036 37.6075 39.6372 37.6072C39.6687 37.6072 39.6989 37.5947 39.7212 37.5724C39.7434 37.5502 39.756 37.52 39.756 37.4885C39.7563 37.455 39.7444 37.4225 39.7226 37.397C39.7008 37.3716 39.6704 37.3549 39.6372 37.3501C39.6004 37.3501 39.5652 37.3647 39.5392 37.3906C39.5132 37.4166 39.4986 37.4518 39.4986 37.4885Z",
    fill: "url(#paint178_radial_336_14486)"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2706 38.2192C40.3362 38.2192 40.3894 38.1661 40.3894 38.1006C40.3894 38.0351 40.3362 37.9819 40.2706 37.9819C40.205 37.9819 40.1519 38.0351 40.1519 38.1006C40.1519 38.1661 40.205 38.2192 40.2706 38.2192Z",
    fill: "url(#paint179_radial_336_14486)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M39.459 38.0811C39.5246 38.0811 39.5778 38.0279 39.5778 37.9624C39.5778 37.8969 39.5246 37.8438 39.459 37.8438C39.3934 37.8438 39.3402 37.8969 39.3402 37.9624C39.3402 38.0279 39.3934 38.0811 39.459 38.0811Z",
    fill: "url(#paint180_radial_336_14486)"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0828 38.7124C39.0825 38.7459 39.0943 38.7785 39.1162 38.8039C39.138 38.8294 39.1684 38.846 39.2016 38.8508C39.2384 38.8508 39.2736 38.8362 39.2996 38.8103C39.3256 38.7843 39.3402 38.7491 39.3402 38.7124C39.3354 38.6792 39.3187 38.6489 39.2932 38.6271C39.2677 38.6053 39.2352 38.5934 39.2016 38.5938C39.1701 38.5938 39.1399 38.6063 39.1176 38.6285C39.0953 38.6508 39.0828 38.6809 39.0828 38.7124Z",
    fill: "url(#paint181_radial_336_14486)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8651 38.3769C38.9307 38.3769 38.9839 38.3238 38.9839 38.2583C38.9839 38.1928 38.9307 38.1396 38.8651 38.1396C38.7995 38.1396 38.7463 38.1928 38.7463 38.2583C38.7463 38.3238 38.7995 38.3769 38.8651 38.3769Z",
    fill: "url(#paint182_radial_336_14486)"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4692 37.9033C38.5348 37.9033 38.588 37.8502 38.588 37.7847C38.588 37.7191 38.5348 37.666 38.4692 37.666C38.4036 37.666 38.3504 37.7191 38.3504 37.7847C38.3504 37.8502 38.4036 37.9033 38.4692 37.9033Z",
    fill: "url(#paint183_radial_336_14486)"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8753 38.9297C37.9409 38.9297 37.994 38.8766 37.994 38.811C37.994 38.7455 37.9409 38.6924 37.8753 38.6924C37.8097 38.6924 37.7565 38.7455 37.7565 38.811C37.7565 38.8766 37.8097 38.9297 37.8753 38.9297Z",
    fill: "url(#paint184_radial_336_14486)"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4296 38.8508C38.4344 38.884 38.4511 38.9143 38.4765 38.9362C38.502 38.958 38.5346 38.9698 38.5681 38.9695C38.5996 38.9695 38.6299 38.957 38.6521 38.9347C38.6744 38.9125 38.6869 38.8823 38.6869 38.8508C38.6873 38.8173 38.6754 38.7848 38.6536 38.7593C38.6317 38.7339 38.6014 38.7172 38.5681 38.7124C38.5314 38.7124 38.4961 38.727 38.4702 38.7529C38.4442 38.7789 38.4296 38.8141 38.4296 38.8508Z",
    fill: "url(#paint185_radial_336_14486)"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M38.093 38.4561C38.1586 38.4561 38.2118 38.4029 38.2118 38.3374C38.2118 38.2719 38.1586 38.2188 38.093 38.2188C38.0274 38.2188 37.9742 38.2719 37.9742 38.3374C37.9742 38.4029 38.0274 38.4561 38.093 38.4561Z",
    fill: "url(#paint186_radial_336_14486)"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6773 37.9622C37.6773 37.9936 37.6898 38.0238 37.7121 38.0461C37.7344 38.0683 37.7646 38.0808 37.7961 38.0808C37.8297 38.0812 37.8622 38.0693 37.8877 38.0475C37.9132 38.0257 37.9299 37.9953 37.9347 37.9622C37.9347 37.9254 37.9201 37.8902 37.8941 37.8643C37.8681 37.8383 37.8328 37.8237 37.7961 37.8237C37.7961 37.8237 37.6773 37.8831 37.6773 37.9622Z",
    fill: "url(#paint187_radial_336_14486)"
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4002 38.6338C37.4658 38.6338 37.5189 38.5807 37.5189 38.5151C37.5189 38.4496 37.4658 38.3965 37.4002 38.3965C37.3346 38.3965 37.2814 38.4496 37.2814 38.5151C37.2814 38.5807 37.3346 38.6338 37.4002 38.6338Z",
    fill: "url(#paint188_radial_336_14486)"
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5387 39.1072C37.5435 39.1404 37.5602 39.1707 37.5857 39.1925C37.6112 39.2143 37.6437 39.2262 37.6773 39.2258C37.7088 39.2258 37.739 39.2133 37.7613 39.1911C37.7835 39.1688 37.7961 39.1386 37.7961 39.1072C37.7964 39.0736 37.7845 39.0411 37.7627 39.0157C37.7409 38.9902 37.7105 38.9735 37.6773 38.9688C37.6405 38.9688 37.6053 38.9833 37.5793 39.0093C37.5533 39.0353 37.5387 39.0705 37.5387 39.1072Z",
    fill: "url(#paint189_radial_336_14486)"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M36.826 38.9297C36.826 38.9664 36.8406 39.0016 36.8666 39.0276C36.8926 39.0535 36.9279 39.0681 36.9646 39.0681C36.9979 39.0633 37.0282 39.0467 37.0501 39.0212C37.0719 38.9957 37.0837 38.9632 37.0834 38.9297C37.0834 38.8982 37.0709 38.868 37.0486 38.8458C37.0263 38.8235 36.9961 38.811 36.9646 38.811C36.9311 38.8107 36.8985 38.8225 36.873 38.8444C36.8475 38.8662 36.8308 38.8965 36.826 38.9297Z",
    fill: "url(#paint190_radial_336_14486)"
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4697 38.3769C36.5353 38.3769 36.5885 38.3238 36.5885 38.2583C36.5885 38.1928 36.5353 38.1396 36.4697 38.1396C36.4041 38.1396 36.3509 38.1928 36.3509 38.2583C36.3509 38.3238 36.4041 38.3769 36.4697 38.3769Z",
    fill: "url(#paint191_radial_336_14486)"
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1133 38.5942C36.1789 38.5942 36.2321 38.5411 36.2321 38.4756C36.2321 38.4101 36.1789 38.3569 36.1133 38.3569C36.0477 38.3569 35.9946 38.4101 35.9946 38.4756C35.9946 38.5411 36.0477 38.5942 36.1133 38.5942Z",
    fill: "url(#paint192_radial_336_14486)"
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5093 38.8901C36.5749 38.8901 36.6281 38.837 36.6281 38.7715C36.6281 38.706 36.5749 38.6528 36.5093 38.6528C36.4437 38.6528 36.3905 38.706 36.3905 38.7715C36.3905 38.837 36.4437 38.8901 36.5093 38.8901Z",
    fill: "url(#paint193_radial_336_14486)"
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8362 38.8113C35.8362 38.8427 35.8487 38.8729 35.871 38.8952C35.8933 38.9174 35.9235 38.9299 35.955 38.9299C35.9885 38.9303 36.0211 38.9184 36.0466 38.8966C36.0721 38.8748 36.0888 38.8445 36.0935 38.8113C36.0935 38.7746 36.0789 38.7394 36.053 38.7134C36.027 38.6874 35.9917 38.6729 35.955 38.6729C35.9217 38.6776 35.8914 38.6943 35.8695 38.7198C35.8477 38.7452 35.8358 38.7777 35.8362 38.8113Z",
    fill: "url(#paint194_radial_336_14486)"
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9737 38.5942C40.0393 38.5942 40.0925 38.5411 40.0925 38.4756C40.0925 38.4101 40.0393 38.3569 39.9737 38.3569C39.9081 38.3569 39.8549 38.4101 39.8549 38.4756C39.8549 38.5411 39.9081 38.5942 39.9737 38.5942Z",
    fill: "url(#paint195_radial_336_14486)"
  }))), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4799 39.1267C35.4799 39.1267 35.4799 39.482 36.0342 39.9163C37.8299 40.0357 39.6256 39.6817 41.2407 38.8898C41.2407 38.8898 41.2407 38.5148 40.5478 38.8898C39.7684 39.2861 38.9133 39.5122 38.0394 39.553C37.1656 39.5939 36.293 39.4485 35.4799 39.1267Z",
    fill: "#B03B25"
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5574 38.9293C40.5694 38.9476 39.5918 39.1346 38.6671 39.4821C37.9595 39.7466 37.1932 39.8149 36.4499 39.6795C36.0438 39.6257 35.6603 39.4619 35.3412 39.2057C35.3412 39.028 35.3412 38.8504 35.3412 38.8504C35.3412 38.8504 35.856 39.1465 36.4103 39.3439C37.1282 39.4596 37.8639 39.3917 38.5483 39.1465C39.4403 38.7815 40.3953 38.5937 41.3595 38.5938L41.5574 38.9293Z",
    fill: "url(#paint196_radial_336_14486)"
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1326 40.0954H37.7961C37.6775 40.1054 37.5583 40.1054 37.4397 40.0954C37.2097 40.1242 36.9769 40.1242 36.7468 40.0954C36.5192 40.0285 36.2999 39.9356 36.0936 39.8186C35.8844 39.7161 35.6964 39.5752 35.5392 39.4033C35.893 39.7118 36.3129 39.9351 36.7666 40.0559C36.9846 40.1256 37.211 40.1655 37.4397 40.1745H38.1326V40.0954Z",
    fill: "#020202"
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5392 39.3833C35.6087 39.4896 35.6883 39.5889 35.7768 39.6799L36.0539 39.937L36.2321 40.0359H36.0539H35.8758L35.5986 39.7788L35.3809 39.4822L35.5392 39.3833Z",
    fill: "#020202"
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M35.559 39.4229L35.6778 39.6404L35.7966 39.8381L35.955 40.0161C36.0044 40.079 36.0648 40.1326 36.1331 40.1743C36.0499 40.1474 35.975 40.0997 35.9154 40.0359C35.8586 39.9856 35.8116 39.9253 35.7768 39.8579C35.6848 39.7234 35.6116 39.577 35.559 39.4229Z",
    fill: "#020202"
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0941 39.1465C33.9877 39.6913 33.8353 40.2262 33.6387 40.7454C33.4606 40.9626 33.8961 40.7454 34.2128 40.5086C34.5296 40.2717 34.7672 40.8836 34.9057 40.5086C35.0443 40.1335 35.3809 40.5086 35.4205 40.173C35.3598 39.6686 35.2054 39.1799 34.9651 38.7319L34.0941 39.1465Z",
    fill: "url(#paint197_radial_336_14486)"
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2626 41.4758C33.0824 41.6636 32.9411 41.8849 32.8469 42.1273C32.5621 42.9856 32.2181 43.8232 31.8174 44.6343C31.5205 45.0093 32.8271 44.8909 33.025 44.6343C33.223 44.3776 34.2128 45.3844 34.6088 44.9106C35.0047 44.4369 35.1235 44.7132 35.3215 44.4961C35.5194 44.2789 33.9159 41.3179 33.2626 41.4758Z",
    fill: "url(#paint198_radial_336_14486)"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1925 47.5755C35.9761 46.8305 35.8564 46.061 35.8362 45.2857C35.9549 44.8119 34.9849 45.6015 34.9849 45.6015C34.8824 46.4838 34.7036 47.3556 34.4504 48.2072C34.1732 48.8192 35.1631 48.7994 35.1631 47.7137C35.1631 47.7137 35.4402 48.7599 35.5392 47.7137C35.6382 46.6675 36.3509 48.5823 36.1925 47.5755Z",
    fill: "url(#paint199_radial_336_14486)"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9849 45.74C35.0144 46.6843 34.8405 47.624 34.4751 48.4957C34.1098 49.3674 33.5613 50.1509 32.8667 50.7935C32.7278 50.9091 32.5527 50.9724 32.3717 50.9724C32.1908 50.9724 32.0157 50.9091 31.8768 50.7935C33.6783 50.1618 34.6088 47.0231 34.9255 45.7202C34.9651 45.7794 34.8463 45.7597 34.9849 45.74Z",
    fill: "#EC9B3A"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "M35.757 45.4438C35.7371 45.7133 35.7371 45.9838 35.757 46.2532C35.757 46.5296 35.757 46.8059 35.757 47.0625C35.757 47.3192 35.757 47.5955 35.8559 47.8719C35.847 47.9968 35.847 48.1221 35.8559 48.247V48.4444L35.9549 48.622C35.8768 48.5107 35.8105 48.3916 35.757 48.2667C35.757 48.1285 35.757 48.0101 35.757 47.8719C35.7033 47.605 35.6702 47.3345 35.658 47.0625C35.6282 46.5234 35.6282 45.983 35.658 45.4438H35.757Z",
    fill: "#020202"
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4798 45.5625C35.4798 45.9968 35.4798 46.4311 35.4798 46.8654C35.4798 47.2996 35.4798 47.2996 35.4798 47.5168C35.4894 47.6284 35.4894 47.7407 35.4798 47.8524C35.4883 47.9047 35.4883 47.958 35.4798 48.0103C35.4798 48.0103 35.4798 47.8919 35.4798 47.8326V45.5625Z",
    fill: "#020202"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1235 45.9175C35.1235 46.1544 35.1235 46.411 35.1235 46.6479V47.3783C35.1235 47.3783 35.1235 47.5164 35.1235 47.5757C35.1235 47.6941 35.1235 47.8125 35.0245 47.931C34.9255 48.0494 35.0245 48.1679 35.0245 48.2863C34.9983 48.4015 34.9359 48.5052 34.8463 48.5824C34.8463 48.5824 34.8463 48.464 34.8463 48.4048V48.0297C34.8463 47.9112 34.8463 47.7928 34.9453 47.6744V47.5757C34.9357 47.5168 34.9357 47.4568 34.9453 47.398C34.9453 47.1611 34.9453 46.9045 34.9453 46.6676C34.9453 46.4307 34.9453 46.1741 34.9453 45.9372L35.1235 45.9175Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6682 38.8506C34.6156 39.1773 34.5825 39.5069 34.5692 39.8376C34.5602 39.9229 34.5602 40.0089 34.5692 40.0942V40.6864C34.5694 40.8046 34.5694 40.8046 34.5694 40.9226C34.5604 40.8439 34.5602 40.7651 34.5692 40.6864V40.4298C34.5593 40.2589 34.5593 40.0875 34.5692 39.9166C34.5692 39.581 34.5692 39.2651 34.5692 38.9295L34.6682 38.8506Z",
    fill: "#020202"
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9651 39.8179V40.5088C34.9651 40.5088 34.9651 40.5088 34.9651 40.6273C34.9743 40.6662 34.9743 40.7068 34.9651 40.7457C34.9651 40.7457 34.9651 40.7457 34.9651 40.6273V39.8179Z",
    fill: "#020202"
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3215 39.8377V40.2325C35.3215 40.3707 35.3215 40.5088 35.3215 40.647C35.3119 40.509 35.3119 40.3705 35.3215 40.2325C35.3215 40.114 35.3215 39.9759 35.3215 39.8377Z",
    fill: "#020202"
  }))), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0149 41.5942C33.6909 41.7775 33.3534 41.9358 33.0053 42.068C32.6291 42.2062 31.3621 42.2259 30.9068 42.4036C30.8078 42.4036 30.7484 42.4036 30.7484 42.522C30.7484 42.6405 30.5307 42.8774 30.9068 42.9761C30.9068 42.9761 30.9068 43.3511 31.2236 43.3709C31.2234 43.4722 31.2624 43.5698 31.3324 43.6433C31.4025 43.7168 31.4982 43.7606 31.5997 43.7657C31.5997 43.7657 31.6987 44.042 31.9164 43.9828C32.1342 43.9236 32.1738 44.2394 32.6885 43.9828H32.8271L33.223 43.7854L33.8169 43.5485L34.6088 43.1932C34.7023 43.1631 34.7895 43.1162 34.8662 43.055C34.8662 43.055 34.2525 41.6535 34.0149 41.5942Z",
    fill: "url(#paint200_radial_336_14486)"
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2011 43.134C40.7853 43.9631 39.1224 44.5948 39.1224 44.5948C38.9838 45.4634 36.5093 46.5688 35.1631 43.9236C33.8169 41.2784 33.3022 41.4758 33.3022 41.4758C33.3605 41.3377 33.4562 41.2183 33.5785 41.1312C33.7009 41.0441 33.8451 40.9925 33.9951 40.9823C34.382 40.9214 34.7761 40.9214 35.1631 40.9823C35.7768 40.548 36.3509 40.9823 36.6874 40.7849C37.0438 40.4296 37.8752 40.6862 37.9544 40.4691C38.0336 40.2519 38.1722 40.2322 38.3108 40.173H38.4889H38.7661C38.934 40.138 39.0993 40.0918 39.261 40.0348C39.4392 39.3044 40.7656 39.1465 40.7656 39.1465H41.2803C42.4483 39.5413 42.2899 40.2519 42.2899 40.2519C42.3196 40.7814 42.2381 41.3113 42.0506 41.8076C41.8631 42.3039 41.5737 42.7556 41.2011 43.134Z",
    fill: "url(#paint201_radial_336_14486)"
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1519 43.6078C39.5184 43.6078 37.6179 41.9891 37.5585 42.226C37.4991 42.4628 39.2808 43.3906 38.9839 43.5288C38.6869 43.667 37.4595 42.7589 36.5884 42.0088C36.1326 41.6347 35.6568 41.2854 35.1631 40.9626C35.7768 40.5283 36.3509 40.9626 36.6874 40.7652C37.0194 41.0991 37.3117 41.47 37.5585 41.8706C38.6275 43.1538 40.7854 43.5683 40.1519 43.6078Z",
    fill: "url(#paint202_radial_336_14486)"
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7853 41.1205C40.7853 41.3179 39.0234 40.1532 39.2016 40.5085C39.3798 40.8638 40.7655 41.2389 40.5874 41.4363C40.4092 41.6337 38.6077 40.4493 38.6077 40.5875C38.6077 40.7256 39.7163 41.2784 39.5975 41.3771C39.4787 41.4758 38.093 40.6072 38.093 40.8243C38.093 41.0415 38.8453 41.2389 38.6671 41.4363C38.4889 41.6337 37.796 40.8243 37.6575 40.9823C37.5189 41.1402 38.2316 41.3376 38.3503 41.5942C38.4691 41.8508 38.0336 41.4363 38.0336 41.5942C38.5173 42.1596 39.1096 42.6228 39.7757 42.9563C40.4092 43.2524 40.0727 43.1932 40.0727 43.1932C38.845 42.5637 37.7444 41.7138 36.826 40.6862C37.1823 40.3308 38.0138 40.5875 38.093 40.3703C38.1722 40.1532 38.3107 40.1334 38.4493 40.0742H38.6275C38.7184 40.0976 38.8137 40.0976 38.9046 40.0742C39.6965 40.4098 40.7853 40.9823 40.7853 41.1205Z",
    fill: "url(#paint203_radial_336_14486)"
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M41.2605 39.0677C41.2605 39.0677 41.0229 38.969 41.0427 39.0677C41.0625 39.1664 40.7062 39.1862 40.4686 39.4033C40.231 39.6205 40.6666 39.7981 40.231 39.8179C39.7955 39.8376 39.8747 39.956 39.8747 39.956C40.528 40.2916 40.3498 40.4495 40.231 40.3508C40.1123 40.2521 39.6371 40.114 39.6173 40.2521C39.5975 40.3903 39.9341 40.2521 39.9143 40.4693C39.8945 40.6864 38.9047 39.8968 38.9047 39.8968H39.0432C39.2111 39.8618 39.3765 39.8157 39.5382 39.7586C39.7163 39.0283 41.0625 38.9888 41.0625 38.9888H41.2407L41.2605 39.0677Z",
    fill: "url(#paint204_radial_336_14486)"
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2712 44.8908C36.5093 45.2264 35.3611 43.5287 35.0245 42.7786C34.6461 42.15 34.1719 41.5839 33.619 41.1007L33.9555 40.9823C34.3424 40.9213 34.7366 40.9213 35.1235 40.9823C35.4429 41.1141 35.7325 41.3088 35.9748 41.5547C36.7468 42.3641 37.9544 43.5287 37.4001 43.055C36.8458 42.5812 35.8956 41.9495 36.1529 42.2851C36.4103 42.6207 36.7468 43.3116 36.4103 42.7984C36.0738 42.2851 35.3809 41.6929 35.5986 42.0482C35.8164 42.4036 36.0738 43.1932 35.757 42.522C35.4403 41.8508 34.9255 41.7521 35.2027 41.9298C35.4799 42.1074 35.7768 42.9365 35.4007 42.3838C35.0245 41.8311 35.0641 42.0087 35.0641 42.0087C35.4299 43.104 36.1735 44.0343 37.1626 44.6342C37.7961 44.9698 39.2412 44.6342 38.2712 44.8908Z",
    fill: "url(#paint205_radial_336_14486)"
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2626 41.4761C33.2626 41.4761 33.5001 41.2985 34.2524 42.3842C35.0047 43.4699 35.6184 46.1348 38.0138 45.6216C38.2675 45.5516 38.5007 45.4218 38.6936 45.2431C38.8866 45.0645 39.0336 44.8422 39.1224 44.5951L38.7463 44.7728C38.0894 44.9376 37.3961 44.8796 36.776 44.608C36.1558 44.3363 35.644 43.8664 35.3214 43.2725C34.3514 41.5156 34.1534 41.1208 33.6189 41.1011C33.5283 41.1201 33.4457 41.1661 33.382 41.2331C33.3184 41.3002 33.2767 41.3849 33.2626 41.4761Z",
    fill: "url(#paint206_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6372 44.378C39.467 44.4083 39.2927 44.4083 39.1225 44.378C38.9507 44.3397 38.7844 44.28 38.6275 44.2003L38.4098 44.0621L38.192 43.9042V43.8055C38.2004 43.7732 38.2004 43.7392 38.192 43.7068V43.5884C38.2896 43.7318 38.41 43.8585 38.5484 43.9634C38.6052 44.0266 38.6721 44.08 38.7463 44.1214C38.8111 44.1787 38.8846 44.2254 38.9641 44.2595C39.1155 44.3359 39.2748 44.3955 39.4392 44.4372C39.6096 44.4659 39.7836 44.4659 39.9539 44.4372L39.6372 44.378Z",
    fill: "#020202"
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1026 44.6347C39.0041 44.6478 38.9042 44.6478 38.8057 44.6347C38.6805 44.6447 38.5547 44.6447 38.4295 44.6347C38.1845 44.5897 37.9453 44.5169 37.7169 44.4176L37.4199 44.2202C37.3183 44.1452 37.2253 44.0591 37.1428 43.9636C37.0521 43.8831 36.9662 43.7974 36.8854 43.707C36.8854 43.6083 36.7468 43.5096 36.6874 43.3911C36.8241 43.5929 36.9835 43.7784 37.1626 43.9438C37.3353 44.1116 37.5281 44.2575 37.7367 44.3781C37.9572 44.4801 38.1901 44.5531 38.4295 44.5953C38.6721 44.6347 38.9195 44.6347 39.162 44.5953L39.1026 44.6347Z",
    fill: "#020202"
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4991 41.4578L37.1031 41.1216C37.0398 41.0648 36.9863 40.998 36.9448 40.9238V40.8249L36.826 40.6865L37.1625 41.0623L37.5189 41.3984L37.4991 41.4578Z",
    fill: "#020202"
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2316 40.1931H38.4097H38.6077C38.7422 40.2094 38.8709 40.2567 38.9838 40.3313C39.1018 40.3923 39.2088 40.4723 39.3006 40.5681C39.3784 40.6626 39.4722 40.7428 39.5777 40.805C39.7999 40.9419 40.0397 41.0482 40.2904 41.1209H40.6666C40.7902 41.1502 40.9191 41.1502 41.0427 41.1209H40.6468L40.2706 41.0222C40.019 40.9613 39.7785 40.8613 39.5579 40.7261C39.4501 40.6513 39.3505 40.5653 39.261 40.4694C39.1752 40.3753 39.075 40.2954 38.964 40.2326C38.7398 40.1078 38.4883 40.04 38.2316 40.0352V40.1931Z",
    fill: "#020202"
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M39.3204 39.8179C39.4539 39.9218 39.6003 40.0082 39.7559 40.0749L39.9935 40.1936H40.231C40.1455 40.2028 40.0592 40.2028 39.9737 40.1936L39.7361 40.0947L39.5183 39.9761H39.3996V39.8772L39.3204 39.8179Z",
    fill: "#020202"
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5381 39.7393H39.9737H40.3894H40.7853H41.0031H41.2011L40.3894 39.5811H39.5579L39.5381 39.7393Z",
    fill: "#020202"
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M39.8747 39.3047L40.1518 39.4036H39.9935H39.8747V39.3047Z",
    fill: "#020202"
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M40.5478 39.048C40.62 39.038 40.6933 39.038 40.7656 39.048H40.8843H40.9833H40.5478Z",
    fill: "#020202"
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0433 39.877L39.4392 40.1533L39.8351 40.4297L40.2509 40.6666L40.4686 40.785H40.7062C40.6283 40.8051 40.5465 40.8051 40.4686 40.785H40.2311L39.8153 40.5284C39.558 40.3507 39.2808 40.1533 39.0433 39.9559V39.877Z",
    fill: "#020202"
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9159 40.9824H34.1139H34.3118C34.4359 41.0432 34.5495 41.1233 34.6484 41.2197V41.3977C34.6594 41.4632 34.6594 41.53 34.6484 41.5954L34.5494 41.4175L34.8463 41.6746C34.7532 41.5801 34.6465 41.5001 34.5296 41.4372C34.4156 41.3681 34.2865 41.3274 34.1535 41.3186L33.9159 40.9824Z",
    fill: "#020202"
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1235 40.9824C35.3835 41.0823 35.6297 41.215 35.856 41.3772C35.9747 41.3772 36.0539 41.5746 36.1529 41.6733L36.4499 41.9694L36.727 42.2655L37.0042 42.5814L37.2813 42.8775L37.4199 43.0354L37.5585 43.1736L37.4001 43.0354L37.2615 42.8972L36.9646 42.6603L36.4103 42.0484L36.1331 41.7523L35.8362 41.4759C35.7372 41.3797 35.6237 41.2998 35.4996 41.239C35.3802 41.1681 35.2542 41.1086 35.1235 41.0614V40.9824Z",
    fill: "#020202"
  }))), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5194 38.7122C35.5074 38.8207 35.4734 38.9257 35.4196 39.0207C35.3658 39.1158 35.2932 39.1991 35.2063 39.2655C35.1193 39.3319 35.0198 39.38 34.9138 39.4071C34.8077 39.4341 34.6972 39.4395 34.589 39.4228C34.4257 39.4018 34.2723 39.3329 34.1483 39.2248C34.0243 39.1167 33.9353 38.9744 33.8926 38.8158C33.8498 38.6572 33.8553 38.4895 33.9082 38.334C33.9612 38.1785 34.0592 38.0422 34.1899 37.9424C34.3207 37.8425 34.4782 37.7836 34.6425 37.7732C34.8069 37.7627 34.9707 37.8011 35.1131 37.8836C35.2555 37.9661 35.3701 38.0888 35.4425 38.2363C35.5148 38.3839 35.5416 38.5495 35.5194 38.7122Z",
    fill: "url(#paint207_radial_336_14486)"
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0245 38.5747C35.0057 38.6584 34.9573 38.7325 34.8882 38.7833C34.8191 38.8342 34.7339 38.8584 34.6484 38.8516C34.6064 38.8445 34.5664 38.829 34.5305 38.8061C34.4947 38.7832 34.4639 38.7534 34.4399 38.7183C34.4158 38.6832 34.3991 38.6437 34.3907 38.602C34.3824 38.5604 34.3824 38.5175 34.391 38.4759C34.3956 38.4348 34.4088 38.3951 34.4297 38.3594C34.4506 38.3237 34.4787 38.2928 34.5122 38.2686C34.5458 38.2444 34.584 38.2274 34.6245 38.2188C34.665 38.2103 34.7069 38.2103 34.7474 38.2188C34.7891 38.2237 34.8294 38.2368 34.866 38.2574C34.9026 38.278 34.9348 38.3057 34.9606 38.3388C34.9863 38.3719 35.0053 38.4098 35.0163 38.4503C35.0272 38.4908 35.0301 38.5331 35.0245 38.5747Z",
    fill: "url(#paint208_radial_336_14486)"
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9453 37.5679C34.9453 37.6865 34.9453 37.7656 34.8067 37.7458C34.6682 37.7261 34.7078 37.647 34.8067 37.5481C34.9057 37.4492 34.8067 37.3701 34.9453 37.3701C35.0839 37.3701 34.9453 37.469 34.9453 37.5679Z",
    fill: "url(#paint209_radial_336_14486)"
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1235 37.6466C35.1235 37.7455 35.0245 37.8048 34.9651 37.785C34.9057 37.7653 34.9651 37.6664 34.9651 37.5675C34.9651 37.4686 35.0641 37.4093 35.1235 37.4291C35.1829 37.4489 35.1631 37.5477 35.1235 37.6466Z",
    fill: "url(#paint210_radial_336_14486)"
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3016 37.7456C35.3016 37.7456 35.1631 37.884 35.1037 37.7456C35.0443 37.6072 35.1037 37.627 35.1037 37.5281C35.1037 37.4292 35.2422 37.3897 35.3016 37.4292C35.361 37.4688 35.3412 37.6467 35.3016 37.7456Z",
    fill: "url(#paint211_radial_336_14486)"
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4402 37.8836C35.4402 37.8836 35.2818 37.9825 35.2224 37.8836C35.1631 37.7847 35.2224 37.7452 35.2224 37.6661C35.2224 37.587 35.3808 37.5672 35.4402 37.6661C35.4996 37.7649 35.5194 37.8045 35.4402 37.8836Z",
    fill: "url(#paint212_radial_336_14486)"
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M35.559 38.0415C35.5278 38.0656 35.4895 38.0786 35.4501 38.0786C35.4107 38.0786 35.3724 38.0656 35.3412 38.0415C35.3412 38.0415 35.3412 37.9031 35.3412 37.8437C35.3412 37.7844 35.5392 37.8437 35.559 37.8437C35.5788 37.8437 35.6382 37.9822 35.559 38.0415Z",
    fill: "url(#paint213_radial_336_14486)"
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6382 38.219C35.6382 38.219 35.4402 38.219 35.4204 38.219C35.4006 38.219 35.4204 38.0806 35.5392 38.041C35.658 38.0015 35.7372 38.041 35.7768 38.041C35.8164 38.041 35.7372 38.1794 35.6382 38.219Z",
    fill: "url(#paint214_radial_336_14486)"
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6778 38.4165C35.6447 38.4356 35.6071 38.4456 35.5689 38.4456C35.5307 38.4456 35.4931 38.4356 35.46 38.4165C35.46 38.4165 35.46 38.2781 35.6382 38.2583C35.8164 38.2385 35.8362 38.2583 35.8362 38.2583C35.8362 38.2583 35.7768 38.377 35.6778 38.4165Z",
    fill: "url(#paint215_radial_336_14486)"
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6778 38.7129C35.5788 38.7129 35.4996 38.7129 35.4996 38.5943C35.4996 38.4756 35.4996 38.4954 35.6778 38.4954C35.856 38.4954 35.8758 38.4954 35.8758 38.5943C35.8758 38.6931 35.7966 38.5943 35.6778 38.7129Z",
    fill: "url(#paint216_radial_336_14486)"
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M35.658 38.7126C35.5392 38.7126 35.46 38.7126 35.4798 38.5742C35.4996 38.4358 35.5788 38.5742 35.6778 38.5742C35.7768 38.5742 35.8758 38.5742 35.856 38.7126C35.8362 38.8511 35.757 38.8115 35.658 38.7126Z",
    fill: "url(#paint217_radial_336_14486)"
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5788 38.989C35.4799 38.989 35.4205 38.8704 35.4403 38.811C35.4601 38.7517 35.559 38.811 35.658 38.811C35.757 38.811 35.8164 38.9099 35.7966 38.9692C35.7768 39.0286 35.6778 39.0286 35.5788 38.989Z",
    fill: "url(#paint218_radial_336_14486)"
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4798 39.147C35.3808 39.147 35.3412 39.0085 35.361 38.9492C35.3922 38.9252 35.4305 38.9121 35.4699 38.9121C35.5093 38.9121 35.5476 38.9252 35.5788 38.9492C35.6778 38.9492 35.7174 39.0876 35.6976 39.147C35.6664 39.171 35.6281 39.1841 35.5887 39.1841C35.5493 39.1841 35.511 39.171 35.4798 39.147Z",
    fill: "url(#paint219_radial_336_14486)"
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3412 39.2854C35.3412 39.2854 35.2225 39.1272 35.3412 39.0679C35.46 39.0085 35.4798 39.0679 35.559 39.0679C35.6382 39.0679 35.658 39.2458 35.559 39.2854C35.46 39.3249 35.4006 39.3645 35.3412 39.2854Z",
    fill: "url(#paint220_radial_336_14486)"
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1631 39.4036C35.1631 39.3047 35.1631 39.2059 35.1631 39.1861C35.1631 39.1663 35.3017 39.1861 35.3611 39.285C35.4204 39.3838 35.3611 39.4629 35.3611 39.5025C35.3611 39.542 35.2225 39.4827 35.1631 39.4036Z",
    fill: "url(#paint221_radial_336_14486)"
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9849 39.463C34.9849 39.463 34.9849 39.285 34.9849 39.2455C34.9849 39.2059 35.1235 39.2455 35.1631 39.3839C35.2027 39.5223 35.1631 39.5817 35.1631 39.6014C35.1631 39.6212 35.0245 39.5619 34.9849 39.463Z",
    fill: "url(#paint222_radial_336_14486)"
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 39.5024V39.3047C34.8463 39.3047 34.9651 39.3047 34.9849 39.4629C35.0047 39.6211 34.9849 39.6606 34.9849 39.6804C34.9849 39.7002 34.8463 39.6211 34.8463 39.5024Z",
    fill: "url(#paint223_radial_336_14486)"
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M34.589 39.5022C34.589 39.5022 34.589 39.3242 34.7078 39.3242C34.8265 39.3242 34.8068 39.3242 34.8068 39.5022C34.8068 39.6802 34.8068 39.6999 34.7078 39.6999C34.6088 39.6999 34.589 39.6208 34.589 39.5022Z",
    fill: "url(#paint224_radial_336_14486)"
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M34.391 39.4625C34.391 39.3636 34.49 39.2845 34.5494 39.3043C34.6088 39.3241 34.5494 39.4032 34.5494 39.5021C34.5494 39.6009 34.5494 39.68 34.4108 39.68C34.2722 39.68 34.3712 39.5614 34.391 39.4625Z",
    fill: "url(#paint225_radial_336_14486)"
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2128 39.3839C34.2128 39.285 34.3316 39.2257 34.391 39.2455C34.4504 39.2653 34.391 39.3839 34.391 39.463C34.391 39.5421 34.2722 39.6212 34.2128 39.6014C34.1534 39.5817 34.1732 39.4828 34.2128 39.3839Z",
    fill: "url(#paint226_radial_336_14486)"
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0544 39.2651C34.0544 39.2651 34.2128 39.1465 34.2524 39.2651C34.292 39.3838 34.2524 39.3838 34.2524 39.4827C34.2524 39.5815 34.094 39.6013 34.0544 39.4827C34.0353 39.4496 34.0253 39.4121 34.0253 39.3739C34.0253 39.3357 34.0353 39.2982 34.0544 39.2651Z",
    fill: "url(#paint227_radial_336_14486)"
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9159 39.127C33.9159 39.127 34.0941 39.0281 34.1337 39.127C34.1733 39.2258 34.1337 39.2654 34.1337 39.3445C34.1337 39.4236 33.9555 39.4434 33.9159 39.3445C33.8763 39.2456 33.8367 39.2061 33.9159 39.127Z",
    fill: "url(#paint228_radial_336_14486)"
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8169 38.9692C33.8481 38.9452 33.8864 38.9321 33.9258 38.9321C33.9652 38.9321 34.0035 38.9452 34.0346 38.9692C34.0346 38.9692 34.0346 39.1077 33.9357 39.167C33.8367 39.2263 33.7377 39.167 33.7179 39.167C33.6981 39.167 33.7179 39.0286 33.8169 38.9692Z",
    fill: "url(#paint229_radial_336_14486)"
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7377 38.7124C33.7377 38.7124 33.9357 38.7124 33.9555 38.7124C33.9753 38.7124 33.9555 38.8508 33.8169 38.8706C33.6783 38.8904 33.6189 38.8706 33.5991 38.8706C33.5793 38.8706 33.6387 38.8113 33.7377 38.7124Z",
    fill: "url(#paint230_radial_336_14486)"
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7179 38.5938C33.8169 38.5938 33.9159 38.5938 33.9159 38.5938C33.9159 38.5938 33.9159 38.7124 33.7575 38.7322C33.5991 38.752 33.5595 38.7322 33.5397 38.7322C33.5199 38.7322 33.6189 38.5938 33.7179 38.5938Z",
    fill: "url(#paint231_radial_336_14486)"
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7179 38.3965C33.8367 38.3965 33.9159 38.3965 33.9159 38.4954C33.9159 38.5943 33.8169 38.6141 33.7179 38.5943C33.6189 38.5745 33.52 38.5943 33.52 38.4954C33.52 38.3965 33.6189 38.3768 33.7179 38.3965Z",
    fill: "url(#paint232_radial_336_14486)"
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7773 38.199C33.8763 38.199 33.9554 38.199 33.9357 38.3374C33.9062 38.3652 33.8673 38.3807 33.8268 38.3807C33.7863 38.3807 33.7473 38.3652 33.7179 38.3374C33.6189 38.3374 33.5397 38.3374 33.5595 38.199C33.5793 38.0605 33.6585 38.1792 33.7773 38.199Z",
    fill: "url(#paint233_radial_336_14486)"
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8565 38.0214C33.9555 38.0214 34.0149 38.14 33.9753 38.1993C33.9357 38.2587 33.8565 38.1993 33.7575 38.1993C33.6585 38.1993 33.6189 38.0609 33.6387 38.0214C33.6585 37.9818 33.7575 37.9818 33.8565 38.0214Z",
    fill: "url(#paint234_radial_336_14486)"
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9752 37.8637C33.9752 37.8637 34.094 38.0219 34.0742 38.0615C34.043 38.0855 34.0047 38.0986 33.9653 38.0986C33.9259 38.0986 33.8877 38.0855 33.8565 38.0615C33.7575 38.0615 33.7179 37.9033 33.7575 37.8439C33.7971 37.7846 33.8961 37.8044 33.9752 37.8637Z",
    fill: "url(#paint235_radial_336_14486)"
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1139 37.7255C34.1139 37.7255 34.2128 37.9035 34.1139 37.943C34.0149 37.9826 33.9753 37.943 33.8961 37.943C33.8169 37.943 33.8961 37.7848 33.8961 37.7453C33.8961 37.7057 34.0545 37.6464 34.1139 37.7255Z",
    fill: "url(#paint236_radial_336_14486)"
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M34.292 37.6269C34.292 37.7258 34.292 37.8246 34.292 37.8444C34.292 37.8642 34.1732 37.8444 34.1139 37.8444C34.0545 37.8444 34.1139 37.6467 34.1139 37.6269C34.1139 37.6071 34.2326 37.5478 34.292 37.6269Z",
    fill: "url(#paint237_radial_336_14486)"
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 37.5675C34.49 37.5675 34.49 37.7653 34.49 37.785C34.49 37.8048 34.3514 37.785 34.3118 37.6466C34.2723 37.5082 34.3118 37.4489 34.3118 37.4291C34.3118 37.4093 34.4504 37.4686 34.49 37.5675Z",
    fill: "url(#paint238_radial_336_14486)"
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6682 37.5481C34.6682 37.647 34.6682 37.7458 34.6682 37.7458C34.6682 37.7458 34.5494 37.7458 34.5494 37.5679C34.5494 37.3899 34.5494 37.3701 34.5494 37.3701C34.5494 37.3701 34.6682 37.4294 34.6682 37.5481Z",
    fill: "url(#paint239_radial_336_14486)"
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4895 45.4634H36.0935C35.7588 45.5794 35.4142 45.6653 35.0641 45.72H34.8463C34.6181 45.7704 34.3817 45.7704 34.1535 45.72C32.9063 44.7725 32.4509 45.0686 31.8966 45.2463C31.3423 45.4239 31.4215 44.9897 31.4215 44.9897C31.5439 44.885 31.6447 44.7576 31.7185 44.6146C31.7185 44.6146 31.9164 44.6146 32.154 44.6146C32.7083 44.4567 33.1636 44.1606 34.4108 45.1081C34.639 45.1584 34.8755 45.1584 35.1037 45.1081H35.2621C35.471 45.0841 35.6768 45.0378 35.8758 44.9699C36.0485 45.1703 36.2565 45.3375 36.4895 45.4634Z",
    fill: "url(#paint240_radial_336_14486)"
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2594 26.8683C44.9702 26.9262 44.6705 26.8992 44.3964 26.7906C44.1223 26.6819 43.8857 26.4964 43.7153 26.2563C43.3505 27.3721 42.6614 28.3546 41.7356 29.0792C41.7356 29.0792 40.6072 30.3426 41.0031 30.54C41.1624 30.6518 41.2761 30.817 41.3233 31.0055C41.3706 31.1939 41.3483 31.3931 41.2605 31.5665C41.1021 31.7244 41.399 32.1982 41.3793 32.6719C41.3595 33.1457 41.7752 33.1457 41.7752 33.1457C43.1272 31.731 44.1421 30.0307 44.7447 28.1712C44.9855 27.7673 45.1593 27.3274 45.2594 26.8683Z",
    fill: "url(#paint241_radial_336_14486)"
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M45.7939 26.1774H45.6949C45.6383 26.143 45.5908 26.0957 45.5563 26.0393C45.5563 25.5655 44.9822 25.5063 44.903 25.3286C44.903 25.3286 45.0614 24.8943 44.903 24.6377C45.1093 24.3315 45.2881 24.0078 45.4375 23.6704C45.4662 23.5873 45.4662 23.497 45.4375 23.4138C45.3188 23.0387 45.0614 23.4138 44.8436 23.6902C44.6259 23.9665 44.4279 24.0455 44.1706 24.46C43.9455 25.0461 43.7862 25.6552 43.6954 26.2761C43.6954 26.2761 44.0122 27.0263 45.2396 26.9276C45.2594 26.8683 45.8929 26.5722 45.7939 26.1774Z",
    fill: "url(#paint242_radial_336_14486)"
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2594 26.9668C45.2444 26.9755 45.2273 26.98 45.2099 26.98C45.1926 26.98 45.1755 26.9755 45.1605 26.9668H44.9229H44.8239H44.9427H45.1605H45.2594Z",
    fill: "#070707"
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8142 26.8684L43.6954 26.7695V26.6509L43.8142 26.8684Z",
    fill: "#070707"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4874 25.23C44.5654 25.3415 44.6318 25.4608 44.6853 25.5859V25.7639C44.6945 25.8295 44.6945 25.8961 44.6853 25.9617V25.7837C44.6853 25.7837 44.6853 25.6453 44.6853 25.5859V25.408L44.5863 25.23H44.4874Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7447 25.98C44.7559 26.1116 44.7559 26.2439 44.7447 26.3755C44.7534 26.4411 44.7534 26.5076 44.7447 26.5732C44.7522 26.6323 44.7522 26.6921 44.7447 26.7512V26.5535V26.3755V26.1777C44.7372 26.112 44.7372 26.0457 44.7447 25.98Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7447 25.9204C44.791 25.975 44.8309 26.0347 44.8635 26.0984C44.8635 26.0984 44.8635 26.0984 44.8635 26.1973C44.8727 26.2363 44.8727 26.2769 44.8635 26.3159V26.217C44.8635 26.217 44.8635 26.217 44.8635 26.1182C44.8742 26.0527 44.8742 25.9859 44.8635 25.9204H44.7447Z",
    fill: "#070707"
  }))), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9427 23.6508V23.7695C44.9427 23.7695 45.2 23.4333 45.1604 23.3542C45.1209 23.2751 44.9427 23.6508 44.9427 23.6508Z",
    fill: "url(#paint243_linear_336_14486)"
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M45.0813 27.3815C44.5281 27.3325 44.0065 27.1036 43.5965 26.7301C43.5575 26.6867 43.536 26.6304 43.536 26.5722C43.536 26.5139 43.5575 26.4577 43.5965 26.4143C43.6368 26.3768 43.6899 26.356 43.745 26.356C43.8001 26.356 43.8531 26.3768 43.8935 26.4143C44.2434 26.7415 44.7007 26.9309 45.1802 26.9472C45.238 26.9472 45.2934 26.9701 45.3342 27.0108C45.3751 27.0516 45.398 27.1068 45.398 27.1644C45.398 27.222 45.3751 27.2772 45.3342 27.3179C45.2934 27.3587 45.238 27.3815 45.1802 27.3815H45.0813Z",
    fill: "url(#paint244_radial_336_14486)"
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M44.7447 28.0327C44.4661 28.012 44.195 27.9326 43.9494 27.7999C43.7037 27.6672 43.489 27.4842 43.3193 27.2629C43.2978 27.2426 43.2806 27.2181 43.2688 27.1909C43.2571 27.1638 43.251 27.1345 43.251 27.1049C43.251 27.0754 43.2571 27.0461 43.2688 27.0189C43.2806 26.9918 43.2978 26.9673 43.3193 26.947C43.3397 26.9255 43.3642 26.9084 43.3915 26.8967C43.4187 26.8849 43.4481 26.8789 43.4777 26.8789C43.5074 26.8789 43.5367 26.8849 43.5639 26.8967C43.5912 26.9084 43.6157 26.9255 43.6361 26.947C44.2498 27.5787 44.6853 27.6379 44.9427 27.5984C44.97 27.5895 44.999 27.5866 45.0275 27.59C45.0561 27.5934 45.0836 27.6029 45.1081 27.6179C45.1326 27.6329 45.1535 27.6531 45.1694 27.677C45.1852 27.7009 45.1957 27.728 45.2 27.7564C45.2076 27.8108 45.1959 27.8662 45.167 27.913C45.1381 27.9598 45.0938 27.9952 45.0417 28.013L44.7447 28.0327Z",
    fill: "url(#paint245_radial_336_14486)"
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M40.7853 42.5027C40.7853 41.9105 40.3498 42.2461 40.3498 42.2461C40.373 41.8707 40.3191 41.4945 40.1914 41.1406C39.5777 40.8445 38.9244 42.0487 38.9244 42.0487C39.0039 42.2424 39.1555 42.3979 39.3474 42.4825C39.5393 42.5672 39.7567 42.5744 39.9539 42.5027C39.7757 42.8185 40.9041 43.5489 40.9041 43.5489V44.2398C41.3396 44.6741 41.3396 43.312 41.3396 43.312C40.9239 43.1739 40.7853 42.5027 40.7853 42.5027Z",
    fill: "url(#paint246_linear_336_14486)"
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9935 42.9762C39.9935 42.9762 39.7361 43.3117 39.9935 43.4302C40.049 43.4844 40.1236 43.5148 40.2013 43.5148C40.2791 43.5148 40.3537 43.4844 40.4092 43.4302L46.0315 38.4951C46.0315 38.4951 46.3878 38.2977 46.0315 38.0214C46.0073 37.9924 45.9771 37.969 45.9428 37.953C45.9086 37.937 45.8713 37.9287 45.8335 37.9287C45.7957 37.9287 45.7584 37.937 45.7242 37.953C45.6899 37.969 45.6597 37.9924 45.6355 38.0214L39.9935 42.9762Z",
    fill: "url(#paint247_linear_336_14486)"
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M39.6768 35.8895C39.9608 36.4997 40.2917 37.0871 40.6666 37.6464C41.3397 38.6729 41.5574 39.1664 41.7356 39.1861C41.9138 39.2059 42.5671 38.7913 43.0422 38.6926C42.5908 37.409 42.0278 36.1672 41.3595 34.9814L39.6768 35.8895Z",
    fill: "url(#paint248_radial_336_14486)"
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M41.597 38.9688C41.5318 39.4241 41.5935 39.8885 41.7752 40.3112C42.0722 40.8441 41.5574 41.2389 41.6366 41.3574C41.7158 41.4758 42.3295 41.3574 42.2503 40.5086C42.1711 39.6597 42.7056 40.7454 42.5473 41.16C42.3889 41.5745 42.2107 41.4758 42.1117 41.5745C42.0128 41.6732 42.1117 42.1667 42.765 41.5745C42.8541 41.5748 42.9415 41.5511 43.0182 41.5059C43.0948 41.4607 43.1578 41.3958 43.2006 41.3179C43.2006 41.3179 43.2006 41.5943 43.5371 41.1995C43.7044 40.7563 43.7393 40.2743 43.6374 39.8118C43.5355 39.3493 43.3012 38.9262 42.963 38.5938C42.963 38.5938 42.0722 39.1465 41.597 38.9688Z",
    fill: "url(#paint249_radial_336_14486)"
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1519 35.8896C40.655 36.9768 41.2372 38.0258 41.894 39.0283H41.597C40.9269 38.0432 40.3122 37.0217 39.7559 35.9686C39.7559 35.6922 40.1519 35.8896 40.1519 35.8896Z",
    fill: "url(#paint250_radial_336_14486)"
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9073 36.0673C28.9073 36.0673 28.9073 37.686 28.2936 38.1993C27.4919 38.7534 26.5547 39.0808 25.5815 39.1468C25.4429 38.9691 25.1855 39.6008 25.5815 39.5613C26.7262 39.4242 27.8061 38.9578 28.6895 38.219C29.0546 37.547 29.2388 36.792 29.2241 36.0278L28.9073 36.0673Z",
    fill: "url(#paint251_radial_336_14486)"
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M39.0828 31.6655H38.6671C38.6671 31.6655 40.0331 31.7842 40.429 31.3096C40.0333 31.5764 39.5589 31.7018 39.0828 31.6655Z",
    fill: "url(#paint252_radial_336_14486)"
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M30.7484 32.9085C30.7484 32.9085 31.6393 33.5994 30.7484 35.6721C30.7484 35.6721 30.5108 36.3433 32.6093 36.975C31.7289 36.9858 30.8731 36.6851 30.1941 36.1261C30.4923 35.6288 30.677 35.072 30.7352 34.4955C30.7933 33.9189 30.7235 33.3367 30.5306 32.79L30.7484 32.9085Z",
    fill: "url(#paint253_radial_336_14486)"
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M30.1347 30.1056C30.1347 30.1056 30.0159 32.4349 31.5997 32.889C31.5997 32.889 32.055 33.1851 31.2235 32.889C30.3921 32.5929 29.7982 31.6058 29.7982 30.0266C29.7982 30.1056 29.8378 29.5134 30.1347 30.1056Z",
    fill: "url(#paint254_radial_336_14486)"
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4295 30.1056C38.4295 30.1056 38.5483 32.4349 36.9646 32.889C36.9646 32.889 36.5092 33.1851 37.3407 32.889C38.1722 32.5929 38.7661 31.6058 38.7661 30.0266C38.8057 30.1056 38.8057 29.5134 38.4295 30.1056Z",
    fill: "url(#paint255_radial_336_14486)"
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M37.8159 32.9085C37.8159 32.9085 36.925 33.5994 37.8159 35.6721C37.8159 35.6721 38.0534 36.3433 35.955 36.975C36.8354 36.9858 37.6911 36.6851 38.3702 36.1261C38.072 35.6288 37.8872 35.072 37.8291 34.4955C37.7709 33.9189 37.8407 33.3367 38.0336 32.79L37.8159 32.9085Z",
    fill: "url(#paint256_radial_336_14486)"
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M29.4616 31.4685C28.9384 31.5151 28.4148 31.3826 27.9769 31.0928C28.3728 31.5476 29.7982 31.4289 29.7982 31.4289L29.4616 31.4685Z",
    fill: "url(#paint257_radial_336_14486)"
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M38.6671 31.1319C38.6671 31.1319 38.5483 33.4613 40.1519 33.9153C40.1519 33.9153 40.5874 34.2114 39.7559 33.9153C38.9245 33.6192 38.3306 32.6125 38.3306 31.053C38.3306 31.1319 38.3702 30.52 38.6671 31.1319Z",
    fill: "url(#paint258_radial_336_14486)"
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6773 27.2826C37.6773 27.2826 37.8159 30.2436 35.7966 30.8161C35.7966 30.8161 35.2225 31.1912 36.2915 30.9148C37.3605 30.6384 38.093 29.2764 38.093 27.2826C38.093 27.2826 38.0534 26.5127 37.6773 27.2826Z",
    fill: "url(#paint259_radial_336_14486)"
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6195 27.204C31.6195 27.204 31.4809 30.165 33.5002 30.7375C33.5002 30.7375 34.0743 31.0928 33.0052 30.8362C31.9362 30.5796 31.2037 29.178 31.2037 27.204C31.2037 27.204 31.2433 26.4341 31.6195 27.204Z",
    fill: "url(#paint260_radial_336_14486)"
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8972 31.3888C29.8972 31.3888 30.0159 33.7182 28.4124 34.1722C28.4124 34.1722 27.9769 34.4683 28.8083 34.1722C29.6398 33.8761 30.2337 32.8693 30.2337 31.3098C30.2337 31.3888 30.1941 30.8163 29.8972 31.3888Z",
    fill: "url(#paint261_radial_336_14486)"
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "M41.894 32.79C42.2899 32.2373 41.4387 32.1189 41.5376 31.1911C41.4186 29.623 40.7118 28.1571 39.558 27.0851C38.4494 26.2757 38.1524 26.0586 37.123 26.0586H36.9844L36.5687 26.256C37.2584 26.2535 37.9261 26.4988 38.4494 26.9469C39.4735 27.6718 40.1816 28.7591 40.429 29.9869C40.4864 30.5163 40.4275 31.0518 40.2566 31.5563C40.0857 32.0608 39.8068 32.5222 39.4392 32.9085C38.6877 33.8088 38.2622 34.9354 38.2316 36.1064C38.3702 36.6196 38.3702 36.2446 38.7661 36.1064C39.7544 36.0154 40.6925 35.6303 41.4585 35.0009C41.5079 34.9244 41.5342 34.8353 41.5342 34.7443C41.5342 34.6533 41.5079 34.5642 41.4585 34.4877C41.2803 34.1521 41.9138 34.1521 41.9732 33.777C42.0326 33.402 41.5178 33.3625 41.894 32.79Z",
    fill: "url(#paint262_radial_336_14486)"
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "M32.3915 26.8682C32.3915 26.8682 32.9656 34.0931 34.2722 34.1918C35.5788 34.2905 35.8362 33.797 36.1331 32.0401C36.4301 30.2832 37.4001 26.9669 37.4001 26.9669L32.3915 26.8682Z",
    fill: "url(#paint263_radial_336_14486)"
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "M28.9073 27.1051C27.7534 28.1771 27.0467 29.643 26.9276 31.2111C27.0266 32.1389 26.1753 32.2573 26.5713 32.8101C26.9672 33.3628 26.3931 33.5602 26.4327 33.955C26.4723 34.3498 27.1256 34.3301 26.9474 34.6657C26.898 34.7422 26.8717 34.8313 26.8717 34.9223C26.8717 35.0133 26.898 35.1024 26.9474 35.1789C27.7134 35.8082 28.6515 36.1934 29.6398 36.2844C30.0357 36.2844 30.0357 36.7186 30.1743 36.2844C30.1436 35.1133 29.7182 33.9868 28.9667 33.0864C28.1154 31.981 27.8581 31.8231 27.8977 30.5597C28.1687 29.2085 28.9038 27.9938 29.9763 27.1249C30.4996 26.6767 31.1672 26.4315 31.857 26.434V26.0786C30.785 26.0748 29.7441 26.437 28.9073 27.1051Z",
    fill: "url(#paint264_radial_336_14486)"
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6484 31.6255C34.6067 31.6125 34.5705 31.5861 34.5454 31.5504C34.5203 31.5146 34.5078 31.4717 34.5098 31.4281C34.4771 31.4573 34.4349 31.4734 34.391 31.4734C34.3472 31.4734 34.3049 31.4573 34.2723 31.4281C34.2554 31.4133 34.2419 31.3951 34.2327 31.3747C34.2234 31.3542 34.2186 31.3321 34.2186 31.3097C34.2186 31.2873 34.2234 31.2651 34.2327 31.2447C34.2419 31.2243 34.2554 31.2061 34.2723 31.1912C34.2574 31.208 34.2391 31.2215 34.2186 31.2307C34.1982 31.2399 34.1759 31.2447 34.1535 31.2447C34.131 31.2447 34.1088 31.2399 34.0883 31.2307C34.0678 31.2215 34.0496 31.208 34.0347 31.1912C34.0178 31.1764 34.0043 31.1582 33.9951 31.1378C33.9859 31.1174 33.9811 31.0952 33.9811 31.0728C33.9811 31.0504 33.9859 31.0282 33.9951 31.0078C34.0043 30.9874 34.0178 30.9692 34.0347 30.9544C34.0674 30.9252 34.1096 30.9091 34.1535 30.9091C34.1973 30.9091 34.2396 30.9252 34.2723 30.9544C34.3001 30.9837 34.3156 31.0225 34.3156 31.0629C34.3156 31.1033 34.3001 31.1422 34.2723 31.1715C34.3049 31.1424 34.3472 31.1263 34.391 31.1263C34.4349 31.1263 34.4771 31.1424 34.5098 31.1715C34.5237 31.1991 34.531 31.2295 34.531 31.2603C34.531 31.2912 34.5237 31.3216 34.5098 31.3492C34.5314 31.3387 34.5551 31.3332 34.5791 31.3332C34.6031 31.3332 34.6268 31.3387 34.6484 31.3492C34.6484 31.3492 34.7474 31.3492 34.7672 31.3492C34.7473 31.2984 34.7473 31.242 34.7672 31.1912C34.7984 31.1672 34.8367 31.1542 34.8761 31.1542C34.9155 31.1542 34.9537 31.1672 34.9849 31.1912C34.9849 31.1912 34.9849 31.0531 34.9849 30.9741C35.0143 30.9463 35.0533 30.9309 35.0938 30.9309C35.1343 30.9309 35.1733 30.9463 35.2027 30.9741C35.1786 30.943 35.1656 30.9048 35.1656 30.8655C35.1656 30.8262 35.1786 30.7881 35.2027 30.757C35.2421 30.7753 35.2871 30.7773 35.328 30.7624C35.3688 30.7476 35.4021 30.7173 35.4205 30.678C35.4388 30.6387 35.4408 30.5938 35.426 30.5531C35.4111 30.5123 35.3807 30.4792 35.3413 30.4609C35.3707 30.4331 35.4097 30.4176 35.4502 30.4176C35.4907 30.4176 35.5296 30.4331 35.559 30.4609C35.5378 30.4286 35.5264 30.3909 35.5264 30.3523C35.5264 30.3137 35.5378 30.2759 35.559 30.2437C35.5766 30.2032 35.6086 30.1707 35.6488 30.1525C35.6891 30.1343 35.7347 30.1316 35.7768 30.145C35.7527 30.1139 35.7397 30.0757 35.7397 30.0364C35.7397 29.9971 35.7527 29.959 35.7768 29.9279C35.7814 29.9068 35.7903 29.8869 35.8029 29.8693C35.8155 29.8518 35.8315 29.837 35.8501 29.8259C35.8686 29.8148 35.8893 29.8077 35.9107 29.8048C35.9322 29.802 35.954 29.8035 35.9748 29.8094C35.9357 29.7959 35.9035 29.7677 35.885 29.7308C35.8665 29.6939 35.8632 29.6513 35.8758 29.612C35.8889 29.5701 35.9182 29.5352 35.9572 29.5148C35.9962 29.4944 36.0417 29.4904 36.0837 29.5034C36.1257 29.5165 36.1607 29.5457 36.1811 29.5846C36.2016 29.6235 36.2057 29.6688 36.1925 29.7107C36.179 29.7507 36.1517 29.7845 36.1154 29.8062C36.0791 29.8279 36.0363 29.8361 35.9946 29.8292C36.0337 29.8427 36.0659 29.8709 36.0844 29.9078C36.1029 29.9446 36.1062 29.9873 36.0936 30.0266C36.0624 30.0506 36.0241 30.0636 35.9847 30.0636C35.9453 30.0636 35.907 30.0506 35.8758 30.0266C35.8975 30.033 35.9176 30.044 35.9347 30.0589C35.9519 30.0737 35.9656 30.092 35.9749 30.1126C35.9843 30.1332 35.9892 30.1556 35.9891 30.1782C35.9891 30.2008 35.9842 30.2231 35.9748 30.2437C35.9535 30.2857 35.9178 30.3187 35.8743 30.3368C35.8307 30.3549 35.7821 30.3569 35.7372 30.3424C35.759 30.3488 35.7791 30.3598 35.7962 30.3747C35.8133 30.3895 35.827 30.4079 35.8364 30.4285C35.8458 30.4491 35.8506 30.4714 35.8506 30.494C35.8505 30.5166 35.8456 30.539 35.8362 30.5596C35.8297 30.5812 35.8187 30.6013 35.8038 30.6183C35.7889 30.6354 35.7705 30.6491 35.7499 30.6584C35.7292 30.6678 35.7068 30.6726 35.6841 30.6726C35.6615 30.6726 35.6391 30.6677 35.6184 30.6583C35.6463 30.6876 35.6618 30.7264 35.6618 30.7668C35.6618 30.8072 35.6463 30.8461 35.6184 30.8754C35.5858 30.9045 35.5435 30.9206 35.4997 30.9206C35.4558 30.9206 35.4135 30.9045 35.3809 30.8754C35.4066 30.9096 35.4205 30.9511 35.4205 30.9938C35.4205 31.0366 35.4066 31.0781 35.3809 31.1123C35.366 31.1291 35.3477 31.1425 35.3272 31.1518C35.3068 31.161 35.2846 31.1657 35.2621 31.1657C35.2396 31.1657 35.2174 31.161 35.1969 31.1518C35.1765 31.1425 35.1582 31.1291 35.1433 31.1123C35.1602 31.1271 35.1737 31.1453 35.1829 31.1657C35.1921 31.1862 35.1969 31.2083 35.1969 31.2307C35.1969 31.2531 35.1921 31.2753 35.1829 31.2957C35.1737 31.3161 35.1602 31.3343 35.1433 31.3492C35.1284 31.366 35.1102 31.3794 35.0897 31.3886C35.0692 31.3979 35.047 31.4026 35.0245 31.4026C35.0021 31.4026 34.9798 31.3979 34.9594 31.3886C34.9389 31.3794 34.9206 31.366 34.9058 31.3492C34.9268 31.3857 34.9356 31.428 34.9309 31.4699C34.9261 31.5118 34.908 31.551 34.8792 31.5819C34.8505 31.6128 34.8125 31.6337 34.771 31.6416C34.7295 31.6494 34.6865 31.6438 34.6484 31.6255ZM33.9159 30.8162C33.8909 30.827 33.864 30.8327 33.8367 30.8327C33.8095 30.8327 33.7825 30.827 33.7575 30.8162C33.7283 30.7836 33.7122 30.7414 33.7122 30.6977C33.7122 30.654 33.7283 30.6119 33.7575 30.5793C33.787 30.5515 33.8259 30.5361 33.8664 30.5361C33.9069 30.5361 33.9459 30.5515 33.9753 30.5793C34.0045 30.6119 34.0207 30.654 34.0207 30.6977C34.0207 30.7414 34.0045 30.7836 33.9753 30.8162H33.9159ZM33.7575 30.4609C33.7326 30.4717 33.7056 30.4773 33.6784 30.4773C33.6511 30.4773 33.6241 30.4717 33.5992 30.4609L33.8961 30.3227C33.924 30.352 33.9395 30.3909 33.9395 30.4312C33.9395 30.4716 33.924 30.5105 33.8961 30.5398L33.7575 30.4609ZM33.619 30.1055C33.5855 30.1079 33.5521 30.0997 33.5236 30.0819C33.4952 30.0642 33.4731 30.0379 33.4606 30.0068C33.4327 29.9775 33.4172 29.9386 33.4172 29.8983C33.4172 29.8579 33.4327 29.819 33.4606 29.7897C33.4185 29.7992 33.3744 29.7947 33.3351 29.7768C33.2958 29.759 33.2634 29.7289 33.2428 29.691C33.2623 29.6819 33.2798 29.6691 33.2944 29.6533C33.3089 29.6374 33.3202 29.6189 33.3275 29.5988C33.3349 29.5786 33.3382 29.5572 33.3372 29.5358C33.3363 29.5143 33.3311 29.4933 33.322 29.4738C33.3129 29.4544 33.3001 29.4369 33.2842 29.4224C33.2683 29.4079 33.2498 29.3967 33.2295 29.3894C33.2093 29.3821 33.1878 29.3788 33.1663 29.3797C33.1448 29.3807 33.1237 29.3858 33.1042 29.3949L33.3616 29.1777C33.3873 29.2119 33.4012 29.2535 33.4012 29.2962C33.4012 29.3389 33.3873 29.3804 33.3616 29.4146C33.391 29.3869 33.43 29.3714 33.4705 29.3714C33.511 29.3714 33.55 29.3869 33.5794 29.4146C33.6072 29.4439 33.6227 29.4828 33.6227 29.5232C33.6227 29.5636 33.6072 29.6024 33.5794 29.6318C33.6117 29.6105 33.6495 29.5992 33.6883 29.5992C33.727 29.5992 33.7648 29.6105 33.7971 29.6318C33.825 29.6611 33.8405 29.6999 33.8405 29.7403C33.8405 29.7807 33.825 29.8196 33.7971 29.8489L33.619 30.1055Z",
    fill: "url(#paint265_radial_336_14486)"
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9849 31.7248C34.985 31.7785 34.9741 31.8316 34.953 31.8809C34.9319 31.9302 34.9009 31.9747 34.862 32.0117C34.8231 32.0487 34.7771 32.0774 34.7268 32.0961C34.6764 32.1148 34.6228 32.123 34.5692 32.1203C34.4642 32.1203 34.3634 32.0787 34.2892 32.0045C34.2149 31.9303 34.1732 31.8297 34.1732 31.7248C34.1705 31.6713 34.1788 31.6177 34.1975 31.5674C34.2162 31.5171 34.2449 31.4712 34.282 31.4323C34.319 31.3935 34.3635 31.3626 34.4129 31.3414C34.4623 31.3203 34.5155 31.3095 34.5692 31.3096C34.6238 31.3096 34.6778 31.3203 34.7283 31.3412C34.7787 31.3621 34.8245 31.3926 34.8631 31.4312C34.9017 31.4698 34.9324 31.5155 34.9532 31.5659C34.9741 31.6163 34.9849 31.6703 34.9849 31.7248Z",
    fill: "url(#paint266_radial_336_14486)"
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7276 31.7243C34.7276 31.7663 34.7109 31.8065 34.6812 31.8362C34.6515 31.8659 34.6112 31.8825 34.5692 31.8825C34.5287 31.8782 34.4908 31.8602 34.462 31.8314C34.4332 31.8026 34.4151 31.7648 34.4108 31.7243C34.4108 31.6824 34.4275 31.6421 34.4572 31.6125C34.4869 31.5828 34.5272 31.5661 34.5692 31.5661C34.5908 31.5627 34.6128 31.5645 34.6336 31.5713C34.6544 31.578 34.6732 31.5896 34.6887 31.605C34.7041 31.6204 34.7157 31.6393 34.7224 31.66C34.7292 31.6807 34.731 31.7028 34.7276 31.7243Z",
    fill: "url(#paint267_radial_336_14486)"
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 31.2903C34.8463 31.2903 34.8463 31.2903 34.8463 31.1914C34.8463 31.0925 34.8463 31.1914 34.9453 31.1914C35.0443 31.1914 34.8463 31.2507 34.8463 31.2903Z",
    fill: "url(#paint268_radial_336_14486)"
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8464 31.3492H34.7474C34.7474 31.3492 34.7474 31.3492 34.7474 31.2503C34.7792 31.2382 34.8145 31.2382 34.8464 31.2503V31.3492Z",
    fill: "url(#paint269_radial_336_14486)"
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9651 31.4089C34.9651 31.4089 34.9651 31.4089 34.8463 31.4089C34.7275 31.4089 34.8463 31.4089 34.8463 31.3101C34.8463 31.2112 34.8463 31.3101 34.9453 31.3101L34.9651 31.4089Z",
    fill: "url(#paint270_radial_336_14486)"
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0047 31.5076C35.0047 31.5076 35.0047 31.5076 35.0047 31.4087C35.0047 31.3098 35.1037 31.4087 35.1235 31.4087C35.1433 31.4087 35.0641 31.468 35.0047 31.5076Z",
    fill: "url(#paint271_radial_336_14486)"
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0443 31.5862H34.9453C34.9634 31.5758 34.9839 31.5703 35.0047 31.5703C35.0256 31.5703 35.046 31.5758 35.0641 31.5862H35.0443Z",
    fill: "url(#paint272_radial_336_14486)"
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0245 31.8821C35.0426 31.8717 35.0631 31.8662 35.0839 31.8662C35.1048 31.8662 35.1253 31.8717 35.1433 31.8821C35.1433 31.8821 35.0839 31.8821 35.0245 31.8821Z",
    fill: "url(#paint273_radial_336_14486)"
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9849 31.9609C34.9849 31.9609 34.9849 31.9609 35.1037 31.9609C35.1037 31.9609 35.0443 31.9807 34.9849 31.9609Z",
    fill: "url(#paint274_radial_336_14486)"
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 32.0403C34.8463 32.0403 34.8463 32.0403 34.8463 31.9414C34.8463 31.8425 34.8463 31.9414 34.9651 31.9414C35.0839 31.9414 34.9651 31.9414 34.9651 32.0403H34.8463Z",
    fill: "url(#paint275_radial_336_14486)"
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 32.0991C34.8463 32.0991 34.8463 32.0991 34.9651 32.0991C35.0839 32.0991 34.9651 32.0991 34.9651 32.198C34.9651 32.2969 34.8463 32.1387 34.8463 32.0991Z",
    fill: "url(#paint276_radial_336_14486)"
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8464 32.1588C34.8359 32.1407 34.8304 32.1203 34.8304 32.0994C34.8304 32.0786 34.8359 32.0581 34.8464 32.0401C34.8614 32.0314 34.8785 32.0269 34.8958 32.0269C34.9132 32.0269 34.9303 32.0314 34.9453 32.0401C34.9558 32.0581 34.9613 32.0786 34.9613 32.0994C34.9613 32.1203 34.9558 32.1407 34.9453 32.1588H34.8464Z",
    fill: "url(#paint277_radial_336_14486)"
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6879 32.1982C34.6879 32.1982 34.6879 32.0994 34.6879 32.0796V32.1785C34.6879 32.1785 34.7077 32.2378 34.6879 32.1982Z",
    fill: "url(#paint278_radial_336_14486)"
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "M34.589 32.198V32.0991C34.6053 32.1099 34.6187 32.1246 34.628 32.1419C34.6373 32.1591 34.6421 32.1784 34.6421 32.198C34.6421 32.2176 34.6373 32.2369 34.628 32.2541C34.6187 32.2714 34.6053 32.286 34.589 32.2969C34.589 32.2969 34.589 32.2573 34.589 32.198Z",
    fill: "url(#paint279_radial_336_14486)"
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3118 32.1191C34.3118 32.1191 34.3118 32.1191 34.3118 32.2378H34.2128C34.2128 32.2378 34.292 32.1785 34.3118 32.1191Z",
    fill: "url(#paint280_radial_336_14486)"
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2326 32.0601C34.2326 32.0601 34.2326 32.0601 34.2326 32.1589C34.2326 32.2578 34.2326 32.1589 34.1337 32.1589C34.0347 32.1589 34.193 32.0996 34.2326 32.0601Z",
    fill: "url(#paint281_radial_336_14486)"
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1732 31.981C34.1732 31.981 34.1732 31.981 34.2722 31.981C34.3712 31.981 34.2722 31.981 34.2722 32.0798C34.2722 32.1787 34.2722 32.0798 34.1732 32.0798C34.0743 32.0798 34.1337 32.0205 34.1732 31.981Z",
    fill: "url(#paint282_radial_336_14486)"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1336 31.9019H34.2326C34.2326 31.9019 34.2326 31.9019 34.2326 32.0007H34.1336C34.1336 32.0007 34.0742 31.9216 34.1336 31.9019Z",
    fill: "url(#paint283_radial_336_14486)"
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M34.094 31.7046H33.9951C33.9951 31.7046 34.0347 31.7244 34.094 31.7046Z",
    fill: "url(#paint284_radial_336_14486)"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1337 31.5269C34.1337 31.5269 34.1337 31.5269 34.0347 31.5269C34.0502 31.5198 34.0671 31.5161 34.0842 31.5161C34.1012 31.5161 34.1181 31.5198 34.1337 31.5269Z",
    fill: "url(#paint285_radial_336_14486)"
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1733 31.4478H34.0743C34.0743 31.4478 34.1337 31.4082 34.1733 31.4478Z",
    fill: "url(#paint286_radial_336_14486)"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2326 31.3692C34.2326 31.3692 34.2326 31.3692 34.1337 31.3692C34.0347 31.3692 34.1337 31.3692 34.1337 31.2703C34.1337 31.1714 34.193 31.3296 34.2326 31.3692Z",
    fill: "url(#paint287_radial_336_14486)"
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3118 31.31C34.3118 31.31 34.3118 31.31 34.3118 31.4088C34.3118 31.4088 34.3118 31.4088 34.3118 31.31C34.3118 31.2111 34.292 31.2704 34.3118 31.31Z",
    fill: "url(#paint288_radial_336_14486)"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 31.231C34.5004 31.249 34.5059 31.2695 34.5059 31.2903C34.5059 31.3111 34.5004 31.3316 34.49 31.3496C34.49 31.3496 34.49 31.2507 34.49 31.231Z",
    fill: "url(#paint289_radial_336_14486)"
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 34.2512C34.8278 34.26 34.8075 34.2646 34.7869 34.2646C34.7664 34.2646 34.7461 34.26 34.7276 34.2512C34.7127 34.268 34.6944 34.2815 34.6739 34.2907C34.6534 34.2999 34.6312 34.3047 34.6088 34.3047C34.5863 34.3047 34.5641 34.2999 34.5436 34.2907C34.5231 34.2815 34.5049 34.268 34.49 34.2512C34.4731 34.2364 34.4596 34.2182 34.4504 34.1978C34.4411 34.1773 34.4364 34.1552 34.4364 34.1328C34.4364 34.1104 34.4411 34.0882 34.4504 34.0678C34.4596 34.0474 34.4731 34.0292 34.49 34.0143C34.4451 34.0288 34.3965 34.0268 34.3529 34.0087C34.3094 33.9906 34.2737 33.9576 34.2524 33.9156C34.2246 33.8863 34.2091 33.8475 34.2091 33.8071C34.2091 33.7667 34.2246 33.7278 34.2524 33.6985C34.2851 33.6694 34.3274 33.6533 34.3712 33.6533C34.415 33.6533 34.4573 33.6694 34.49 33.6985C34.5141 33.7296 34.5271 33.7678 34.5271 33.8071C34.5271 33.8464 34.5141 33.8845 34.49 33.9156C34.5029 33.9025 34.5183 33.8921 34.5353 33.8849C34.5523 33.8778 34.5705 33.8742 34.589 33.8742C34.6074 33.8742 34.6257 33.8778 34.6427 33.8849C34.6597 33.8921 34.6751 33.9025 34.688 33.9156C34.7181 33.8983 34.7522 33.8892 34.7869 33.8892C34.8217 33.8892 34.8558 33.8983 34.8859 33.9156C34.8634 33.8876 34.8512 33.8528 34.8512 33.8169C34.8512 33.7811 34.8634 33.7462 34.8859 33.7182C34.8898 33.6972 34.8985 33.6773 34.9114 33.6602C34.9243 33.6431 34.941 33.6292 34.9602 33.6197C34.9794 33.6101 35.0006 33.6051 35.022 33.6051C35.0435 33.6051 35.0647 33.61 35.0839 33.6195C35.0433 33.602 35.0107 33.5701 34.9924 33.53C34.9741 33.4899 34.9714 33.4444 34.9849 33.4024C35.0022 33.3609 35.0333 33.3265 35.0729 33.3049C35.1125 33.2834 35.1583 33.276 35.2027 33.2839C35.1815 33.2794 35.1616 33.2705 35.144 33.258C35.1264 33.2454 35.1116 33.2294 35.1005 33.2109C35.0893 33.1924 35.0821 33.1718 35.0793 33.1504C35.0764 33.129 35.078 33.1073 35.0839 33.0865C35.067 33.0575 35.0578 33.0246 35.0572 32.991C35.0566 32.9574 35.0646 32.9242 35.0804 32.8945C35.0963 32.8649 35.1195 32.8398 35.1478 32.8215C35.1761 32.8033 35.2086 32.7926 35.2423 32.7904C35.2865 32.8041 35.3236 32.8345 35.3458 32.875C35.3679 32.9155 35.3734 32.9631 35.361 33.0076C35.3195 33.003 35.2776 33.0132 35.2428 33.0363C35.208 33.0594 35.1825 33.094 35.1707 33.1341C35.1589 33.1741 35.1615 33.2169 35.1783 33.2552C35.195 33.2934 35.2246 33.3246 35.2621 33.3432C35.2575 33.3642 35.2486 33.3842 35.236 33.4017C35.2234 33.4192 35.2073 33.434 35.1888 33.4451C35.1702 33.4562 35.1496 33.4634 35.1282 33.4662C35.1067 33.4691 35.0849 33.4675 35.0641 33.4616C35.0854 33.4938 35.0967 33.5316 35.0967 33.5702C35.0967 33.6088 35.0854 33.6465 35.0641 33.6788C35.0347 33.7065 34.9957 33.722 34.9552 33.722C34.9147 33.722 34.8757 33.7065 34.8463 33.6788C34.8637 33.6953 34.8775 33.7153 34.887 33.7373C34.8964 33.7594 34.9013 33.7831 34.9013 33.8071C34.9013 33.831 34.8964 33.8548 34.887 33.8768C34.8775 33.8989 34.8637 33.9188 34.8463 33.9354C34.8754 33.9503 34.8998 33.973 34.9168 34.0008C34.9339 34.0287 34.9429 34.0607 34.9429 34.0933C34.9429 34.1259 34.9339 34.1579 34.9168 34.1858C34.8998 34.2136 34.8754 34.2363 34.8463 34.2512ZM34.2326 33.5011C34.1967 33.5022 34.1614 33.4911 34.1326 33.4696C34.1038 33.4481 34.0832 33.4174 34.0743 33.3826C34.0626 33.3594 34.0563 33.3339 34.0556 33.3079C34.0549 33.282 34.06 33.2562 34.0704 33.2324C34.0808 33.2086 34.0963 33.1873 34.1158 33.1701C34.1354 33.1529 34.1584 33.1402 34.1834 33.1329C34.2084 33.1256 34.2347 33.1238 34.2605 33.1277C34.2862 33.1316 34.3108 33.1411 34.3325 33.1555C34.3542 33.1699 34.3724 33.1889 34.3859 33.2111C34.3995 33.2332 34.408 33.2581 34.4108 33.2839C34.4349 33.315 34.4479 33.3532 34.4479 33.3925C34.4479 33.4318 34.4349 33.47 34.4108 33.5011H34.2326ZM34.1138 33.1458C34.0751 33.1461 34.0375 33.1322 34.0083 33.1067C33.9791 33.0812 33.9603 33.046 33.9555 33.0076C33.9486 32.966 33.9567 32.9233 33.9785 32.8871C34.0002 32.8509 34.0342 32.8237 34.0743 32.8102C34.0949 32.8008 34.1173 32.7959 34.14 32.7959C34.1626 32.7958 34.1851 32.8006 34.2057 32.81C34.2264 32.8194 34.2448 32.833 34.2596 32.8501C34.2745 32.8672 34.2856 32.8872 34.292 32.9089C34.2989 32.9505 34.2908 32.9932 34.269 33.0294C34.2473 33.0655 34.2133 33.0928 34.1732 33.1063L34.1138 33.1458ZM35.3412 32.8102C35.3184 32.8091 35.2962 32.8025 35.2766 32.7908C35.257 32.7791 35.2405 32.7628 35.2288 32.7432C35.217 32.7237 35.2103 32.7016 35.2092 32.6788C35.2081 32.656 35.2127 32.6334 35.2225 32.6128C35.2271 32.5917 35.2359 32.5718 35.2485 32.5543C35.2611 32.5367 35.2772 32.522 35.2958 32.5109C35.3143 32.4998 35.3349 32.4926 35.3564 32.4897C35.3778 32.4869 35.3996 32.4885 35.4204 32.4943C35.3788 32.4771 35.3443 32.4461 35.3227 32.4066C35.3011 32.3671 35.2937 32.3215 35.3017 32.2772C35.319 32.2357 35.35 32.2013 35.3896 32.1797C35.4292 32.1582 35.475 32.1508 35.5194 32.1588C35.4957 32.1541 35.4732 32.1447 35.4533 32.1312C35.4334 32.1176 35.4164 32.1001 35.4034 32.0798C35.3905 32.0595 35.3818 32.0368 35.3779 32.013C35.374 31.9893 35.375 31.965 35.3808 31.9416C35.3854 31.9205 35.3943 31.9006 35.4069 31.8831C35.4195 31.8656 35.4356 31.8508 35.4541 31.8397C35.4727 31.8286 35.4933 31.8214 35.5148 31.8186C35.5362 31.8157 35.558 31.8173 35.5788 31.8232C35.5551 31.8185 35.5326 31.8091 35.5127 31.7956C35.4928 31.782 35.4758 31.7645 35.4628 31.7442C35.4499 31.7239 35.4412 31.7012 35.4373 31.6774C35.4334 31.6537 35.4344 31.6294 35.4402 31.606C35.4448 31.5849 35.4537 31.565 35.4663 31.5475C35.4789 31.53 35.495 31.5152 35.5135 31.5041C35.5321 31.493 35.5527 31.4858 35.5741 31.483C35.5956 31.4801 35.6174 31.4817 35.6382 31.4876C35.6145 31.4829 35.592 31.4736 35.5721 31.46C35.5522 31.4464 35.5352 31.4289 35.5222 31.4086C35.5093 31.3883 35.5006 31.3656 35.4967 31.3419C35.4928 31.3181 35.4938 31.2938 35.4996 31.2704C35.5132 31.2305 35.5405 31.1966 35.5768 31.1749C35.613 31.1532 35.6559 31.1451 35.6976 31.152C35.7205 31.1541 35.7427 31.1612 35.7625 31.1727C35.7824 31.1842 35.7996 31.1999 35.8127 31.2187C35.8259 31.2375 35.8349 31.2589 35.8389 31.2815C35.8429 31.304 35.842 31.3272 35.8362 31.3494C35.8012 31.3615 35.7709 31.3842 35.7495 31.4143C35.7281 31.4443 35.7166 31.4803 35.7166 31.5172C35.7166 31.5541 35.7281 31.5901 35.7495 31.6201C35.7709 31.6502 35.8012 31.6729 35.8362 31.685C35.834 31.7078 35.827 31.7299 35.8154 31.7497C35.8039 31.7696 35.7881 31.7867 35.7693 31.7998C35.7504 31.813 35.729 31.8219 35.7063 31.8259C35.6837 31.8299 35.6604 31.829 35.6382 31.8232C35.6611 31.8253 35.6833 31.8323 35.7031 31.8439C35.723 31.8554 35.7402 31.8711 35.7534 31.8899C35.7665 31.9086 35.7755 31.9301 35.7795 31.9526C35.7836 31.9752 35.7826 31.9984 35.7768 32.0206C35.7672 32.0642 35.7416 32.1026 35.7049 32.1282C35.6682 32.1538 35.6232 32.1647 35.5788 32.1588C35.6 32.1633 35.6199 32.1722 35.6375 32.1847C35.6551 32.1973 35.6699 32.2133 35.681 32.2318C35.6922 32.2503 35.6994 32.2709 35.7022 32.2923C35.7051 32.3137 35.7035 32.3354 35.6976 32.3562C35.688 32.3998 35.6624 32.4382 35.6257 32.4638C35.589 32.4894 35.544 32.5003 35.4996 32.4943C35.5208 32.4989 35.5407 32.5078 35.5583 32.5203C35.5759 32.5329 35.5907 32.5489 35.6018 32.5674C35.613 32.5859 35.6202 32.6065 35.623 32.6279C35.6259 32.6493 35.6243 32.671 35.6184 32.6917C35.6315 32.7362 35.6264 32.7841 35.6041 32.8248C35.5818 32.8656 35.5443 32.8958 35.4996 32.9089C35.455 32.922 35.407 32.9168 35.3661 32.8946C35.3253 32.8724 35.295 32.8349 35.2819 32.7904L35.3412 32.8102ZM34.0149 32.8102C33.9761 32.8105 33.9385 32.7966 33.9093 32.7711C33.8801 32.7456 33.8613 32.7104 33.8565 32.672C33.8496 32.6304 33.8577 32.5877 33.8795 32.5515C33.9012 32.5154 33.9352 32.4881 33.9753 32.4746C34.0199 32.4623 34.0676 32.4677 34.1082 32.4898C34.1489 32.5119 34.1793 32.5489 34.193 32.593C34.193 32.6917 34.193 32.7707 34.0743 32.8102H34.0149ZM33.9159 32.4351C33.8771 32.4354 33.8395 32.4215 33.8104 32.396C33.7812 32.3706 33.7624 32.3353 33.7575 32.2969C33.7515 32.2527 33.7624 32.2078 33.7881 32.1712C33.8138 32.1346 33.8523 32.109 33.8961 32.0995C33.9378 32.0926 33.9806 32.1008 34.0169 32.1225C34.0532 32.1442 34.0805 32.178 34.0941 32.218C34.0999 32.2413 34.1009 32.2656 34.097 32.2894C34.0931 32.3131 34.0844 32.3359 34.0714 32.3562C34.0585 32.3765 34.0415 32.3939 34.0216 32.4075C34.0017 32.4211 33.9792 32.4305 33.9555 32.4351H33.9159ZM33.9159 32.06C33.8756 32.0579 33.837 32.0435 33.8051 32.0188C33.7733 31.9941 33.7498 31.9603 33.7377 31.9219C33.7317 31.8776 33.7426 31.8327 33.7683 31.7962C33.794 31.7596 33.8325 31.734 33.8763 31.7245C33.918 31.7176 33.9608 31.7257 33.9971 31.7474C34.0334 31.7691 34.0607 31.8029 34.0743 31.8429C34.0866 31.8874 34.0812 31.9349 34.059 31.9755C34.0368 32.016 33.9997 32.0463 33.9555 32.06H33.9159ZM33.9159 31.685C33.8756 31.6828 33.837 31.6684 33.8051 31.6437C33.7733 31.619 33.7498 31.5852 33.7377 31.5468C33.7318 31.5261 33.7302 31.5043 33.7331 31.4829C33.7359 31.4616 33.7431 31.441 33.7543 31.4225C33.7654 31.404 33.7802 31.388 33.7978 31.3754C33.8154 31.3628 33.8354 31.354 33.8565 31.3494C33.9011 31.3371 33.9488 31.3425 33.9894 31.3646C34.0301 31.3867 34.0605 31.4238 34.0743 31.4678C34.0803 31.5121 34.0693 31.557 34.0437 31.5935C34.018 31.6301 33.9794 31.6557 33.9357 31.6652L33.9159 31.685ZM33.9159 31.3099C33.8756 31.3077 33.837 31.2933 33.8051 31.2686C33.7733 31.2439 33.7498 31.2101 33.7377 31.1717C33.7319 31.1496 33.7309 31.1264 33.735 31.1038C33.739 31.0812 33.7479 31.0598 33.7611 31.041C33.7743 31.0222 33.7915 31.0065 33.8113 30.995C33.8312 30.9835 33.8534 30.9764 33.8763 30.9743C33.9207 30.9683 33.9657 30.9792 34.0024 31.0048C34.039 31.0305 34.0647 31.0689 34.0743 31.1125C34.0803 31.1568 34.0693 31.2016 34.0437 31.2382C34.018 31.2748 33.9794 31.3004 33.9357 31.3099H33.9159ZM35.9945 30.9743C35.9545 30.9608 35.9205 30.9336 35.8987 30.8974C35.877 30.8612 35.8688 30.8185 35.8758 30.7769C35.8893 30.737 35.9166 30.7031 35.9529 30.6814C35.9892 30.6597 36.032 30.6516 36.0737 30.6585C36.0337 30.645 35.9997 30.6177 35.9779 30.5816C35.9562 30.5454 35.948 30.5027 35.9549 30.4611C35.9685 30.4211 35.9958 30.3873 36.0321 30.3656C36.0684 30.3439 36.1112 30.3357 36.1529 30.3426C36.1758 30.3448 36.198 30.3518 36.2179 30.3633C36.2377 30.3749 36.2549 30.3906 36.2681 30.4093C36.2813 30.4281 36.2902 30.4495 36.2942 30.4721C36.2983 30.4947 36.2973 30.5179 36.2915 30.5401C36.2894 30.5629 36.2823 30.585 36.2707 30.6048C36.2592 30.6246 36.2435 30.6417 36.2246 30.6549C36.2058 30.668 36.1843 30.6769 36.1617 30.681C36.139 30.685 36.1158 30.6841 36.0935 30.6782C36.1164 30.6803 36.1386 30.6874 36.1585 30.6989C36.1784 30.7104 36.1955 30.7261 36.2087 30.7449C36.2219 30.7637 36.2308 30.7851 36.2348 30.8077C36.2389 30.8303 36.238 30.8535 36.2321 30.8756C36.24 30.9463 36.2194 31.0172 36.1748 31.0727C36.1303 31.1283 36.0654 31.1639 35.9945 31.1717C35.9237 31.1796 35.8526 31.159 35.7969 31.1146C35.7412 31.0702 35.7055 31.0055 35.6976 30.9349L35.9945 30.9743ZM33.8367 30.9743C33.7964 30.9721 33.7578 30.9577 33.7259 30.933C33.6941 30.9084 33.6706 30.8745 33.6585 30.8362C33.6527 30.814 33.6517 30.7908 33.6558 30.7682C33.6598 30.7457 33.6688 30.7242 33.682 30.7054C33.6951 30.6867 33.7123 30.671 33.7322 30.6594C33.752 30.6479 33.7742 30.6409 33.7971 30.6388C33.8415 30.6328 33.8865 30.6437 33.9232 30.6693C33.9599 30.6949 33.9855 30.7333 33.9951 30.7769C34.002 30.8185 33.9938 30.8612 33.9721 30.8974C33.9503 30.9336 33.9164 30.9608 33.8763 30.9743H33.8367ZM33.8367 30.5993C33.7979 30.5996 33.7604 30.5857 33.7312 30.5602C33.702 30.5347 33.6832 30.4995 33.6783 30.4611C33.6905 30.4262 33.7132 30.396 33.7434 30.3747C33.7735 30.3533 33.8096 30.3418 33.8466 30.3418C33.8836 30.3418 33.9197 30.3533 33.9498 30.3747C33.98 30.396 34.0027 30.4262 34.0149 30.4611C34.0139 30.504 34.0002 30.5456 33.9756 30.5807C33.9509 30.6158 33.9164 30.6429 33.8763 30.6585L33.8367 30.5993ZM36.2321 30.2637C36.192 30.2502 36.1581 30.2229 36.1363 30.1868C36.1146 30.1506 36.1064 30.1079 36.1133 30.0663C36.1268 30.0263 36.1542 29.9925 36.1905 29.9708C36.2267 29.9491 36.2696 29.9409 36.3113 29.9478C36.3342 29.95 36.3563 29.957 36.3762 29.9685C36.3961 29.98 36.4133 29.9957 36.4264 30.0145C36.4396 30.0333 36.4486 30.0547 36.4526 30.0773C36.4566 30.0999 36.4557 30.1231 36.4499 30.1452C36.4551 30.2238 36.4289 30.3012 36.3769 30.3604C36.3512 30.3897 36.3199 30.4137 36.2848 30.431C36.2498 30.4483 36.2117 30.4585 36.1727 30.4611C36.094 30.4663 36.0163 30.4401 35.9569 30.3883C35.8975 30.3365 35.8612 30.2633 35.856 30.1847L36.2321 30.2637ZM33.7575 30.2637C33.7187 30.264 33.6812 30.2501 33.652 30.2246C33.6228 30.1991 33.604 30.1639 33.5991 30.1255C33.5933 30.1033 33.5924 30.0801 33.5964 30.0576C33.6004 30.035 33.6094 30.0136 33.6226 29.9948C33.6357 29.976 33.6529 29.9603 33.6728 29.9488C33.6926 29.9373 33.7148 29.9302 33.7377 29.9281C33.7794 29.9212 33.8223 29.9293 33.8585 29.951C33.8948 29.9727 33.9222 30.0066 33.9357 30.0465C33.9417 30.0908 33.9308 30.1357 33.9051 30.1723C33.8794 30.2088 33.8409 30.2344 33.7971 30.2439L33.7575 30.2637ZM36.3113 29.9281C36.2712 29.9146 36.2373 29.8873 36.2155 29.8512C36.1937 29.815 36.1856 29.7723 36.1925 29.7307C36.2063 29.6866 36.2367 29.6496 36.2773 29.6275C36.318 29.6054 36.3657 29.5999 36.4103 29.6123C36.4314 29.6168 36.4514 29.6257 36.469 29.6382C36.4865 29.6508 36.5014 29.6668 36.5125 29.6853C36.5236 29.7038 36.5308 29.7244 36.5337 29.7458C36.5365 29.7672 36.535 29.7889 36.5291 29.8097C36.5291 29.8882 36.4978 29.9635 36.4421 30.019C36.3864 30.0746 36.3109 30.1058 36.2321 30.1058C36.1533 30.1058 36.0778 30.0746 36.0221 30.019C35.9664 29.9635 35.9351 29.8882 35.9351 29.8097L36.3113 29.9281ZM33.6981 29.9281C33.6593 29.9284 33.6218 29.9145 33.5926 29.889C33.5634 29.8636 33.5446 29.8283 33.5397 29.7899C33.5337 29.7457 33.5447 29.7008 33.5703 29.6642C33.596 29.6276 33.6346 29.602 33.6783 29.5925C33.722 29.5905 33.7651 29.603 33.8009 29.628C33.8367 29.653 33.8632 29.6891 33.8763 29.7307C33.8763 29.8294 33.8763 29.9281 33.7575 29.9281H33.6981ZM36.3905 29.5925C36.3467 29.583 36.3082 29.5574 36.2825 29.5208C36.2568 29.4842 36.2459 29.4394 36.2519 29.3951C36.2656 29.351 36.2961 29.314 36.3367 29.2919C36.3774 29.2698 36.425 29.2643 36.4697 29.2767C36.4908 29.2812 36.5108 29.2901 36.5284 29.3027C36.5459 29.3152 36.5608 29.3313 36.5719 29.3498C36.583 29.3682 36.5902 29.3888 36.5931 29.4102C36.5959 29.4316 36.5943 29.4533 36.5884 29.4741C36.5832 29.55 36.5479 29.6207 36.4904 29.6707C36.4328 29.7207 36.3577 29.7458 36.2816 29.7406C36.2055 29.7353 36.1345 29.7002 36.0844 29.6428C36.0343 29.5854 36.0091 29.5105 36.0143 29.4346L36.3905 29.5925ZM33.6387 29.5925C33.5976 29.5935 33.5574 29.5803 33.5249 29.5551C33.4924 29.53 33.4697 29.4943 33.4606 29.4543C33.4547 29.4322 33.4538 29.409 33.4578 29.3864C33.4619 29.3638 33.4708 29.3424 33.484 29.3236C33.4972 29.3048 33.5143 29.2891 33.5342 29.2776C33.5541 29.2661 33.5762 29.259 33.5991 29.2569C33.6428 29.2549 33.6859 29.2674 33.7217 29.2924C33.7575 29.3174 33.784 29.3535 33.7971 29.3951C33.8029 29.4173 33.8039 29.4405 33.7998 29.463C33.7958 29.4856 33.7869 29.507 33.7737 29.5258C33.7605 29.5446 33.7434 29.5603 33.7235 29.5718C33.7036 29.5833 33.6814 29.5904 33.6585 29.5925H33.6387ZM36.4697 29.2767C36.4259 29.2672 36.3874 29.2416 36.3617 29.205C36.336 29.1684 36.3251 29.1235 36.3311 29.0793C36.3357 29.0582 36.3445 29.0383 36.3571 29.0207C36.3698 29.0032 36.3858 28.9884 36.4044 28.9773C36.4229 28.9662 36.4436 28.9591 36.465 28.9562C36.4864 28.9534 36.5082 28.9549 36.5291 28.9608C36.4853 28.9513 36.4468 28.9257 36.4211 28.8891C36.3954 28.8526 36.3845 28.8077 36.3905 28.7634C36.3951 28.7423 36.4039 28.7224 36.4165 28.7049C36.4291 28.6874 36.4452 28.6726 36.4638 28.6615C36.4823 28.6504 36.5029 28.6432 36.5244 28.6404C36.5458 28.6375 36.5676 28.6391 36.5884 28.645C36.5447 28.6355 36.5061 28.6099 36.4805 28.5733C36.4548 28.5367 36.4439 28.4918 36.4499 28.4476C36.4405 28.4208 36.4377 28.3922 36.4418 28.3641C36.4458 28.3361 36.4564 28.3094 36.4729 28.2863C36.4894 28.2632 36.5112 28.2443 36.5364 28.2313C36.5617 28.2183 36.5897 28.2115 36.6181 28.2115C36.6466 28.2115 36.6746 28.2183 36.6998 28.2313C36.7251 28.2443 36.7469 28.2632 36.7634 28.2863C36.7798 28.3094 36.7905 28.3361 36.7945 28.3641C36.7985 28.3922 36.7958 28.4208 36.7864 28.4476C36.7843 28.4704 36.7772 28.4925 36.7657 28.5123C36.7541 28.5322 36.7384 28.5493 36.7195 28.5624C36.7007 28.5756 36.6792 28.5845 36.6566 28.5885C36.6339 28.5925 36.6107 28.5916 36.5884 28.5858C36.6322 28.5953 36.6707 28.6209 36.6964 28.6575C36.7221 28.694 36.733 28.7389 36.727 28.7832C36.7175 28.8268 36.6918 28.8652 36.6551 28.8908C36.6184 28.9164 36.5734 28.9273 36.5291 28.9213C36.5691 28.9348 36.6031 28.9621 36.6248 28.9983C36.6466 29.0344 36.6548 29.0771 36.6478 29.1187C36.64 29.192 36.6032 29.2592 36.5457 29.3055C36.4881 29.3518 36.4145 29.3734 36.341 29.3655C36.2675 29.3576 36.2001 29.321 36.1537 29.2636C36.1073 29.2062 36.0856 29.1328 36.0935 29.0595L36.4697 29.2767ZM33.5595 29.2767C33.5208 29.277 33.4832 29.2631 33.454 29.2376C33.4248 29.2121 33.406 29.1769 33.4012 29.1385C33.3992 29.0949 33.4117 29.052 33.4367 29.0163C33.4618 28.9806 33.498 28.9541 33.5397 28.9411C33.562 28.9353 33.5852 28.9343 33.6079 28.9384C33.6305 28.9424 33.652 28.9513 33.6708 28.9644C33.6897 28.9776 33.7054 28.9947 33.717 29.0145C33.7285 29.0343 33.7356 29.0564 33.7377 29.0793C33.7437 29.1235 33.7328 29.1684 33.7071 29.205C33.6814 29.2416 33.6429 29.2672 33.5991 29.2767H33.5595ZM33.5595 28.9016C33.5208 28.9019 33.4832 28.888 33.454 28.8625C33.4248 28.8371 33.406 28.8018 33.4012 28.7634C33.3952 28.7192 33.4061 28.6743 33.4318 28.6377C33.4574 28.6011 33.496 28.5755 33.5397 28.566C33.562 28.5602 33.5852 28.5593 33.6079 28.5633C33.6305 28.5673 33.652 28.5762 33.6708 28.5894C33.6897 28.6025 33.7054 28.6196 33.717 28.6394C33.7285 28.6593 33.7356 28.6814 33.7377 28.7042C33.7386 28.7504 33.7233 28.7954 33.6944 28.8315C33.6654 28.8676 33.6247 28.8924 33.5793 28.9016H33.5595ZM33.5595 28.5265C33.5193 28.5244 33.4806 28.5099 33.4488 28.4853C33.4169 28.4606 33.3934 28.4268 33.3814 28.3884C33.3794 28.3448 33.3919 28.3018 33.4169 28.2661C33.442 28.2304 33.4782 28.204 33.5199 28.191C33.5663 28.19 33.6114 28.2053 33.6476 28.2342C33.6838 28.263 33.7087 28.3036 33.7179 28.3489C33.7238 28.3711 33.7247 28.3942 33.7207 28.4168C33.7166 28.4394 33.7077 28.4608 33.6945 28.4796C33.6813 28.4984 33.6642 28.5141 33.6443 28.5256C33.6244 28.5371 33.6022 28.5442 33.5793 28.5463L33.5595 28.5265Z",
    fill: "url(#paint290_radial_336_14486)"
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 50.3787V50.2603C34.8915 50.5487 34.8502 50.844 34.7275 51.1091C34.5327 51.2891 34.3801 51.5099 34.2809 51.7556C34.1816 52.0014 34.1381 52.2659 34.1534 52.5304C34.1534 53.5174 33.7179 53.9517 33.6387 53.9714C33.5595 53.9912 33.1636 54.0701 33.3022 54.8795C33.4605 54.8795 33.6387 54.8795 33.6585 54.6821C33.7199 54.2639 33.9142 53.8764 34.2128 53.5766C34.4108 53.3792 34.2128 52.0171 34.7473 51.4644C34.8891 51.3238 34.9766 51.138 34.9947 50.9395C35.0128 50.741 34.9603 50.5425 34.8463 50.3787Z",
    fill: "url(#paint291_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M33.2032 54.3661C33.2032 54.3661 32.9854 54.6034 33.025 54.6627C33.0646 54.7221 33.2428 54.8407 33.3022 54.7616C33.3514 54.6619 33.3848 54.5552 33.4012 54.4452C33.3777 54.4162 33.3472 54.3937 33.3125 54.3798C33.2779 54.366 33.2402 54.3612 33.2032 54.3661Z",
    fill: "url(#paint292_radial_336_14486)"
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8666 53.8922C32.8666 53.8922 32.7479 54.0504 32.7677 54.0899C32.7875 54.1295 32.9062 54.2284 32.9458 54.0899C32.9586 54.0246 32.9586 53.9575 32.9458 53.8922C32.9197 53.8869 32.8928 53.8869 32.8666 53.8922Z",
    fill: "url(#paint293_radial_336_14486)"
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6093 53.478C32.6093 53.478 32.4509 53.5967 32.4509 53.6362C32.4509 53.6758 32.5499 53.7944 32.5895 53.7549C32.6407 53.7042 32.6811 53.6436 32.7083 53.5769C32.7021 53.5531 32.6896 53.5314 32.6722 53.5141C32.6548 53.4967 32.6331 53.4842 32.6093 53.478Z",
    fill: "url(#paint294_radial_336_14486)"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6687 53.0635H32.5301C32.5301 53.0635 32.5301 53.1821 32.5301 53.1624C32.568 53.1347 32.6014 53.1013 32.6291 53.0635C32.6291 53.0635 32.7083 53.0833 32.6687 53.0635Z",
    fill: "url(#paint295_radial_336_14486)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8667 54.2295C32.8474 54.1516 32.8474 54.0701 32.8667 53.9922C32.8588 53.9265 32.8588 53.8601 32.8667 53.7944L32.9855 53.6165L33.1439 53.4385L33.0053 53.5967C32.9946 53.6622 32.9946 53.7289 33.0053 53.7944C32.9974 53.8601 32.9974 53.9265 33.0053 53.9922C32.9971 54.0645 32.9971 54.1374 33.0053 54.2097L32.8667 54.2295Z",
    fill: "#020202"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6489 53.9529C32.6379 53.8874 32.6379 53.8206 32.6489 53.7551C32.6383 53.7029 32.6383 53.6491 32.6489 53.5969C32.6701 53.5377 32.7039 53.4837 32.7479 53.4387L32.8667 53.3003C32.7893 53.3982 32.7229 53.5043 32.6687 53.6167V53.7749C32.6762 53.834 32.6762 53.8938 32.6687 53.9529H32.6489Z",
    fill: "#020202"
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 53.1228C32.5302 53.1228 32.5302 53.1228 32.5302 53.0239H32.6489H32.5499L32.5302 53.1228Z",
    fill: "#020202"
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4707 53.4387C32.4605 53.3931 32.4605 53.3459 32.4707 53.3003H32.5697H32.6885H32.8271H32.7083H32.5895V53.3992V53.498L32.4707 53.4387Z",
    fill: "#020202"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.6286 43.0552L33.8367 43.4106L33.2428 43.6474L32.8469 43.8448H32.7083C32.1936 44.1607 31.9362 43.8448 31.9362 43.8448L31.6195 43.6277C31.5179 43.6226 31.4222 43.5788 31.3522 43.5053C31.2822 43.4318 31.2432 43.3343 31.2433 43.2329C30.9266 43.2329 30.9266 42.8381 30.9266 42.8381C30.5504 42.7394 30.7682 42.3841 30.7682 42.3841C30.7682 42.3841 30.7682 42.2854 30.9266 42.2656C30.9938 42.3088 31.0539 42.362 31.1047 42.4235C31.1854 42.7808 31.396 43.0955 31.6958 43.307C31.9956 43.5184 32.3634 43.6116 32.7281 43.5685C33.3758 43.3833 33.9952 43.111 34.5692 42.7591L34.6286 43.0552Z",
    fill: "url(#paint296_radial_336_14486)"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    },
    opacity: 0.5
  }, _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M30.986 43.0356H31.1641H31.3423L31.6591 42.8379C31.6591 42.8379 31.6591 42.9368 31.5007 42.9565L31.3423 43.0752H31.1641C31.1641 43.0752 31.1641 43.0752 31.0652 43.0752L30.986 43.0356Z",
    fill: "#020202"
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2037 43.3713H31.3819H31.5601L31.7185 43.2725L31.8768 43.1538L31.7382 43.2922H31.5799L31.4017 43.3911H31.2037V43.3713Z",
    fill: "#020202"
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M31.4611 43.6873L31.5798 43.5884H31.7184L32.0154 43.4697L31.7382 43.6279H31.5996H31.4611V43.6873Z",
    fill: "#020202"
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8768 43.9436L32.0154 43.8447L31.8966 43.9634L31.8768 43.9436Z",
    fill: "#020202"
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2433 42.6602L31.3621 42.7986L31.5996 43.0754L31.8768 43.3325C31.9797 43.3986 32.0937 43.4455 32.2133 43.4709C32.0872 43.4584 31.9655 43.4178 31.857 43.3523L31.5799 43.0952C31.4904 43.0123 31.4107 42.9194 31.3423 42.8184L31.2235 42.6799L31.2433 42.6602Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.1641 42.6602C31.0723 42.6458 30.9788 42.6458 30.887 42.6602C30.887 42.6602 30.887 42.8778 30.887 42.8975C30.887 42.9173 31.1641 42.8975 31.1641 42.8975C31.1871 42.8622 31.1994 42.821 31.1994 42.7789C31.1994 42.7368 31.1871 42.6956 31.1641 42.6602Z",
    fill: "url(#paint297_linear_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.4017 43.0748C31.3299 43.0604 31.2558 43.0604 31.184 43.0748C31.184 43.0748 31.184 43.233 31.184 43.2527C31.184 43.2725 31.3819 43.1539 31.3819 43.1539C31.394 43.1291 31.4007 43.1022 31.4017 43.0748Z",
    fill: "url(#paint298_linear_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.5799 43.3511H31.3819C31.3819 43.3511 31.3819 43.4895 31.4809 43.5093C31.5799 43.529 31.659 43.3906 31.659 43.3906C31.6377 43.3691 31.6099 43.3553 31.5799 43.3511Z",
    fill: "url(#paint299_linear_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M31.9362 43.6079C31.8663 43.6325 31.7998 43.6657 31.7382 43.7068C31.7382 43.7068 31.7382 43.865 31.857 43.8848C31.9758 43.9045 32.0352 43.7266 32.0352 43.7266L31.9362 43.6079Z",
    fill: "url(#paint300_linear_336_14486)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M42.4285 41.6934C42.4285 41.6934 42.2701 41.8319 42.2503 41.8121C42.2305 41.7923 42.1117 41.6737 42.2503 41.6341C42.3157 41.6213 42.3829 41.6213 42.4483 41.6341C42.4463 41.6551 42.4395 41.6754 42.4285 41.6934Z",
    fill: "url(#paint301_linear_336_14486)"
  }))), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M38.2712 36.2843C38.2712 36.2843 38.093 33.876 39.8945 33.4812C39.8945 33.4812 40.1321 33.343 39.6569 33.8365C39.2224 34.2752 38.897 34.8093 38.7067 35.396C38.7067 35.6131 39.3402 34.3498 40.0133 34.1524C40.6864 33.955 39.2412 34.6459 39.1422 35.317C39.4323 34.9437 39.8142 34.6513 40.2508 34.4682C40.8645 34.2313 39.2016 35.1394 39.1026 35.5737C39.1026 35.5737 40.3102 34.7248 40.7853 34.8235C41.2605 34.9222 39.8351 35.0012 39.261 35.8303C39.261 35.8303 39.261 35.9685 39.7757 35.5737C40.2904 35.1788 39.8945 35.5737 39.5381 35.7908C39.1818 36.0079 39.2808 36.1066 39.5381 35.9685C39.7955 35.8303 40.0133 35.8105 39.8351 35.9685C39.6569 36.1264 39.8351 35.9685 39.9935 35.9685C40.1518 35.9685 38.2316 36.8568 38.2712 36.2843Z",
    fill: "url(#paint302_radial_336_14486)"
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M30.2931 36.2448C30.2931 36.2448 30.4713 33.8167 28.6698 33.4416C28.6698 33.4416 28.4124 33.3035 28.8875 33.797C29.3354 34.2287 29.6687 34.7645 29.8576 35.3564C29.8576 35.5736 29.2241 34.3102 28.551 34.1128C27.8779 33.9154 29.3231 34.6063 29.422 35.2577C29.1283 34.8928 28.747 34.6077 28.3134 34.4286C27.6799 34.1918 29.3627 35.0801 29.4616 35.5341C29.4616 35.5341 28.2342 34.6853 27.7591 34.784C27.284 34.8827 28.7292 34.9616 29.2835 35.7907C29.2835 35.7907 29.2835 35.9289 28.7885 35.5341C28.2936 35.1393 28.6698 35.5341 29.0063 35.7512C29.3429 35.9684 29.2835 36.0671 29.0063 35.9289C28.7292 35.7907 28.5312 35.771 28.7292 35.9289C28.9271 36.0868 28.7292 35.9289 28.5708 35.9289C28.4124 35.9289 30.3327 36.7383 30.2931 36.2448Z",
    fill: "url(#paint303_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M41.201 29.8491C41.303 30.1276 41.3565 30.4213 41.3594 30.7177C41.381 31.0188 41.3406 31.3211 41.2406 31.606C41.191 31.7514 41.1246 31.8905 41.0427 32.0206C40.9684 32.1531 40.8823 32.2786 40.7853 32.3956L40.4686 32.7312L40.33 32.9089L40.1914 33.0668C39.9959 33.2971 39.8172 33.5412 39.6569 33.7972C39.4834 34.0404 39.331 34.2979 39.2016 34.567C39.0662 34.836 38.9472 35.1129 38.8452 35.3961C38.8452 35.3961 38.8452 35.5541 38.8452 35.6133C38.8357 35.692 38.8357 35.7715 38.8452 35.8502C38.8452 35.8502 38.8452 35.6922 38.8452 35.6133V35.3961C38.928 35.1025 39.0408 34.818 39.1818 34.5473C39.4556 34.0126 39.7875 33.5094 40.1716 33.047C40.2193 32.9895 40.2723 32.9367 40.33 32.8891L40.4686 32.7115L40.7853 32.3759L41.0427 32.0206C41.1167 31.8863 41.1828 31.7479 41.2406 31.606C41.4514 31.0392 41.4514 30.4159 41.2406 29.8491H41.201Z",
    fill: "#020202"
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9046 36.0477C38.8949 35.969 38.8949 35.8895 38.9046 35.8108C38.9046 35.8108 38.9046 35.8108 38.9046 35.7121C38.9046 35.6134 38.9046 35.7121 38.9046 35.5937V35.495C38.9046 35.495 38.9046 35.495 38.9046 35.3963V35.2976V35.1988C39.0703 34.9486 39.2702 34.7227 39.4985 34.5277L39.6767 34.3698H39.7757L39.9539 34.2316L40.1518 34.0934L40.33 33.975L40.528 33.8368L40.9239 33.6196L40.5478 33.8763L40.3498 33.9947L40.1716 34.1329L39.9935 34.2711L39.7955 34.3895H39.6965C39.6351 34.4246 39.5812 34.4716 39.5381 34.5277C39.2974 34.7216 39.0842 34.9475 38.9046 35.1988V35.2976V35.3963V35.495C38.8961 35.534 38.8961 35.5744 38.9046 35.6134C38.9046 35.6134 38.9046 35.6134 38.9046 35.7121C38.8951 35.7908 38.8951 35.8703 38.9046 35.949V36.0477Z",
    fill: "#020202"
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M38.8057 36.2844C38.9127 36.0836 39.0458 35.8978 39.2016 35.7317L39.3006 35.5935L39.4194 35.4751L39.5381 35.3566L39.6767 35.2382L39.7955 35.1198C39.89 35.0534 39.9892 34.994 40.0925 34.9421C40.2869 34.8237 40.4924 34.7246 40.7061 34.646L40.1122 34.9618L39.8351 35.1592L39.6965 35.2579H39.5579L39.4392 35.3764L39.3204 35.4948L39.2016 35.633C39.0539 35.8056 38.9215 35.9905 38.8057 36.1857V36.2844Z",
    fill: "#020202"
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M41.8346 34.7642L41.5574 35.0608L41.2407 35.3179L40.8843 35.5156L40.4884 35.6145L40.8645 35.4761L41.2209 35.2783C41.3388 35.2172 41.4458 35.137 41.5376 35.041C41.6503 34.9645 41.7504 34.8711 41.8346 34.7642Z",
    fill: "#020202"
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M41.7356 32.4548C41.6871 32.6046 41.6135 32.7451 41.5178 32.8701L41.3594 33.0481L41.5376 32.9097L41.696 32.7515L41.8148 32.5735C41.8222 32.5012 41.8222 32.4283 41.8148 32.356L41.7356 32.4548Z",
    fill: "#020202"
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M37.7366 26.3945C37.8868 26.4128 38.0335 26.4527 38.1722 26.513C38.322 26.5602 38.4676 26.6196 38.6077 26.6906C38.8813 26.8338 39.1343 27.0131 39.36 27.2236L39.6965 27.5592L39.9935 27.9145C40.1716 28.1712 40.33 28.4278 40.4884 28.7041C40.636 28.9728 40.7682 29.2496 40.8843 29.5332C40.9883 29.8238 41.0742 30.1205 41.1417 30.4215C41.1814 30.7295 41.1814 31.0413 41.1417 31.3493C41.1203 31.5048 41.0804 31.6573 41.0229 31.8034C40.9701 31.9449 40.8967 32.0779 40.8051 32.1982C40.9753 31.9435 41.0837 31.6529 41.1219 31.3493C41.1711 31.042 41.1711 30.7289 41.1219 30.4215C40.9897 29.8202 40.7696 29.2416 40.4686 28.7041C40.3102 28.4475 40.1518 28.1712 39.9737 27.9343C39.8975 27.8041 39.8043 27.6846 39.6965 27.5789L39.36 27.2434C39.1429 27.0314 38.8962 26.8519 38.6275 26.7104L38.192 26.513C38.0533 26.4527 37.9066 26.4128 37.7564 26.3945H37.7366Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M27.4423 29.5923C27.3978 29.7409 27.3647 29.8927 27.3433 30.0463C27.3346 30.1975 27.3346 30.3491 27.3433 30.5003C27.3427 30.8134 27.3826 31.1253 27.4621 31.4281C27.5604 31.7228 27.7003 32.002 27.8779 32.2572L28.1946 32.6125L28.4916 32.9481C28.8992 33.4311 29.2573 33.9535 29.5606 34.5076C29.705 34.7837 29.8179 35.075 29.8971 35.3762C29.9416 35.5248 29.9747 35.6766 29.9961 35.8302C30.016 35.9809 30.016 36.1335 29.9961 36.2842C30.0055 36.133 30.0055 35.9814 29.9961 35.8302C29.9747 35.6766 29.9416 35.5248 29.8971 35.3762C29.8025 35.0838 29.6833 34.7998 29.5408 34.5274C29.3824 34.251 29.224 33.9746 29.0459 33.718C28.8677 33.4614 28.6895 33.2245 28.4916 32.9876L28.1748 32.6323L27.8779 32.277C27.6811 32.0262 27.5395 31.737 27.4621 31.4281C27.4126 31.1208 27.4126 30.8076 27.4621 30.5003C27.4524 30.3492 27.4524 30.1975 27.4621 30.0463C27.4835 29.8927 27.5166 29.7409 27.5611 29.5923H27.4423Z",
    fill: "black"
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M29.7784 36.0476C29.7976 35.9698 29.7976 35.8885 29.7784 35.8107V35.712C29.7784 35.712 29.7784 35.712 29.7784 35.5936V35.4949C29.7784 35.4949 29.7784 35.4949 29.7784 35.3962C29.7784 35.2975 29.7784 35.3962 29.7784 35.2975C29.6004 35.051 29.3944 34.8258 29.1647 34.6263L28.9865 34.4881L28.8083 34.3697L28.6301 34.2315L28.4322 34.0933L28.254 33.9749L27.8779 33.7183L28.2738 33.9354L28.452 34.0736L28.6499 34.192L28.8281 34.3302L29.0261 34.4684H29.1251L29.2834 34.6263C29.5181 34.8207 29.7246 35.0466 29.8971 35.2975V35.3962V35.4949V35.5936V35.6923V35.8107C29.8991 35.8436 29.8991 35.8766 29.8971 35.9094C29.9067 35.9881 29.9067 36.0676 29.8971 36.1463L29.7784 36.0476Z",
    fill: "black"
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8773 36.3039C29.7615 36.1037 29.6219 35.9181 29.4616 35.7512L29.3428 35.613L29.224 35.4946L29.1052 35.3761H28.9865L28.8479 35.2774L28.5707 35.08L27.957 34.7642C28.1771 34.8427 28.3892 34.9418 28.5905 35.0603C28.69 35.1078 28.7831 35.1674 28.8677 35.2379L29.0063 35.3564L29.125 35.4748L29.2438 35.5933L29.3626 35.7117L29.4814 35.8499C29.6245 36.0259 29.7567 36.2105 29.8773 36.4026V36.3039Z",
    fill: "black"
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9276 34.7642C27.0099 34.866 27.1028 34.9588 27.2048 35.041C27.3037 35.1374 27.4173 35.2175 27.5413 35.2783C27.653 35.3563 27.7724 35.4226 27.8977 35.4761L28.2738 35.6145L27.8779 35.5156C27.7507 35.4659 27.6309 35.3994 27.5215 35.3179L27.185 35.0608L26.9276 34.7642Z",
    fill: "black"
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9276 32.4546L27.0266 32.6721L27.1652 32.8501L27.3235 33.0083L27.5017 33.1467H27.3829L27.1652 32.7908C27.0758 32.6647 27.0088 32.5242 26.9672 32.3755L26.9276 32.4546Z",
    fill: "black"
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M31.5798 26.1772C31.2355 26.2186 30.8969 26.298 30.5702 26.4141C30.2447 26.5152 29.9324 26.6543 29.6398 26.8287C29.4934 26.916 29.3543 27.015 29.224 27.1248L28.8281 27.4604C28.7118 27.5831 28.6059 27.7151 28.5114 27.8552V27.9539L28.3728 28.171C28.206 28.4669 28.0669 28.7775 27.957 29.0988C27.8344 29.4239 27.748 29.7615 27.6997 30.1056C27.6501 30.4459 27.6501 30.7917 27.6997 31.132C27.6997 31.132 27.6997 31.29 27.6997 31.3689V31.5071C27.6911 31.5461 27.6911 31.5865 27.6997 31.6256C27.7438 31.7889 27.8176 31.9428 27.9175 32.0796C27.8257 31.9381 27.7525 31.7855 27.6997 31.6256C27.6911 31.5865 27.6911 31.5461 27.6997 31.5071V31.3887C27.6916 31.3033 27.6916 31.2174 27.6997 31.132C27.6402 30.7858 27.6402 30.432 27.6997 30.0858C27.7457 29.7478 27.8321 29.4164 27.957 29.0988C28.074 28.7708 28.2197 28.4537 28.3926 28.1513C28.471 28.0023 28.5569 27.8573 28.6499 27.717C28.7687 27.5788 28.8677 27.4406 28.9865 27.3222L29.3824 26.9866C29.5196 26.8767 29.6652 26.7777 29.8179 26.6905C30.1106 26.5162 30.4229 26.377 30.7484 26.2759C31.0751 26.1599 31.4137 26.0804 31.758 26.0391L31.5798 26.1772Z",
    fill: "black"
  }))), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0936 33.9747C35.9748 35.6329 34.6286 35.554 34.6286 35.554C34.2441 35.513 33.8864 35.3381 33.6184 35.0601C33.3504 34.7821 33.1894 34.4187 33.1636 34.034C33.4855 33.8526 33.8323 33.7196 34.1931 33.6392C34.1931 33.6392 34.1931 33.8366 34.1931 33.8563C34.5494 34.034 34.7474 34.0142 35.0839 33.6392C35.4268 33.7311 35.7639 33.8432 36.0936 33.9747Z",
    fill: "url(#paint304_linear_336_14486)"
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4295 24.6177C38.4636 24.547 38.4681 24.4657 38.4421 24.3917C38.4161 24.3177 38.3618 24.257 38.291 24.2229C37.5981 23.7886 38.1722 23.5123 38.093 22.8608C37.9697 22.3818 37.7081 21.9494 37.3407 21.6172C37.3064 23.0676 37.4325 24.5174 37.7169 25.9403L38.9838 26.6707C38.964 26.2561 38.291 24.8941 38.4295 24.6177Z",
    fill: "url(#paint305_radial_336_14486)"
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M31.8174 25.822V25.5654C31.8174 25.9997 30.1545 26.3747 30.1545 26.3747C29.9961 25.8417 30.6494 25.1508 30.491 24.8942C30.4706 24.861 30.4575 24.824 30.4524 24.7854C30.4474 24.7468 30.4506 24.7076 30.4618 24.6703C30.473 24.633 30.492 24.5985 30.5175 24.5691C30.543 24.5396 30.5745 24.5159 30.6098 24.4994C31.2631 24.0059 30.6098 23.769 30.7088 23.1176C30.8096 22.623 31.0663 22.1734 31.4413 21.8345C31.4413 21.8345 31.4413 22.0911 31.4413 22.4464C31.4926 23.5786 31.6182 24.7062 31.8174 25.822Z",
    fill: "url(#paint306_radial_336_14486)"
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3803 23.0385C37.123 24.1242 37.0042 26.493 35.2819 26.4535C33.9309 26.4453 32.6291 25.9471 31.6195 25.052C31.6195 24.7164 31.6195 23.2951 31.4809 22.466C31.7976 21.025 32.5895 19.505 35.955 19.88C35.9748 19.8603 37.6377 21.9527 37.3803 23.0385Z",
    fill: "url(#paint307_radial_336_14486)"
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M36.826 21.4595L36.925 21.5583L37.0438 21.677L37.2615 21.8747H37.3605H37.4991H37.6179H37.7564C37.6663 21.9035 37.5694 21.9035 37.4793 21.8747C37.3868 21.8338 37.3002 21.7806 37.2219 21.7165L37.0042 21.499L36.826 21.4595Z",
    fill: "#A8A1A1"
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5499 21.104C32.5499 21.104 32.5499 21.2029 32.5499 21.2424V21.3809L32.3915 21.6182C32.3985 21.6507 32.3985 21.6844 32.3915 21.717H32.2926H32.1738H32.055H32.154H32.2728L32.4707 21.5193L32.6291 21.282C32.6739 21.2013 32.7073 21.1148 32.7281 21.0249L32.5499 21.104Z",
    fill: "#A8A1A1"
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M32.2529 21.2029V21.3608V21.5188L32.0748 21.7951C32.0169 21.8928 31.9352 21.9743 31.8372 22.032H31.6788H31.5204C31.6291 22.0103 31.7309 21.9629 31.8174 21.8938L32.0352 21.6569C32.1083 21.5744 32.1683 21.4812 32.2133 21.3806C32.2738 21.2861 32.3267 21.1871 32.3717 21.0845L32.2529 21.2029Z",
    fill: "#A8A1A1"
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2423 15.8529C35.2423 15.8529 35.1037 15.7542 34.4504 15.8529C33.7971 15.9517 33.6783 15.8529 33.6783 15.8529C33.5632 15.9013 33.4707 15.9912 33.4193 16.1047C33.3679 16.2182 33.3614 16.3468 33.4012 16.4649C33.3623 16.5802 33.3694 16.706 33.421 16.8163C33.4726 16.9265 33.5647 17.0128 33.6783 17.0571C33.6783 17.0571 33.8169 17.1755 34.4504 17.0571C35.0839 16.9387 35.2423 17.0571 35.2423 17.0571C35.3529 17.0067 35.4439 16.9214 35.5011 16.8144C35.5583 16.7074 35.5787 16.5846 35.559 16.4649C35.58 16.3424 35.5604 16.2165 35.5032 16.1061C35.4461 15.9957 35.3545 15.9069 35.2423 15.8529Z",
    fill: "url(#paint308_radial_336_14486)"
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6976 16.6232C35.6976 16.6232 35.4798 16.3863 34.49 16.485C33.5001 16.5837 33.3022 16.6232 33.3022 16.6232C33.0659 16.8504 32.8789 17.1235 32.7529 17.4258C32.6269 17.728 32.5646 18.0528 32.5697 18.3801C32.6847 18.2342 32.8285 18.1132 32.9921 18.0247C33.1557 17.9362 33.3357 17.8819 33.5211 17.8653C33.7065 17.8487 33.8933 17.87 34.0701 17.928C34.247 17.9859 34.41 18.0793 34.5494 18.2024C34.6859 18.0737 34.8484 17.9754 35.026 17.914C35.2035 17.8526 35.3922 17.8295 35.5794 17.8463C35.7665 17.8631 35.948 17.9194 36.1117 18.0114C36.2755 18.1034 36.4177 18.2291 36.529 18.3801C36.529 18.3801 36.4301 17.1167 35.6976 16.6232Z",
    fill: "url(#paint309_radial_336_14486)"
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M37.9544 23.0188C37.8904 22.4535 37.7226 21.9048 37.4595 21.4001C37.4467 21.0755 37.3286 20.7637 37.1229 20.5118C36.7939 20.302 36.4024 20.2113 36.0143 20.2551C36.3119 20.422 36.5322 20.6983 36.628 21.025C36.7468 21.5383 36.9052 21.7751 37.1229 21.8738C37.3407 21.9726 37.3803 22.6437 36.8458 23.1767C36.6992 23.4347 36.6305 23.7295 36.6478 24.0255C36.6478 24.598 35.6778 25.052 34.7869 24.519V24.2822L34.6285 24.4203L34.4702 24.2822V24.519C33.5793 25.052 32.6489 24.519 32.6093 24.0255C32.6266 23.7295 32.5579 23.4347 32.4113 23.1767C31.8768 22.6437 31.9362 21.9726 32.1342 21.8738C32.3321 21.7751 32.5103 21.5383 32.6291 21.025C32.6835 20.8581 32.7712 20.7039 32.8868 20.5716C33.0025 20.4393 33.1438 20.3316 33.3022 20.2551C33.0448 20.1367 32.5301 20.2551 32.1342 20.4131C32.0393 20.4332 31.9498 20.473 31.8713 20.5299C31.7929 20.5868 31.7273 20.6594 31.6788 20.7431C31.6303 20.8269 31.5999 20.9198 31.5897 21.016C31.5795 21.1121 31.5896 21.2094 31.6194 21.3014C31.4014 21.8475 31.2938 22.4311 31.3027 23.0188C31.3043 23.4866 31.3985 23.9495 31.5799 24.3809V24.4993C31.5799 25.664 31.9956 25.9403 31.9956 25.9403C31.9276 26.4429 32.0397 26.9533 32.3123 27.3814C32.3954 27.5122 32.4952 27.6317 32.6093 27.7367C32.7382 27.8574 32.8851 27.9573 33.0448 28.0328L33.2032 28.1315C33.4895 28.4292 33.7059 28.7865 33.8367 29.1777C33.8523 29.3779 33.9096 29.5726 34.0051 29.7494C34.1005 29.9262 34.232 30.0811 34.391 30.2042C34.5295 30.3554 34.6071 30.5522 34.6088 30.757C34.6104 30.5522 34.688 30.3554 34.8265 30.2042C34.9883 30.0838 35.1218 29.9295 35.2176 29.7521C35.3133 29.5748 35.369 29.3788 35.3808 29.1777C35.3808 29.1777 35.6976 28.25 36.1727 28.0328C36.5484 27.8411 36.8529 27.5347 37.0417 27.1583C37.2304 26.7818 37.2936 26.3551 37.2219 25.9403C37.2219 25.9403 37.6575 25.6442 37.6377 24.3809C37.8327 23.9522 37.9403 23.4892 37.9544 23.0188Z",
    fill: "url(#paint310_radial_336_14486)"
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5098 14.4912C34.5098 14.4912 33.9555 14.7873 33.9555 15.1426C33.9473 15.2231 33.9552 15.3043 33.9786 15.3817C34.0021 15.4591 34.0408 15.5311 34.0923 15.5935C34.1438 15.6559 34.2073 15.7075 34.2789 15.7453C34.3506 15.7831 34.429 15.8064 34.5098 15.8138C34.6708 15.794 34.818 15.7133 34.9212 15.5885C35.0243 15.4636 35.0755 15.304 35.0641 15.1426C35.0641 14.7873 34.5098 14.4912 34.5098 14.4912Z",
    fill: "url(#paint311_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4499 20.6304C36.5349 20.6473 36.6156 20.6809 36.6875 20.7292C36.745 20.7939 36.7917 20.8673 36.826 20.9468C36.8993 20.9904 36.9605 21.0516 37.0042 21.1247C37.0042 21.1247 37.0042 21.1247 37.0042 21.2434C36.9723 21.1669 36.9325 21.094 36.8854 21.0259L36.826 20.9468L36.6281 20.8083L36.3905 20.7095L36.4499 20.6304Z",
    fill: "#070707"
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0143 20.2554H36.3113L36.6082 20.3542C36.7023 20.3923 36.7892 20.4458 36.8656 20.5124C36.9474 20.5765 37.0036 20.6677 37.024 20.7695C36.9688 20.6879 36.9021 20.6147 36.826 20.552C36.7594 20.4775 36.6787 20.417 36.5884 20.374L36.3113 20.2751H36.0143V20.2554Z",
    fill: "#070707"
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3022 20.2554C33.1098 20.2736 32.9256 20.3416 32.7677 20.4528C32.6878 20.503 32.6201 20.5705 32.5697 20.6502V20.7884C32.505 20.9729 32.4115 21.1462 32.2926 21.3016C32.2298 21.3775 32.1565 21.4439 32.0748 21.499C31.9965 21.5629 31.9099 21.616 31.8174 21.6569C31.9927 21.5715 32.1427 21.4423 32.253 21.2819C32.3756 21.1327 32.4757 20.9664 32.5499 20.7884C32.5525 20.7423 32.5525 20.6962 32.5499 20.6502C32.6003 20.5705 32.668 20.503 32.7479 20.4528C32.9154 20.3494 33.1057 20.2884 33.3022 20.2751V20.2554Z",
    fill: "#070707"
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4311 20.4136C32.3579 20.4572 32.2967 20.5184 32.253 20.5916L32.1342 20.7893L32.0352 21.0266V21.1453C32.0352 21.1453 32.0352 21.1453 32.0352 21.2441C32.0352 21.2441 32.0352 21.2441 32.0352 21.1255C32.0266 21.0864 32.0266 21.0459 32.0352 21.0068C32.056 20.9294 32.0895 20.8559 32.1342 20.7893L32.2727 20.5718L32.4509 20.4136H32.4311Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M33.1834 16.9985L33.0646 17.137V17.2952C33.0534 17.3473 33.0534 17.4012 33.0646 17.4534C33.0547 17.5123 33.0547 17.5724 33.0646 17.6313C33.045 17.5736 33.045 17.5111 33.0646 17.4534C33.0554 17.3944 33.0554 17.3344 33.0646 17.2754L33.1636 17.137L33.2824 16.9985H33.1834Z",
    fill: "#070707"
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M33.3418 16.9983C33.3353 17.0442 33.3353 17.0908 33.3418 17.1367C33.3325 17.1957 33.3325 17.2557 33.3418 17.3147C33.3306 17.3668 33.3306 17.4208 33.3418 17.4729C33.3322 17.414 33.3322 17.3539 33.3418 17.2949V17.1367V16.9785V16.9983Z",
    fill: "#070707"
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5397 16.9985C33.5329 17.051 33.5329 17.1042 33.5397 17.1567C33.5397 17.1567 33.5397 17.2754 33.5397 17.3149C33.5285 17.3671 33.5285 17.421 33.5397 17.4731C33.5199 17.524 33.5199 17.5805 33.5397 17.6313C33.5247 17.5864 33.5247 17.5378 33.5397 17.4929C33.5201 17.4352 33.5201 17.3726 33.5397 17.3149C33.5216 17.2102 33.5216 17.1032 33.5397 16.9985Z",
    fill: "#070707"
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8367 16.9985C33.8179 17.1098 33.8179 17.2234 33.8367 17.3347C33.827 17.387 33.827 17.4406 33.8367 17.4929C33.8265 17.5385 33.8265 17.5858 33.8367 17.6313C33.8367 17.6313 33.8367 17.6313 33.7377 17.4929C33.7265 17.4408 33.7265 17.3868 33.7377 17.3347C33.7265 17.2229 33.7265 17.1103 33.7377 16.9985H33.8367Z",
    fill: "#070707"
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1534 16.9985C34.1347 17.0965 34.1347 17.1972 34.1534 17.2952V17.4534C34.1384 17.4983 34.1384 17.5469 34.1534 17.5918C34.1534 17.5918 34.1534 17.5918 34.1534 17.4534V17.2952V16.9985Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8163 16.998L35.9351 17.1167C35.9751 17.1647 36.0084 17.2179 36.0341 17.2749C36.0434 17.3339 36.0434 17.3939 36.0341 17.4529C36.0537 17.5106 36.0537 17.5731 36.0341 17.6308C36.0441 17.5719 36.0441 17.5118 36.0341 17.4529C36.0434 17.3939 36.0434 17.3339 36.0341 17.2749V17.1365L35.8163 16.998Z",
    fill: "#070707"
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M35.658 17.1562C35.658 17.1562 35.658 17.1562 35.658 17.3144C35.6668 17.2621 35.6668 17.2086 35.658 17.1562Z",
    fill: "#070707"
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M35.46 16.998C35.4803 17.1025 35.4803 17.21 35.46 17.3144C35.4799 17.3653 35.4799 17.4218 35.46 17.4726C35.4799 17.5235 35.4799 17.58 35.46 17.6308C35.4689 17.5785 35.4689 17.525 35.46 17.4726C35.4697 17.4204 35.4697 17.3667 35.46 17.3144C35.46 17.3144 35.46 17.2156 35.46 17.1562C35.4689 17.1039 35.4689 17.0504 35.46 16.998Z",
    fill: "#070707"
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1631 16.998C35.1721 17.1033 35.1721 17.2092 35.1631 17.3144C35.1727 17.3734 35.1727 17.4335 35.1631 17.4924C35.1631 17.4924 35.1631 17.6111 35.0641 17.6308C35.0743 17.5853 35.0743 17.538 35.0641 17.4924C35.0726 17.44 35.0726 17.3866 35.0641 17.3342C35.0845 17.2231 35.0845 17.1092 35.0641 16.998H35.1631Z",
    fill: "#070707"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 16.8794V17.1958V17.3342C34.8463 17.3342 34.8463 17.4529 34.8463 17.4726C34.8556 17.4507 34.8603 17.4272 34.8603 17.4034C34.8603 17.3797 34.8556 17.3561 34.8463 17.3342V17.1958C34.8671 17.0914 34.8671 16.9838 34.8463 16.8794Z",
    fill: "#070707"
  }))), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4991 22.1304C37.2021 22.1304 37.1625 22.5647 37.2615 22.9792C37.3392 23.2568 37.3392 23.5504 37.2615 23.828C37.3803 23.828 37.7564 23.2358 37.8158 22.8608C37.8752 22.4857 37.7762 22.1304 37.4991 22.1304Z",
    fill: "url(#paint312_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "M37.2814 22.644V22.4268V22.3281C37.2899 22.3671 37.2899 22.4076 37.2814 22.4466C37.2911 22.5252 37.2911 22.6048 37.2814 22.6835C37.2604 22.8326 37.2205 22.9786 37.1626 23.1177C37.1378 23.1936 37.1046 23.2664 37.0636 23.3349H37.1626V23.2362L37.2616 23.0388C37.3061 22.8902 37.3391 22.7384 37.3605 22.5847C37.3695 22.5126 37.3695 22.4397 37.3605 22.3676C37.3605 22.3676 37.3605 22.3676 37.2616 22.3676V22.565L37.2814 22.644Z",
    fill: "#020202"
  }))), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0154 22.9199C32.0154 22.5053 32.0154 22.0908 31.7778 22.0711C31.5403 22.0513 31.4809 22.4264 31.5403 22.8014C31.5997 23.1765 31.956 23.8674 32.0748 23.7687C31.9822 23.4956 31.9617 23.2032 32.0154 22.9199Z",
    fill: "url(#paint313_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9758 22.644C31.9837 22.5784 31.9837 22.5122 31.9758 22.4466C31.9658 22.5186 31.9658 22.5917 31.9758 22.6637C31.9552 22.8078 31.9552 22.954 31.9758 23.098C32.0005 23.1739 32.0337 23.2467 32.0748 23.3152H31.956V23.2165C31.9489 23.1508 31.9489 23.0847 31.956 23.0191C31.8927 22.8759 31.8591 22.7215 31.857 22.565C31.8366 22.4941 31.8366 22.4189 31.857 22.3479C31.8678 22.3316 31.8825 22.3182 31.8998 22.309C31.9171 22.2998 31.9364 22.2949 31.956 22.2949C31.9756 22.2949 31.9949 22.2998 32.0122 22.309C32.0294 22.3182 32.0441 22.3316 32.055 22.3479V22.5453L31.9758 22.644Z",
    fill: "#020202"
  }))), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6874 20.9463L36.8062 21.0847L36.9448 21.2231L37.1824 21.5L37.4595 21.7175H37.6377C37.6886 21.7374 37.7451 21.7374 37.7961 21.7175C37.6873 21.7568 37.5682 21.7568 37.4595 21.7175C37.3442 21.6612 37.2428 21.5802 37.1626 21.4802C37.0667 21.3978 36.9804 21.3049 36.9052 21.2034C36.8235 21.1115 36.7506 21.0122 36.6874 20.9067V20.9463Z",
    fill: "#A8A1A1"
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M37.0636 30.0067C36.8136 29.833 36.5306 29.7121 36.2321 29.6514C35.9351 29.6514 35.6382 31.3293 35.6382 31.6254C35.6382 31.9215 36.3707 32.1386 36.529 32.1386C36.6874 32.1386 36.727 31.8623 36.727 31.8623V31.507L36.826 31.0529L36.9646 30.6384L37.0636 30.0067Z",
    fill: "url(#paint314_radial_336_14486)"
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5291 32.0399C36.2713 31.8671 35.9821 31.7464 35.6778 31.6846C35.4007 31.6846 35.1037 33.3625 35.1037 33.6586C35.1037 33.9547 35.8164 34.1916 35.9748 34.1916C36.1331 34.1916 36.1925 33.8955 36.1925 33.8955V33.5402L36.2915 33.0861L36.4301 32.6716L36.5291 32.0399Z",
    fill: "url(#paint315_linear_336_14486)"
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M38.1326 25.6839C38.291 25.5063 38.0336 25.3483 38.0336 25.3483C38.0529 25.2636 38.0462 25.175 38.0144 25.094C37.9827 25.0131 37.9273 24.9435 37.8554 24.8943C37.8773 24.8181 37.8713 24.7367 37.8387 24.6644C37.8061 24.5922 37.7489 24.5338 37.6773 24.4995C37.6773 25.6642 37.2813 25.9406 37.2813 25.9406C37.3396 26.4427 37.2281 26.9498 36.9646 27.3816C36.8749 27.5132 36.7684 27.6327 36.6478 27.7369C36.9695 27.8279 37.3035 27.8679 37.6377 27.8554C37.7762 27.8554 37.7564 27.5593 37.7564 27.5593L37.8554 27.1842C37.9111 27.1255 37.9422 27.0478 37.9422 26.967C37.9422 26.8863 37.9111 26.8086 37.8554 26.7499C37.925 26.686 37.9763 26.6048 38.0042 26.5146C38.032 26.4244 38.0353 26.3285 38.0138 26.2367C38.3503 26.059 38.1326 25.6839 38.1326 25.6839Z",
    fill: "url(#paint316_linear_336_14486)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.6677 25.1321C36.6869 25.2234 36.6869 25.3176 36.6677 25.4089C36.6773 25.4612 36.6773 25.5148 36.6677 25.5671C36.6791 25.4752 36.6791 25.3822 36.6677 25.2903C36.6775 25.1916 36.6775 25.0923 36.6677 24.9936C36.6789 24.9017 36.6789 24.8087 36.6677 24.7168V25.1321Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.826 25.0127C36.9361 25.2014 37.01 25.4089 37.0438 25.6246C37.0542 25.7297 37.0542 25.8355 37.0438 25.9405C37.0536 26.0455 37.0536 26.1513 37.0438 26.2563C37.0438 26.3748 37.0438 26.4735 37.0438 26.5722L36.826 26.8683C36.7128 27.0472 36.5647 27.2016 36.3905 27.3223C36.6085 27.0997 36.783 26.8387 36.9052 26.5524C36.9052 26.4537 36.9052 26.355 36.9052 26.2366C36.9253 26.0331 36.9253 25.8281 36.9052 25.6246C36.8735 25.4222 36.8204 25.2237 36.7468 25.0324L36.826 25.0127Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.826 27.0261C36.7755 27.1524 36.7089 27.2719 36.6281 27.3814L36.5093 27.5393L36.3509 27.6973L36.2123 27.8157C36.1566 27.8512 36.1093 27.8983 36.0737 27.9539L35.8362 28.2697C35.8795 28.1439 35.9394 28.0244 36.0144 27.9144L36.1529 27.7565L36.2915 27.6183C36.3981 27.5416 36.4917 27.4483 36.5687 27.3419C36.6653 27.2388 36.7515 27.1264 36.826 27.0063V27.0261Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.4199 25.2695C37.4199 25.2695 37.4199 25.3882 37.4199 25.4475V25.7441V25.9023C37.4199 25.9023 37.4199 25.9023 37.4199 25.7441C37.4199 25.5859 37.4199 25.6255 37.4199 25.5859L37.5387 25.2695H37.4199Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.5296 24.993C34.5296 24.993 34.5296 24.993 34.5296 25.1114L34.6286 25.3088L34.7672 25.4865C34.7781 25.5319 34.7781 25.5792 34.7672 25.6246C34.7854 25.7092 34.7854 25.7967 34.7672 25.8813C34.7672 25.98 34.7672 26.0589 34.7672 26.1379C34.7081 26.2989 34.6282 26.4515 34.5296 26.5919C34.6089 26.4441 34.6625 26.2839 34.688 26.1181C34.7379 25.9642 34.7379 25.7984 34.688 25.6444C34.6986 25.6123 34.6986 25.5777 34.688 25.5457C34.6353 25.4847 34.5889 25.4185 34.5494 25.3483C34.5323 25.2702 34.5323 25.1894 34.5494 25.1114C34.5186 25.0354 34.5186 24.9505 34.5494 24.8745L34.5296 24.993Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.391 24.8945C34.3622 24.9843 34.3622 25.0809 34.391 25.1708C34.3708 25.2552 34.3708 25.3431 34.391 25.4275C34.4193 25.5202 34.4744 25.6026 34.5494 25.6643C34.5664 25.7223 34.5664 25.784 34.5494 25.842C34.5725 25.899 34.5725 25.9627 34.5494 26.0197V26.1381C34.5322 26.2161 34.5322 26.2969 34.5494 26.375C34.5296 26.466 34.5296 26.5603 34.5494 26.6513C34.5408 26.7367 34.5408 26.8226 34.5494 26.908C34.5494 26.908 34.5494 27.0856 34.5494 27.1646C34.5494 27.2436 34.5494 27.3225 34.5494 27.4212C34.5397 27.4999 34.5397 27.5794 34.5494 27.6581C34.5401 27.697 34.5401 27.7376 34.5494 27.7765C34.5358 27.8149 34.5358 27.8567 34.5494 27.895V27.7963C34.5408 27.7573 34.5408 27.7169 34.5494 27.6778C34.5404 27.5925 34.5404 27.5065 34.5494 27.4212C34.5292 27.2507 34.5292 27.0785 34.5494 26.908C34.5076 26.8192 34.4745 26.7267 34.4504 26.6316C34.4312 26.5338 34.4312 26.4333 34.4504 26.3355C34.4692 26.2358 34.5097 26.1414 34.5692 26.0591V25.9407C34.5809 25.8954 34.5809 25.8478 34.5692 25.8025C34.5778 25.7569 34.5778 25.71 34.5692 25.6643C34.5051 25.5863 34.4518 25.4999 34.4108 25.4077C34.3673 25.322 34.3447 25.2274 34.3447 25.1313C34.3447 25.0353 34.3673 24.9407 34.4108 24.855L34.391 24.8945Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.688 24.9929C34.688 24.9929 34.688 24.9929 34.688 25.0918C34.6787 25.1308 34.6787 25.1714 34.688 25.2104C34.6786 25.1382 34.6786 25.0651 34.688 24.9929Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.154 24.3025V24.52V24.6189C32.1446 24.6512 32.1446 24.6855 32.154 24.7178C32.1464 24.7503 32.1464 24.7841 32.154 24.8166V24.7178C32.1428 24.6457 32.1428 24.5723 32.154 24.5002C32.1336 24.4292 32.1336 24.3538 32.154 24.2827C32.1363 24.218 32.1363 24.1497 32.154 24.085V24.3025Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.9956 24.2624V24.5783C31.986 24.6305 31.986 24.684 31.9956 24.7362V25.0323C31.9956 25.0323 31.9956 25.0323 31.9956 25.1705C32.0196 25.2719 32.0528 25.371 32.0946 25.4666C32.023 25.3791 31.9692 25.2785 31.9362 25.1705C31.9254 25.0655 31.9254 24.9596 31.9362 24.8546C31.927 24.7495 31.927 24.6439 31.9362 24.5388C31.9362 24.4401 31.9362 24.3414 31.9362 24.2427L31.9956 24.2624Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.46 28.5067C35.3756 28.6067 35.3087 28.7201 35.2621 28.8423C35.2528 28.9011 35.2528 28.9611 35.2621 29.0199C35.2527 29.0522 35.2527 29.0864 35.2621 29.1186V29.2371C35.2621 29.2371 35.2621 29.2371 35.2621 29.3555C35.2713 29.3945 35.2713 29.435 35.2621 29.474C35.2198 29.5361 35.166 29.5897 35.1037 29.6319H34.8859L35.0245 29.474L35.1235 29.3358V29.1779V29.0397V28.9212C35.1113 28.8895 35.1113 28.8543 35.1235 28.8225C35.1031 28.7516 35.1031 28.6764 35.1235 28.6054C35.194 28.4828 35.2882 28.3755 35.4006 28.2896L35.46 28.5067Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.5302 26.2368C32.5439 26.4853 32.5904 26.7309 32.6687 26.9672L32.8469 27.3028L33.1043 27.5792L33.4012 27.8358L33.6586 28.1319C33.7258 28.2462 33.7853 28.3649 33.8367 28.4872C33.897 28.6034 33.9308 28.7315 33.9357 28.8623L33.7576 28.5464C33.5965 28.3464 33.4247 28.1553 33.2428 27.974L32.8667 27.362C32.7918 27.252 32.7319 27.1325 32.6885 27.0067C32.6494 26.7515 32.6494 26.492 32.6885 26.2368H32.5302Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.1535 28.9807C34.2316 29.2174 34.2316 29.2174 34.3108 29.4543L34.3119 29.5729C34.3119 29.5729 34.3119 29.5729 34.3119 29.6716C34.3119 29.7703 34.3119 29.6716 34.3119 29.8098V29.9282C34.242 29.8699 34.1876 29.7953 34.1535 29.7111C34.1421 29.6325 34.1421 29.5527 34.1535 29.4742C34.1535 29.4742 34.1535 29.2965 34.1535 29.2176V28.9609V28.9807Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.8667 25.3481C32.8568 25.4664 32.8568 25.5852 32.8667 25.7035C32.8571 25.8151 32.8571 25.9274 32.8667 26.0391C32.9059 26.1423 32.9389 26.2478 32.9657 26.3549C32.9657 26.3549 32.9657 26.3549 32.9657 26.4536C32.9657 26.5523 32.9657 26.5523 32.9657 26.6313V26.4536C32.9753 26.3948 32.9753 26.3348 32.9657 26.2759V25.9206C32.9468 25.8029 32.9468 25.683 32.9657 25.5653L32.8667 25.3481Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.7174 26.5918V26.7102L35.6184 26.8089C35.5547 26.8727 35.5012 26.946 35.4601 27.0261C35.4025 27.0906 35.3558 27.1639 35.3215 27.2432C35.313 27.322 35.313 27.4014 35.3215 27.4801C35.3125 27.5588 35.3125 27.6383 35.3215 27.717V27.9736C35.3215 27.9736 35.3215 28.1513 35.3215 28.2302C35.3215 28.3092 35.3215 28.2302 35.3215 28.3684C35.3215 28.5066 35.3215 28.3684 35.3215 28.4869C35.324 28.4408 35.324 28.3947 35.3215 28.3487C35.3215 28.3487 35.3215 28.3487 35.3215 28.2105C35.3108 28.1187 35.3108 28.026 35.3215 27.9341C35.3027 27.8496 35.3027 27.762 35.3215 27.6775C35.3127 27.5856 35.3127 27.4931 35.3215 27.4011C35.3945 27.2344 35.4949 27.081 35.6184 26.9471L35.7966 26.7497H35.8956V26.651L35.7174 26.5918Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.7565 23.7495V23.9074L37.8555 24.0456L37.9544 24.1641V24.2825C37.9687 24.3409 37.9687 24.4018 37.9544 24.4602V24.8944V24.776C37.9107 24.7386 37.8768 24.6912 37.8555 24.6378C37.8484 24.5854 37.8484 24.5323 37.8555 24.4799V24.322C37.8555 24.322 37.8555 24.2035 37.8555 24.1443L37.7565 23.7495Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.6773 23.8281C37.6559 23.9753 37.6228 24.1205 37.5783 24.2624C37.5463 24.4139 37.493 24.5601 37.4199 24.6967V24.7954V24.9731C37.4087 25.111 37.4087 25.2497 37.4199 25.3876C37.3672 25.3259 37.333 25.2506 37.3209 25.1705C37.3008 25.0928 37.3008 25.0113 37.3209 24.9336C37.3031 24.8556 37.3031 24.7747 37.3209 24.6967C37.3613 24.6419 37.3945 24.5822 37.4199 24.519C37.4306 24.4537 37.4306 24.387 37.4199 24.3216L37.5981 23.9268L37.6773 23.8281Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.5601 23.4531L31.4413 23.6308V23.8282C31.4492 23.8938 31.4492 23.96 31.4413 24.0256V24.144V24.2427C31.4495 24.3149 31.4495 24.3877 31.4413 24.4599L30.887 24.8942H30.788V24.6968C30.817 24.629 30.8501 24.5631 30.887 24.4994V24.4007C30.8976 24.3686 30.8976 24.334 30.887 24.302L31.0058 24.1046C31.038 24.0346 31.0778 23.9684 31.1246 23.9072L31.2631 23.7492C31.3154 23.6862 31.3838 23.6385 31.4611 23.611L31.5601 23.4531Z",
    fill: "#A8A1A1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6393 21.7358C31.6497 21.8409 31.6497 21.9467 31.6393 22.0517C31.6393 22.0517 31.6393 22.1701 31.6393 22.2096C31.6505 22.2617 31.6505 22.3155 31.6393 22.3675C31.6393 22.3675 31.6393 22.486 31.6393 22.5255C31.6453 22.5779 31.6453 22.6309 31.6393 22.6834L31.5205 22.8018H31.3621C31.3831 22.6995 31.4163 22.6001 31.4611 22.5057C31.4668 22.4664 31.4668 22.4265 31.4611 22.3873V22.2491V22.1109C31.5029 22.0154 31.5361 21.9163 31.5601 21.8148L31.6393 21.7358Z",
    fill: "#A8A1A1"
  }))), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M37.6971 27.8158C37.6894 27.7905 37.6767 27.7669 37.6596 27.7466C37.6426 27.7262 37.6217 27.7095 37.5981 27.6974C37.5253 27.5968 37.4304 27.5142 37.3205 27.456C37.2107 27.3979 37.0889 27.3656 36.9646 27.3618C36.9646 27.5197 36.7072 27.6382 36.5489 27.8356C36.3905 28.033 36.2717 28.0132 36.2321 28.2501C36.1925 28.487 36.2321 28.3686 36.2321 28.4278C36.0721 28.8814 36.0721 29.3758 36.2321 29.8293C36.3634 29.9354 36.5173 30.01 36.682 30.0477C36.8467 30.0853 37.0178 30.0849 37.1823 30.0465C37.3803 29.9281 37.2813 29.6517 37.2813 29.6517L37.4991 29.2964C37.5409 29.239 37.5635 29.1699 37.5635 29.099C37.5635 29.028 37.5409 28.9589 37.4991 28.9016C37.481 28.8281 37.4824 28.7513 37.5032 28.6785C37.5241 28.6058 37.5636 28.5398 37.6179 28.487C37.8158 28.3488 37.6179 28.0922 37.6179 28.0922C37.6179 28.0922 37.7367 27.8751 37.6971 27.8158Z",
    fill: "url(#paint317_linear_336_14486)"
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3605 20.9461C37.1117 20.6244 36.7519 20.4063 36.3509 20.3342C36.1939 20.3052 36.0328 20.3052 35.8758 20.3342H35.5194C35.1741 20.4061 34.8493 20.5546 34.5692 20.7685C34.3303 20.5919 34.0623 20.4583 33.7773 20.3737C33.6522 20.3626 33.5263 20.3626 33.4012 20.3737C33.2185 20.3341 33.0295 20.3341 32.8469 20.3737C32.3924 20.4689 31.986 20.7205 31.6987 21.0843C31.7432 20.1036 32.1526 19.1746 32.8469 18.4786C32.8469 18.4786 33.1834 18.1233 34.6088 18.2812C36.0539 18.1233 36.3905 18.4786 36.3905 18.4786C37.0191 19.1467 37.3664 20.03 37.3605 20.9461Z",
    fill: "url(#paint318_radial_336_14486)"
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5194 20.275C35.1741 20.347 34.8493 20.4954 34.5692 20.7093C34.3303 20.5327 34.0623 20.3991 33.7773 20.3145V20.1171C33.7866 20.0782 33.7866 20.0376 33.7773 19.9987C33.7773 19.9987 33.7773 19.9987 33.7773 19.8802V19.7618C33.7704 19.7293 33.7704 19.6956 33.7773 19.6631H33.8961H34.0347H34.1732H34.4108H34.5494H34.688H34.8067L34.9057 19.7618C34.9114 19.8011 34.9114 19.841 34.9057 19.8802V20.0184C34.9083 20.0644 34.9083 20.1106 34.9057 20.1566V20.275H35.5194Z",
    fill: "url(#paint319_radial_336_14486)"
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6285 19.8802C34.5369 19.8688 34.4445 19.8933 34.3706 19.9486C34.2968 20.004 34.2473 20.0858 34.2326 20.1768C34.2207 20.2707 34.2446 20.3656 34.2997 20.4425C34.3547 20.5195 34.4368 20.5729 34.5296 20.5921C34.6255 20.5988 34.7206 20.5704 34.7971 20.5121C34.8736 20.4539 34.9263 20.3699 34.9453 20.2757C34.9508 20.2289 34.9469 20.1815 34.934 20.1362C34.921 20.0909 34.8991 20.0486 34.8696 20.0118C34.8402 19.975 34.8037 19.9445 34.7623 19.9219C34.7209 19.8993 34.6755 19.8851 34.6285 19.8802Z",
    fill: "url(#paint320_radial_336_14486)"
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6783 20.334H33.4606C33.4606 20.334 33.322 20.334 33.3022 20.4329C33.4273 20.4218 33.5532 20.4218 33.6783 20.4329V20.334Z",
    fill: "url(#paint321_radial_336_14486)"
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5199 19.9395C33.6387 19.9395 33.7179 19.9395 33.7179 20.0779C33.7179 20.2163 33.5991 20.1966 33.4803 20.0779C33.3616 19.9593 33.2824 20.0779 33.3022 19.9197C33.322 19.7615 33.4011 19.9197 33.5199 19.9395Z",
    fill: "url(#paint322_radial_336_14486)"
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5992 19.7225C33.7179 19.7225 33.7773 19.8609 33.7575 19.9203C33.7377 19.9796 33.6388 19.9203 33.52 19.9203C33.4012 19.9203 33.3418 19.7818 33.3616 19.7225C33.3814 19.6632 33.5002 19.683 33.5992 19.7225Z",
    fill: "url(#paint323_radial_336_14486)"
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7179 19.5445C33.8169 19.5445 33.8763 19.7027 33.8367 19.762C33.7971 19.8213 33.6981 19.762 33.5991 19.762C33.5002 19.762 33.4408 19.6038 33.4804 19.5445C33.52 19.4852 33.6189 19.4852 33.7179 19.5445Z",
    fill: "url(#paint324_radial_336_14486)"
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8763 19.3865C33.8763 19.3865 33.9951 19.5842 33.8763 19.6238C33.7575 19.6633 33.7179 19.6238 33.6387 19.6238C33.5596 19.6238 33.52 19.426 33.6387 19.3865C33.7575 19.3469 33.7971 19.3074 33.8763 19.3865Z",
    fill: "url(#paint325_radial_336_14486)"
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0742 19.2685C34.0972 19.3038 34.1095 19.345 34.1095 19.3871C34.1095 19.4293 34.0972 19.4705 34.0742 19.5058C34.0742 19.5058 33.9159 19.5058 33.8565 19.5058C33.8291 19.4685 33.8144 19.4235 33.8144 19.3772C33.8144 19.331 33.8291 19.286 33.8565 19.2487C33.8565 19.2487 33.9951 19.1696 34.0742 19.2685Z",
    fill: "url(#paint326_radial_336_14486)"
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2722 19.1893C34.2722 19.2882 34.2722 19.4068 34.2722 19.4266C34.2722 19.4464 34.1337 19.4266 34.0941 19.2684C34.0545 19.1102 34.0941 19.0509 34.0941 19.0311C34.0941 19.0113 34.2129 19.0706 34.2722 19.1893Z",
    fill: "url(#paint327_radial_336_14486)"
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 19.1304C34.49 19.2491 34.49 19.3677 34.49 19.3677C34.49 19.3677 34.3514 19.3677 34.3316 19.1898C34.3118 19.0118 34.3316 18.9722 34.3316 18.9525C34.3316 18.9327 34.4702 18.9722 34.49 19.1304Z",
    fill: "url(#paint328_radial_336_14486)"
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7078 19.1501C34.7078 19.2688 34.7078 19.3479 34.589 19.3479C34.4702 19.3479 34.4702 19.3479 34.4702 19.1501C34.4702 18.9524 34.4702 18.9326 34.589 18.9326C34.7078 18.9326 34.7078 18.9722 34.7078 19.1501Z",
    fill: "url(#paint329_radial_336_14486)"
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8464 19.1897C34.8464 19.3083 34.7474 19.3874 34.688 19.3677C34.6286 19.3479 34.589 19.249 34.688 19.1304C34.787 19.0117 34.8464 18.9722 34.8464 18.9722C34.8464 18.9722 34.9453 19.071 34.8464 19.1897Z",
    fill: "url(#paint330_radial_336_14486)"
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1235 19.2687C35.1235 19.3873 34.9849 19.4466 34.9255 19.4269C34.8661 19.4071 34.9255 19.2884 34.9255 19.1896C34.9255 19.0907 35.0641 19.0116 35.1235 19.0314C35.1829 19.0511 35.1631 19.1698 35.1235 19.2687Z",
    fill: "url(#paint331_radial_336_14486)"
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3017 19.4069C35.3017 19.4069 35.1433 19.5453 35.0839 19.4069C35.0245 19.2685 35.0839 19.2685 35.0839 19.1696C35.0839 19.0707 35.2621 19.0114 35.3017 19.051C35.3412 19.0905 35.3808 19.308 35.3017 19.4069Z",
    fill: "url(#paint332_radial_336_14486)"
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4601 19.565C35.4601 19.565 35.2621 19.565 35.2225 19.565C35.1829 19.565 35.2225 19.4068 35.2225 19.3277C35.2225 19.2486 35.4007 19.2288 35.4403 19.3277C35.4798 19.4266 35.5392 19.4859 35.4601 19.565Z",
    fill: "url(#paint333_radial_336_14486)"
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5788 19.7422C35.4798 19.7422 35.361 19.7422 35.3214 19.7422C35.3167 19.6981 35.3256 19.6537 35.3468 19.6149C35.368 19.576 35.4006 19.5445 35.4402 19.5246C35.4786 19.4999 35.5232 19.4868 35.5689 19.4868C35.6145 19.4868 35.6592 19.4999 35.6976 19.5246C35.7023 19.5687 35.6934 19.6131 35.6722 19.652C35.651 19.6908 35.6184 19.7223 35.5788 19.7422Z",
    fill: "url(#paint334_radial_336_14486)"
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "M35.658 19.9595C35.5392 19.9595 35.4402 19.9595 35.4006 19.9595C35.361 19.9595 35.4006 19.821 35.559 19.7617C35.7174 19.7024 35.7768 19.7617 35.8164 19.7617C35.856 19.7617 35.757 19.9199 35.658 19.9595Z",
    fill: "url(#paint335_radial_336_14486)"
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6778 20.1768C35.5788 20.1768 35.46 20.1768 35.46 20.1768C35.46 20.1768 35.46 20.0383 35.6382 20.0186C35.8164 19.9988 35.8758 20.0186 35.8758 20.0186C35.8758 20.0186 35.7966 20.157 35.6778 20.1768Z",
    fill: "url(#paint336_radial_336_14486)"
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "M35.8758 20.2354H35.5194H35.7372C35.7372 20.2354 35.856 20.1958 35.8758 20.2354Z",
    fill: "url(#paint337_radial_336_14486)"
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5093 18.1634C36.5093 18.8753 35.5392 18.1634 34.4306 18.1634C33.322 18.1634 32.2926 18.8951 32.4509 18.1634C32.4509 17.9459 33.3616 17.7877 34.4306 17.7482C36.4697 17.6888 36.4895 18.025 36.5093 18.1634Z",
    fill: "url(#paint338_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8667 18.6758L32.6687 18.9719C32.6116 19.0293 32.5647 19.0961 32.5301 19.1693C32.4393 19.3074 32.3599 19.4527 32.2926 19.6036C32.2194 19.7471 32.1661 19.8998 32.1342 20.0576V20.176C32.1342 20.176 32.1342 20.176 32.1342 20.3142V20.4327C32.1435 20.4716 32.1435 20.5122 32.1342 20.5511V20.2945C32.1249 20.2555 32.1249 20.215 32.1342 20.176V20.0576C32.169 19.8943 32.2222 19.7353 32.2926 19.5838C32.3665 19.4324 32.4526 19.2872 32.5499 19.1495C32.632 19.0061 32.7317 18.8734 32.8469 18.7547L32.8667 18.6758Z",
    fill: "#070707"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0448 18.9721H32.8667C32.814 19.0215 32.7734 19.0823 32.7479 19.1498C32.6682 19.2637 32.5954 19.3824 32.5301 19.5051C32.4689 19.6332 32.416 19.765 32.3717 19.8999V19.9986C32.3717 19.9986 32.3717 19.9986 32.3717 20.117C32.3717 20.2355 32.3717 20.2552 32.3717 20.3144C32.3522 20.1769 32.3522 20.0374 32.3717 19.8999C32.4125 19.7638 32.4655 19.6316 32.5301 19.5051C32.5909 19.3736 32.6638 19.248 32.7479 19.13C32.8293 19.0096 32.9221 18.8972 33.025 18.7944L33.0448 18.9721Z",
    fill: "#070707"
  }))), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0646 29.6514C32.7603 29.7132 32.4711 29.8339 32.2133 30.0067C32.2133 30.0067 32.0352 30.441 32.2133 30.6186C32.3915 30.7963 32.2133 30.9542 32.3519 31.0332C32.4905 31.1121 32.2331 31.349 32.4509 31.4872C32.6687 31.6254 32.2925 31.7833 32.4509 31.8425C32.6093 31.9018 32.4509 32.1189 32.6687 32.1189C32.8864 32.1189 33.5397 31.882 33.5397 31.6057C33.5397 31.3293 33.3418 29.6711 33.0646 29.6514Z",
    fill: "url(#paint339_radial_336_14486)"
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5992 31.6846C33.2948 31.7464 33.0056 31.8671 32.7479 32.0399C32.7479 32.0399 32.5697 32.4939 32.8667 32.6518C33.1636 32.8098 32.8667 32.9874 32.9855 33.0664C33.1042 33.1453 32.9855 33.3822 33.0844 33.5204C33.1834 33.6586 32.9459 33.8165 33.0844 33.8757C33.223 33.935 33.0844 34.1718 33.3022 34.1718C33.52 34.1718 34.1733 33.9152 34.1733 33.6389C34.1733 33.3625 33.8961 31.7043 33.5992 31.6846Z",
    fill: "url(#paint340_linear_336_14486)"
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0844 28.4278C33.0662 28.37 33.0662 28.308 33.0844 28.2501C33.0844 28.0132 32.8865 27.9738 32.7677 27.8356C32.6489 27.6974 32.4113 27.5197 32.352 27.3618C32.2276 27.3656 32.1059 27.3979 31.996 27.456C31.8862 27.5142 31.7912 27.5968 31.7185 27.6974C31.7114 27.7366 31.7114 27.7767 31.7185 27.8158C31.6975 27.8589 31.6865 27.9061 31.6865 27.954C31.6865 28.0019 31.6975 28.0492 31.7185 28.0922C31.7185 28.0922 31.5601 28.3488 31.7185 28.487C31.7762 28.5377 31.8195 28.6028 31.8438 28.6756C31.8682 28.7485 31.8727 28.8264 31.857 28.9016C31.857 28.9016 31.7185 29.1384 31.857 29.2964C31.9956 29.4543 31.857 29.6122 32.0748 29.6517C32.2926 29.6912 32.0748 29.9281 32.1738 30.0465C32.2728 30.1649 32.8271 30.1847 33.124 29.8293C33.2745 29.3718 33.2605 28.8762 33.0844 28.4278Z",
    fill: "url(#paint341_linear_336_14486)"
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "M32.6093 27.7369C32.2943 27.8278 31.9668 27.8678 31.6392 27.8554C31.5007 27.8554 31.5402 27.5593 31.5402 27.5593V27.1842C31.5036 27.1637 31.4714 27.1361 31.4456 27.1031C31.4197 27.0701 31.4007 27.0323 31.3897 26.9918C31.3786 26.9514 31.3757 26.9092 31.3812 26.8677C31.3866 26.8261 31.4003 26.7861 31.4215 26.7499C31.3564 26.6828 31.3081 26.6014 31.2806 26.5122C31.2531 26.423 31.2471 26.3286 31.2631 26.2367C31.0651 26.059 31.2631 25.6839 31.2631 25.6839L31.3819 25.3483C31.3626 25.2636 31.3693 25.175 31.401 25.094C31.4328 25.0131 31.4882 24.9435 31.56 24.8943C31.56 24.6574 31.56 24.539 31.7184 24.4995C31.7184 25.6642 32.1341 25.9406 32.1341 25.9406C32.0661 26.4431 32.1783 26.9535 32.4509 27.3816C32.4905 27.5055 32.5436 27.6246 32.6093 27.7369Z",
    fill: "url(#paint342_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0422 40.4102C43.0619 40.6071 43.0619 40.8054 43.0422 41.0024C43.0511 41.1009 43.0511 41.2 43.0422 41.2985C43.0041 41.3922 42.9505 41.4789 42.8838 41.5551C42.9429 41.48 42.9836 41.3921 43.0026 41.2985C43.0113 41.2066 43.0113 41.114 43.0026 41.0221C43.0122 40.9236 43.0122 40.8245 43.0026 40.726C43.0026 40.6273 43.0026 40.5286 43.0026 40.4299L43.0422 40.4102Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3787 40.3706C43.3885 40.4559 43.3885 40.542 43.3787 40.6272C43.3893 40.719 43.3893 40.8118 43.3787 40.9036C43.3899 40.9888 43.3899 41.075 43.3787 41.1602C43.3573 41.2561 43.3008 41.3405 43.2203 41.3971C43.2753 41.3268 43.3157 41.2463 43.3391 41.1602C43.3451 41.0748 43.3451 40.989 43.3391 40.9036C43.3487 40.8117 43.3487 40.7191 43.3391 40.6272C43.3489 40.542 43.3489 40.4559 43.3391 40.3706H43.3787Z",
    fill: "#020202"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "M42.765 39.0874C42.5954 39.1232 42.4413 39.2109 42.3241 39.3383C42.207 39.4657 42.1327 39.6265 42.1117 39.798C42.1117 40.2126 42.3097 40.489 42.1117 40.8443C41.9138 41.1996 41.9929 40.8443 41.9336 40.489C41.8742 40.1336 41.6564 39.8375 41.9336 39.5019C42.2107 39.1664 42.765 39.0874 42.765 39.0874Z",
    fill: "url(#paint343_radial_336_14486)"
  }))), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M42.765 37.7449C42.7215 37.706 42.6651 37.6846 42.6067 37.6846C42.5482 37.6846 42.4919 37.706 42.4483 37.7449C42.1221 38.0889 41.6753 38.294 41.2011 38.3174C41.1433 38.3174 41.088 38.3402 41.0471 38.381C41.0063 38.4217 40.9833 38.4769 40.9833 38.5345C40.9832 38.5622 40.9889 38.5896 41.0001 38.6149C41.0112 38.6402 41.0276 38.6629 41.0481 38.6816C41.0687 38.7002 41.0929 38.7143 41.1193 38.7229C41.1456 38.7316 41.1735 38.7347 41.2011 38.7319C41.802 38.7109 42.3706 38.4557 42.7848 38.0213C42.8143 37.9801 42.8285 37.93 42.8249 37.8795C42.8213 37.8291 42.8001 37.7814 42.765 37.7449Z",
    fill: "url(#paint344_radial_336_14486)"
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "M41.3792 39.3833C41.3506 39.3808 41.3227 39.3727 41.2973 39.3594C41.2718 39.3461 41.2492 39.328 41.2308 39.306C41.2124 39.2839 41.1985 39.2585 41.19 39.2311C41.1815 39.2037 41.1786 39.1749 41.1813 39.1464C41.1813 39.0082 41.2803 38.949 41.4584 38.949C42.3295 38.949 42.666 38.6726 42.8046 38.4357C42.8449 38.3983 42.898 38.3774 42.9531 38.3774C43.0082 38.3774 43.0612 38.3983 43.1016 38.4357C43.1226 38.4543 43.1395 38.477 43.151 38.5026C43.1626 38.5281 43.1686 38.5558 43.1686 38.5838C43.1686 38.6118 43.1626 38.6395 43.151 38.665C43.1395 38.6905 43.1226 38.7133 43.1016 38.7318C42.899 38.9764 42.6403 39.1687 42.3474 39.2924C42.0544 39.4161 41.7359 39.4676 41.4188 39.4425L41.3792 39.3833Z",
    fill: "url(#paint345_radial_336_14486)"
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4601 24.5005C35.4601 24.5005 35.1631 23.8479 34.589 23.9666C34.0149 24.0852 34.0347 24.4609 34.0347 24.4609C34.0347 24.4609 34.4108 24.718 35.4601 24.5005Z",
    fill: "url(#paint346_radial_336_14486)"
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "M33.7179 24.7173C33.7179 24.7173 34.292 25.4094 35.8361 24.7173L35.4402 24.4009C34.9805 24.5291 34.4944 24.5291 34.0346 24.4009L33.7179 24.7173Z",
    fill: "url(#paint347_radial_336_14486)"
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "M36.925 23.5912C36.5489 25.2692 34.9453 23.3149 34.8068 23.5912C34.7767 23.6625 34.7198 23.7192 34.6484 23.7492C34.5881 23.7107 34.54 23.656 34.5098 23.5912C34.391 23.3149 32.7479 25.2692 32.3916 23.5912C32.3916 23.5912 32.1342 24.519 32.7677 24.7954C32.7677 24.7954 32.9459 24.9336 32.9063 24.7954C32.8667 24.6572 33.3022 25.0718 33.1834 24.7954C33.0646 24.519 33.7575 24.9138 33.9951 24.7954V24.677L34.4702 24.4401C34.6748 24.5251 34.8732 24.624 35.0641 24.7362C35.0858 24.8001 35.1274 24.8555 35.1829 24.8941C35.4265 24.9783 35.6915 24.9783 35.9352 24.8941C35.8362 25.131 36.2321 24.8941 36.2321 24.8941H36.3707C37.1824 24.519 36.925 23.5912 36.925 23.5912Z",
    fill: "url(#paint348_radial_336_14486)"
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1337 23.2954C34.1337 23.2954 33.8763 23.5129 33.8961 23.6118C33.9159 23.7107 33.8961 23.9678 34.3118 23.8293C34.3118 23.8293 34.1337 23.8293 34.1733 23.2954H34.1337Z",
    fill: "url(#paint349_radial_336_14486)"
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M34.0149 22.4067C34.1337 22.4067 34.1931 22.6239 34.1931 22.7423C34.203 22.8737 34.203 23.0057 34.1931 23.1371V23.5319C34.1931 23.6701 34.1931 23.7886 34.4108 23.7688C34.5705 23.7099 34.7461 23.7099 34.9057 23.7688C34.9474 23.7476 34.9835 23.7169 35.011 23.6792C35.0386 23.6414 35.0567 23.5978 35.0641 23.5517C35.0641 23.453 35.0641 23.374 34.9453 23.374C34.9816 23.3703 35.0181 23.3778 35.05 23.3954C35.0818 23.4131 35.1075 23.4401 35.1235 23.4727C35.1417 23.5305 35.1417 23.5926 35.1235 23.6504C35.1217 23.7133 35.1021 23.7744 35.0671 23.8267C35.0321 23.8791 34.9831 23.9206 34.9255 23.9465C34.7829 23.9079 34.6326 23.9079 34.49 23.9465C34.4515 23.9473 34.4133 23.9387 34.3788 23.9215C34.3443 23.9043 34.3145 23.879 34.292 23.8478C34.2833 23.7823 34.2833 23.7159 34.292 23.6504C34.2822 23.5124 34.2822 23.3738 34.292 23.2358C34.292 23.0976 34.292 22.9792 34.292 22.841C34.2983 22.7486 34.2748 22.6567 34.225 22.5785C34.1751 22.5004 34.1015 22.4402 34.0149 22.4067Z",
    fill: "url(#paint350_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M34.0743 22.3872C34.1918 22.539 34.2483 22.7291 34.2327 22.9202C34.2327 23.2755 34.2327 23.7098 34.2327 23.7493C34.2327 23.7888 34.5494 23.6506 34.688 23.7493C34.8266 23.848 34.9057 23.5321 34.688 23.4532C34.688 23.4532 34.688 23.6308 34.688 23.6506C34.688 23.6703 34.5098 23.5124 34.2722 23.6506C34.0347 23.7888 34.4108 22.6241 34.0743 22.3872Z",
    fill: "url(#paint351_radial_336_14486)"
  }), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8666 22.624C32.7392 22.6727 32.5982 22.6727 32.4707 22.624C32.5912 22.6735 32.7263 22.6735 32.8468 22.624H32.8666Z",
    fill: "#42210B"
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4707 22.4664C32.5489 22.5115 32.6377 22.5352 32.7281 22.5352C32.8184 22.5352 32.9072 22.5115 32.9854 22.4664C33.2428 22.3279 33.6585 22.15 33.9555 22.585C33.8095 22.7184 33.6188 22.7924 33.4209 22.7924C33.2231 22.7924 33.0324 22.7184 32.8864 22.585C32.8864 22.585 32.5301 22.5652 32.4707 22.4664Z",
    fill: "url(#paint352_radial_336_14486)"
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6585 22.5652C33.6585 22.6229 33.6356 22.6782 33.5948 22.719C33.5539 22.7598 33.4985 22.7827 33.4408 22.7827C33.383 22.7827 33.3276 22.7598 33.2868 22.719C33.246 22.6782 33.223 22.6229 33.223 22.5652C33.223 22.5075 33.246 22.4522 33.2868 22.4114C33.3276 22.3706 33.383 22.3477 33.4408 22.3477C33.4985 22.3477 33.5539 22.3706 33.5948 22.4114C33.6356 22.4522 33.6585 22.5075 33.6585 22.5652Z",
    fill: "black"
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M33.5397 22.4858C33.5397 22.4858 33.5397 22.6243 33.421 22.6243C33.3022 22.6243 33.3022 22.6243 33.3022 22.4858C33.3022 22.4544 33.3147 22.4242 33.337 22.4019C33.3593 22.3797 33.3895 22.3672 33.421 22.3672C33.4525 22.3672 33.4827 22.3797 33.505 22.4019C33.5272 22.4242 33.5397 22.4544 33.5397 22.4858Z",
    fill: "url(#paint353_radial_336_14486)"
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8667 22.5649H32.6291H32.4509C32.4509 22.6638 32.8667 22.6836 32.8667 22.6836C33.0126 22.817 33.2033 22.891 33.4012 22.891C33.599 22.891 33.7897 22.817 33.9357 22.6836C33.7753 22.8019 33.5761 22.8554 33.3779 22.8334C33.1797 22.8114 32.9972 22.7155 32.8667 22.5649Z",
    fill: "black"
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9854 22.4861C33.053 22.4254 33.1328 22.3799 33.2194 22.3528C33.3061 22.3256 33.3976 22.3174 33.4877 22.3286C33.5778 22.3399 33.6645 22.3703 33.7418 22.418C33.8191 22.4656 33.8852 22.5293 33.9357 22.6047C33.6387 22.1697 33.223 22.3476 32.9656 22.4861C32.8874 22.5312 32.7986 22.555 32.7083 22.555C32.6179 22.555 32.5292 22.5312 32.4509 22.4861C32.5338 22.5278 32.6254 22.5495 32.7182 22.5495C32.811 22.5495 32.9025 22.5278 32.9854 22.4861Z",
    fill: "#42210B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9555 22.5851C33.8914 22.5104 33.8182 22.444 33.7377 22.3873C33.6337 22.3336 33.5183 22.3055 33.4012 22.3055C33.284 22.3055 33.1686 22.3336 33.0646 22.3873C32.7677 22.5257 32.6291 22.3873 32.6291 22.3873C32.6816 22.423 32.7437 22.4421 32.8073 22.4421C32.8708 22.4421 32.9329 22.423 32.9854 22.3873C33.1042 22.328 33.7971 22.0314 33.9555 22.5851Z",
    fill: "url(#paint354_radial_336_14486)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.9357 22.5854C33.9357 22.5854 33.9357 22.2096 33.5002 22.1899C33.0646 22.1701 32.9657 22.4865 32.6687 22.4272C32.7235 22.4566 32.7847 22.472 32.8469 22.472C32.9091 22.472 32.9703 22.4566 33.025 22.4272C33.223 22.269 33.7575 22.1108 33.9357 22.5854Z",
    fill: "url(#paint355_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M33.9555 22.5845C33.9555 22.5845 33.7575 23.0393 33.1042 22.7427C33.2485 22.7855 33.401 22.7936 33.549 22.7661C33.697 22.7385 33.8363 22.6763 33.9555 22.5845Z",
    fill: "url(#paint356_radial_336_14486)"
  }), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0941 22.2303C34.0808 22.1502 34.0488 22.0745 34.0006 22.0092C33.9525 21.9439 33.8895 21.8909 33.8169 21.8545C33.6861 21.7758 33.5334 21.7412 33.3814 21.7557C33.235 21.7778 33.0953 21.8317 32.9722 21.9137C32.849 21.9958 32.7454 22.1038 32.6687 22.2303C32.7475 22.111 32.8528 22.0114 32.9764 21.9394C33.1 21.8674 33.2386 21.8248 33.3814 21.815C33.5192 21.8176 33.6545 21.8514 33.7773 21.9139C33.8793 21.9921 33.9495 22.1045 33.9753 22.2303H34.0941Z",
    fill: "url(#paint357_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M33.9357 22.1904C33.9357 22.1904 33.5596 21.3796 32.7281 22.1904C32.8072 22.1109 32.9013 22.0478 33.0049 22.0047C33.1085 21.9617 33.2197 21.9395 33.3319 21.9395C33.4441 21.9395 33.5552 21.9617 33.6589 22.0047C33.7625 22.0478 33.8566 22.1109 33.9357 22.1904Z",
    fill: "url(#paint358_radial_336_14486)"
  }), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2519 22.6045C36.3724 22.6539 36.5076 22.6539 36.628 22.6045C36.5006 22.6532 36.3596 22.6532 36.2321 22.6045H36.2519Z",
    fill: "#42210B"
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6875 22.4666C36.6092 22.5117 36.5204 22.5354 36.4301 22.5354C36.3397 22.5354 36.251 22.5117 36.1727 22.4666C36.1022 22.4084 36.0206 22.3651 35.9328 22.3395C35.845 22.3139 35.7529 22.3064 35.6622 22.3175C35.5714 22.3286 35.4838 22.3581 35.4048 22.4041C35.3258 22.4501 35.2571 22.5117 35.2027 22.5852C35.3487 22.7186 35.5394 22.7926 35.7372 22.7926C35.9351 22.7926 36.1257 22.7186 36.2717 22.5852C36.2717 22.5852 36.6281 22.5654 36.6875 22.4666Z",
    fill: "url(#paint359_radial_336_14486)"
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4996 22.5654C35.4996 22.6231 35.5226 22.6784 35.5634 22.7192C35.6042 22.76 35.6596 22.783 35.7174 22.783C35.7467 22.7861 35.7764 22.7826 35.8043 22.7728C35.8321 22.7629 35.8574 22.747 35.8783 22.7261C35.8991 22.7053 35.9151 22.68 35.9249 22.6522C35.9348 22.6244 35.9383 22.5948 35.9351 22.5654C35.9379 22.5352 35.9343 22.5048 35.9246 22.4761C35.9149 22.4474 35.8993 22.421 35.8788 22.3987C35.8583 22.3763 35.8334 22.3585 35.8056 22.3464C35.7778 22.3342 35.7477 22.328 35.7174 22.3281C35.687 22.328 35.657 22.3342 35.6292 22.3464C35.6014 22.3585 35.5765 22.3763 35.556 22.3987C35.5355 22.421 35.5199 22.4474 35.5102 22.4761C35.5004 22.5048 35.4969 22.5352 35.4996 22.5654Z",
    fill: "black"
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M35.6184 22.4858C35.6181 22.5194 35.6299 22.5519 35.6518 22.5773C35.6736 22.6028 35.704 22.6195 35.7372 22.6243C35.7372 22.6243 35.856 22.6243 35.856 22.4858C35.856 22.4544 35.8435 22.4242 35.8212 22.4019C35.7989 22.3797 35.7687 22.3672 35.7372 22.3672C35.7057 22.3672 35.6755 22.3797 35.6532 22.4019C35.6309 22.4242 35.6184 22.4544 35.6184 22.4858Z",
    fill: "url(#paint360_radial_336_14486)"
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M35.8113 22.5152C35.8194 22.5152 35.826 22.5086 35.826 22.5005C35.826 22.4924 35.8194 22.4858 35.8113 22.4858C35.8031 22.4858 35.7966 22.4924 35.7966 22.5005C35.7966 22.5086 35.8031 22.5152 35.8113 22.5152Z",
    fill: "white"
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2717 22.5649H36.5093H36.6875C36.6875 22.6638 36.2717 22.6836 36.2717 22.6836C36.1257 22.817 35.9351 22.891 35.7372 22.891C35.5394 22.891 35.3487 22.817 35.2027 22.6836C35.3631 22.8019 35.5623 22.8554 35.7605 22.8334C35.9586 22.8114 36.1412 22.7155 36.2717 22.5649Z",
    fill: "black"
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M36.1727 22.4861C36.1052 22.4254 36.0254 22.3799 35.9387 22.3528C35.8521 22.3256 35.7606 22.3174 35.6705 22.3286C35.5803 22.3399 35.4937 22.3703 35.4164 22.418C35.3391 22.4656 35.273 22.5293 35.2225 22.6047C35.2768 22.5313 35.3456 22.4696 35.4246 22.4236C35.5036 22.3776 35.5912 22.3481 35.6819 22.337C35.7727 22.3259 35.8648 22.3334 35.9526 22.359C36.0404 22.3846 36.122 22.4279 36.1925 22.4861C36.2708 22.5312 36.3595 22.555 36.4499 22.555C36.5402 22.555 36.629 22.5312 36.7072 22.4861C36.6235 22.525 36.5323 22.5451 36.44 22.5451C36.3476 22.5451 36.2564 22.525 36.1727 22.4861Z",
    fill: "#42210B"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2
  }, _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2027 22.5851C35.2668 22.5104 35.3399 22.444 35.4205 22.3873C35.5245 22.3336 35.6399 22.3055 35.757 22.3055C35.8741 22.3055 35.9895 22.3336 36.0935 22.3873C36.3905 22.5257 36.5291 22.3873 36.5291 22.3873C36.4765 22.423 36.4145 22.4421 36.3509 22.4421C36.2874 22.4421 36.2253 22.423 36.1727 22.3873C36.054 22.328 35.3611 22.0314 35.2027 22.5851Z",
    fill: "url(#paint361_radial_336_14486)"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.2225 22.5854C35.2225 22.5854 35.2225 22.2096 35.658 22.1899C36.0935 22.1701 36.1925 22.4865 36.4895 22.4272C36.4383 22.4567 36.3803 22.4722 36.3212 22.4722C36.2621 22.4722 36.2041 22.4567 36.1529 22.4272C35.9352 22.269 35.4006 22.1108 35.2225 22.5854Z",
    fill: "url(#paint362_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    d: "M35.2027 22.5845C35.2027 22.5845 35.4007 23.0393 36.054 22.7427C35.9097 22.7855 35.7572 22.7936 35.6092 22.7661C35.4612 22.7385 35.3219 22.6763 35.2027 22.5845Z",
    fill: "url(#paint363_radial_336_14486)"
  }), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0839 22.2303C35.09 22.1506 35.117 22.0739 35.1622 22.0079C35.2073 21.942 35.2691 21.8891 35.3413 21.8545C35.4721 21.7758 35.6248 21.7412 35.7768 21.7557C35.9251 21.78 36.0667 21.8347 36.1928 21.9164C36.3188 21.9981 36.4266 22.105 36.5093 22.2303C36.4243 22.1125 36.3149 22.0144 36.1885 21.9427C36.062 21.871 35.9216 21.8275 35.7768 21.815C35.639 21.8176 35.5037 21.8514 35.3809 21.9139C35.2789 21.9921 35.2087 22.1045 35.1829 22.2303H35.0839Z",
    fill: "url(#paint364_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.3,
    d: "M35.2225 22.1904C35.2225 22.1904 35.5986 21.3796 36.4301 22.1904C36.351 22.1109 36.2569 22.0478 36.1533 22.0047C36.0496 21.9617 35.9385 21.9395 35.8263 21.9395C35.714 21.9395 35.6029 21.9617 35.4993 22.0047C35.3957 22.0478 35.3016 22.1109 35.2225 22.1904Z",
    fill: "url(#paint365_radial_336_14486)"
  }), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5194 21.1238C34.8807 21.36 34.1784 21.36 33.5397 21.1238C33.5397 21.1238 33.5397 21.1238 33.5397 21.0249C33.8528 21.1576 34.1895 21.226 34.5296 21.226C34.8697 21.226 35.2063 21.1576 35.5194 21.0249H35.6184C35.6184 21.0249 35.559 21.104 35.5194 21.1238Z",
    fill: "white"
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5986 21.3015C35.2475 21.4484 34.8706 21.524 34.49 21.524C34.1093 21.524 33.7325 21.4484 33.3813 21.3015C33.3813 21.3015 33.3813 21.3015 33.4803 21.3015C34.1524 21.5784 34.9068 21.5784 35.5788 21.3015C35.5968 21.2911 35.6173 21.2856 35.6382 21.2856C35.659 21.2856 35.6795 21.2911 35.6976 21.3015C35.6825 21.3102 35.6655 21.3148 35.6481 21.3148C35.6307 21.3148 35.6136 21.3102 35.5986 21.3015Z",
    fill: "white"
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3118 20.7883C34.3315 20.9721 34.3315 21.1573 34.3118 21.3411L34.5296 21.6372L34.7078 21.3608V21.0844C34.7078 20.9857 34.7078 20.9068 34.7078 20.8081C34.7078 20.7094 34.7078 20.9857 34.7078 21.0844V21.3608L34.5296 21.6569L34.3118 21.3608C34.3012 21.1701 34.3012 20.979 34.3118 20.7883Z",
    fill: "#FF0000"
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5098 21.0449L34.4702 21.4009H34.5494L34.5098 21.0449Z",
    fill: "#FF0000"
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M34.5296 21.8149C34.5733 21.8149 34.6088 21.7795 34.6088 21.7358C34.6088 21.6922 34.5733 21.6567 34.5296 21.6567C34.4858 21.6567 34.4504 21.6922 34.4504 21.7358C34.4504 21.7795 34.4858 21.8149 34.5296 21.8149Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M34.1336 23.2954C33.9993 23.3744 33.9002 23.5015 33.8565 23.6507C33.7306 23.9554 33.5256 24.2211 33.2626 24.4206C33.454 24.2248 33.6203 24.0059 33.7575 23.7692C33.8367 23.552 33.9357 23.3546 34.1336 23.2954Z",
    fill: "url(#paint366_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M34.9453 23.2954C35.0796 23.3744 35.1787 23.5015 35.2225 23.6507C35.3621 23.9527 35.5726 24.2168 35.8362 24.4206C35.6447 24.2248 35.4785 24.0059 35.3412 23.7692C35.2423 23.552 35.1631 23.3546 34.9453 23.2954Z",
    fill: "url(#paint367_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M34.0149 22.624C33.9637 22.8178 33.8513 22.9898 33.6944 23.1145C33.5374 23.2393 33.3443 23.31 33.1438 23.3162C33.33 23.2695 33.5041 23.1836 33.6543 23.0642C33.8045 22.9448 33.9275 22.7948 34.0149 22.624Z",
    fill: "url(#paint368_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "multiply"
    },
    opacity: 0.2,
    d: "M35.1037 22.624C35.1558 22.821 35.2711 22.9954 35.4321 23.1204C35.593 23.2455 35.7907 23.3142 35.9946 23.3162C35.8048 23.2721 35.6268 23.1873 35.473 23.0678C35.3192 22.9483 35.1932 22.7969 35.1037 22.624Z",
    fill: "url(#paint369_radial_336_14486)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M42.0524 41.1011C42.0524 41.1011 41.9534 41.3581 41.9138 41.3581C41.8742 41.3581 41.6762 41.3581 41.696 41.1999C41.7524 41.1193 41.8189 41.0461 41.894 40.9824C41.9279 40.9883 41.9599 41.0021 41.9875 41.0227C42.015 41.0434 42.0372 41.0702 42.0524 41.1011Z",
    fill: "url(#paint370_linear_336_14486)"
  }))), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M46.1898 24.894C46.1898 24.4794 45.9721 24.4202 45.9721 24.4202C45.9721 23.9464 45.5563 24.0846 45.5563 24.0846L45.398 23.749C45.1922 24.2082 44.9186 24.6341 44.5863 25.0124C44.4675 25.348 44.5863 25.3875 44.8041 25.5059C44.8064 25.5518 44.8183 25.5968 44.8388 25.6379C44.8593 25.6791 44.8881 25.7156 44.9234 25.7452C44.9586 25.7749 44.9996 25.7969 45.0438 25.8101C45.088 25.8233 45.1344 25.8272 45.1802 25.8218C45.1802 26.0192 45.4178 26.0192 45.4178 26.0192C45.409 26.0377 45.4044 26.0579 45.4044 26.0784C45.4044 26.0989 45.409 26.1191 45.4178 26.1376C45.4476 26.1912 45.488 26.2382 45.5365 26.2758C45.5551 26.2846 45.5754 26.2891 45.5959 26.2891C45.6165 26.2891 45.6368 26.2846 45.6553 26.2758C45.9353 26.0896 46.139 25.8094 46.2294 25.4862C46.5462 24.894 46.1898 24.894 46.1898 24.894Z",
    fill: "url(#paint371_radial_336_14486)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "soft-light"
    }
  }, _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M45.596 24.1045C45.596 24.1045 45.596 24.2427 45.596 24.3019C45.607 24.3672 45.607 24.434 45.596 24.4993C45.596 24.6375 45.497 24.7559 45.4574 24.8744C45.3921 24.9971 45.3193 25.1157 45.2396 25.2297C45.1574 25.3314 45.0644 25.424 44.9625 25.5061C45.052 25.409 45.1316 25.3031 45.2 25.1902C45.2543 25.0955 45.3007 24.9965 45.3386 24.8941C45.3996 24.7795 45.4525 24.6607 45.497 24.5388V24.3414C45.4894 24.2758 45.4894 24.2096 45.497 24.144L45.596 24.1045Z",
    fill: "#070707"
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2396 25.8418C45.3233 25.7445 45.3963 25.6387 45.4574 25.5259C45.5369 25.4187 45.6096 25.3066 45.6752 25.1904C45.7501 25.0803 45.81 24.9608 45.8533 24.835C45.9106 24.7163 45.9506 24.59 45.9721 24.46C45.9484 24.5872 45.9153 24.7126 45.8731 24.835C45.8324 24.9648 45.7794 25.0904 45.7147 25.2101C45.6537 25.329 45.5808 25.4414 45.497 25.5457C45.4223 25.6595 45.3361 25.7654 45.2396 25.8615V25.8418Z",
    fill: "#070707"
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M45.497 26.039C45.5857 25.9703 45.6656 25.8907 45.7345 25.8022C45.8052 25.7204 45.8713 25.6347 45.9325 25.5455C45.939 25.4997 45.939 25.4532 45.9325 25.4074C45.9325 25.4074 45.9325 25.4074 45.9325 25.2494C45.9438 25.1445 45.9438 25.0386 45.9325 24.9336C45.942 25.0453 45.942 25.1575 45.9325 25.2692V25.4271L45.8335 25.5653C45.779 25.6651 45.7125 25.7579 45.6355 25.8416C45.5591 25.9243 45.4726 25.9973 45.3782 26.0588L45.497 26.039Z",
    fill: "#070707"
  }))), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M44.9427 25.1904C44.9427 25.1904 44.8437 25.4277 44.7843 25.408C44.7249 25.3882 44.5665 25.408 44.6061 25.2498L44.7843 25.0718C44.8484 25.0934 44.9039 25.135 44.9427 25.1904Z",
    fill: "url(#paint372_linear_336_14486)"
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M45.2792 25.5063C45.2792 25.5063 45.1802 25.7239 45.1406 25.7239C45.101 25.7239 44.9427 25.625 44.9625 25.5657C45.0108 25.4962 45.0711 25.436 45.1406 25.3877C45.1406 25.3877 45.2594 25.4272 45.2792 25.5063Z",
    fill: "url(#paint373_linear_336_14486)"
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6157 25.842C45.6157 25.842 45.4772 26.0398 45.4376 26.02C45.398 26.0002 45.2396 25.9014 45.2792 25.842C45.3188 25.7827 45.497 25.7036 45.497 25.7036C45.5264 25.7155 45.5526 25.7342 45.5733 25.7583C45.5939 25.7824 45.6085 25.8111 45.6157 25.842Z",
    fill: "url(#paint374_linear_336_14486)"
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8731 26.0588C45.8731 26.0588 45.7345 26.2764 45.6949 26.2566C45.6554 26.2368 45.497 26.1379 45.5366 26.0786C45.5762 26.0193 45.7543 25.9204 45.7543 25.9204C45.8084 25.9518 45.8503 26.0006 45.8731 26.0588Z",
    fill: "url(#paint375_linear_336_14486)"
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0245 35.5741C35.0197 35.6617 34.9828 35.7445 34.9206 35.8065C34.8585 35.8686 34.7757 35.9055 34.6879 35.9102C34.5968 35.9104 34.509 35.8756 34.4427 35.8131C34.3764 35.7505 34.3367 35.665 34.3316 35.5741C34.3315 35.5282 34.3408 35.4828 34.359 35.4407C34.3771 35.3985 34.4037 35.3606 34.4371 35.3291C34.4704 35.2976 34.5099 35.2733 34.5531 35.2576C34.5962 35.2419 34.6421 35.2352 34.6879 35.2379C34.7321 35.2379 34.7759 35.2466 34.8167 35.2635C34.8576 35.2804 34.8947 35.3051 34.9259 35.3363C34.9572 35.3676 34.982 35.4046 34.9989 35.4454C35.0158 35.4862 35.0245 35.5299 35.0245 35.5741Z",
    fill: "url(#paint376_radial_336_14486)"
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3017 34.4485C35.2626 34.6043 35.1671 34.7403 35.0336 34.8303C34.9001 34.9202 34.7379 34.9578 34.5783 34.9358C34.4187 34.9137 34.2728 34.8336 34.1688 34.7109C34.0648 34.5881 34.01 34.4314 34.0149 34.2708C34.0394 34.1011 34.1301 33.9479 34.2673 33.8444C34.4044 33.7409 34.5769 33.6955 34.7474 33.7181C34.9176 33.7426 35.0712 33.833 35.175 33.9697C35.2788 34.1064 35.3243 34.2785 35.3017 34.4485Z",
    fill: "url(#paint377_radial_336_14486)"
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 34.3894C34.8572 34.4277 34.8592 34.468 34.8519 34.5071C34.8446 34.5462 34.8283 34.5831 34.8043 34.6149C34.7803 34.6466 34.7493 34.6724 34.7136 34.6901C34.678 34.7079 34.6387 34.7171 34.5988 34.7171C34.559 34.7171 34.5197 34.7079 34.4841 34.6901C34.4484 34.6724 34.4174 34.6466 34.3934 34.6149C34.3694 34.5831 34.3531 34.5462 34.3458 34.5071C34.3385 34.468 34.3404 34.4277 34.3514 34.3894C34.3612 34.3247 34.3953 34.2662 34.4468 34.2258C34.4983 34.1854 34.5633 34.1661 34.6285 34.1719C34.6848 34.1764 34.7376 34.2008 34.7775 34.2406C34.8174 34.2805 34.8418 34.3332 34.8463 34.3894Z",
    fill: "url(#paint378_radial_336_14486)"
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 33.6194C34.8476 33.6502 34.8385 33.6805 34.8206 33.7056C34.8027 33.7307 34.7769 33.749 34.7473 33.7578C34.7312 33.7346 34.7225 33.707 34.7225 33.6787C34.7225 33.6504 34.7312 33.6228 34.7473 33.5996C34.7473 33.5996 34.7473 33.4414 34.7473 33.4612C34.7473 33.481 34.8463 33.5403 34.8463 33.6194Z",
    fill: "url(#paint379_radial_336_14486)"
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9849 33.6592C34.9849 33.6592 34.9849 33.7976 34.8661 33.7778C34.7474 33.7581 34.8661 33.7778 34.8661 33.6196C34.8661 33.4614 34.8661 33.4812 34.9849 33.501C35.1037 33.5208 35.0245 33.5801 34.9849 33.6592Z",
    fill: "url(#paint380_radial_336_14486)"
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1235 33.7378C35.1235 33.7378 35.0245 33.8565 34.9849 33.8367C34.9453 33.8169 34.9849 33.7378 34.9849 33.6587C34.9849 33.5796 35.0839 33.5599 35.1235 33.6587C35.1631 33.7576 35.1631 33.6785 35.1235 33.7378Z",
    fill: "url(#paint381_radial_336_14486)"
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2422 33.8566C35.2422 33.8566 35.1037 33.8566 35.0839 33.8566C35.0641 33.8566 35.0839 33.738 35.0839 33.6786C35.1071 33.6625 35.1347 33.6538 35.1631 33.6538C35.1914 33.6538 35.219 33.6625 35.2422 33.6786C35.2422 33.6786 35.3016 33.7973 35.2422 33.8566Z",
    fill: "url(#paint382_radial_336_14486)"
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3215 33.9751C35.3215 33.9751 35.1829 33.9751 35.1631 33.9751C35.1433 33.9751 35.1631 33.8762 35.1631 33.8169C35.1631 33.7576 35.3215 33.8169 35.3413 33.8169C35.3547 33.8421 35.36 33.8708 35.3565 33.8991C35.3529 33.9274 35.3407 33.954 35.3215 33.9751Z",
    fill: "url(#paint383_radial_336_14486)"
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4007 34.113C35.4007 34.113 35.2423 34.113 35.2225 34.113C35.2027 34.113 35.2225 34.0142 35.2225 33.9746C35.2225 33.9351 35.3809 33.9746 35.4007 33.9746C35.4205 33.9746 35.46 34.0735 35.4007 34.113Z",
    fill: "url(#paint384_radial_336_14486)"
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4204 34.271C35.4204 34.271 35.2819 34.271 35.2621 34.271C35.2423 34.271 35.2621 34.271 35.3808 34.271C35.4996 34.271 35.5392 34.271 35.559 34.271C35.5788 34.271 35.4996 34.2512 35.4204 34.271Z",
    fill: "url(#paint385_radial_336_14486)"
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4204 34.4089H35.2819C35.2819 34.4089 35.2819 34.3101 35.4204 34.3101C35.559 34.3101 35.5788 34.3101 35.5788 34.3101C35.5788 34.3101 35.5194 34.4089 35.4204 34.4089Z",
    fill: "url(#paint386_radial_336_14486)"
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M35.4007 34.5669H35.2621C35.2621 34.5669 35.2621 34.5669 35.4403 34.5669C35.6184 34.5669 35.5788 34.5669 35.559 34.6658C35.5392 34.7646 35.4799 34.5867 35.4007 34.5669Z",
    fill: "url(#paint387_radial_336_14486)"
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3413 34.7646C35.3413 34.7646 35.2225 34.7646 35.2423 34.646C35.2621 34.5273 35.2423 34.646 35.4007 34.646C35.559 34.646 35.5392 34.646 35.5194 34.7646C35.4996 34.8833 35.4204 34.7646 35.3413 34.7646Z",
    fill: "url(#paint388_radial_336_14486)"
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M35.2621 34.7646C35.2621 34.7646 35.1631 34.646 35.2621 34.6064C35.3611 34.5669 35.2621 34.6064 35.4402 34.6064C35.6184 34.6064 35.4402 34.7053 35.4402 34.7449C35.4402 34.7844 35.3413 34.8833 35.2621 34.7646Z",
    fill: "url(#paint389_radial_336_14486)"
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1631 34.9424C35.1631 34.9424 35.0641 34.8237 35.1631 34.7842C35.2621 34.7446 35.2621 34.7842 35.3214 34.7842C35.3808 34.7842 35.4204 34.9226 35.3214 34.9622C35.2225 35.0017 35.2225 35.0017 35.1631 34.9424Z",
    fill: "url(#paint390_radial_336_14486)"
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M35.0245 35.0408C35.0245 35.0408 35.0245 34.8826 35.0245 34.8628C35.0245 34.843 35.1433 34.8628 35.1829 34.8628C35.2225 34.8628 35.1829 35.0012 35.1829 35.0408C35.1829 35.0803 35.0641 35.1001 35.0245 35.0408Z",
    fill: "url(#paint391_radial_336_14486)"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8463 35.1004C34.8463 35.1004 34.8463 34.9422 34.8463 34.9224C34.8463 34.9026 34.8463 34.9224 34.9849 35.0213C35.1235 35.1202 34.9849 35.1795 34.9849 35.1993C34.9849 35.219 34.8463 35.1795 34.8463 35.1004Z",
    fill: "url(#paint392_radial_336_14486)"
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7275 35.1201V34.9619C34.7275 34.9619 34.8265 34.9619 34.8463 35.1003C34.8661 35.2388 34.8463 35.2388 34.8463 35.2585C34.8463 35.2783 34.8463 35.1992 34.7275 35.1201Z",
    fill: "url(#paint393_radial_336_14486)"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M34.589 35.1199V34.9814C34.589 34.9814 34.589 34.9814 34.589 35.1199C34.589 35.2583 34.589 35.2781 34.589 35.2781C34.589 35.2781 34.5692 35.199 34.589 35.1199Z",
    fill: "url(#paint394_radial_336_14486)"
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M34.4306 35.1002C34.4306 35.0013 34.4306 34.942 34.5494 34.9618C34.6681 34.9816 34.5494 34.9618 34.5494 35.12C34.5494 35.2782 34.5494 35.2584 34.4306 35.2584C34.3118 35.2584 34.4108 35.1793 34.4306 35.1002Z",
    fill: "url(#paint395_radial_336_14486)"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M34.292 35.021C34.292 35.021 34.292 34.9024 34.4306 34.9221C34.5692 34.9419 34.4306 35.021 34.4306 35.1001C34.4306 35.1792 34.4306 35.2188 34.3118 35.1001C34.193 34.9815 34.2524 35.1001 34.292 35.021Z",
    fill: "url(#paint396_radial_336_14486)"
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M34.1535 34.9419C34.1535 34.9419 34.2722 34.843 34.3118 34.9419C34.3514 35.0408 34.3118 35.0408 34.3118 35.1199C34.3118 35.199 34.1931 35.2187 34.1733 35.1199C34.1494 35.0974 34.1343 35.0671 34.1307 35.0345C34.127 35.0019 34.1351 34.9691 34.1535 34.9419Z",
    fill: "url(#paint397_radial_336_14486)"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0544 34.7642C34.0544 34.7642 34.193 34.7642 34.2128 34.7642C34.2326 34.7642 34.2128 34.7642 34.2128 34.9224C34.2128 35.0806 34.0742 34.9224 34.0544 34.9224C34.0346 34.9224 33.995 34.8828 34.0544 34.7642Z",
    fill: "url(#paint398_radial_336_14486)"
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9753 34.7643C33.9864 34.7517 34.0002 34.7416 34.0155 34.7346C34.0309 34.7277 34.0475 34.7241 34.0644 34.7241C34.0812 34.7241 34.0979 34.7277 34.1133 34.7346C34.1286 34.7416 34.1423 34.7517 34.1535 34.7643C34.1535 34.7643 34.1535 34.8829 34.1535 34.9225C34.1535 34.962 34.0149 34.9225 33.9951 34.9225C33.9753 34.9225 33.8961 34.7643 33.9753 34.7643Z",
    fill: "url(#paint399_radial_336_14486)"
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9159 34.5474C33.9159 34.5474 34.0743 34.5474 34.0941 34.5474C34.1138 34.5474 34.094 34.6462 33.9753 34.666C33.8565 34.6858 33.8169 34.666 33.8169 34.666C33.8169 34.666 33.8367 34.5869 33.9159 34.5474Z",
    fill: "url(#paint400_radial_336_14486)"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M33.8961 34.4092H34.0545C34.0545 34.4092 34.0545 34.4092 33.9159 34.4092C33.8926 34.4253 33.865 34.434 33.8367 34.434C33.8084 34.434 33.7807 34.4253 33.7575 34.4092C33.7786 34.397 33.8025 34.3906 33.8268 34.3906C33.8511 34.3906 33.875 34.397 33.8961 34.4092Z",
    fill: "url(#paint401_radial_336_14486)"
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M33.9357 34.0931C33.9357 34.0931 34.0742 34.0931 34.0742 34.2117C34.0742 34.3304 33.9752 34.2117 33.8961 34.2117C33.8169 34.2117 33.7575 34.2117 33.7773 34.0931C33.7971 33.9744 33.8565 34.0733 33.9357 34.0931Z",
    fill: "url(#paint402_radial_336_14486)"
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0149 33.955C34.0149 33.955 34.1337 34.0538 34.1139 34.0934C34.0941 34.1329 34.0149 34.0934 33.9357 34.0934C33.8565 34.0934 33.8169 33.9945 33.8367 33.955C33.8565 33.9154 33.9357 33.9352 34.0149 33.955Z",
    fill: "url(#paint403_radial_336_14486)"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M34.0941 33.8368C34.0941 33.8368 34.1931 33.9554 34.0941 33.995C33.9951 34.0345 33.9951 33.995 33.9159 33.995C33.8367 33.995 33.8169 33.8763 33.9159 33.8368C34.0149 33.7972 34.0347 33.7972 34.0941 33.8368Z",
    fill: "url(#paint404_radial_336_14486)"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2128 33.7378C34.2128 33.7378 34.2128 33.8762 34.2128 33.896C34.2128 33.9157 34.1139 33.896 34.0545 33.896C33.9951 33.896 34.0545 33.7575 34.0545 33.718C34.0545 33.6784 34.1535 33.6784 34.2128 33.7378Z",
    fill: "url(#paint405_radial_336_14486)"
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3514 33.659C34.3514 33.659 34.3514 33.8172 34.3514 33.8369C34.3514 33.8567 34.2524 33.8369 34.193 33.7381C34.1336 33.6392 34.193 33.5996 34.193 33.5799C34.193 33.5601 34.3118 33.5996 34.3514 33.659Z",
    fill: "url(#paint406_radial_336_14486)"
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M34.49 33.6196C34.49 33.6196 34.49 33.758 34.49 33.7778C34.49 33.7975 34.49 33.7778 34.3514 33.6591C34.2128 33.5405 34.3514 33.5207 34.3514 33.5009C34.3514 33.4811 34.4702 33.5405 34.49 33.6196Z",
    fill: "url(#paint407_radial_336_14486)"
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M34.6484 33.5999C34.6484 33.5999 34.6484 33.7383 34.6484 33.7581C34.6484 33.7778 34.5494 33.7581 34.5296 33.6196C34.5098 33.4812 34.5296 33.4614 34.5296 33.4614C34.5296 33.4614 34.6286 33.5208 34.6484 33.5999Z",
    fill: "url(#paint408_radial_336_14486)"
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M43.1003 24.2866L42.9794 24.5538L46.1551 26.7015L46.2472 26.5125L43.1003 24.2866Z",
    fill: "#C9ECEA"
  }))), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M2.78689 19.5854C2.71847 19.125 2.68426 18.4651 2.8553 18.4191C3.02634 18.3731 3.18597 18.8488 3.26579 19.4166C3.36248 20.2131 3.41204 21.0188 3.41401 21.8259C3.09772 21.1417 2.88464 20.3804 2.78689 19.5854Z",
    fill: "#61B653"
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M3.41938 22.9172C3.41938 22.4508 3.41938 21.8075 3.72094 21.8235C4.02251 21.8396 4.086 22.3382 4.10187 22.885C4.08277 23.6728 4.00316 24.4578 3.86378 25.2331C3.55859 24.5007 3.40724 23.712 3.41938 22.9172Z",
    fill: "#61B653"
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M4.14437 25.6522C4.14437 25.1996 4.3878 24.5508 4.87472 24.5508C5.36164 24.5508 5.5138 25.0789 5.45294 25.622C5.33495 26.4109 5.08041 27.1933 4.69213 27.9606C4.19099 27.218 4.00452 26.4322 4.14437 25.6522Z",
    fill: "#61B653"
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M2.76633 22.5436C2.59141 22.1944 2.27907 21.7144 2.11665 21.8453C1.95423 21.9762 2.11665 22.4127 2.29157 22.8491C2.62811 23.4494 3.00405 24.0184 3.41603 24.5511C3.31903 23.8374 3.09795 23.1543 2.76633 22.5436Z",
    fill: "#61B653"
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M3.42067 25.0959C3.23518 24.8299 2.92966 24.4786 2.78781 24.5638C2.64597 24.6489 2.78783 24.9895 3.00605 25.3195C3.32895 25.7769 3.69419 26.2044 4.09718 26.5967C3.97348 26.0584 3.74371 25.5487 3.42067 25.0959Z",
    fill: "#61B653"
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M0.837158 28.8923C0.677302 28.5334 0.585955 28.0016 0.837158 27.9617C1.08836 27.9219 1.49943 28.3206 1.70496 28.7593C1.90607 29.3956 2.0206 30.0401 2.0475 30.6869C1.44078 30.1421 1.02912 29.5318 0.837158 28.8923Z",
    fill: "#61B653"
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M2.77795 30.5041C2.71385 30.0457 2.68822 29.3735 2.8805 29.3277C3.07279 29.2819 3.23943 29.7707 3.31634 30.336C3.39992 31.1314 3.42993 31.9335 3.40608 32.7345C3.07312 32.0489 2.85948 31.2903 2.77795 30.5041Z",
    fill: "#61B653"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M1.1886 29.9559C0.829506 29.6065 0.254953 29.1697 0.0574531 29.3794C-0.140047 29.589 0.201102 30.0433 0.632011 30.4801C1.28585 31.0604 1.98854 31.5865 2.73269 32.0526C2.36881 31.2594 1.84355 30.5462 1.1886 29.9559Z",
    fill: "#61B653"
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M1.84515 31.3238C1.48937 30.9756 0.907201 30.5404 0.729309 30.7319C0.551417 30.9234 0.891012 31.4109 1.34383 31.8461C1.9941 32.4267 2.68629 32.9506 3.41384 33.4129C3.02614 32.6105 2.4927 31.9001 1.84515 31.3238Z",
    fill: "#61B653"
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M6.58764 31.9907C6.03082 31.2249 5.16902 30.5794 4.0993 30.127C4.0993 30.127 4.0993 30.127 4.0993 30.0218C4.12197 30.0108 4.14917 30.0049 4.17707 30.0049C4.20497 30.0049 4.23218 30.0108 4.25484 30.0218C5.36066 30.4958 6.25226 31.1666 6.83199 31.9606V32.0508L6.58764 31.9907Z",
    fill: "#61B653"
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M8.73646 36.7404H8.66022C8.47172 36.4294 8.20974 36.1607 7.89328 35.9536C7.57683 35.7466 7.21385 35.6065 6.83069 35.5435V35.46C6.83069 35.46 6.83068 35.46 6.92216 35.46C7.32657 35.5294 7.70945 35.6787 8.04394 35.8975C8.37843 36.1163 8.65643 36.3992 8.85843 36.7265C8.8724 36.7395 8.8802 36.757 8.8802 36.7752C8.8802 36.7934 8.8724 36.8109 8.85843 36.8239L8.73646 36.7404Z",
    fill: "#61B653"
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M6.74591 38.7468C6.38144 38.0622 5.93656 37.6818 5.47688 37.6618C5.47132 37.6382 5.46838 37.6115 5.46838 37.5843C5.46838 37.5571 5.47132 37.5304 5.47688 37.5068C5.96854 37.518 6.44527 37.9207 6.83473 38.6538V38.8708C6.83473 38.8708 6.77129 38.7468 6.74591 38.7468Z",
    fill: "#61B653"
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7557 42.8767C10.1809 42.2812 9.54688 41.9125 8.8929 41.7934C8.88465 41.7667 8.88031 41.7363 8.88031 41.7055C8.88031 41.6747 8.88465 41.6444 8.8929 41.6177C8.92302 41.5949 8.95669 41.5949 8.98681 41.6177C9.66529 41.7326 10.3223 42.1222 10.9122 42.7596C10.9237 42.7894 10.9298 42.8253 10.9298 42.862C10.9298 42.8988 10.9237 42.9347 10.9122 42.9645L10.7557 42.8767Z",
    fill: "#61B653"
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84542 21.8232C2.84542 21.8232 3.22188 23.0494 3.76203 24.9049C4.30217 26.7603 5.08784 29.2127 6.02082 31.6167C6.82103 33.8495 7.8178 36.0089 8.99978 38.0704C9.3845 38.7382 9.82236 39.3748 10.3092 39.9743L10.8821 40.6519C10.9121 40.6821 10.9289 40.7226 10.9289 40.7648C10.9289 40.8071 10.9121 40.8476 10.8821 40.8778C10.8499 40.904 10.8093 40.9184 10.7675 40.9184C10.7257 40.9184 10.6852 40.904 10.653 40.8778L10.0801 40.184C9.57684 39.5723 9.12781 38.9192 8.73791 38.2318C8.16857 37.2827 7.65486 36.3023 7.19931 35.2953C6.67554 34.1982 6.18448 32.9881 5.72618 31.7942C4.80957 29.3741 4.00756 26.9539 3.51652 25.0501C3.02548 23.1463 2.73083 21.92 2.73083 21.92H2.86178L2.84542 21.8232Z",
    fill: "#61B653"
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M0.773454 27.9702C2.05606 30.887 3.6017 33.6651 5.38873 36.2656C6.63347 38.0376 7.99587 39.7129 9.46555 41.2788C10.0655 41.9483 10.5886 42.4545 11.004 42.8138L11.5732 43.369C11.5982 43.4011 11.6119 43.4416 11.6119 43.4833C11.6119 43.525 11.5982 43.5654 11.5732 43.5976C11.5444 43.6275 11.5058 43.6443 11.4655 43.6443C11.4252 43.6443 11.3866 43.6275 11.3578 43.5976L10.7732 43.0424C10.404 42.6831 9.86555 42.1769 9.2348 41.5237C8.60404 40.8705 7.94252 40.103 7.21946 39.2539C6.4964 38.4048 5.80411 37.4413 5.1272 36.4616C3.86981 34.6707 2.75813 32.7697 1.8042 30.7789C1.35933 29.8819 0.983758 28.948 0.681152 27.9865C0.681152 27.9865 0.773454 27.9376 0.773454 27.9702Z",
    fill: "#61B653"
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8838 33.0745C8.8838 33.1651 8.81184 33.252 8.68372 33.316C8.5556 33.3801 8.38182 33.4161 8.20063 33.4161C8.01943 33.4161 7.84566 33.3801 7.71754 33.316C7.58941 33.252 7.51746 33.1651 7.51746 33.0745C7.51746 32.9839 7.58941 32.897 7.71754 32.833C7.84566 32.7689 8.01943 32.7329 8.20063 32.7329C8.29034 32.7329 8.37918 32.7417 8.46207 32.7589C8.54496 32.7761 8.62028 32.8012 8.68372 32.833C8.74716 32.8647 8.79749 32.9023 8.83182 32.9438C8.86615 32.9852 8.8838 33.0296 8.8838 33.0745Z",
    fill: "#61B653"
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83216 35.8015C6.83216 35.8691 6.81212 35.9351 6.77459 35.9913C6.73706 36.0475 6.6837 36.0913 6.62128 36.1171C6.55887 36.143 6.4902 36.1497 6.42394 36.1366C6.35768 36.1234 6.2968 36.0909 6.24903 36.0431C6.20125 35.9953 6.16873 35.9345 6.15555 35.8682C6.14237 35.8019 6.14914 35.7332 6.17499 35.6708C6.20085 35.6084 6.24463 35.5551 6.30081 35.5175C6.35698 35.48 6.42301 35.46 6.49056 35.46C6.58116 35.46 6.66804 35.4959 6.7321 35.56C6.79616 35.6241 6.83216 35.7109 6.83216 35.8015Z",
    fill: "#61B653"
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M5.46524 38.2123C5.46062 38.3461 5.41664 38.4756 5.33882 38.5846C5.261 38.6936 5.15277 38.7773 5.0276 38.8254C4.90243 38.8734 4.76586 38.8836 4.63493 38.8547C4.504 38.8258 4.38449 38.759 4.29129 38.6628C4.19809 38.5665 4.13531 38.4451 4.11081 38.3135C4.0863 38.1818 4.10115 38.0459 4.15347 37.9227C4.2058 37.7994 4.29332 37.6943 4.40509 37.6203C4.51687 37.5464 4.64796 37.5069 4.78206 37.5068C4.87379 37.5068 4.9646 37.5252 5.04906 37.5609C5.13352 37.5966 5.20989 37.649 5.27365 37.7148C5.33741 37.7807 5.38725 37.8586 5.42016 37.9441C5.45308 38.0296 5.4684 38.1208 5.46524 38.2123Z",
    fill: "#61B653"
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M3.76029 30.0079C3.94894 30.0079 4.10187 29.8549 4.10187 29.6663C4.10187 29.4776 3.94894 29.3247 3.76029 29.3247C3.57163 29.3247 3.4187 29.4776 3.4187 29.6663C3.4187 29.8549 3.57163 30.0079 3.76029 30.0079Z",
    fill: "#61B653"
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M7.17227 30.0079C7.36093 30.0079 7.51386 29.8549 7.51386 29.6663C7.51386 29.4776 7.36093 29.3247 7.17227 29.3247C6.98362 29.3247 6.83069 29.4776 6.83069 29.6663C6.83069 29.8549 6.98362 30.0079 7.17227 30.0079Z",
    fill: "#61B653"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M3.07242 36.1431C3.26107 36.1431 3.41401 35.9902 3.41401 35.8015C3.41401 35.6129 3.26107 35.46 3.07242 35.46C2.88377 35.46 2.73083 35.6129 2.73083 35.8015C2.73083 35.9902 2.88377 36.1431 3.07242 36.1431Z",
    fill: "#61B653"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "M9.2219 41.6031C9.41055 41.6031 9.56348 41.4502 9.56348 41.2615C9.56348 41.0729 9.41055 40.9199 9.2219 40.9199C9.03324 40.9199 8.88031 41.0729 8.88031 41.2615C8.88031 41.4502 9.03324 41.6031 9.2219 41.6031Z",
    fill: "#61B653"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "M8.20063 38.8708C8.57793 38.8708 8.8838 38.5654 8.8838 38.1888C8.8838 37.8122 8.57793 37.5068 8.20063 37.5068C7.82332 37.5068 7.51746 37.8122 7.51746 38.1888C7.51746 38.5654 7.82332 38.8708 8.20063 38.8708Z",
    fill: "#61B653"
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M8.8815 50.1855C8.26469 50.5737 7.57537 50.8267 6.85741 50.9284C5.50126 51.176 4.20584 51.2586 4.10464 50.9284C4.00343 50.5982 5.35958 49.8966 6.73597 49.8141C7.4715 49.7161 8.21894 49.8455 8.8815 50.1855Z",
    fill: "#61B653"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41935 40.9167C4.84553 40.6135 4.38183 40.1596 4.08686 39.6126C3.50751 38.6479 3.27576 37.6654 3.5075 37.5224C3.73925 37.3795 4.76275 38.237 5.20692 39.3089C5.45411 39.812 5.52826 40.3733 5.41935 40.9167Z",
    fill: "#61B653"
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9107 47.0995C10.88 46.7757 10.88 46.449 10.9107 46.1252C10.9059 46.4466 10.9278 46.7678 10.976 47.0845C11.0231 47.4019 11.0975 47.7132 11.1979 48.0138L11.6157 48.4185C11.5963 47.8406 11.5439 47.2648 11.459 46.6948C11.3858 45.8468 11.1301 45.033 10.7149 44.3267C10.519 44.3267 10.1926 44.9262 10.2579 45.9454C10.3188 46.4675 10.4556 46.9741 10.6626 47.4442L11.0674 47.8489C10.997 47.6046 10.9446 47.3539 10.9107 47.0995Z",
    fill: "#61B653"
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M8.84358 44.4365C8.84084 43.4622 8.62765 42.4999 8.2184 41.6144C7.99106 41.5015 7.5364 42.0848 7.51746 43.2136C7.53492 43.822 7.64346 44.4243 7.83951 45.0009L8.86251 46.3744C8.89621 45.7286 8.8899 45.0815 8.84358 44.4365ZM8.44575 45.6594H8.33206C8.22801 45.2597 8.1708 44.8493 8.16157 44.4365C8.12317 44.0235 8.12317 43.6078 8.16157 43.1948C8.11745 43.5949 8.11745 43.9987 8.16157 44.3989C8.20437 44.7995 8.28039 45.196 8.38889 45.5842L8.44575 45.6783V45.6594Z",
    fill: "#61B653"
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M6.53725 39.5712C6.43587 39.4552 6.20548 39.919 6.15018 40.8796C6.14231 41.3981 6.17331 41.9162 6.24235 42.4199L6.41745 42.9168C6.40038 42.6028 6.40038 42.2867 6.41745 41.9727C6.42628 41.61 6.45404 41.2496 6.50039 40.8962C6.48184 41.2487 6.48184 41.6036 6.50039 41.9562C6.50872 42.3071 6.53338 42.6561 6.57412 42.9996C6.5801 43.0139 6.58333 43.0314 6.58333 43.0493C6.58333 43.0672 6.5801 43.0846 6.57412 43.099L6.76764 43.6455C6.80694 43.0961 6.82849 42.5431 6.83216 41.9893C6.82719 41.1554 6.7268 40.3323 6.53725 39.5712Z",
    fill: "#61B653"
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M6.01006 43.5038C5.54295 43.2963 5.02438 43.138 4.4751 43.0355C3.42854 42.8721 2.73083 43.0354 2.73083 43.1988C3.39801 43.5864 4.20618 43.8668 5.0856 44.0158C5.65366 44.148 6.23669 44.2536 6.82986 44.3317L6.01006 43.5038ZM6.18449 43.8742C5.85051 43.7626 5.50001 43.6714 5.13793 43.6019C4.77803 43.5394 4.41048 43.4957 4.03903 43.4712C4.42086 43.4748 4.80098 43.504 5.17282 43.5583C5.54339 43.6192 5.90513 43.6993 6.25425 43.798C6.25425 43.798 6.25425 43.798 6.25425 43.8633C6.25425 43.9287 6.25427 43.8633 6.13217 43.8633L6.18449 43.8742Z",
    fill: "#61B653"
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M8.58551 45.5742C8.09222 45.2655 7.56543 45.0742 7.02695 45.0083C6.01388 45.0083 5.46838 45.4654 5.46838 45.7701C6.19239 46.3852 7.0086 46.7577 7.85298 46.8583C8.42088 46.9746 8.99353 47.0401 9.56741 47.0542L8.58551 45.5742ZM8.80371 46.2271C8.49017 46.0738 8.16647 45.9644 7.83741 45.9007C7.50547 45.8627 7.17186 45.8627 6.83993 45.9007C7.17686 45.856 7.51605 45.856 7.85298 45.9007C8.19027 45.9349 8.52435 46.0151 8.85046 46.1401C8.86188 46.1623 8.86801 46.1889 8.86801 46.2163C8.86801 46.2436 8.86188 46.2702 8.85046 46.2924H8.75695L8.80371 46.2271Z",
    fill: "#61B653"
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7085 49.5885C14.4591 48.6249 14.0296 47.7354 13.8911 47.7354C13.7525 47.7354 13.5586 48.4025 13.7248 49.292C13.8292 49.738 13.9884 50.1576 14.1959 50.5336L15.0271 51.1452C14.948 50.617 14.8416 50.0969 14.7085 49.5885ZM14.5561 50.6263H14.4729C14.4009 50.391 14.3408 50.1496 14.2929 49.9035C14.2236 49.5514 14.1682 49.1808 14.1682 49.1808C14.214 49.4194 14.2695 49.6545 14.3344 49.885C14.3917 50.1166 14.466 50.3401 14.5561 50.5522C14.5561 50.5522 14.5976 50.6078 14.5561 50.6263Z",
    fill: "#61B653"
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6906 50.7003C15.4388 50.7708 15.1929 50.8653 14.9558 50.9828C14.7225 51.1101 14.497 51.2544 14.2809 51.4147C14.4849 51.2287 14.7061 51.0672 14.9408 50.9329C15.1327 50.8099 15.3333 50.7043 15.5407 50.6173L15.0758 50.4678C14.619 50.5315 14.1795 50.7013 13.786 50.9662C13.0512 51.5144 12.8712 52.2786 13.0362 52.4613C13.2012 52.644 14.2659 52.3284 15.1357 51.83C15.5791 51.5734 16.0007 51.2731 16.3955 50.9329L15.6906 50.7003Z",
    fill: "#61B653"
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4238 50.4678C10.8723 50.5601 10.3475 50.7038 9.8682 50.894C8.99428 51.2883 8.74958 51.7465 8.94185 51.8317C9.84677 51.7511 10.7085 51.5432 11.4587 51.2243C11.9911 51.0307 12.4993 50.8135 12.9793 50.5743L11.4238 50.4678ZM12.0705 50.617C11.7394 50.6687 11.4174 50.7401 11.1091 50.8301C10.7989 50.9246 10.506 51.0389 10.2352 51.1711C10.4922 51.0257 10.7734 50.8972 11.0742 50.7874C11.3871 50.6844 11.7147 50.5988 12.053 50.5317C12.053 50.5317 12.053 50.5317 12.1579 50.5317C12.1739 50.5417 12.1828 50.5551 12.1828 50.569C12.1828 50.583 12.1739 50.5963 12.1579 50.6063L12.0705 50.617Z",
    fill: "#61B653"
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M7.63119 48.4214C8.37937 48.5161 9.10479 48.8224 9.76105 49.3207C10.168 49.605 10.5597 49.928 10.9333 50.2874L9.95919 50.4028L9.41434 50.4673C8.96319 50.3405 8.52891 50.1207 8.12652 49.8153C7.46609 49.2308 7.41656 48.5563 7.63119 48.4214Z",
    fill: "#61B653"
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M25.3387 3.37639C23.4438 4.06077 21.7703 5.25121 20.4982 6.81969C22.5305 6.55626 24.4792 5.84263 26.2036 4.73032C28.0386 3.70022 29.4173 2.01014 30.0626 0C28.7994 1.51093 27.1735 2.67302 25.3387 3.37639ZM26.6693 3.62713C26.4497 3.79727 26.2159 3.94826 25.9707 4.07844L24.3073 4.89746C23.0931 5.43233 21.9121 6.05079 21.9121 6.05079C22.1367 5.88776 22.3699 5.73709 22.6107 5.59948C23.0598 5.36547 23.6586 5.0479 24.2741 4.78047L25.9374 4.02827C26.1901 3.9176 26.4347 3.78914 26.6693 3.64384C26.6693 3.64384 26.686 3.62713 26.6693 3.62713Z",
    fill: "#61B653"
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M21.293 2.86428C20.2078 3.52661 19.2579 4.43594 18.504 5.53405C17.8545 6.73652 17.6191 8.16393 17.8422 9.54756C18.4623 8.88169 19.1203 8.26157 19.8118 7.69109C20.1583 6.23459 20.8308 4.90167 21.7657 3.81902C22.671 2.69426 23.396 1.40218 23.9087 0C23.295 1.21251 22.3883 2.20552 21.293 2.86428ZM20.19 4.7561C19.736 5.25645 19.3815 5.85902 19.15 6.52416C18.9162 7.16349 18.7984 7.84871 18.8034 8.53975C18.8034 8.5632 18.7951 8.58568 18.7803 8.60226C18.7655 8.61884 18.7455 8.62816 18.7246 8.62816C18.7037 8.62816 18.6837 8.61884 18.6689 8.60226C18.6541 8.58568 18.6458 8.5632 18.6458 8.53975C18.652 7.82566 18.7916 7.12097 19.0555 6.47112C19.3105 5.82827 19.6868 5.2552 20.1585 4.79147L20.19 4.7561Z",
    fill: "#61B653"
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0679 7.36759C13.6064 9.6576 13.5367 12.0107 13.8616 14.3246L14.5493 13.1419C14.5493 13.1419 14.4634 13.1419 14.5493 13.0375C14.6425 12.7128 14.7115 12.3814 14.7556 12.0462C14.7556 11.4548 14.8932 10.6374 14.9791 9.81994C15.0651 9.0025 15.1511 8.18503 15.2542 7.5763C15.3574 6.96756 15.4777 6.56753 15.4777 6.56753C15.4777 6.56753 15.3918 6.96756 15.2886 7.5763C15.1855 8.18503 15.1167 8.98509 15.0651 9.80253C15.0135 10.62 14.9619 11.4548 14.876 12.0636C14.79 12.6723 14.7556 12.7245 14.7213 12.8984L15.1854 12.0809C17.025 8.51548 15.5121 4.67176 17.0766 1.36719C15.7561 3.18743 14.7397 5.21448 14.0679 7.36759Z",
    fill: "#61B653"
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4461 8.9013C19.9831 8.98063 18.5434 9.32074 17.1877 9.90722C15.9614 10.8819 14.9854 12.1655 14.3487 13.641C15.239 12.5192 16.4708 11.7598 17.8329 11.4928C19.1556 11.1347 20.5589 11.0666 21.8655 10.6233C23.6502 9.97321 25.1217 8.60769 25.9626 6.82129C24.6992 7.99556 23.12 8.72284 21.4461 8.9013ZM22.0913 9.75376C21.7772 9.87163 21.4531 9.95728 21.1235 10.0095C20.5428 10.1118 19.7685 10.2141 18.9943 10.3846C18.2939 10.5259 17.604 10.7196 16.9296 10.9643C16.6266 11.0887 16.3304 11.231 16.0424 11.3905C16.0259 11.403 16.0062 11.4097 15.9859 11.4097C15.9657 11.4097 15.9459 11.403 15.9295 11.3905C15.9177 11.3731 15.9113 11.3522 15.9113 11.3308C15.9113 11.3094 15.9177 11.2885 15.9295 11.2711C16.2215 11.1036 16.5232 10.9555 16.8328 10.8279C17.5163 10.5579 18.2244 10.3637 18.9459 10.2482C19.7201 10.1118 20.5589 10.0436 21.0912 9.95836C21.4141 9.92407 21.733 9.85551 22.0429 9.75376H22.0913Z",
    fill: "#61B653"
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8496 11.161C12.6371 10.5785 12.323 10.0331 11.9201 9.54692C11.5318 9.05195 11.2189 8.50869 10.9904 7.93279C10.8795 7.63792 10.8421 7.32317 10.8808 7.01263C10.9196 6.70209 11.0337 6.40398 11.2142 6.14111C10.8997 6.43428 10.6521 6.78436 10.4863 7.17006C10.3206 7.55576 10.2403 7.96902 10.2502 8.38475C10.2707 9.23192 10.4334 10.0708 10.7322 10.8705C11.0273 11.673 11.2406 12.4999 11.3692 13.3401C11.5413 14.9542 11.3692 16.0357 12.2643 17.0526C12.3682 16.8111 12.495 16.5788 12.6431 16.3585C12.2471 14.6314 13.3489 12.8236 12.8496 11.161ZM12.3332 16.6329C12.272 16.3351 12.2432 16.0323 12.2471 15.729C12.2471 15.1964 12.2471 14.4862 12.2471 13.7759C12.2902 13.1281 12.2497 12.4777 12.1266 11.839C12.0729 11.5494 11.9804 11.2674 11.8512 10.9996C11.9987 11.2649 12.1086 11.547 12.1783 11.839C12.3191 12.4813 12.3826 13.1365 12.3676 13.7921C12.3676 14.5023 12.3676 15.2125 12.3676 15.7451C12.3413 16.0352 12.3413 16.3268 12.3676 16.6168C12.3676 16.6168 12.4193 16.6168 12.4193 16.6329H12.3332Z",
    fill: "#61B653"
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6511 14.5545C14.3042 14.9435 13.0911 15.6955 12.1452 16.7276L12.6482 16.4541C13.186 16.2142 13.7414 16.0161 14.3097 15.8614C14.8724 15.7247 15.427 15.5572 15.9712 15.3599C16.2226 15.2686 16.4589 15.1406 16.6724 14.98C16.4629 15.1462 16.2322 15.2842 15.9865 15.3903C15.5444 15.5879 14.9347 15.7702 14.325 15.9678C13.7695 16.1314 13.2248 16.3294 12.694 16.5605C12.4625 16.6783 12.2385 16.8103 12.0233 16.9556C11.8708 17.214 11.7641 17.4723 11.6117 17.7307C12.1608 17.2343 12.8266 16.8841 13.5476 16.7124C14.264 16.4997 14.9957 16.3629 15.6816 16.0894C16.5202 15.775 17.2709 15.2645 17.8704 14.6007C18.4699 13.9369 18.9007 13.1393 19.1266 12.2749C18.221 13.3621 17.0111 14.1557 15.6511 14.5545Z",
    fill: "#61B653"
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2481 22.433C10.2294 22.4447 10.2069 22.4511 10.1839 22.4511C10.1609 22.4511 10.1385 22.4447 10.1198 22.433C9.77874 21.7456 9.52077 21.0289 9.35008 20.2943C9.19044 19.5573 9.10459 18.8094 9.09352 18.0593C9.14025 18.8017 9.26291 19.539 9.46004 20.2622C9.65029 20.9712 9.90775 21.6651 10.2297 22.3365C10.2385 22.2079 10.2385 22.0791 10.2297 21.9506C10.294 18.3571 9.36329 14.8036 7.51746 11.5952C7.97354 12.8691 8.19019 14.1997 8.15889 15.5347C8.05476 16.8766 8.11619 18.2244 8.34213 19.5547C8.71258 20.8253 9.27337 22.0473 10.0098 23.1887C10.0424 22.9345 10.0913 22.6822 10.1564 22.433C10.1564 22.433 10.2664 22.433 10.2481 22.433Z",
    fill: "#61B653"
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0115 19.3339C11.6708 20.4375 10.7855 22.0025 10.5272 23.7254C10.5272 23.8651 10.5272 24.0203 10.45 24.1755C10.6335 24.0013 10.7989 23.809 10.9438 23.6013C11.2792 23.1007 11.5882 22.5827 11.8696 22.0495C12.1783 21.4909 12.4869 20.9167 12.7646 20.4977C12.9087 20.2743 13.098 20.0839 13.3202 19.9391C13.1106 20.1076 12.9329 20.3126 12.7955 20.5443C12.491 21.0466 12.2129 21.5645 11.9622 22.0961C11.7068 22.6404 11.4021 23.1598 11.0518 23.6479C10.8884 23.869 10.6964 24.0673 10.4809 24.2375C10.4809 24.2375 10.4809 24.2375 10.4037 24.2375C10.4037 24.5634 10.2957 24.8893 10.2494 25.2307C10.6813 25.1282 11.0878 24.9376 11.4435 24.6706C11.7992 24.4037 12.0965 24.0661 12.3171 23.6789C12.7801 22.8875 13.0887 22.003 13.5362 21.196C14.4444 19.5335 15.9611 18.2922 17.7643 17.7355C16.0383 17.6608 14.3456 18.23 13.0115 19.3339Z",
    fill: "#61B653"
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47359 28.2323C9.23086 25.8326 8.30393 23.5847 6.83069 21.8232C7.64067 23.5154 8.08132 25.3989 8.11643 27.319C8.16128 29.2335 8.65393 31.1011 9.54502 32.7347C9.53074 31.2286 9.63073 29.7225 9.47359 28.2323ZM9.47359 30.6838H9.38788C9.18787 30.6838 8.94501 28.9694 8.91644 28.7451C8.78787 27.7677 8.63073 26.8063 8.63073 26.8063C8.63073 26.8063 8.81644 27.7677 8.98787 28.7451C9.04383 29.3792 9.19855 29.9975 9.44501 30.5717C9.44501 30.5717 9.48786 30.6678 9.45929 30.6838H9.47359Z",
    fill: "#61B653"
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3015 27.9007C10.1226 30.092 10.7656 32.1404 10.2604 34.7764C10.2323 35.2331 10.258 35.6917 10.3369 36.142C10.3459 34.9487 10.6238 33.7741 11.1484 32.7121C11.6231 31.6323 12.3121 30.6319 12.6795 29.5362C13.4298 27.4243 13.7207 25.0583 14.3484 23.1846C13.4757 24.9472 12.1283 26.3763 11.3015 27.9007ZM11.623 29.9809C11.1484 31.2512 10.7963 32.5692 10.7963 32.5692C10.9124 31.6559 11.1335 30.7603 11.4546 29.9015C11.7951 29.0477 12.221 28.2334 12.7254 27.4719C12.3038 28.3088 11.9355 29.1734 11.623 30.0603V29.9809Z",
    fill: "#61B653"
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M10.93 38.654L11.2017 39.8222C11.2772 39.5501 11.4131 39.038 11.549 38.4939L11.9717 36.9737C11.9717 36.9737 11.8359 37.8538 11.6547 38.574C11.4735 39.2941 11.2621 39.9982 11.2621 39.9982C11.398 40.5743 11.5641 41.1824 11.6849 41.5985C12.8776 39.1661 12.5303 34.6693 13.6627 32.7329C11.9415 33.8851 11.247 36.2215 10.93 38.654Z",
    fill: "#61B653"
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0552 44.6507C12.7869 42.1428 13.2383 39.5925 14.3197 37.5068C14.0248 39.0616 13.9688 40.6796 14.1553 42.2638C14.4366 43.8442 14.4061 45.4943 14.0668 47.0544C13.615 46.3485 13.2714 45.5319 13.0552 44.6507Z",
    fill: "#61B653"
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5057 49.6521C15.0309 49.146 14.5957 48.6013 14.2044 48.0232C13.1932 46.5033 12.3615 44.8625 11.7274 43.1363C11.3004 41.9827 10.9443 40.802 10.6613 39.6015C10.322 38.2688 10.0706 36.9136 9.90872 35.5454C9.54592 32.5798 9.46716 29.5842 9.67357 26.6024C9.8039 25.0858 10.0238 23.5789 10.332 22.0902C10.6417 20.6496 11.0664 19.2384 11.6019 17.8712C12.0826 16.5827 12.6702 15.3401 13.3579 14.1572C13.9793 13.0987 14.6708 12.0863 15.4273 11.1274C16.569 9.70352 17.8629 8.41924 19.2841 7.29932C19.6837 6.98854 20.1027 6.70557 20.5383 6.45226L20.9929 6.17534C21.0031 6.1645 21.0154 6.15589 21.0288 6.15001C21.0423 6.14413 21.0567 6.14111 21.0713 6.14111C21.0859 6.14111 21.1004 6.14413 21.1138 6.15001C21.1273 6.15589 21.1395 6.1645 21.1497 6.17534C21.1663 6.19588 21.1754 6.22183 21.1754 6.24864C21.1754 6.27545 21.1663 6.3014 21.1497 6.32194L19.5819 7.62511C18.2082 8.74969 16.9475 10.0159 15.8193 11.4043C14.2296 13.3773 12.9588 15.6053 12.0566 18.0015C11.5317 19.36 11.1123 20.76 10.8024 22.188C10.4877 23.6479 10.2677 25.1281 10.1439 26.6187L10.0341 28.883C10.0341 29.6323 10.0341 30.3816 10.0341 31.1309C10.0706 32.5803 10.1805 34.0266 10.3634 35.4639C10.5277 36.8144 10.7738 38.1528 11.1003 39.4712C11.3707 40.6521 11.7218 41.8116 12.1507 42.9408C12.7627 44.6426 13.5791 46.2572 14.5807 47.7462C14.9427 48.3289 15.3575 48.8744 15.8193 49.3752C15.8623 49.4209 15.8865 49.4823 15.8865 49.5462C15.8865 49.6102 15.8623 49.6716 15.8193 49.7173C15.7753 49.762 15.7162 49.7871 15.6546 49.7871C15.5931 49.7871 15.534 49.762 15.49 49.7173L15.5057 49.6521Z",
    fill: "#61B653"
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M5.63884 40.9272C6.13822 42.0919 6.80451 43.1842 7.61851 44.1725C8.00804 44.6763 8.42926 45.1569 8.87978 45.6115C9.31866 46.0732 9.78227 46.5126 10.2687 46.9281C11.2593 47.7565 12.3283 48.4945 13.4618 49.1325C14.0206 49.4693 14.6273 49.7295 15.202 50.0204C15.7767 50.3113 16.4154 50.5103 17.0061 50.7552L16.8624 51.0308C15.4573 50.4523 13.9639 50.0956 12.44 49.9745C11.695 49.9132 10.9286 49.8826 10.141 49.8826C9.37469 49.8826 8.54449 49.8826 7.84202 49.9898C9.37298 49.7144 10.9355 49.6372 12.4879 49.7602C14.0605 49.8673 15.601 50.2405 17.038 50.8624C17.052 50.8752 17.0632 50.8907 17.0708 50.9078C17.0784 50.9249 17.0823 50.9433 17.0823 50.9619C17.0823 50.9804 17.0784 50.9988 17.0708 51.0159C17.0632 51.033 17.052 51.0485 17.038 51.0614C17.031 51.0787 17.0204 51.0945 17.0069 51.1078C16.9934 51.1211 16.9772 51.1317 16.9593 51.1388C16.9414 51.146 16.9221 51.1496 16.9027 51.1494C16.8833 51.1493 16.8642 51.1454 16.8464 51.1379C16.2397 50.8777 15.6171 50.6633 15.0104 50.3878C14.4037 50.1122 13.813 49.8367 13.2542 49.4846C12.1181 48.8387 11.0489 48.0903 10.0612 47.2496C9.05771 46.4053 8.16267 45.4494 7.395 44.4022C6.60901 43.3736 5.96506 42.2519 5.47918 41.0649C5.47208 41.0506 5.46838 41.0349 5.46838 41.019C5.46838 41.0031 5.47208 40.9874 5.47918 40.9731C5.47918 40.9731 5.62287 40.8965 5.63884 40.9272Z",
    fill: "#61B653"
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2144 19.5854C66.2828 19.125 66.317 18.4651 66.146 18.4191C65.975 18.3731 65.8153 18.8488 65.7355 19.4166C65.6388 20.2131 65.5893 21.0188 65.5873 21.8259C65.9036 21.1417 66.1167 20.3804 66.2144 19.5854Z",
    fill: "#61B653"
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M64.9019 22.9172C64.9019 22.4508 64.9019 21.8075 64.6 21.8235C64.2982 21.8396 64.2346 22.3382 64.2188 22.885C64.2299 23.6732 64.3096 24.459 64.457 25.2331C64.7545 24.4983 64.9056 23.7113 64.9019 22.9172Z",
    fill: "#61B653"
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1717 25.6522C64.1717 25.1996 63.9319 24.5508 63.4526 24.5508C62.9732 24.5508 62.8234 25.0789 62.8533 25.622C62.9971 26.4102 63.2574 27.1919 63.6323 27.9606C64.1257 27.218 64.3093 26.4322 64.1717 25.6522Z",
    fill: "#61B653"
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M65.5496 22.5436C65.7245 22.1944 66.0369 21.7144 66.1993 21.8453C66.3617 21.9762 66.1993 22.4127 66.0244 22.8491C65.6878 23.4494 65.3119 24.0184 64.8999 24.5511C64.9969 23.8374 65.218 23.1543 65.5496 22.5436Z",
    fill: "#61B653"
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2335 25.0959C65.4954 24.8299 65.97 24.4786 66.1828 24.5638C66.3956 24.6489 66.1828 24.9895 65.8555 25.3195C65.3661 25.7744 64.8185 26.2016 64.2188 26.5967C64.4043 26.0584 64.7489 25.5487 65.2335 25.0959Z",
    fill: "#61B653"
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M68.8897 26.4953C68.9733 26.0402 69.057 25.3413 68.9524 25.2438C68.8479 25.1463 68.7224 25.6177 68.6248 26.1703C68.493 26.9723 68.3904 27.7987 68.3181 28.6408C68.5682 28.022 68.7626 27.2925 68.8897 26.4953Z",
    fill: "#61B653"
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M67.4807 28.8923C67.638 28.5334 67.7278 28.0016 67.4807 27.9617C67.2336 27.9219 66.8293 28.3206 66.6272 28.7593C66.4314 29.3961 66.3113 30.0402 66.2678 30.6869C66.8788 30.1451 67.2919 29.5339 67.4807 28.8923Z",
    fill: "#61B653"
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M66.2239 30.5041C66.2872 30.0457 66.3126 29.3735 66.1225 29.3277C65.9325 29.2819 65.7677 29.7707 65.6917 30.336C65.6102 31.1316 65.5763 31.9331 65.5904 32.7345C65.9217 32.0488 66.137 31.2907 66.2239 30.5041Z",
    fill: "#61B653"
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8119 29.9559C68.171 29.6065 68.7456 29.1697 68.9431 29.3794C69.1406 29.589 68.7994 30.0433 68.3685 30.4801C67.7147 31.0604 67.012 31.5865 66.2678 32.0526C66.6317 31.2594 67.157 30.5462 67.8119 29.9559Z",
    fill: "#61B653"
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M66.4881 31.3238C66.8447 30.9756 67.4281 30.5404 67.5902 30.7319C67.7522 30.9234 67.4281 31.4109 66.9905 31.8461C66.3357 32.4303 65.6363 32.9544 64.8999 33.4129C65.2975 32.612 65.837 31.9024 66.4881 31.3238Z",
    fill: "#61B653"
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M62.3503 31.9906C62.7631 31.2237 63.402 30.5774 64.195 30.1243C64.2101 30.1103 64.2186 30.0914 64.2186 30.0717C64.2186 30.052 64.2101 30.0331 64.195 30.019C64.1775 30.0097 64.1576 30.0049 64.1374 30.0049C64.1172 30.0049 64.0973 30.0097 64.0797 30.019C63.2599 30.4936 62.5989 31.1654 62.1691 31.9605V32.0508C62.1691 32.0508 62.3338 31.9906 62.3503 31.9906Z",
    fill: "#61B653"
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M61.7646 33.3098C62.3066 32.2282 62.3066 31.0865 61.7646 30.0049C61.7646 30.0049 61.7646 30.0049 61.573 30.0049C61.3815 30.0049 61.573 30.0049 61.573 30.1098C62.0989 31.157 62.0989 32.2626 61.573 33.3098C61.573 33.3098 61.573 33.3972 61.573 33.4147L61.7646 33.3098Z",
    fill: "#61B653"
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7054 36.7426C59.9594 36.4399 60.3125 36.1782 60.739 35.9767C61.1654 35.7751 61.6546 35.6387 62.171 35.5774C62.171 35.5774 62.171 35.5774 62.171 35.4961C62.171 35.4148 62.171 35.4961 62.0477 35.4961C61.5017 35.5619 60.9846 35.7065 60.5334 35.9197C60.0823 36.1329 59.7083 36.4093 59.4383 36.7291C59.4383 36.7291 59.4383 36.7968 59.4383 36.8239L59.7054 36.7426Z",
    fill: "#61B653"
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9924 36.1072C63.7017 35.7699 64.5703 35.5691 65.4804 35.5319C65.5092 35.529 65.5353 35.5202 65.554 35.507C65.5727 35.4938 65.5828 35.4771 65.5823 35.46C65.5823 35.46 65.5823 35.46 65.46 35.46C64.5074 35.5017 63.5981 35.7104 62.8497 36.0592V36.1431L62.9924 36.1072Z",
    fill: "#61B653"
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M61.5733 38.7468C61.9237 38.0622 62.3514 37.6818 62.7933 37.6618C62.8013 37.6618 62.8092 37.6578 62.8166 37.65C62.824 37.6422 62.8307 37.6308 62.8364 37.6164C62.8421 37.602 62.8466 37.585 62.8496 37.5662C62.8527 37.5473 62.8543 37.5272 62.8543 37.5068H62.7933C62.3206 37.518 61.8623 37.9207 61.4879 38.6538V38.8708C61.4879 38.8708 61.5489 38.7468 61.5733 38.7468Z",
    fill: "#61B653"
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M57.5322 42.8756C58.1201 42.2725 58.7686 41.8991 59.4376 41.7785V41.6006C59.4376 41.6006 59.4376 41.6006 59.3575 41.6006C58.6635 41.7169 57.9915 42.1115 57.3881 42.7569C57.3881 42.7569 57.3881 42.757 57.3881 42.9645L57.5322 42.8756Z",
    fill: "#61B653"
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M65.439 21.8232L64.5399 24.9046C63.9678 26.7437 63.2159 29.212 62.2841 31.6158C61.4779 33.8455 60.4827 36.0041 59.309 38.0688C58.9248 38.7365 58.4875 39.3731 58.0013 39.9725L57.4292 40.65C57.4026 40.6818 57.3881 40.7218 57.3881 40.763C57.3881 40.8042 57.4026 40.8441 57.4292 40.8759C57.464 40.9034 57.5072 40.9184 57.5518 40.9184C57.5963 40.9184 57.6396 40.9034 57.6744 40.8759L58.2465 40.1822C58.7491 39.5706 59.1975 38.9175 59.5869 38.2301C60.1555 37.2812 60.6685 36.3009 61.1235 35.294C61.6466 34.197 62.137 32.987 62.5947 31.7932C63.5101 29.3733 64.2294 26.9534 64.8015 25.0498C65.3736 23.1461 65.5861 21.92 65.5861 21.92V21.8394L65.439 21.8232Z",
    fill: "#61B653"
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M68.2165 27.9681C66.8552 30.8875 65.2106 33.6667 63.3062 36.266C61.992 38.0418 60.5477 39.7179 58.9852 41.2807C58.3469 41.9504 57.7904 42.4568 57.3485 42.8161L56.7429 43.3715C56.7161 43.4011 56.7011 43.4394 56.7008 43.4793C56.7004 43.5192 56.7146 43.5578 56.7407 43.5879C56.7669 43.618 56.8032 43.6376 56.8428 43.6428C56.8824 43.6481 56.9225 43.6388 56.9557 43.6165L57.5776 43.0611C57.9705 42.7018 58.5433 42.1954 59.2144 41.5421C59.8854 40.8887 60.5893 40.121 61.3422 39.2716C62.0951 38.4222 62.8643 37.4584 63.5845 36.4784C64.9222 34.687 66.105 32.7854 67.1199 30.794C67.5844 29.8926 67.9837 28.9591 68.3147 28.0008C68.3147 28.0008 68.2165 27.9355 68.2165 27.9681Z",
    fill: "#61B653"
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 33.0745C59.4383 33.1421 59.4784 33.2081 59.5534 33.2643C59.6285 33.3204 59.7352 33.3642 59.86 33.3901C59.9848 33.4159 60.1222 33.4227 60.2547 33.4095C60.3873 33.3963 60.509 33.3638 60.6045 33.316C60.7001 33.2683 60.7652 33.2074 60.7915 33.1411C60.8179 33.0749 60.8043 33.0062 60.7526 32.9438C60.7009 32.8814 60.6133 32.828 60.501 32.7905C60.3887 32.7529 60.2566 32.7329 60.1214 32.7329C59.9403 32.7329 59.7665 32.7689 59.6384 32.8329C59.5103 32.897 59.4383 32.9839 59.4383 33.0745Z",
    fill: "#61B653"
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M62.1691 35.8015C62.1691 35.8691 62.1891 35.9351 62.2266 35.9913C62.2642 36.0475 62.3175 36.0913 62.3799 36.1171C62.4423 36.143 62.511 36.1497 62.5773 36.1366C62.6436 36.1234 62.7044 36.0909 62.7522 36.0431C62.8 35.9953 62.8325 35.9345 62.8457 35.8682C62.8589 35.8019 62.8521 35.7332 62.8262 35.6708C62.8004 35.6084 62.7566 35.5551 62.7004 35.5175C62.6443 35.48 62.5782 35.46 62.5107 35.46C62.4201 35.46 62.3332 35.4959 62.2691 35.56C62.205 35.6241 62.1691 35.7109 62.1691 35.8015Z",
    fill: "#61B653"
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M62.8501 38.2123C62.8547 38.3461 62.8986 38.4756 62.9765 38.5846C63.0543 38.6936 63.1626 38.7773 63.2877 38.8254C63.4129 38.8734 63.5494 38.8836 63.6804 38.8547C63.8113 38.8258 63.9308 38.759 64.0241 38.6628C64.1173 38.5665 64.18 38.4451 64.2045 38.3135C64.229 38.1818 64.2142 38.0459 64.1619 37.9227C64.1095 37.7994 64.022 37.6943 63.9102 37.6203C63.7985 37.5464 63.6673 37.5069 63.5332 37.5068C63.4415 37.5068 63.3507 37.5252 63.2663 37.5609C63.1818 37.5966 63.1054 37.649 63.0416 37.7148C62.9779 37.7807 62.9281 37.8586 62.8952 37.9441C62.8622 38.0296 62.8469 38.1208 62.8501 38.2123Z",
    fill: "#61B653"
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5603 30.0079C64.749 30.0079 64.9019 29.8549 64.9019 29.6663C64.9019 29.4776 64.749 29.3247 64.5603 29.3247C64.3717 29.3247 64.2188 29.4776 64.2188 29.6663C64.2188 29.8549 64.3717 30.0079 64.5603 30.0079Z",
    fill: "#61B653"
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8295 30.0079C62.0182 30.0079 62.1711 29.8549 62.1711 29.6663C62.1711 29.4776 62.0182 29.3247 61.8295 29.3247C61.6409 29.3247 61.4879 29.4776 61.4879 29.6663C61.4879 29.8549 61.6409 30.0079 61.8295 30.0079Z",
    fill: "#61B653"
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M65.2415 36.1431C65.4301 36.1431 65.5831 35.9902 65.5831 35.8015C65.5831 35.6129 65.4301 35.46 65.2415 35.46C65.0528 35.46 64.8999 35.6129 64.8999 35.8015C64.8999 35.9902 65.0528 36.1431 65.2415 36.1431Z",
    fill: "#61B653"
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M60.1215 41.6031C60.4988 41.6031 60.8046 41.4502 60.8046 41.2615C60.8046 41.0729 60.4988 40.9199 60.1215 40.9199C59.7442 40.9199 59.4383 41.0729 59.4383 41.2615C59.4383 41.4502 59.7442 41.6031 60.1215 41.6031Z",
    fill: "#61B653"
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M60.8006 38.1888C60.8006 38.2784 60.8094 38.3671 60.8266 38.4498C60.8438 38.5325 60.8689 38.6077 60.9007 38.6711C60.9324 38.7344 60.97 38.7846 61.0115 38.8189C61.0529 38.8531 61.0973 38.8708 61.1422 38.8708C61.1871 38.8708 61.2315 38.8531 61.2729 38.8189C61.3144 38.7846 61.352 38.7344 61.3837 38.6711C61.4154 38.6077 61.4406 38.5325 61.4578 38.4498C61.4749 38.3671 61.4838 38.2784 61.4838 38.1888C61.4838 38.0993 61.4749 38.0106 61.4578 37.9278C61.4406 37.8451 61.4154 37.7699 61.3837 37.7066C61.352 37.6433 61.3144 37.593 61.2729 37.5587C61.2315 37.5245 61.1871 37.5068 61.1422 37.5068C61.0516 37.5068 60.9647 37.5787 60.9007 37.7066C60.8366 37.8345 60.8006 38.008 60.8006 38.1888Z",
    fill: "#61B653"
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4383 50.1855C60.0524 50.5794 60.743 50.8328 61.4624 50.9284C62.8185 51.176 64.114 51.2586 64.2152 50.9284C64.3164 50.5982 62.9602 49.8966 61.5838 49.8141C60.8483 49.7161 60.1009 49.8455 59.4383 50.1855Z",
    fill: "#61B653"
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M64.2513 40.9167C64.6306 40.6078 64.9387 40.1554 65.1397 39.6126C65.5259 38.6479 65.6804 37.6654 65.5259 37.5224C65.3714 37.3795 64.6762 38.237 64.3929 39.3089C64.2282 39.812 64.1787 40.3733 64.2513 40.9167Z",
    fill: "#61B653"
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M57.3274 47.0995C57.3582 46.7757 57.3582 46.449 57.3274 46.1252C57.3539 46.4443 57.3539 46.7655 57.3274 47.0845C57.2803 47.4019 57.206 47.7132 57.1055 48.0138L56.7007 48.4185C56.7202 47.8406 56.7726 47.2648 56.8574 46.6948C56.9307 45.8468 57.1864 45.033 57.6016 44.3267C57.7975 44.3267 58.1239 44.9262 58.0586 45.9454C57.9977 46.4675 57.8609 46.9741 57.6538 47.4442L57.2491 47.8489C57.293 47.602 57.3192 47.3513 57.3274 47.0995Z",
    fill: "#61B653"
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4702 46.3744L61.0047 45.0009C61.2988 44.4243 61.4616 43.822 61.4878 43.2136C61.4878 42.0848 60.7774 41.5015 60.4364 41.6144C59.8225 42.4999 59.5027 43.4622 59.4986 44.4365C59.4291 45.0815 59.4197 45.7286 59.4702 46.3744ZM60.0101 45.5465C60.1729 45.1583 60.2869 44.7619 60.3511 44.3612C60.4173 43.9611 60.4173 43.5573 60.3511 43.1571C60.4087 43.5702 60.4087 43.9858 60.3511 44.3989C60.3212 44.8108 60.2356 45.22 60.0954 45.6218H59.9249H60.0101V45.5465Z",
    fill: "#61B653"
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4393 39.5712C62.5491 39.4552 62.7986 39.919 62.8485 40.8796C62.8635 41.3975 62.8333 41.9164 62.7587 42.4199L62.569 42.9168C62.5875 42.6028 62.5875 42.2867 62.569 41.9727C62.5595 41.61 62.5294 41.2496 62.4792 40.8962C62.516 41.2461 62.5327 41.601 62.5291 41.9562C62.5201 42.3071 62.4934 42.6561 62.4493 42.9996C62.4493 42.9996 62.4493 42.9996 62.4493 43.099L62.2397 43.6455C62.1972 43.0961 62.1738 42.5431 62.1699 41.9893C62.1595 41.1612 62.2512 40.3383 62.4393 39.5712Z",
    fill: "#61B653"
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M63.2322 43.6949C62.6643 43.9606 62.0812 44.1724 61.4879 44.3285L62.3077 42.6681C62.7748 42.2518 63.2934 41.9344 63.8427 41.7287C64.8718 41.401 65.5869 41.7724 65.5869 42.0564C64.9198 42.8337 64.1116 43.3961 63.2322 43.6949Z",
    fill: "#61B653"
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7504 47.0542C59.3294 47.0405 59.9073 46.9754 60.4804 46.8592C61.3207 46.7644 62.1327 46.3931 62.8494 45.7759C62.8494 45.4726 62.3039 44.9309 61.2908 45.0176C60.7523 45.0832 60.2256 45.2736 59.7323 45.5809L58.7504 47.0542ZM59.5296 46.2309H59.4361C59.4247 46.2088 59.4186 46.1823 59.4186 46.1551C59.4186 46.1279 59.4247 46.1013 59.4361 46.0792C59.7677 45.956 60.1069 45.8762 60.4492 45.8409C60.7861 45.7965 61.1253 45.7965 61.4623 45.8409C61.1303 45.8031 60.7967 45.8031 60.4648 45.8409C60.1309 45.9059 59.8021 46.0147 59.4829 46.1659L59.5296 46.2309Z",
    fill: "#61B653"
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9694 51.1452L54.7977 50.5337C55.0044 50.1577 55.1631 49.738 55.2671 49.292C55.4328 48.4025 55.2671 47.7354 55.1014 47.7354C54.9357 47.7354 54.5354 48.6805 54.2869 49.5885C54.1459 50.0933 54.0396 50.6144 53.9694 51.1452ZM54.4111 50.5522C54.4945 50.3358 54.5682 50.1131 54.632 49.885C54.6967 49.6545 54.752 49.4194 54.7977 49.1808C54.7977 49.1808 54.7977 49.5515 54.6734 49.9036C54.6257 50.1496 54.5657 50.391 54.494 50.6263L54.3835 50.5151L54.4111 50.5522Z",
    fill: "#61B653"
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M52.907 50.7003C53.2533 50.7698 53.5908 50.8643 53.9152 50.9828C54.2503 51.1078 54.5733 51.2521 54.8815 51.4147C54.5959 51.2287 54.286 51.0672 53.9573 50.9329C53.6864 50.813 53.4057 50.7075 53.117 50.6173L53.7682 50.4678C54.408 50.5315 55.0236 50.7013 55.5747 50.9662C56.583 51.5144 56.8561 52.2786 56.625 52.4613C56.394 52.644 54.9025 52.3284 53.6842 51.83C53.0632 51.5734 52.4727 51.2731 51.9197 50.9329L52.907 50.7003Z",
    fill: "#61B653"
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M57.713 51.2243C57.3586 51.0307 57.0203 50.8135 56.7007 50.5743L57.2953 50.5131L57.7363 50.4678C58.1035 50.5601 58.4528 50.7038 58.7719 50.894C59.3886 51.2883 59.5166 51.7465 59.3886 51.8317C58.7857 51.7527 58.2117 51.5446 57.713 51.2243Z",
    fill: "#61B653"
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3292 50.3989L57.3881 50.2874C57.7616 49.928 58.1533 49.605 58.5603 49.3207C59.2166 48.8224 59.942 48.5161 60.6902 48.4214C60.9048 48.5563 60.8553 49.2308 60.1949 49.8153C59.7925 50.1207 59.3582 50.3405 58.907 50.4673L58.3375 50.3998H58.3292V50.3989Z",
    fill: "#61B653"
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9401 0C39.5393 2.01014 40.8195 3.70022 42.5234 4.73032C44.1247 5.84263 45.9342 6.55626 47.8213 6.81969C46.6401 5.25121 45.0862 4.06077 43.3266 3.37639C41.6228 2.67302 40.1131 1.51093 38.9401 0ZM42.0292 3.6104C42.2471 3.7557 42.4742 3.88418 42.7088 3.99486L44.2534 4.74703C44.8094 5.01447 45.3654 5.33206 45.7979 5.56607C46.0277 5.70158 46.2495 5.85228 46.4621 6.01735C46.4621 6.01735 45.3654 5.3989 44.2225 4.86402L42.6779 4.045C42.4502 3.91482 42.2332 3.76383 42.0292 3.5937C42.0292 3.5937 42.0755 3.62712 42.0755 3.6104H42.0292Z",
    fill: "#61B653"
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M46.792 3.81902C45.7848 2.69426 44.9782 1.40218 44.4078 0C45.088 1.20833 46.09 2.20053 47.3003 2.86428C48.5131 3.52588 49.5758 4.43512 50.4208 5.53405C51.1451 6.73585 51.4013 8.16612 51.1395 9.54756C50.4594 8.8776 49.733 8.25721 48.9658 7.69109C48.5803 6.23459 47.832 4.90167 46.792 3.81902Z",
    fill: "#61B653"
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9263 7.36759C55.3901 9.6576 55.4603 12.0107 55.1337 14.3246L54.4425 13.1419C54.4516 13.126 54.4564 13.108 54.4564 13.0897C54.4564 13.0714 54.4516 13.0534 54.4425 13.0375C54.3488 12.7128 54.2795 12.3814 54.2351 12.0462C54.2351 11.4548 54.0796 10.6374 54.0105 9.81994C53.9414 9.0025 53.8377 8.18503 53.734 7.5763C53.6303 6.96756 53.5094 6.56753 53.5094 6.56753C53.5094 6.56753 53.6131 6.96756 53.7167 7.5763C53.8204 8.18503 53.8895 8.98509 53.9414 9.80253C53.9932 10.62 54.0451 11.4548 54.1315 12.0636C54.2179 12.6723 54.2524 12.7245 54.287 12.8984L53.8204 12.0809C51.9542 8.51548 53.4921 4.67176 51.9197 1.36719C53.2408 3.18861 54.2564 5.21559 54.9263 7.36759Z",
    fill: "#61B653"
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M43.0394 6.82129C43.8873 8.60095 45.3538 9.96367 47.1308 10.6233C48.4356 11.0666 49.8531 11.1347 51.1739 11.4928C52.5327 11.7638 53.7616 12.5225 54.6533 13.641C54.0174 12.1655 53.0428 10.8819 51.8183 9.90722C50.4639 9.32261 49.0264 8.98257 47.5657 8.9013C45.8909 8.71637 44.3106 7.99014 43.0394 6.82129ZM46.9053 9.73672C47.2148 9.83847 47.5332 9.90701 47.8557 9.9413C48.4356 9.9413 49.2249 10.0947 49.9981 10.2311C50.7185 10.3466 51.4257 10.5409 52.1082 10.8108C52.4114 10.9403 52.7072 11.0883 52.9942 11.2541C53.0089 11.27 53.0172 11.2915 53.0172 11.3138C53.0172 11.3361 53.0089 11.3575 52.9942 11.3734C52.977 11.3839 52.9576 11.3894 52.9378 11.3894C52.918 11.3894 52.8986 11.3839 52.8814 11.3734C52.5938 11.214 52.2981 11.0717 51.9955 10.9472C51.322 10.7026 50.633 10.5089 49.9336 10.3675C49.1604 10.197 48.3228 10.0947 47.7913 9.99244C47.4676 9.93896 47.1494 9.85334 46.8409 9.73672H46.9053Z",
    fill: "#61B653"
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M55.6763 16.3585C55.8244 16.5788 55.9511 16.8111 56.055 17.0526C56.9157 16.0357 56.778 14.9542 56.9501 13.3401C57.0787 12.4999 57.292 11.673 57.587 10.8705C57.8859 10.0708 58.0485 9.23192 58.069 8.38475C58.0798 7.96748 57.9981 7.55265 57.8293 7.16647C57.6604 6.78029 57.4079 6.43115 57.0878 6.14111C57.2712 6.40268 57.3883 6.70016 57.4301 7.01073C57.4718 7.32131 57.4372 7.63672 57.3288 7.93279C57.101 8.51215 56.7819 9.05623 56.3821 9.54692C55.9908 10.0375 55.683 10.582 55.4697 11.161C54.9705 12.872 56.0722 14.6798 55.6763 16.3585ZM55.9001 16.5845C55.9221 16.2943 55.9221 16.0031 55.9001 15.7129C55.9001 15.1802 55.9001 14.47 55.9001 13.7598C55.8982 13.1039 55.9674 12.4495 56.1066 11.8067C56.1763 11.517 56.2802 11.2354 56.4165 10.9674C56.2857 11.236 56.1875 11.5175 56.1238 11.8067C56.0153 12.447 55.9807 13.0964 56.0206 13.7437C56.0206 14.4539 56.0206 15.1641 56.0206 15.6967C56.0245 16 55.9957 16.3028 55.9345 16.6006C55.9345 16.6006 55.9345 16.6006 55.8312 16.6006C55.8519 16.5889 55.8759 16.5833 55.9001 16.5845Z",
    fill: "#61B653"
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M52.9887 14.5545C54.4551 14.9435 55.7758 15.6955 56.8056 16.7276L56.2579 16.4541C55.6725 16.2142 55.0678 16.0161 54.4491 15.8614C53.8359 15.7268 53.2319 15.5593 52.6402 15.3599C52.3643 15.2733 52.1062 15.1449 51.8768 14.98C52.105 15.1462 52.3561 15.2842 52.6236 15.3903C53.1048 15.5879 53.7686 15.7702 54.4325 15.9678C55.0328 16.1287 55.6205 16.3267 56.1916 16.5605C56.45 16.6765 56.6995 16.8085 56.9384 16.9556C57.0877 17.214 57.2205 17.4723 57.3864 17.7307C56.7847 17.2309 56.0535 16.8804 55.2622 16.7124C54.4988 16.4997 53.7023 16.3629 52.9555 16.0894C52.0415 15.7738 51.223 15.2631 50.5678 14.5997C49.9126 13.9362 49.4397 13.1393 49.1884 12.2749C50.1834 13.3598 51.5051 14.1526 52.9887 14.5545Z",
    fill: "#61B653"
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M58.071 22.433C58.0904 22.4428 58.1124 22.448 58.1347 22.448C58.1571 22.448 58.179 22.4428 58.1984 22.433C58.5372 21.7456 58.7935 21.0289 58.9631 20.2943C59.1217 19.5573 59.207 18.8094 59.218 18.0593C59.1829 18.8017 59.067 19.5394 58.8721 20.2622C58.6831 20.9712 58.4273 21.6651 58.1074 22.3365C58.0987 22.2079 58.0987 22.0791 58.1074 21.9506C58.0347 18.3562 58.9598 14.8009 60.8019 11.5952C60.3488 12.8691 60.1336 14.1997 60.1647 15.5347C60.2681 16.8766 60.2071 18.2244 59.9826 19.5547C59.6146 20.8253 59.0575 22.0473 58.3259 23.1887C58.2936 22.9345 58.2449 22.6822 58.1802 22.433C58.1802 22.433 58.0528 22.433 58.071 22.433Z",
    fill: "#61B653"
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M55.809 19.3361C57.2716 20.4393 58.2374 22.0037 58.5192 23.726C58.5192 23.8656 58.5192 24.0207 58.6034 24.1758C58.4032 24.0018 58.2228 23.8095 58.0647 23.6019C57.6924 23.1052 57.3551 22.5871 57.0547 22.0507C56.718 21.4923 56.3813 20.9183 56.0783 20.4995C55.9212 20.2761 55.7147 20.0858 55.4723 19.941C55.6979 20.108 55.8864 20.3134 56.0278 20.546C56.3725 21.0441 56.6817 21.5623 56.9537 22.0972C57.2258 22.6445 57.5587 23.1643 57.9469 23.6484C58.1252 23.8695 58.3346 24.0677 58.5697 24.2379C58.5697 24.5636 58.7044 24.8894 58.7549 25.2307C58.2825 25.1309 57.8379 24.9414 57.4495 24.6743C57.0611 24.4072 56.7374 24.0683 56.4992 23.6794C55.9773 22.8883 55.6575 22.0042 55.1693 21.1975C54.1785 19.5356 52.524 18.2948 50.5568 17.7383C52.4626 17.648 54.3361 18.2179 55.809 19.3361Z",
    fill: "#61B653"
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M58.7634 32.7347C59.8788 31.0981 60.4991 29.2323 60.5638 27.3191C60.6106 25.4012 61.1593 23.5194 62.1662 21.8232C60.3264 23.5948 59.1609 25.8375 58.8354 28.2323C58.6734 29.7385 58.7994 31.2446 58.7634 32.7347ZM58.8714 30.6037C59.1693 30.0253 59.3637 29.409 59.4476 28.7771C59.6636 27.7998 59.8977 26.8384 59.8977 26.8384C59.8977 26.8384 59.6996 27.7998 59.5556 28.7771C59.5556 29.0015 59.2135 30.7479 58.9435 30.7159H58.8354C58.8268 30.6963 58.8256 30.6747 58.8321 30.6544C58.8386 30.6341 58.8525 30.6163 58.8714 30.6037Z",
    fill: "#61B653"
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9694 23.1846C54.61 25.0424 54.8999 27.4084 55.6473 29.5362C56.0439 30.6478 56.7304 31.6482 57.1727 32.7121C57.6954 33.7741 57.9722 34.9487 57.9812 36.142C58.0598 35.6917 58.0854 35.2331 58.0575 34.7764C57.5541 32.1404 58.1947 30.092 57.0049 27.9007C56.227 26.3763 54.8846 24.9472 53.9694 23.1846ZM55.6168 27.5037C56.1194 28.2652 56.5437 29.0795 56.8829 29.9332C57.2029 30.7921 57.4231 31.6877 57.5388 32.6009C57.3084 31.7236 57.0335 30.8596 56.7151 30.0126C56.4048 29.1511 56.0378 28.3128 55.6168 27.5037Z",
    fill: "#61B653"
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0725 38.654L57.7328 39.8222C57.6385 39.5501 57.4686 39.038 57.2988 38.4939L56.7704 36.9737C56.7704 36.9737 56.9402 37.8538 57.1667 38.574C57.3931 39.2941 57.6573 39.9982 57.6573 39.9982C57.4875 40.5743 57.2799 41.1824 57.1289 41.5985C55.638 39.1661 56.0721 34.6693 54.6567 32.7329C56.8081 33.8851 57.6573 36.2215 58.0725 38.654Z",
    fill: "#61B653"
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M54.2485 47.0544C53.9092 45.4943 53.8787 43.8442 54.16 42.2638C54.3465 40.6796 54.2906 39.0616 53.9956 37.5068C55.077 39.5925 55.5284 42.1428 55.2601 44.6507C55.044 45.5319 54.7003 46.3485 54.2485 47.0544Z",
    fill: "#61B653"
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M64.1489 40.9272C63.6182 42.0918 62.9101 43.1841 62.0451 44.1723C61.6311 44.6761 61.1836 45.1566 60.7048 45.6112C60.2326 46.073 59.7343 46.5124 59.2118 46.9276C58.1628 47.7601 57.0263 48.4984 55.8185 49.1319C55.2247 49.4687 54.58 49.7289 53.9692 50.0197C53.3584 50.3106 52.6798 50.5096 52.052 50.7545L52.2047 51.03C53.6926 50.4534 55.2738 50.0968 56.8874 49.9738C57.7018 49.9738 58.584 49.882 59.3475 49.882C60.111 49.882 61.0441 49.882 61.7906 49.9891C60.1636 49.7141 58.5032 49.6369 56.8535 49.7595C55.1819 49.8647 53.5445 50.2379 52.0181 50.8617C51.9781 50.8784 51.9468 50.9085 51.931 50.9456C51.9151 50.9828 51.916 51.024 51.9333 51.0606C51.9518 51.0968 51.9852 51.125 52.0264 51.1393C52.0675 51.1535 52.1133 51.1528 52.1538 51.1372C52.7985 50.8769 53.4602 50.6626 54.088 50.3871C54.7157 50.1116 55.3774 49.836 55.9712 49.484C57.1785 48.8381 58.3148 48.0898 59.3644 47.2491C60.4308 46.4049 61.382 45.4491 62.1978 44.4019C63.0278 43.373 63.7064 42.2513 64.2168 41.0649V40.9731C64.2168 40.9731 64.1659 40.8965 64.1489 40.9272Z",
    fill: "#61B653"
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0713 55.919C19.0783 55.3893 17.1162 54.7544 15.1938 54.017C15.1465 54.0033 15.1052 53.9745 15.0766 53.9353C15.0479 53.8961 15.0334 53.8486 15.0354 53.8005C15.028 53.7544 15.028 53.7074 15.0354 53.6613L16.3028 51.4346L15.2097 48.0481C15.1935 48.0055 15.1904 47.9592 15.2009 47.915C15.2114 47.8707 15.235 47.8304 15.2688 47.7991C15.3025 47.7678 15.3449 47.7469 15.3908 47.7389C15.4366 47.731 15.4838 47.7363 15.5265 47.7543C17.755 48.5988 20.0354 49.3064 22.3545 49.8728C22.4012 49.8875 22.4432 49.9137 22.4766 49.949C22.5099 49.9842 22.5333 50.0272 22.5446 50.0738C22.5464 50.1218 22.5339 50.1693 22.5086 50.2105C22.4833 50.2517 22.4462 50.2848 22.402 50.3058C21.895 50.5532 21.3406 51.0171 21.3406 51.2954V55.687C21.3384 55.7226 21.3289 55.7574 21.3126 55.7893C21.2962 55.8212 21.2734 55.8496 21.2455 55.8726L21.0713 55.919Z",
    fill: "#509C43"
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9128 55.9203H47.769C47.7382 55.8979 47.7133 55.8678 47.6966 55.8328C47.6798 55.7977 47.6718 55.7588 47.6731 55.7196V50.9034C47.6731 50.6191 47.114 50.1174 46.5868 49.8498C46.5438 49.8265 46.5085 49.79 46.4857 49.7452C46.4629 49.7004 46.4536 49.6494 46.459 49.599C46.4704 49.5485 46.494 49.502 46.5276 49.464C46.5612 49.4259 46.6036 49.3975 46.6507 49.3816C48.9892 48.7691 51.2888 48.0039 53.5359 47.0905C53.5748 47.0671 53.6188 47.0547 53.6637 47.0547C53.7086 47.0547 53.7526 47.0671 53.7915 47.0905C53.8112 47.1321 53.8215 47.1779 53.8215 47.2243C53.8215 47.2707 53.8112 47.3165 53.7915 47.3581L52.6892 51.0205L53.9672 53.4286C53.9741 53.4673 53.9741 53.5069 53.9672 53.5456C53.9688 53.6017 53.9545 53.6571 53.9261 53.7047C53.8976 53.7524 53.8564 53.7901 53.8075 53.8132C51.8669 54.6048 49.8888 55.2914 47.8808 55.8701L47.9128 55.9203Z",
    fill: "#509C43"
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3335 51.8198C22.3035 51.8309 22.2705 51.8309 22.2406 51.8198C21.8544 51.6293 21.4972 51.3859 21.1794 51.0968V50.9259C21.1856 50.7867 21.2266 50.6512 21.2988 50.5315C21.3695 50.4398 21.4546 50.3599 21.5508 50.2949C21.8559 50.0714 22.5457 49.8742 22.4529 49.7822C22.4803 49.802 22.5029 49.8276 22.519 49.8572C22.5351 49.8868 22.5442 49.9196 22.5457 49.9531V51.6489C22.5442 51.6825 22.5351 51.7153 22.519 51.7449C22.5029 51.7745 22.4803 51.8001 22.4529 51.8198H22.3335Z",
    fill: "#61B653"
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M46.5498 51.8192C46.521 51.8011 46.4973 51.7759 46.4811 51.7459C46.465 51.716 46.4569 51.6824 46.4576 51.6484V49.9531C46.4569 49.9191 46.465 49.8855 46.4811 49.8556C46.4973 49.8256 46.521 49.8004 46.5498 49.7822C46.4444 49.8742 47.1296 50.0714 47.4458 50.2948C47.5355 50.3668 47.6193 50.4459 47.6962 50.5313C47.7614 50.6537 47.8017 50.7877 47.8148 50.9256C47.8269 50.9819 47.8269 51.0401 47.8148 51.0964C47.493 51.3838 47.134 51.6269 46.7475 51.8192C46.7351 51.8251 46.7216 51.8281 46.7079 51.8281C46.6943 51.8281 46.6808 51.8251 46.6684 51.8192H46.5498Z",
    fill: "#61B653"
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M34.7917 59.9997C29.2224 59.9997 22.8806 59.0528 21.2388 56.9382C21.2249 56.8918 21.2249 56.8425 21.2388 56.7961V50.9729C21.2329 50.7862 21.3023 50.6048 21.432 50.4679C21.4811 50.6064 21.5639 50.731 21.6734 50.8309C22.945 52.4879 28.1118 53.5926 34.5502 53.5926C40.9887 53.5926 46.2199 52.4721 47.4271 50.8309C47.5198 50.7155 47.5957 50.5881 47.6524 50.4521C47.7889 50.5923 47.864 50.7792 47.8617 50.9729V56.7961C47.8756 56.8425 47.8756 56.8918 47.8617 56.9382C46.1072 59.1949 40.0068 59.9997 34.8722 59.9997H34.7917Z",
    fill: "#61B653"
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M24.2404 56.0924C24.2199 56.1563 24.183 56.211 24.1298 56.2565C24.0779 56.3024 24.0131 56.3322 23.9355 56.3459C23.8579 56.3596 23.7745 56.3522 23.6852 56.3236C23.5561 56.2823 23.4604 56.2178 23.3981 56.13C23.3358 56.0423 23.3221 55.9441 23.357 55.8356L23.5777 55.9063C23.5648 55.9633 23.5711 56.0139 23.5969 56.058C23.6226 56.1021 23.6699 56.1352 23.7386 56.1572C23.8098 56.18 23.8711 56.1797 23.9226 56.1562C23.9752 56.1332 24.0106 56.0933 24.0288 56.0367C24.0432 55.992 24.0417 55.953 24.0245 55.9196C24.0089 55.8853 23.9845 55.8556 23.9514 55.8304C23.9186 55.8039 23.8722 55.7724 23.8121 55.7359C23.7362 55.6903 23.6763 55.6492 23.6322 55.6125C23.5885 55.5746 23.5559 55.5269 23.5344 55.4695C23.5133 55.4109 23.5156 55.3418 23.5411 55.2622C23.5644 55.1898 23.603 55.1317 23.657 55.0878C23.711 55.0439 23.7754 55.0174 23.8503 55.0081C23.9251 54.9988 24.0047 55.0076 24.0892 55.0347C24.2123 55.0741 24.3019 55.1347 24.3581 55.2165C24.4155 55.2987 24.4308 55.396 24.404 55.5085L24.176 55.4355C24.1867 55.3857 24.1791 55.3387 24.1534 55.2946C24.1277 55.2504 24.0846 55.2187 24.0243 55.1994C23.9616 55.1793 23.9059 55.1788 23.8572 55.1978C23.8085 55.2168 23.7743 55.257 23.7545 55.3185C23.7402 55.3631 23.7407 55.4032 23.7559 55.4386C23.7727 55.4733 23.7975 55.5038 23.8302 55.5303C23.8634 55.5555 23.9106 55.5866 23.9719 55.6235C24.0466 55.6687 24.1057 55.7102 24.1494 55.7481C24.1935 55.7848 24.2257 55.8317 24.246 55.8887C24.2678 55.9449 24.266 56.0128 24.2404 56.0924Z",
    fill: "white"
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M24.9772 55.3245L24.7585 56.1333C24.7324 56.2299 24.7378 56.3094 24.7748 56.3718C24.8129 56.4346 24.8772 56.4781 24.9678 56.5025C25.0595 56.5272 25.1371 56.5219 25.2004 56.4865C25.265 56.4514 25.3104 56.3856 25.3365 56.289L25.5551 55.4802L25.7643 55.5365L25.5456 56.3453C25.5175 56.4493 25.4711 56.5312 25.4064 56.5912C25.3416 56.6511 25.2665 56.6886 25.1811 56.7036C25.0957 56.7186 25.0071 56.7138 24.9154 56.6891C24.8236 56.6644 24.7446 56.6241 24.6784 56.5682C24.6133 56.5126 24.5686 56.4429 24.544 56.3589C24.5195 56.2749 24.5213 56.1809 24.5494 56.077L24.768 55.2682L24.9772 55.3245Z",
    fill: "white"
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M26.9414 55.8137L26.9036 55.9785L26.5609 55.9002L26.3037 57.0224L26.0925 56.9742L26.3498 55.852L26.0052 55.7733L26.043 55.6085L26.9414 55.8137Z",
    fill: "white"
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "M28.3033 56.0839L28.0534 57.3805L27.8407 57.3396L27.9511 56.7669L27.3409 56.6497L27.2305 57.2224L27.0177 57.1815L27.2677 55.885L27.4804 55.9258L27.3725 56.4855L27.9827 56.6027L28.0906 56.0431L28.3033 56.0839Z",
    fill: "white"
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "M29.2375 57.3002L28.6912 57.215L28.5556 57.4669L28.3322 57.4321L29.0042 56.1986L29.252 56.2372L29.515 57.6166L29.2897 57.5814L29.2375 57.3002ZM29.2055 57.1241L29.0875 56.4769L28.7756 57.057L29.2055 57.1241Z",
    fill: "white"
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "M30.4964 57.7421L30.2335 57.1702L30.1015 57.154L30.0362 57.6858L29.8212 57.6595L29.982 56.3489L30.4347 56.4043C30.5353 56.4166 30.618 56.4446 30.6828 56.4882C30.7491 56.5308 30.7956 56.5837 30.8223 56.6469C30.8502 56.7103 30.8597 56.7784 30.8508 56.8514C30.84 56.9394 30.8032 57.0153 30.7405 57.079C30.6791 57.143 30.5917 57.1789 30.4784 57.1867L30.7586 57.7741L30.4964 57.7421ZM30.1221 56.9862L30.3597 57.0153C30.4415 57.0253 30.5048 57.0132 30.5498 56.9792C30.5949 56.9451 30.6216 56.8935 30.6301 56.8244C30.6387 56.754 30.6253 56.6968 30.5899 56.6529C30.5544 56.609 30.4958 56.5821 30.4141 56.5721L30.1765 56.5431L30.1221 56.9862Z",
    fill: "white"
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4105 56.601L32.335 57.5499C32.3257 57.6673 32.2823 57.7572 32.2049 57.8197C32.1288 57.8823 32.0326 57.909 31.9164 57.8998C31.8003 57.8905 31.7089 57.849 31.6424 57.7751C31.5771 57.7013 31.5491 57.6057 31.5584 57.4883L31.7763 57.5056C31.7729 57.5637 31.7838 57.611 31.8088 57.6473C31.8352 57.6837 31.8761 57.7041 31.9317 57.7085C31.9872 57.7129 32.0309 57.6992 32.0626 57.6674C32.0945 57.6343 32.1127 57.5894 32.1172 57.5326L32.1927 56.5837L32.4105 56.601Z",
    fill: "white"
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6795 57.7264L33.1271 57.7011L33.0199 57.9662L32.794 57.9559L33.3273 56.6565L33.5779 56.668L33.9898 58.0106L33.762 58.0002L33.6795 57.7264ZM33.6284 57.5547L33.4406 56.9242L33.1938 57.5348L33.6284 57.5547Z",
    fill: "white"
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "M35.3147 58.0293L35.0981 58.0271L34.4568 57.0342L34.4464 58.0202L34.2298 58.018L34.2438 56.6956L34.4603 56.6979L35.1016 57.6889L35.112 56.7048L35.3286 56.707L35.3147 58.0293Z",
    fill: "white"
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "M36.2452 56.6757C36.3857 56.6717 36.5114 56.7029 36.6224 56.7694C36.7345 56.8345 36.8171 56.9297 36.8701 57.0549L36.61 57.0624C36.5739 56.9976 36.5249 56.9496 36.4632 56.9184C36.4014 56.886 36.3307 56.8709 36.2509 56.8732C36.1635 56.8758 36.0862 56.8976 36.019 56.9389C35.9518 56.9801 35.8996 57.0374 35.8624 57.1107C35.8265 57.1839 35.81 57.2681 35.8127 57.363C35.8155 57.458 35.8369 57.5416 35.8771 57.614C35.9184 57.685 35.9738 57.7391 36.0433 57.7764C36.1128 57.8137 36.1913 57.8311 36.2787 57.8285C36.3964 57.8251 36.491 57.7894 36.5626 57.7215C36.6353 57.6522 36.6776 57.5604 36.6895 57.446L36.1938 57.4603L36.1889 57.2913L36.9163 57.2703L36.9212 57.4393C36.9103 57.5422 36.8763 57.6376 36.8193 57.7254C36.7635 57.8132 36.689 57.8844 36.5955 57.9391C36.5033 57.9925 36.3996 58.0208 36.2843 58.0241C36.1603 58.0277 36.0461 58.0025 35.9419 57.9485C35.8376 57.8932 35.7536 57.8152 35.6899 57.7144C35.6274 57.6136 35.5943 57.4986 35.5905 57.3694C35.5868 57.2403 35.6132 57.1236 35.6697 57.0193C35.7275 56.915 35.8068 56.8329 35.9077 56.7729C36.0099 56.7117 36.1224 56.6793 36.2452 56.6757Z",
    fill: "white"
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4308 56.6416L37.5087 57.9598L37.2924 57.9725L37.2146 56.6543L37.4308 56.6416Z",
    fill: "white"
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "M38.4107 57.8914L38.0362 57.3851L37.9037 57.3963L37.9487 57.9302L37.7329 57.9483L37.6219 56.6325L38.0763 56.5943C38.1773 56.5858 38.264 56.5963 38.3364 56.6258C38.41 56.654 38.4663 56.6963 38.5054 56.7527C38.5457 56.8091 38.569 56.8739 38.5751 56.9471C38.5826 57.0354 38.5621 57.1172 38.5138 57.1925C38.4668 57.2676 38.3886 57.3206 38.2793 57.3514L38.6738 57.8693L38.4107 57.8914ZM37.8895 57.2278L38.128 57.2077C38.2101 57.2008 38.2697 57.1761 38.3067 57.1336C38.3438 57.0911 38.3595 57.0351 38.3536 56.9657C38.3476 56.895 38.3228 56.8418 38.2791 56.8061C38.2354 56.7703 38.1726 56.7559 38.0905 56.7628L37.852 56.7828L37.8895 57.2278Z",
    fill: "white"
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "M40.4926 57.2656C40.502 57.3321 40.4926 57.3974 40.4645 57.4614C40.4377 57.5253 40.3924 57.5803 40.3285 57.6263C40.2646 57.6724 40.1863 57.7019 40.0935 57.715C39.9593 57.7338 39.845 57.7172 39.7507 57.6652C39.6564 57.6132 39.6013 57.5308 39.5854 57.4179L39.8149 57.3857C39.8281 57.4427 39.8559 57.4854 39.8983 57.514C39.9407 57.5426 39.9976 57.5519 40.0691 57.5419C40.1431 57.5315 40.1982 57.5046 40.2343 57.4611C40.2716 57.4175 40.2861 57.3662 40.2778 57.3073C40.2713 57.2609 40.253 57.2264 40.223 57.2037C40.194 57.1796 40.1591 57.1634 40.1183 57.1551C40.0773 57.1455 40.0217 57.1373 39.9517 57.1305C39.8636 57.1224 39.7917 57.1114 39.736 57.0974C39.6801 57.0822 39.63 57.0535 39.5857 57.0111C39.5412 56.9674 39.5131 56.9042 39.5014 56.8214C39.4908 56.7462 39.5003 56.6771 39.5298 56.6141C39.5593 56.5511 39.6057 56.4992 39.669 56.4583C39.7324 56.4175 39.8079 56.3909 39.8957 56.3785C40.0237 56.3606 40.1308 56.3763 40.217 56.4256C40.3045 56.4747 40.3607 56.5557 40.3855 56.6686L40.1485 56.7019C40.1364 56.6524 40.1091 56.6134 40.0667 56.5848C40.0243 56.5562 39.9718 56.5463 39.9091 56.5551C39.8438 56.5643 39.7935 56.588 39.7579 56.6262C39.7224 56.6644 39.7091 56.7156 39.7181 56.7795C39.7246 56.8259 39.7425 56.8618 39.7716 56.8871C39.8018 56.911 39.8375 56.9278 39.8785 56.9374C39.9193 56.9457 39.9754 56.9532 40.0466 56.9598C40.1335 56.9681 40.2049 56.9798 40.2607 56.995C40.3164 57.009 40.3658 57.0372 40.4089 57.0798C40.4531 57.1209 40.481 57.1829 40.4926 57.2656Z",
    fill: "white"
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "M41.5039 57.199L40.96 57.298L40.915 57.5805L40.6926 57.621L40.9203 56.2353L41.167 56.1904L41.8702 57.4066L41.6459 57.4474L41.5039 57.199ZM41.4156 57.0432L41.0908 56.4708L40.9875 57.1211L41.4156 57.0432Z",
    fill: "white"
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "M43.3466 55.7118L43.6572 56.9953L43.4466 57.046L43.2339 56.167L43.055 57.1405L42.9091 57.1756L42.303 56.3914L42.5157 57.2705L42.3052 57.3212L41.9946 56.0377L42.2218 55.9829L42.916 56.8808L43.1213 55.7661L43.3466 55.7118Z",
    fill: "white"
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "M44.6997 56.4055L44.1707 56.5661L44.1584 56.8518L43.9421 56.9175L44.0093 55.515L44.2493 55.4421L45.0874 56.5698L44.8692 56.636L44.6997 56.4055ZM44.5941 56.2608L44.2057 55.7294L44.1778 56.3872L44.5941 56.2608Z",
    fill: "white"
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "M45.5774 54.9964L45.9004 55.892C45.9404 56.0028 45.938 56.1026 45.8932 56.1913C45.8497 56.2797 45.7731 56.3435 45.6634 56.383C45.5538 56.4224 45.4534 56.4221 45.3622 56.3822C45.2723 56.3418 45.2073 56.2662 45.1673 56.1554L45.373 56.0815C45.3939 56.1359 45.4233 56.1745 45.4611 56.1972C45.5002 56.2195 45.5459 56.2213 45.5983 56.2024C45.6508 56.1836 45.6849 56.1531 45.7007 56.1111C45.7161 56.0679 45.7141 56.0195 45.6948 55.9658L45.3718 55.0703L45.5774 54.9964Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.7602 49.8645) scale(2.96951 0.444156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6A2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#834F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9F785C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B99C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFBBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E0D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEE7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F7F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.6949 49.8645) scale(2.96951 0.444156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6A2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#834F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9F785C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B99C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFBBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E0D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEE7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F7F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3493 48.3898) scale(2.96951 0.444156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6A2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#834F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9F785C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B99C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFBBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E0D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEE7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F7F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.6505 48.4402) scale(2.96951 0.444154)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.22,
    stopColor: "#6A2C00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#834F2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#9F785C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#B99C87"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#CFBBAC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#E0D3CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#EEE7E2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#F7F4F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#FDFCFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.9464 51.6619) scale(5.4243 5.40883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5633 22.3115) scale(9.06691 9.04104)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_336_14486",
    x1: 23.681,
    y1: 51.0698,
    x2: 23.7597,
    y2: 43.6277,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_336_14486",
    x1: 23.7008,
    y1: 50.4609,
    x2: 23.7798,
    y2: 47.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_336_14486",
    x1: 26.6703,
    y1: 49.668,
    x2: 26.749,
    y2: 42.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_336_14486",
    x1: 26.6901,
    y1: 49.0564,
    x2: 26.7688,
    y2: 46.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_336_14486",
    x1: 42.3097,
    y1: 49.668,
    x2: 42.3687,
    y2: 42.2259,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_336_14486",
    x1: 42.3097,
    y1: 49.0564,
    x2: 42.3884,
    y2: 46.2335,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_336_14486",
    x1: 45.6158,
    y1: 51.0695,
    x2: 45.6945,
    y2: 43.6274,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_336_14486",
    x1: 45.6356,
    y1: 50.4609,
    x2: 45.7146,
    y2: 47.6528,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6681 17.9457) scale(29.2992 29.2156)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#04DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#02809C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1935 42.6408) scale(27.6758 27.5969)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_336_14486",
    x1: 34.7474,
    y1: 50.7343,
    x2: 34.7474,
    y2: 18.7156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.6119 30.2042) scale(7.8989 7.87636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8003 18.676) scale(8.84915 8.8239)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.1363 20.8076) scale(0.950245 0.949202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4333 23.295) scale(2.23703 2.23065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.75 24.0453) scale(2.15784 2.15169)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_336_14486",
    x1: 23.6202,
    y1: 22.4431,
    x2: 25.5405,
    y2: 22.4431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9876 24.9929) scale(3.89996 3.88883)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.9876 23.77) scale(0.950242 0.949205)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.4926 24.1257) scale(1.42536 1.4238)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2353 24.2634) scale(0.91065 0.909654)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.9977 24.4016) scale(0.989832 0.988755)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6483 30.5792) scale(8.37402 8.35013)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_336_14486",
    x1: 34.2326,
    y1: 52.8464,
    x2: 34.5673,
    y2: 38.7716,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#FC842A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#F2612C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#EB452D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#E5322D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#E2262E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#B21D31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#811735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8,
    stopColor: "#5E1337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#481138"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3209 54.4653) scale(33.8128 33.7164)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#04DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#02809C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F51"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_336_14486",
    x1: 22.7703,
    y1: 47.9508,
    x2: 22.6916,
    y2: 35.1591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_336_14486",
    x1: 24.0175,
    y1: 47.9903,
    x2: 23.9388,
    y2: 35.0604,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_336_14486",
    x1: 25.2449,
    y1: 48.0102,
    x2: 25.1661,
    y2: 34.9421,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_336_14486",
    x1: 26.4921,
    y1: 48.0494,
    x2: 26.4134,
    y2: 34.8234,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_336_14486",
    x1: 27.7393,
    y1: 50.438,
    x2: 27.6015,
    y2: 27.7959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_336_14486",
    x1: 28.9667,
    y1: 50.438,
    x2: 28.8486,
    y2: 27.7762,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_336_14486",
    x1: 30.2139,
    y1: 50.4378,
    x2: 30.0761,
    y2: 27.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_336_14486",
    x1: 31.4611,
    y1: 50.4181,
    x2: 31.3233,
    y2: 27.776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_336_14486",
    x1: 32.6885,
    y1: 50.4181,
    x2: 32.5704,
    y2: 27.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_336_14486",
    x1: 33.9357,
    y1: 50.3983,
    x2: 33.7979,
    y2: 27.7563,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_336_14486",
    x1: 35.1631,
    y1: 50.3983,
    x2: 35.045,
    y2: 27.7365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_336_14486",
    x1: 36.4103,
    y1: 50.3983,
    x2: 36.2725,
    y2: 27.7365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_336_14486",
    x1: 37.6377,
    y1: 50.3786,
    x2: 37.5196,
    y2: 27.7365,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_336_14486",
    x1: 38.8848,
    y1: 50.3786,
    x2: 38.7471,
    y2: 27.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_336_14486",
    x1: 40.1123,
    y1: 50.3786,
    x2: 39.9942,
    y2: 27.7168,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_336_14486",
    x1: 41.3397,
    y1: 47.4177,
    x2: 41.2806,
    y2: 35.9289,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_336_14486",
    x1: 42.5869,
    y1: 47.6152,
    x2: 42.5081,
    y2: 35.4749,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_336_14486",
    x1: 43.8143,
    y1: 47.4967,
    x2: 43.7552,
    y2: 35.7117,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_336_14486",
    x1: 45.0614,
    y1: 47.3784,
    x2: 45.0024,
    y2: 35.9488,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_336_14486",
    x1: 46.2888,
    y1: 47.2599,
    x2: 46.2298,
    y2: 36.1856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6682 27.4014) scale(20.5292 20.4707)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#05FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#04DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#02809C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#001F51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6286 17.1165) scale(3.86036 3.84935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.9844 18.9721) scale(0.158375 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.7864 19.2091) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5488 19.4266) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3113 19.6042) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0341 19.7816) scale(0.158373 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.757 19.9198) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.46 20.0188) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1631 20.0974) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8464 20.1371) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5296 20.137) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2326 20.1176) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9159 20.0583) scale(0.158375 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint65_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6189 19.9596) scale(0.158375 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.322 19.8407) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.0646 19.7025) scale(0.158375 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8073 19.5251) scale(0.158375 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5697 19.3081) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3519 19.091) scale(0.158373 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint71_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.154 18.8539) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint72_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9758 18.5776) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint73_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8372 18.3014) scale(0.158373 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint74_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7184 18.0053) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint75_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6393 17.709) scale(0.158375 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint76_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5997 17.4127) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint77_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5799 17.0969) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint78_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5997 16.7812) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint79_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.6591 16.4654) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint80_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.7382 16.1692) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint81_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.857 15.8733) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint82_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9956 15.5967) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint83_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.1738 15.3403) scale(0.158375 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint84_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.3717 15.103) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint85_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.5895 14.8861) scale(0.158372 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint86_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8271 14.6887) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint87_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.1042 14.5112) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint88_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3616 14.3728) scale(0.158375 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint89_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6585 14.2546) scale(0.158373 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint90_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9555 14.156) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint91_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2722 14.1165) scale(0.158376 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint92_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.589 14.0964) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint93_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9057 14.0967) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint94_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2026 14.156) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint95_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4996 14.2153) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint96_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7966 14.3332) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint97_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.0737 14.4717) scale(0.158375 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint98_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.3509 14.6494) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint99_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.5884 14.8267) scale(0.158375 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint100_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.826 15.0439) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint101_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.024 15.281) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint102_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.2021 15.5377) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint103_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3605 15.814) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint104_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4793 16.1099) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint105_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5585 16.406) scale(0.158372 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint106_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6179 16.7024) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint107_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6575 17.0181) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint108_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.6376 17.3337) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint109_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.598 17.6301) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint110_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.5387 17.9459) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint111_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.4397 18.2419) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint112_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.3011 18.5184) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint113_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1428 18.7944) scale(0.158373 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint114_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.391 21.4395) scale(7.06743 7.04727)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#05FFFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#04DBE3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#02809C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#001F51"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint115_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.9748 34.1127) scale(6.51313 6.49455)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint116_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.2829 35.5143) scale(4.57304 4.56)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint117_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.094 33.0468) scale(7.2456 7.22493)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint118_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.7302 50.4381) scale(16.4313 16.3844)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F67E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E93A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_336_14486",
    x1: 36.2519,
    y1: 53.2411,
    x2: 35.4054,
    y2: 44.0417,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#EF572C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#D2202F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#9F1B33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#761635"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#581337"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#461139"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint120_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.262 46.2924) scale(9.56182 9.53454)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_336_14486",
    x1: 34.3316,
    y1: 50.4973,
    x2: 34.7253,
    y2: 43.5486,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EF572C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C41F30"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#7C1735"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint122_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6735 52.2737) scale(39.6132 39.5002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint123_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.1443 36.2052) scale(9.62122 9.59375)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint124_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6735 52.274) scale(39.6133 39.5002)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint125_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.6735 52.2741) scale(39.6133 39.5003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint126_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.5799 32.1782) scale(13.1648 13.1273)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint127_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.8003 37.0738) scale(4.35528 4.34286)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint128_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4536 37.0737) scale(3.93956 3.92831)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_336_14486",
    x1: 23.5028,
    y1: 36.4424,
    x2: 23.9185,
    y2: 36.4424,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint130_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.5028 38.4953) scale(1.92028 1.91481)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint131_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.8988 38.653) scale(2.09845 2.09247)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint132_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.9565 31.8429) scale(12.3136 12.2784)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint133_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.1625 33.8366) scale(14.4912 14.4499)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint134_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5494 31.1716) scale(9.42325 9.39636)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint135_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6484 37.509) scale(0.415732 0.415277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint136_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6484 37.5083) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint137_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8464 37.0544) scale(0.0791857 0.0790998)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint138_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9255 37.1135) scale(0.0791861 0.0791016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint139_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0047 37.1726) scale(0.0791881 0.0790991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint140_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0641 37.2515) scale(0.0791864 0.0791003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint141_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1037 37.3303) scale(0.0791862 0.0791003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint142_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1037 37.7056) scale(0.0791862 0.0791021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint143_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9849 37.8638) scale(0.0791888 0.0790997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint144_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8266 37.9622) scale(0.079178 0.0791)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint145_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7275 37.9822) scale(0.079187 0.0791006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint146_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5296 37.9624) scale(0.0791869 0.0790997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint147_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4504 37.9427) scale(0.0791873 0.0790995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint148_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3514 37.8833) scale(0.0791879 0.0791016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint149_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.292 37.8242) scale(0.0791865 0.0790995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint150_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2326 37.7454) scale(0.0791859 0.0791021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint151_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.193 37.3704) scale(0.0791864 0.0791003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint152_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2326 37.2717) scale(0.0791882 0.0790991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint153_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.292 37.1924) scale(0.0791862 0.0791021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint154_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3514 37.1333) scale(0.0791882 0.0790991)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint155_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4504 37.074) scale(0.0791857 0.0790993)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint156_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.085 33.0772) scale(15.1841 15.1675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint157_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0787) scale(15.1841 15.1675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint158_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0587) scale(15.2038 15.1872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint159_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0772) scale(15.1841 15.1676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint160_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0775) scale(15.1841 15.1675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint161_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.085 33.0567) scale(15.184 15.1676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint162_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.085 33.0772) scale(15.1841 15.1675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint163_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.058) scale(15.2038 15.1872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint164_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.076) scale(15.1841 15.1675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint165_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.085 33.0564) scale(15.184 15.1676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint166_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.057) scale(15.204 15.1872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint167_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.085 33.058) scale(15.1842 15.1674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint168_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0765) scale(15.1841 15.1676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint169_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.085 33.0758) scale(15.1841 15.1675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint170_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.085 33.056) scale(15.1842 15.1674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint171_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0772) scale(15.1841 15.1675)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint172_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.057) scale(15.204 15.1872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint173_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0563) scale(15.2038 15.1872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint174_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.0561) scale(15.1842 15.1674)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint175_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.0849 33.057) scale(15.2038 15.1872)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint176_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.501) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint177_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5022) scale(11.1852 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint178_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8459 34.4827) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint179_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5015) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint180_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5018) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint181_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.4806) scale(11.1852 11.1728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint182_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8459 34.501) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint183_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8459 34.502) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint184_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5001) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint185_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.4806) scale(11.1852 11.1728)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint186_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.501) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint187_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.4817) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint188_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5008) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint189_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.4798) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint190_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.32856 17.8097) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint191_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.501) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint192_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5008) scale(11.1852 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint193_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5001) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint194_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.4805) scale(11.1851 11.173)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint195_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.8458 34.5008) scale(11.1851 11.1729)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#84E269"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.04,
    stopColor: "#79D75E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#59B53C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#429D23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#348E14"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#2F890F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#2C850F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#227A0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#13660E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#08590E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint196_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8158 36.2052) scale(9.38365 9.35687)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint197_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8661 45.7792) scale(7.3446 7.32364)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#DC3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CC3924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B33126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8F2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#621A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint198_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5793 49.668) scale(7.10703 7.08675)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#D63C23"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#BA3425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "#8B2629"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#4C132E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint199_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6874 53.1225) scale(7.87911 7.85662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#DC3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CC3924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#B33126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#8F2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94,
    stopColor: "#621A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint200_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6885 41.6337) scale(3.0487 3.04)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#FEF0C1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint201_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.4777 46.3714) scale(10.9872 10.9558)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F67E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E93A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint202_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6361 48.1678) scale(16.1541 16.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DC3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CC3924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B33126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8F2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#621A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint203_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6361 48.1677) scale(16.1541 16.108)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DC3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CC3924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B33126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8F2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#621A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint204_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6361 48.168) scale(16.1541 16.1081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DC3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CC3924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B33126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8F2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#621A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint205_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6361 48.1677) scale(16.1541 16.1081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DC3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CC3924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B33126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8F2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#621A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint206_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.6361 48.1681) scale(16.1541 16.1081)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#DC3D22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#CC3924"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#B33126"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83,
    stopColor: "#8F2729"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#621A2C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint207_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7078 38.5345) scale(0.831463 0.829091)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint208_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7078 38.5352) scale(0.316748 0.316401)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint209_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8265 37.5679) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint210_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0245 37.6071) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint211_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2027 37.6863) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint212_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.361 37.8045) scale(0.158372 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint213_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4996 37.9426) scale(0.158375 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint214_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5986 38.1201) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint215_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.658 38.2979) scale(0.158374 0.158199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint216_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6778 38.4954) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint217_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6778 38.6929) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint218_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6184 38.8901) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint219_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5194 39.0481) scale(0.158374 0.158203)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint220_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4006 39.2063) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint221_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2621 39.3443) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint222_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0839 39.4235) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint223_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8859 39.4827) scale(0.158373 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint224_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7078 39.5022) scale(0.158372 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint225_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5098 39.4823) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint226_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3118 39.4235) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint227_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1534 39.3442) scale(0.158375 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint228_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9951 39.2061) scale(0.158372 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint229_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.8763 39.0483) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint230_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7773 38.8706) scale(0.158373 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint231_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7377 38.6926) scale(0.158374 0.1582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint232_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7179 38.4954) scale(0.158375 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint233_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7377 38.2978) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint234_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.8169 38.1202) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint235_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9159 37.9428) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint236_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0347 37.8046) scale(0.158372 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint237_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.193 37.6862) scale(0.158374 0.158199)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint238_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3712 37.6071) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint239_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5692 37.5679) scale(0.158372 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint240_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2326 42.5024) scale(6.6913 6.6722)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint241_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(45.8335 32.6127) scale(6.90906 6.88935)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint242_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(46.8431 20.8871) scale(8.23545 8.21195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint243_linear_336_14486",
    x1: 45.5366,
    y1: 22.8598,
    x2: 44.8646,
    y2: 23.9876,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint244_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.9625 25.9207) scale(1.76191 1.75689)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint245_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7249 26.2364) scale(2.21723 2.21091)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint246_linear_336_14486",
    x1: 39.36,
    y1: 42.8777,
    x2: 42.5468,
    y2: 42.3815,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCCCCC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CCCCCC"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint247_linear_336_14486",
    x1: 41.1219,
    y1: 38.3175,
    x2: 43.5484,
    y2: 41.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFF1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint248_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.6869 39.2059) scale(5.64206 5.62597)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint249_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.3199 41.1205) scale(3.0685 3.05974)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint250_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.5173 34.5473) scale(5.50349 5.48779)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint251_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.215 35.1395) scale(5.95882 5.94182)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint252_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.3996 30.2417) scale(2.4152 2.41256)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint253_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6682 24.3017) scale(14.8476 14.8052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint254_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6682 24.3019) scale(14.8475 14.8052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint255_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6681 24.3019) scale(14.8475 14.8052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint256_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6682 24.3017) scale(14.8476 14.8052)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint257_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.1647 29.9458) scale(2.29642 2.29391)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint258_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(42.3889 30.4608) scale(6.71109 6.69195)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint259_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0545 27.6774) scale(6.0776 6.06026)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint260_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6082 28.8227) scale(7.22581 7.20519)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint261_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.1556 31.1519) scale(5.68166 5.66546)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint262_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.6281 34.0337) scale(8.29483 8.27117)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F67E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E93A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint263_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.391 24.7757) scale(8.86894 8.84363)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint264_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6981 34.942) scale(10.7892 10.7584)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F67E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E93A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint265_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6286 30.3424) scale(1.40557 1.40156)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint266_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5692 31.7248) scale(0.415731 0.415277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint267_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5692 31.7243) scale(0.158374 0.158202)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint268_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7671 31.2705) scale(0.0791861 0.0790995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint269_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8464 31.3097) scale(0.0791857 0.079102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint270_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9255 31.3892) scale(0.0791864 0.0790995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint271_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9849 31.4482) scale(0.0791863 0.0791016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint272_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0245 31.5467) scale(0.0791887 0.0790914)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint273_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0443 31.8228) scale(0.0791862 0.0791102)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint274_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0047 31.9214) scale(0.0791862 0.0791003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint275_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9651 32.0007) scale(0.0791864 0.0791016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint276_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9057 32.0793) scale(0.0791864 0.0791015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint277_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8266 32.139) scale(0.0791861 0.0791018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint278_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7275 32.1785) scale(0.0791869 0.0791018)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint279_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6484 32.198) scale(0.0791835 0.0791006)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint280_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3514 32.1389) scale(0.0791857 0.0790996)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint281_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2722 32.0996) scale(0.0791881 0.0791016)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint282_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2128 32.0205) scale(0.0791863 0.0790995)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint283_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1534 31.9414) scale(0.0791884 0.0791021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint284_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.094 31.7639) scale(0.0791873 0.0791003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint285_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1139 31.5665) scale(0.0791857 0.0791074)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint286_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1535 31.4873) scale(0.0791857 0.0791003)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint287_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2128 31.4087) scale(0.0791882 0.0791015)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint288_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2722 31.3297) scale(0.0791869 0.0790997)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint289_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4504 31.2507) scale(0.0791968 0.0791021)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint290_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8067 22.7821) scale(10.9674 10.9361)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint291_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.6002 51.4249) scale(6.57252 6.55377)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint292_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.827 55.078) scale(1.56395 1.56222)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint293_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.6489 54.7425) scale(1.44516 1.44358)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint294_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.8966 53.9526) scale(1.52434 1.52269)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint295_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.9956 53.3601) scale(1.48475 1.48311)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint296_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(30.5702 44.3581) scale(2.23703 2.23065)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint297_linear_336_14486",
    x1: 30.392,
    y1: 42.9569,
    x2: 32.0348,
    y2: 42.4021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint298_linear_336_14486",
    x1: 30.887,
    y1: 43.2923,
    x2: 32.3518,
    y2: 42.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint299_linear_336_14486",
    x1: 31.1245,
    y1: 43.6279,
    x2: 32.1141,
    y2: 43.2317,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint300_linear_336_14486",
    x1: 31.4413,
    y1: 44.0034,
    x2: 32.3118,
    y2: 43.4884,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint301_linear_336_14486",
    x1: 41.8148,
    y1: 41.8912,
    x2: 42.7251,
    y2: 41.495,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint302_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(43.0818 31.2703) scale(8.63138 8.60676)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F67E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E93A00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint303_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.5221 32.0993) scale(6.81008 6.79065)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC72E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#FEC02D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFAE2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F67E19"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#E93A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint304_linear_336_14486",
    x1: 34.6286,
    y1: 31.5467,
    x2: 34.6286,
    y2: 36.2054,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#EF572C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint305_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.9935 24.8546) scale(3.12788 3.11896)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint306_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(28.3728 23.4137) scale(4.75122 4.73766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint307_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.49 22.4857) scale(4.13752 4.12571)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint308_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4702 14.9844) scale(2.4548 2.44779)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint309_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4504 15.044) scale(4.39488 4.38234)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint310_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9057 24.7164) scale(5.66187 5.64571)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint311_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4702 13.7608) scale(2.71216 2.70442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FDB72A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#F9A328"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E75724"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.68,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint312_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.0438 23.0384) scale(1.26699 1.26338)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint313_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(32.8073 23.3937) scale(2.19744 2.19117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint314_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(37.8158 31.4477) scale(2.83094 2.82286)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB60E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFAF0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FF9B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF900C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F96007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F01500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint315_linear_336_14486",
    x1: 37.7565,
    y1: 33.2835,
    x2: 34.7282,
    y2: 32.7079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EF572C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint316_linear_336_14486",
    x1: 39.261,
    y1: 26.7104,
    x2: 36.1542,
    y2: 25.8372,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.06,
    stopColor: "#ACFF0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#B9FF11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#F9FF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#F8E71B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#F6C219"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F5A817"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#F49816"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F49216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#310815"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint317_linear_336_14486",
    x1: 34.193,
    y1: 28.1909,
    x2: 38.0922,
    y2: 28.965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#EF572C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.89,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint318_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3712 15.5175) scale(8.4928 8.46857)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint319_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.589 20.2356) scale(1.18781 1.18441)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint320_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.589 20.2361) scale(0.752274 0.751452)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint321_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5002 20.2351) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint322_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5001 20.0581) scale(0.178171 0.177977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint323_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5596 19.8412) scale(0.178171 0.177975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint324_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6585 19.6434) scale(0.178171 0.177975)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint325_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.7971 19.4656) scale(0.178172 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint326_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9753 19.3278) scale(0.17817 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint327_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1535 19.2288) scale(0.178168 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint328_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3712 19.17) scale(0.17817 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint329_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.589 19.1501) scale(0.178172 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint330_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8068 19.1699) scale(0.17817 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint331_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0245 19.2291) scale(0.178169 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint332_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2027 19.3278) scale(0.178169 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint333_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3809 19.4661) scale(0.178169 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint334_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.5194 19.6433) scale(0.178171 0.177977)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint335_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6184 19.8408) scale(0.17817 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint336_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.658 20.0581) scale(0.178171 0.177976)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint337_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.6778 20.2156) scale(0.158374 0.158201)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint338_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4702 16.6408) scale(4.15731 4.15277)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#F18326"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#E55223"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint339_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(31.956 31.0924) scale(2.25683 2.25039)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFB60E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFAF0E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.12,
    stopColor: "#FF9B0D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FF900C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#F96007"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#F01500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint340_linear_336_14486",
    x1: 31.9164,
    y1: 33.323,
    x2: 34.4495,
    y2: 32.6483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#EF572C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint341_linear_336_14486",
    x1: 29.1251,
    y1: 29.4543,
    x2: 33.776,
    y2: 28.4023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#FF902A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#EF572C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E1222E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#401039"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint342_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(29.4418 27.2631) scale(4.83041 4.81662)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#ACFF0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#B9FF11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#F9FF1C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#F6C719"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#F49216"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#310815"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint343_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(40.5082 40.3723) scale(3.0487 2.8272)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint344_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5179 37.0145) scale(2.19743 2.19117)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint345_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.5376 37.2711) scale(2.71215 2.70442)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint346_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7672 23.6106) scale(1.24719 1.24583)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EB7A98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AA243D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint347_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7869 25.5874) scale(1.86089 1.85886)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.33,
    stopColor: "#EB7A98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#AA243D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint348_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5494 22.9003) scale(2.91012 2.90182)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#F7F7F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#E1E1E1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#BEBEBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#9E9E9E"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint349_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1139 23.5723) scale(0.257356 0.257077)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint350_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1062 23.022) rotate(-4.58704) scale(0.622026 0.64861)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#622300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4C1B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2A0E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint351_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5098 23.0781) scale(0.574105 0.572468)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint352_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3814 22.5652) scale(0.890853 0.889877)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFF6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFEAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFD9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC3B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFA694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCAB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F4BAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E7D3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D4F6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint353_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.421 22.4858) scale(0.118781 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#622300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4C1B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2A0E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint354_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3022 22.4269) scale(0.475122 0.474602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF3C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F83818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E42C11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C31A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BD1605"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint355_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3418 21.5571) scale(0.989839 0.988753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint356_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.5208 22.8866) rotate(3.42989) scale(0.317315 0.316971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint357_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3814 21.993) rotate(180) scale(0.534513 0.533927)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#622300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4C1B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2A0E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint358_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.3418 21.9927) rotate(180) scale(0.455325 0.454827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint359_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7768 22.5654) rotate(180) scale(0.890853 0.889876)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#FFFDFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FFF6F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#FFEAE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#FFD9D1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FFC3B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.58,
    stopColor: "#FFA694"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#FCAB9B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#F4BAAF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "#E7D3D0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#D4F6FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint360_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7372 22.4858) rotate(180) scale(0.118781 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#622300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4C1B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2A0E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint361_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.856 22.4269) rotate(180) scale(0.475122 0.474602)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FF3C1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#F83818"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.65,
    stopColor: "#E42C11"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#C31A07"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#BD1605"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint362_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8164 21.5571) rotate(180) scale(0.989836 0.988753)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint363_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(36.2009 21.6962) rotate(176.57) scale(0.317316 0.316971)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint364_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.7966 21.993) scale(0.534511 0.533927)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6A2600"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#622300"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#4C1B00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#2A0E00"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint365_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.8362 21.9927) scale(0.455324 0.454827)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint366_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4702 22.0518) scale(1.97967 1.97403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint367_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4702 22.0518) scale(1.97968 1.97403)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint368_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.6981 21.9517) scale(0.910651 0.909653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint369_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4204 21.9517) rotate(180) scale(0.910651 0.909653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.34,
    stopColor: "#FFB59A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55,
    stopColor: "#FBAE93"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#EE9A7F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#EC967B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint370_linear_336_14486",
    x1: 41.597,
    y1: 41.5559,
    x2: 42.1111,
    y2: 40.9028,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint371_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(44.7645 26.5127) scale(3.08829 3.07948)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.01,
    stopColor: "#FDFDD9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FDF9D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#FEEFC0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFDFA2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43,
    stopColor: "#FFDA98"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#D2683A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint372_linear_336_14486",
    x1: 44.1112,
    y1: 25.7244,
    x2: 45.1597,
    y2: 24.9916,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint373_linear_336_14486",
    x1: 44.4477,
    y1: 26.1391,
    x2: 45.7532,
    y2: 25.0501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint374_linear_336_14486",
    x1: 44.6457,
    y1: 26.3364,
    x2: 46.0109,
    y2: 25.5441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint375_linear_336_14486",
    x1: 44.6853,
    y1: 26.4939,
    x2: 46.3676,
    y2: 25.8401,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.05,
    stopColor: "#FFB17F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FFAE86"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#FEA79A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#FC9BBA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FA8DDF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint376_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6879 35.5741) scale(0.336545 0.336176)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint377_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6682 34.3695) scale(0.653292 0.65143)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint378_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6681 34.3697) scale(0.257358 0.257076)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint379_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.7671 33.5996) scale(0.118782 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint380_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9057 33.6394) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint381_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.0641 33.6983) scale(0.11878 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint382_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1829 33.7973) scale(0.11878 0.118653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint383_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2819 33.9158) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint384_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3611 34.0339) scale(0.118781 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint385_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4006 34.1919) scale(0.118781 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint386_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4204 34.3298) scale(0.118782 0.118649)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint387_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.4205 34.4878) scale(0.118781 0.118652)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint388_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3809 34.6262) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint389_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.3017 34.7646) scale(0.118781 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint390_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.2027 34.8831) scale(0.11878 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint391_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(35.1037 34.9814) scale(0.11878 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint392_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.9651 35.0608) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint393_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.8067 35.1003) scale(0.118779 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint394_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.6682 35.1199) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint395_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5098 35.1002) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint396_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.3712 35.0606) scale(0.118782 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint397_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2326 34.9814) scale(0.11878 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint398_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1138 34.8828) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint399_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0149 34.7643) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint400_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9555 34.6265) scale(0.118781 0.118653)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint401_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9159 34.4883) scale(0.11878 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint402_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9159 34.1919) scale(0.118782 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint403_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(33.9753 34.0341) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint404_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.0545 33.9159) scale(0.118781 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint405_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.1535 33.7971) scale(0.11878 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint406_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.2722 33.6985) scale(0.11878 0.118651)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint407_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.4108 33.6393) scale(0.11878 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint408_radial_336_14486",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(34.5692 33.5999) scale(0.118779 0.11865)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#FFFE1A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#FFBE2A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#EE7425"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#E13F22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#40102F"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_336_14486"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 27.854,
    height: 41.0005,
    fill: "white",
    transform: "translate(20.7906 13.9185)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.bd2bbbd8dc2b47f025cf94b9f0ef218f.svg";
export { ForwardRef as ReactComponent };